/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )( -
 *              _/           |
 */
export const hospitalisationRates = {
  bands: {
    single: {
      age: [
        [18, 25],
        [26, 30],
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
      ],
    },
    joint: {
      male: [
        [18, 25],
        [26, 30],
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
      ],
      female: [
        [18, 25],
        [26, 30],
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
      ],
    },
  },
  single: {
    5: [
      25.7428978582916, 25.7263466672234, 25.6948946976947, 25.626452402166,
      25.4972925489165, 25.2901110987207, 24.9852775876084,
    ],
    6: [
      19.0573190117205, 19.0487220520552, 19.0319469285318, 18.9958024385703,
      18.9289034933164, 18.8225781500758, 21.7819502150147,
    ],
    7: [
      16.8938870877239, 16.8868749913026, 16.8728734040113, 16.843181336809,
      16.7894242297873, 16.705013774611, 20.7298315284291,
    ],
    8: [
      15.4500759851153, 15.4441464212842, 15.4320545691874, 15.4068992852191,
      15.3622942710704, 15.292972105056, 20.0283809395932,
    ],
    9: [
      14.1809707126316, 14.1763643410742, 14.1668284416455, 14.1474038761755,
      14.1135704105424, 14.0613999302334, 19.4177492473934,
    ],
    10: [
      13.5375871471051, 13.5334698459431, 13.5248850955055, 13.5077860956461,
      13.4785189256211, 13.4337382376931, 19.1061468810122,
    ],
    11: [
      13.0826909703519,
      13.0789307742133,
      13.0710986223543,
      13.0558286035833,
      13.0300886172128,
      13.2106479351995,
      null,
    ],
    12: [
      12.6652294468365,
      12.6620747099611,
      12.6555571334762,
      12.6430785505242,
      12.622253813171,
      13.0082560842302,
      null,
    ],
    13: [
      12.4226322969539,
      12.4197563677658,
      12.4138814166407,
      12.40283996888,
      12.3846022453145,
      12.8902377087962,
      null,
    ],
    14: [
      12.2364974237554,
      12.233871999923,
      12.2285879912918,
      12.2188293697174,
      12.2028515905167,
      12.8000631224367,
      null,
    ],
    15: [
      12.0766667781533,
      12.0743765897517,
      12.0698429260436,
      12.061582458622,
      12.0481218003348,
      12.7234687813416,
      null,
    ],
    16: [
      11.9766717991352,
      11.9745910944267,
      11.9705402711584,
      11.9632472688171,
      11.9992689939375,
      null,
      null,
    ],
    17: [
      11.9021700514436,
      11.9002779395306,
      11.8966540787466,
      11.8901911305122,
      11.9630081331837,
      null,
      null,
    ],
    18: [
      11.8401664875789,
      11.8384956953548,
      11.8353443264813,
      11.8297519728514,
      11.9330641909643,
      null,
      null,
    ],
    19: [
      11.8001292236006,
      11.7986100513388,
      11.7957823622919,
      11.7907789043542,
      11.9137632082932,
      null,
      null,
    ],
    20: [
      11.7704143132659,
      11.7690310923143,
      11.7664853826588,
      11.7619825984403,
      11.8995216015715,
      null,
      null,
    ],
  },
  joint: {
    5: {
      0: [
        28.3651322850955, 28.3652455785033, 28.3654644247721, 28.3658515902372,
        28.3664382127516, 28.3671217547756, 28.3670421783461,
      ],
      1: [
        28.3651848357683, 28.3652970562449, 28.365513884099, 28.3658978287019,
        28.3664798242234, 28.3671583040234, 28.3670782831747,
      ],
      2: [
        28.3654107064358, 28.365520613212, 28.3657341069217, 28.3661106759598,
        28.3666820273442, 28.3673456903217, 28.3672463010255,
      ],
      3: [
        28.3658042320831, 28.3659103603669, 28.3661165618503, 28.366486977319,
        28.3670402286991, 28.367679102355, 28.3675468053079,
      ],
      4: [
        28.3663965371578, 28.3664969417098, 28.3666927081996, 28.3670451153407,
        28.3676068803764, 28.3682079526849, 28.3680257123098,
      ],
      5: [
        28.3670864982611, 28.3671792105676, 28.367360496929, 28.3676883505142,
        28.3682124192846, 28.3689765071748, 28.3687242717153,
      ],
      6: [
        28.3670182394702, 28.3671009820193, 28.3672633963615, 28.3675587409101,
        28.3680331715012, 28.3687274417941, 28.3696924976087,
      ],
    },
    6: {
      0: [
        26.57907311473, 26.5556373197969, 26.5623519717447, 26.5619945708281,
        26.581865343954, 26.5758193913489, 27.4838534912791,
      ],
      1: [
        26.5558498522015, 26.5603340246718, 26.538940586465, 26.5454295795697,
        26.5445371641952, 26.5431231705472, 27.4544532975784,
      ],
      2: [
        26.5623422381998, 26.5391436813601, 26.543498624218, 26.5451339694742,
        26.5442516829641, 26.5431720453468, 27.4545498350645,
      ],
      3: [
        26.5455580077018, 26.5454119752853, 26.5451256939861, 26.5446136941648,
        26.543732000551, 26.5432317870815, 27.4548746736182,
      ],
      4: [
        26.5446530445371, 26.544512638258, 26.5442360561546, 26.5437248531924,
        26.5434283894973, 26.543277742316, 27.455394800089,
      ],
      5: [
        26.5431436638506, 26.5431191026732, 26.5431683263594, 26.5432299493273,
        26.5432764591039, 26.5438217368558, 27.4561559573376,
      ],
      6: [
        27.4678749281375, 27.4678299907688, 27.4678552774151, 27.4680016144726,
        27.4682529933234, 27.4686345617473, 27.4572125984073,
      ],
    },
    7: {
      0: [
        26.4631558175534, 26.4506470745894, 26.42629096152, 26.3823499078573,
        26.3115279029515, 26.2063836558006, 27.2731787293291,
      ],
      1: [
        26.4296197911973, 26.4170411052651, 26.3925342805597, 26.3482098741943,
        26.2765399397679, 26.1698058738139, 27.2403036169894,
      ],
      2: [
        26.4041620723962, 26.3917691759755, 26.3675812891942, 26.3237915329973,
        26.2527404642038, 26.1470389686583, 27.2328051240104,
      ],
      3: [
        26.3588722110988, 26.3467668277801, 26.3231049089165, 26.2799077959365,
        26.2101799056936, 26.1061948529315, 27.2182708403044,
      ],
      4: [
        26.2863022224329, 26.2745284217876, 26.2514749645361, 26.2095923337145,
        26.1416082848055, 26.0402608297206, 27.1932256153915,
      ],
      5: [
        26.1784929656171, 26.1672726175623, 26.1452343871787, 26.1050556669644,
        26.0396964639367, 25.9418618391664, 27.154317003187,
      ],
      6: [
        27.2674844679275, 27.2633360747302, 27.2552680025498, 27.2396108456837,
        27.2127600210292, 27.1712056645677, 27.0974517453446,
      ],
    },
    8: {
      0: [
        26.4625261436921, 26.4499874547545, 26.4255728732502, 26.3815091511183,
        26.3104621062434, 26.2049418308388, 27.271109286664,
      ],
      1: [
        26.4296053265241, 26.4170267416735, 26.3925203353129, 26.3481964103059,
        26.2765249700606, 26.1697890235631, 27.2402950879167,
      ],
      2: [
        26.4041480447709, 26.3917552347311, 26.367567519504, 26.3237765587191,
        26.2527254021512, 26.1470220356242, 27.2327965701382,
      ],
      3: [
        26.3588587421211, 26.346753361023, 26.3230899313883, 26.2798927820142,
        26.210163177452, 26.1061778019361, 27.2182622473192,
      ],
      4: [
        26.2862872553303, 26.2745134402883, 26.2514598865453, 26.2095755953586,
        26.1415913094953, 26.0404924919529, 27.1932169793749,
      ],
      5: [
        26.1784761228813, 26.1672557326517, 26.1452174257151, 26.1050385951671,
        26.0399323901201, 25.9430223757914, 27.1545571830529,
      ],
      6: [
        27.2674862055609, 27.2633375507982, 27.2552689653032, 27.2396107976379,
        27.2127587986223, 27.1717872106429, 27.0986209000642,
      ],
    },
    9: {
      0: [
        26.462525372688, 26.4499865841935, 26.4255718427519, 26.381507783137,
        26.3104597696893, 26.204938491004, 27.271109286664,
      ],
      1: [
        26.4296036564514, 26.417024922246, 26.3925182662311, 26.3481938540263,
        26.276521087278, 26.169783180623, 27.2402917282497,
      ],
      2: [
        26.4041461093592, 26.3917531550077, 26.3675651588378, 26.3237733392453,
        26.2527211887415, 26.1470158404175, 27.23279309265,
      ],
      3: [
        26.3588563040193, 26.3467507834888, 26.3230866996984, 26.279888952864,
        26.2101579813032, 26.1061709599192, 27.218258537348,
      ],
      4: [
        26.2862834981665, 26.2745095211558, 26.2514556485153, 26.2095703854327,
        26.1415850313436, 26.0404846917388, 27.1932128585427,
      ],
      5: [
        26.1784703938606, 26.1672498317292, 26.1452111856164, 26.105031722,
        26.0399245750338, 25.9430133328659, 27.1545525207496,
      ],
      6: [
        27.2674880345423, 27.2633393507452, 27.2552707026198, 27.2396123038118,
        27.2127597856123, 27.1717870071524, 27.0986156569682,
      ],
    },
    10: {
      0: [
        26.462525372688, 26.4499865841935, 26.4255718427519, 26.381507783137,
        26.3104597696893, 26.204938491004, 27.271109286664,
      ],
      1: [
        26.4296036564514, 26.417024922246, 26.3925182662311, 26.3481938540263,
        26.276521087278, 26.169783180623, 27.2402917282497,
      ],
      2: [
        26.4041461093592, 26.3917531550077, 26.3675651588378, 26.3237733392453,
        26.2527211887415, 26.1470158404175, 27.23279309265,
      ],
      3: [
        26.3588563040193, 26.3467507834888, 26.3230866996984, 26.279888952864,
        26.2101579813032, 26.1061709599192, 27.218258537348,
      ],
      4: [
        26.2862834981665, 26.2745095211558, 26.2514556485153, 26.2095703854327,
        26.1415850313436, 26.0404846917388, 27.1932128585427,
      ],
      5: [
        26.1784703938606, 26.1672498317292, 26.1452111856164, 26.105031722,
        26.0399245750338, 25.9430133328659, 27.1545525207496,
      ],
      6: [
        27.2674880345423, 27.2633393507452, 27.2552707026198, 27.2396123038118,
        27.2127597856123, 27.1717870071524, 27.0986156569682,
      ],
    },
    11: {
      0: [
        26.462525372688,
        26.4499865841935,
        26.4255718427519,
        26.381507783137,
        26.3104597696893,
        null,
        null,
      ],
      1: [
        26.4296036564514,
        26.417024922246,
        26.3925182662311,
        26.3481938540263,
        26.276521087278,
        null,
        null,
      ],
      2: [
        26.4041461093592,
        26.3917531550077,
        26.3675651588378,
        26.3237733392453,
        26.2527211887415,
        null,
        null,
      ],
      3: [
        26.3588563040193,
        26.3467507834888,
        26.3230866996984,
        26.279888952864,
        26.2101579813032,
        null,
        null,
      ],
      4: [
        26.2862834981665,
        26.2745095211558,
        26.2514556485153,
        26.2095703854327,
        26.1415850313436,
        null,
        null,
      ],
      5: [
        26.1784703938606,
        26.1672498317292,
        26.1452111856164,
        26.105031722,
        26.0399245750338,
        null,
        null,
      ],
      6: [null, null, null, null, null, null, null],
    },
    12: {
      0: [
        26.462525372688,
        26.4499865841935,
        26.4255718427519,
        26.381507783137,
        26.3104597696893,
        null,
        null,
      ],
      1: [
        26.4296036564514,
        26.417024922246,
        26.3925182662311,
        26.3481938540263,
        26.276521087278,
        null,
        null,
      ],
      2: [
        26.4041461093592,
        26.3917531550077,
        26.3675651588378,
        26.3237733392453,
        26.2527211887415,
        null,
        null,
      ],
      3: [
        26.3588563040193,
        26.3467507834888,
        26.3230866996984,
        26.279888952864,
        26.2101579813032,
        null,
        null,
      ],
      4: [
        26.2862834981665,
        26.2745095211558,
        26.2514556485153,
        26.2095703854327,
        26.1415850313436,
        null,
        null,
      ],
      5: [
        26.1784703938606,
        26.1672498317292,
        26.1452111856164,
        26.105031722,
        26.0399245750338,
        null,
        null,
      ],
      6: [null, null, null, null, null, null, null],
    },
    13: {
      0: [
        26.462525372688,
        26.4499865841935,
        26.4255718427519,
        26.381507783137,
        26.3104597696893,
        null,
        null,
      ],
      1: [
        26.4296036564514,
        26.417024922246,
        26.3925182662311,
        26.3481938540263,
        26.276521087278,
        null,
        null,
      ],
      2: [
        26.4041461093592,
        26.3917531550077,
        26.3675651588378,
        26.3237733392453,
        26.2527211887415,
        null,
        null,
      ],
      3: [
        26.3588563040193,
        26.3467507834888,
        26.3230866996984,
        26.279888952864,
        26.2101579813032,
        null,
        null,
      ],
      4: [
        26.2862834981665,
        26.2745095211558,
        26.2514556485153,
        26.2095703854327,
        26.1415850313436,
        null,
        null,
      ],
      5: [
        26.1784703938606,
        26.1672498317292,
        26.1452111856164,
        26.105031722,
        26.0399245750338,
        null,
        null,
      ],
      6: [null, null, null, null, null, null, null],
    },
    14: {
      0: [
        26.462525372688,
        26.4499865841935,
        26.4255718427519,
        26.381507783137,
        26.3104597696893,
        null,
        null,
      ],
      1: [
        26.4296036564514,
        26.417024922246,
        26.3925182662311,
        26.3481938540263,
        26.276521087278,
        null,
        null,
      ],
      2: [
        26.4041461093592,
        26.3917531550077,
        26.3675651588378,
        26.3237733392453,
        26.2527211887415,
        null,
        null,
      ],
      3: [
        26.3588563040193,
        26.3467507834888,
        26.3230866996984,
        26.279888952864,
        26.2101579813032,
        null,
        null,
      ],
      4: [
        26.2862834981665,
        26.2745095211558,
        26.2514556485153,
        26.2095703854327,
        26.1415850313436,
        null,
        null,
      ],
      5: [
        26.1784703938606,
        26.1672498317292,
        26.1452111856164,
        26.105031722,
        26.0399245750338,
        null,
        null,
      ],
      6: [null, null, null, null, null, null, null],
    },
    15: {
      0: [
        26.462525372688,
        26.4499865841935,
        26.4255718427519,
        26.381507783137,
        26.3104597696893,
        null,
        null,
      ],
      1: [
        26.4296036564514,
        26.417024922246,
        26.3925182662311,
        26.3481938540263,
        26.276521087278,
        null,
        null,
      ],
      2: [
        26.4041461093592,
        26.3917531550077,
        26.3675651588378,
        26.3237733392453,
        26.2527211887415,
        null,
        null,
      ],
      3: [
        26.3588563040193,
        26.3467507834888,
        26.3230866996984,
        26.279888952864,
        26.2101579813032,
        null,
        null,
      ],
      4: [
        26.2862834981665,
        26.2745095211558,
        26.2514556485153,
        26.2095703854327,
        26.1415850313436,
        null,
        null,
      ],
      5: [
        26.1784703938606,
        26.1672498317292,
        26.1452111856164,
        26.105031722,
        26.0399245750338,
        null,
        null,
      ],
      6: [null, null, null, null, null, null, null],
    },
    16: {
      0: [
        26.462525372688,
        26.4499865841935,
        26.4255718427519,
        26.381507783137,
        null,
        null,
        null,
      ],
      1: [
        26.4296036564514,
        26.417024922246,
        26.3925182662311,
        26.3481938540263,
        null,
        null,
        null,
      ],
      2: [
        26.4041461093592,
        26.3917531550077,
        26.3675651588378,
        26.3237733392453,
        null,
        null,
        null,
      ],
      3: [
        26.3588563040193,
        26.3467507834888,
        26.3230866996984,
        26.279888952864,
        null,
        null,
        null,
      ],
      4: [
        26.2862834981665,
        26.2745095211558,
        26.2514556485153,
        26.2095703854327,
        null,
        null,
        null,
      ],
      5: [
        26.1784703938606,
        26.1672498317292,
        26.1452111856164,
        26.105031722,
        null,
        null,
        null,
      ],
      6: [null, null, null, null, null, null, null],
    },
    17: {
      0: [
        26.462525372688,
        26.4499865841935,
        26.4255718427519,
        26.381507783137,
        null,
        null,
        null,
      ],
      1: [
        26.4296036564514,
        26.417024922246,
        26.3925182662311,
        26.3481938540263,
        null,
        null,
        null,
      ],
      2: [
        26.4041461093592,
        26.3917531550077,
        26.3675651588378,
        26.3237733392453,
        null,
        null,
        null,
      ],
      3: [
        26.3588563040193,
        26.3467507834888,
        26.3230866996984,
        26.279888952864,
        null,
        null,
        null,
      ],
      4: [
        26.2862834981665,
        26.2745095211558,
        26.2514556485153,
        26.2095703854327,
        null,
        null,
        null,
      ],
      5: [
        26.1784703938606,
        26.1672498317292,
        26.1452111856164,
        26.105031722,
        null,
        null,
        null,
      ],
      6: [null, null, null, null, null, null, null],
    },
    18: {
      0: [
        26.462525372688,
        26.4499865841935,
        26.4255718427519,
        26.381507783137,
        null,
        null,
        null,
      ],
      1: [
        26.4296036564514,
        26.417024922246,
        26.3925182662311,
        26.3481938540263,
        null,
        null,
        null,
      ],
      2: [
        26.4041461093592,
        26.3917531550077,
        26.3675651588378,
        26.3237733392453,
        null,
        null,
        null,
      ],
      3: [
        26.3588563040193,
        26.3467507834888,
        26.3230866996984,
        26.279888952864,
        null,
        null,
        null,
      ],
      4: [
        26.2862834981665,
        26.2745095211558,
        26.2514556485153,
        26.2095703854327,
        null,
        null,
        null,
      ],
      5: [
        26.1784703938606,
        26.1672498317292,
        26.1452111856164,
        26.105031722,
        null,
        null,
        null,
      ],
      6: [null, null, null, null, null, null, null],
    },
    19: {
      0: [
        26.462525372688,
        26.4499865841935,
        26.4255718427519,
        26.381507783137,
        null,
        null,
        null,
      ],
      1: [
        26.4296036564514,
        26.417024922246,
        26.3925182662311,
        26.3481938540263,
        null,
        null,
        null,
      ],
      2: [
        26.4041461093592,
        26.3917531550077,
        26.3675651588378,
        26.3237733392453,
        null,
        null,
        null,
      ],
      3: [
        26.3588563040193,
        26.3467507834888,
        26.3230866996984,
        26.2798890774106,
        null,
        null,
        null,
      ],
      4: [
        26.2862834981665,
        26.2745095211558,
        26.2514556485153,
        26.2095703854292,
        null,
        null,
        null,
      ],
      5: [
        26.1784703938606,
        26.1672498317292,
        26.1452111856164,
        26.105031722,
        null,
        null,
        null,
      ],
      6: [null, null, null, null, null, null, null],
    },
    20: {
      0: [
        26.462525372688,
        26.4499865841935,
        26.4255718427519,
        26.381507783137,
        null,
        null,
        null,
      ],
      1: [
        26.4296036564514,
        26.417024922246,
        26.3925182662311,
        26.3481938540263,
        null,
        null,
        null,
      ],
      2: [
        26.4041461093592,
        26.3917531550077,
        26.3675651588378,
        26.3237733392453,
        null,
        null,
        null,
      ],
      3: [
        26.3588563040193,
        26.3467507834888,
        26.3230866996984,
        26.2913793199405,
        null,
        null,
        null,
      ],
      4: [
        26.2862834981665,
        26.2745095211558,
        26.2514556485153,
        26.2095703988035,
        null,
        null,
        null,
      ],
      5: [
        26.1784703938606,
        26.1672498317292,
        26.1452111856164,
        26.105031722,
        null,
        null,
        null,
      ],
      6: [null, null, null, null, null, null, null],
    },
  },
}

export const transitionPlanRates = {
  bands: {
    age: [
      [18, 25],
      [26, 30],
      [31, 35],
      [36, 40],
      [41, 45],
      [46, 50],
      [51, 55],
      [56, 60],
      [61, 65],
      [66, 70],
      [71, 75],
      [76, 80],
      [81, 85],
      [86, 90],
      [91, 95],
      [96, 100],
    ],
  },
  covers: [10000, 15000, 20000, 25000, 30000, 50000, 70000, 100000],
  mainLife: {
    10000: [
      20.37, 20.95, 21.96, 23.76, 26.68, 31.14, 37.63, 47.12, 60.87, 80.68,
      109.35, 150.62, 209.73, 293.15, 416.2, 649.91,
    ],
    15000: [
      21.37, 22.23, 23.7, 26.3, 30.6, 37.15, 46.74, 60.65, 80.74, 109.8, 151.83,
      212.41, 299.33, 422.47, 603.56, 945.5,
    ],
    20000: [
      22.4, 23.52, 25.46, 28.91, 34.61, 43.28, 55.91, 74.26, 100.83, 139.21,
      194.76, 274.86, 389.39, 551.7, 790.86, 1241.55,
    ],
    25000: [
      23.43, 24.82, 27.24, 31.54, 38.65, 49.47, 65.21, 87.94, 120.79, 168.5,
      237.6, 337.12, 479.47, 681.23, 978.58, 1538.18,
    ],
    30000: [
      24.44, 26.11, 29.03, 34.21, 42.71, 55.66, 74.52, 101.7, 140.99, 197.86,
      280.22, 399.03, 569.0, 809.9, 1164.99, 1832.99,
    ],
    50000: [
      28.62, 31.42, 36.35, 45.08, 59.3, 80.75, 111.84, 156.65, 221.39, 315.15,
      451.01, 647.16, 927.98, 1326.18, 1913.56, 3016.26,
    ],
    70000: [
      32.82, 36.81, 43.83, 56.17, 76.05, 105.92, 149.22, 211.66, 301.89, 432.63,
      622.15, 895.85, 1287.79, 1843.63, 2663.64, 4201.71,
    ],
    100000: [
      39.14, 45.01, 55.21, 72.91, 101.26, 143.74, 205.51, 294.63, 423.28,
      609.69, 879.95, 1270.27, 1829.26, 2622.07, 3791.63, 5977.61,
    ],
  },
}

export const personalAccidentRates = {
  bands: {
    age: [
      [18, 25],
      [26, 30],
      [31, 35],
      [36, 40],
      [41, 45],
      [46, 50],
      [51, 55],
    ],
  },
  mainLife: {
    5: [
      0.531430753675874, 0.531813702110151, 0.57820644038779, 0.701318370571894,
      0.886506370357325, 1.16608606025304, 1.3815708173855,
    ],
    6: [
      0.393532506828866, 0.395701486766574, 0.433471003351342,
      0.526905737457548, 0.670418076071963, 0.882524561079886, 1.2156400568948,
    ],
    7: [
      0.348919974543217, 0.352055757618793, 0.387692187608708,
      0.472272239364901, 0.602699962798792, 0.790862870766059, 1.16096229465685,
    ],
    8: [
      0.319369945814132, 0.323087914809296, 0.357197151695869,
      0.436136531987905, 0.557576219082296, 0.728985074318369, 1.12409963289722,
    ],
    9: [
      0.293533978838599, 0.29758973823383, 0.330015423612319, 0.403884397015079,
      0.517028985498029, 0.673795274992519, 1.09163718684434,
    ],
    10: [
      0.280565657455918, 0.284934948034339, 0.316648142480023,
      0.388221846148735, 0.497224377310875, 0.645714117099177, 1.07482205452436,
    ],
    11: [
      0.271352151625559,
      0.276102934376427,
      0.307258259301415,
      0.377249900365656,
      0.483270364651283,
      0.637680032455028,
      null,
    ],
    12: [
      0.262998672128427,
      0.267872342354965,
      0.298443704383632,
      0.366798722752668,
      0.469853922375001,
      0.630007739210099,
      null,
    ],
    13: [
      0.258009981162868,
      0.262919677301985,
      0.29316849572093,
      0.360518806144127,
      0.461673444201363,
      0.625308067635562,
      null,
    ],
    14: [
      0.254227920198109,
      0.259125239729835,
      0.289059878223137,
      0.355593232853252,
      0.455243171613804,
      0.621628636172606,
      null,
    ],
    15: [
      0.251014547055659,
      0.255922498656557,
      0.285559651648105,
      0.351335675285717,
      0.449691454613741,
      0.618463099847882,
      null,
    ],
    16: [
      0.249022830216746,
      0.253945028611425,
      0.283413697830715,
      0.34871561719692,
      0.448211343867945,
      null,
      null,
    ],
    17: [
      0.247548011454847,
      0.252482729941304,
      0.281822774393319,
      0.346757233907893,
      0.447102759433534,
      null,
      null,
    ],
    18: [
      0.246323926100728,
      0.251267795909982,
      0.280492314327385,
      0.345109410193755,
      0.446170540900506,
      null,
      null,
    ],
    19: [
      0.245541126902637,
      0.250496077978929,
      0.279649193737306,
      0.344053858368918,
      0.445570140958212,
      null,
      null,
    ],
    20: [
      0.244962637391052,
      0.249927885466754,
      0.279027164663657,
      0.343268279219464,
      0.445122332941988,
      null,
      null,
    ],
  },
}

export const funeralCoverRates = {
  term10: {
    bands: {
      age: [
        [1, 5],
        [6, 10],
        [11, 15],
        [16, 20],
        [21, 25],
        [26, 30],
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
        [56, 60],
        [61, 65],
        [66, 70],
        [71, 75],
        [76, 80],
        [81, 85],
        [86, 90],
        [91, 95],
        [96, 100],
        [101, 105],
        [106, 110],
        [111, 115],
        [116, 120],
      ],
    },
    covers: [
      5000, 7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 60000, 70000,
      80000, 90000, 100000, 120000, 140000, 160000, 180000, 200000,
    ],
    deathBenefit: {
      5000: [
        28.6081106785037, 28.5634514226916, 28.5765304500807, 28.6023214993804,
        28.7002860363803, 29.0701841878498, 31.7848923500145, 34.7854161310028,
        41.0114127351326, 44.3995209756644, 57.5944922903732, 57.8681956442521,
        59.4857674693186, 67.8333333333333, 79.75, 95.3333333333333,
        139.034615284729, 171.877437792932, 214.573107053597, 321.632511595696,
        577.072655285042, 744.14529457332, 744.359633020038, 744.359633020038,
      ],
      7500: [
        29.5069224515216, 29.4907215685743, 29.4957337627832, 29.5349029380688,
        29.6723470136732, 30.2347883597884, 33.2328855159868, 36.9910319527856,
        44.7989464797462, 50.1863827703952, 67.8333333333333, 69.6938280274583,
        73.9564516516116, 85.25, 103.583333333333, 126.5, 189.393609797308,
        238.657843559613, 303.248727825747, 466.359241788717, 829.025547011756,
        1061.11952939997, 1061.1316476027, 1061.1316476027,
      ],
      10000: [
        30.4527293596269, 30.4339337809648, 30.4402808858462, 30.4935648123528,
        30.8333333333333, 31.7096560846561, 34.7432425513904, 39.2484675184966,
        48.6364583210037, 55.9757541977573, 78.8333333333333, 81.7132812390927,
        88.5367886398427, 102.666666666667, 127.416666666667, 158.282497787085,
        239.752604309887, 304.34348857602, 390.829587847623, 611.162340169092,
        1082.06396803999, 1380.47918891115, 1380.47925102674, 1380.47925102674,
      ],
      15000: [
        32.3640010768226, 32.3365422009794, 32.346689164776, 32.4287827520922,
        33.0357142857143, 33.9219576719577, 37.8094512977753, 43.7480967873521,
        56.2587922756657, 67.6700683519608, 101.75, 105.701053067288,
        117.837872260422, 140.585100286736, 174.166666666667, 225.293880469321,
        339.375832584771, 437.904300109382, 567.086068641649, 901.021782275273,
        1584.3308066318, 2011.28932407536, 2011.28932896378, 2011.28932896378,
      ],
      20000: [
        34.1749631893086, 34.1396325292642, 34.1532655717538, 34.3055377758481,
        34.7253992879691, 36.8716931216931, 40.8396660616722, 48.2938234765663,
        64.0086206896552, 80.4761904761905, 124.666666666667, 129.476210803808,
        147.016092770718, 178.753979473457, 222.473614684173, 292.473603224068,
        438.999060859655, 570.37035089247, 742.247788685402, 1190.62175367354,
        2091.31964928204, 2651.88392085492, 2651.88392088861, 2651.88392088861,
      ],
      25000: [
        36.0673410924899, 36.0234550936219, 36.0408455887444, 36.1816306971965,
        36.7063492063492, 39.0839947089947, 44.4444444444444, 53.25,
        72.7011494252874, 93.6309523809524, 147.583333333333, 153.592921137031,
        176.248116515714, 216.572716349394, 271.411390746644, 359.403608985165,
        539.717049884813, 702.836401675558, 918.728029116146, 1480.68273768054,
        2593.09612271213, 3281.46053760841, 3281.46053761027, 3281.46053761027,
      ],
      30000: [
        37.967638213484, 37.9151006353166, 37.9362882865069, 38.1007421868714,
        38.9087301587302, 42.0337301587302, 47.4074074074074, 59.25,
        81.3936781609195, 106.785714285714, 170.5, 177.654808229891,
        205.627778202736, 254.845732352184, 321.008656153413, 426.472142863223,
        639.340278159697, 835.302452458646, 1096.42159338403, 1769.06667904275,
        3098.76062632352, 3920.98104765074, 3920.9810476508, 3920.9810476508,
      ],
      40000: [
        41.8147046677962, 41.7445366294938, 41.7734578776786, 41.9964246666338,
        43.3134920634921, 47.1957671957672, 54.8148148148148, 69.75,
        99.5689655172414, 133.095238095238, 217.25, 225.670154523919,
        264.22201272251, 331.124526119932, 419.829065293411, 560.914937147422,
        839.68149545974, 1101.3293147751, 1454.0992038903, 2349.54072573438,
        4109.81464008601, 5194.68109798108, 5194.68109798108, 5194.68109798108,
      ],
      50000: [
        45.6108124175255, 45.5233762251667, 45.5598747462432, 45.8397596570496,
        47.718253968254, 52.3578042328042, 61.4814814814815, 80.25,
        116.954022988506, 159.404761904762, 263.083333333333, 273.32659670143,
        322.285597833297, 406.583804168331, 518.116223801602, 695.308103324447,
        1040.02271275978, 1367.35617709154, 1811.60107534292, 2929.71484518599,
        5113.11624796592, 6453.26519735666, 6453.26519735667, 6453.26519735667,
      ],
      60000: [
        49.4046602195509, 49.2999885661561, 49.3440498572838, 49.6807322217696,
        50.822478783891, 53.9376936740131, 65.0352721188691, 84.4140304966579,
        125.399777419575, 173.258844982154, 279.005238766662, 321.53666023853,
        381.145899341175, 483.244451610341, 616.85841829348, 828.887842474839,
        1210.60161037409, 1611.51299639554, 2166.91927936142, 3506.42920896652,
        6124.59895314595, 7732.66548166529, 7732.66548166529, 7732.66548166529,
      ],
      70000: [
        53.1976862630946, 53.0757914873142, 53.1274101033861, 53.5208806830864,
        54.8546495737775, 58.4729810995502, 71.1038313182854, 93.5092190352286,
        140.677782428996, 196.602656336934, 319.388507266724, 369.648750192264,
        439.867181294267, 559.698505055837, 715.874255916013, 963.581248927526,
        1409.10029981473, 1877.08376659509, 2525.21055350881, 4087.84532813978,
        7137.33277554067, 9008.5383572151, 9008.5383572151, 9008.5383572151,
      ],
      80000: [
        56.9901275750879, 56.8510179405643, 56.910190248798, 57.3606605761954,
        58.8863506550897, 63.0077795742845, 77.1711498782114, 102.582997263505,
        156.134352792924, 219.980089617258, 359.168738127659, 416.882101796203,
        498.070183459763, 636.018700647164, 814.730297756197, 1098.07084305563,
        1607.28382476383, 2142.23870468335, 2882.94311161826, 4668.36871296129,
        8132.4894844072, 10250.3932764007, 10250.3932764007, 10250.3932764007,
      ],
      90000: [
        60.7821322562922, 60.6258136419295, 60.6925370689849, 61.199972112186,
        62.9176965148089, 67.5420373945547, 83.237040684088, 111.652620163469,
        171.549259960355, 243.494544001784, 399.6541481423, 465.217876184045,
        556.465181703163, 711.41263918394, 912.392918103384, 1230.87004017183,
        1802.9077898198, 2404.00833581389, 3236.13873902168, 5241.58617964027,
        9145.04241075769, 11536.4607993011, 11536.4607993011, 11536.4607993011,
      ],
      100000: [
        64.5738041966467, 64.400300335572, 64.474754390274, 65.0391244636851,
        66.9487906701257, 72.0758897123527, 89.3023541016733, 120.720190239538,
        186.956565009577, 267.000872450366, 440.048697003473, 513.333353897383,
        615.153587718062, 787.805772951173, 1011.32478892935, 1365.41207599421,
        2001.19955203318, 2669.39663391411, 3594.28861881461, 5822.9659755291,
        10159.559611268, 12815.8498296328, 12815.8498296328, 12815.8498296328,
      ],
      120000: [
        81.2080444158185, 80.9829870318519, 81.0684232569419, 81.746146611774,
        84.0639328079507, 90.2056884074038, 111.238496911971, 149.643202146381,
        230.620518826633, 329.634425759824, 544.530788897716, 634.800121764381,
        760.085704805917, 974.566346373305, 1357.35214421752, 1869.82395795487,
        2685.17976955015, 3653.84877950002, 5043.00535409706, 8587.85898358941,
        19528.3036513545, 27757.425681473, 27757.425681473, 27757.425681473,
      ],
      140000: [
        90.2321932213149, 89.9702889696418, 90.0699078916709, 90.8590269790937,
        93.5578800796649, 100.825315590649, 125.127753333767, 169.815852321012,
        264.072642410698, 379.920170507888, 630.373848535252, 736.480258751592,
        883.513486419579, 1133.37636840421, 1580.62727520347, 2178.8567315734,
        3128.86390391378, 4259.94680543055, 5884.23876868859, 10017.1145648051,
        22793.5564948219, 32412.4938284019, 32412.4938284019, 32412.4938284019,
      ],
      160000: [
        99.3431594201798, 99.0438125967141, 99.1578608387134, 100.060823521816,
        103.148071788736, 111.447998426373, 139.011116229658, 189.744443447079,
        296.67668553904, 428.761223306027, 714.569849195768, 837.065607767226,
        1005.68884648812, 1291.84298585066, 1803.28884622146, 2487.30272255691,
        3573.21294880996, 4866.30313647515, 6723.04805206592, 11446.6131742388,
        26048.9172010527, 37042.537924782, 37042.537924782, 37042.537924782,
      ],
      180000: [
        108.452615981927, 108.115837995525, 108.244321309781, 109.261229278955,
        112.737020557562, 122.065572354182, 152.847249938711, 209.764968596728,
        329.823658088241, 478.795141541634, 799.144668118367, 936.484233234825,
        1126.39772841437, 1448.37651187126, 2023.13434329396, 2791.71781482462,
        4011.60162856941, 5464.18997828555, 7549.9789563461, 12856.8970894374,
        29261.7071582929, 41612.0685413291, 41612.0685413291, 41612.0685413291,
      ],
      200000: [
        117.55967411059, 117.185392593006, 117.328140425985, 118.458553030154,
        122.322322933482, 132.678580655709, 166.676494214624, 229.778988712838,
        362.898396905417, 528.565168732117, 884.077961376309, 1037.11764657301,
        1248.62653362534, 1606.91738518765, 2245.91029759405, 3100.38923520123,
        4456.35653439325, 6070.96329000187, 8389.45361352333, 14288.6013366343,
        32523.3327575602, 46251.2024196714, 46251.2024196714, 46251.2024196714,
      ],
    },
  },
  term15: {
    bands: {
      age: [
        [1, 5],
        [6, 10],
        [11, 15],
        [16, 20],
        [21, 25],
        [26, 30],
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
        [56, 60],
        [61, 65],
        [66, 70],
        [71, 75],
        [76, 80],
        [81, 85],
        [86, 90],
        [91, 95],
        [96, 100],
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
      ],
    },
    covers: [
      5000, 7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 60000, 70000,
      80000, 90000, 100000, 120000, 140000, 160000, 180000, 200000,
    ],
    deathBenefit: {
      5000: [
        26.6666666666667,
        26.6666666666667,
        26.6666666666667,
        26.6666666666667,
        27.5,
        27.5,
        28.3333333333333,
        30.0,
        32.5,
        36.6666666666667,
        45.2774263425336,
        46.0706625490024,
        48.2053050399321,
        53.4785518395968,
        63.6004704368865,
        80.8963688882019,
        113.943735173861,
        150.536238566118,
        202.29009923455,
        321.590880031253,
        null,
        null,
        null,
        null,
      ],
      7500: [
        27.5,
        27.5,
        27.5,
        27.5,
        28.3333333333333,
        28.3333333333333,
        30.0,
        32.5,
        35.8333333333333,
        41.6666666666667,
        53.2287454600747,
        55.6738144501659,
        60.1414002396292,
        69.3351878675964,
        84.7389832958572,
        110.631247229164,
        159.304340824642,
        213.90719606237,
        290.591893658748,
        466.349715756897,
        null,
        null,
        null,
        null,
      ],
      10000: [
        28.3333333333333,
        28.3333333333333,
        28.3333333333333,
        28.3333333333333,
        29.1666666666667,
        30.0,
        31.6666666666667,
        34.1666666666667,
        40.0,
        47.5,
        61.2460189984397,
        65.404427670234,
        72.1415065460583,
        85.2154206009084,
        105.973059921643,
        140.573974954053,
        205.066472300986,
        277.430793670932,
        378.849833032703,
        611.15004966903,
        null,
        null,
        null,
        null,
      ],
      15000: [
        30.0,
        30.0,
        30.0,
        30.0,
        30.8333333333333,
        31.6666666666667,
        34.1666666666667,
        39.1666666666667,
        46.6666666666667,
        58.3333333333333,
        77.2641888781468,
        84.8171276450707,
        96.2689049370002,
        117.052885587037,
        148.262481309782,
        200.290537938458,
        296.35006989587,
        404.407680729606,
        555.573499200418,
        901.003780322797,
        null,
        null,
        null,
        null,
      ],
      20000: [
        31.6666666666667,
        31.6666666666667,
        31.6666666666667,
        31.6666666666667,
        32.5,
        34.1666666666667,
        37.5,
        43.3333333333333,
        54.1666666666667,
        70.0,
        93.1754425100371,
        104.164938924999,
        120.410832635817,
        149.011319155369,
        190.865741101875,
        260.17494877364,
        387.549095786448,
        531.26297928307,
        732.139301856529,
        1190.59804702492,
        null,
        null,
        null,
        null,
      ],
      25000: [
        33.3333333333333,
        33.3333333333333,
        33.3333333333333,
        33.3333333333333,
        34.1666666666667,
        36.6666666666667,
        40.8333333333333,
        48.3333333333333,
        61.6666666666667,
        80.8333333333333,
        109.283016860633,
        123.579474997952,
        144.369631413551,
        180.82002193549,
        233.372536975801,
        320.063695284916,
        478.922945820127,
        658.347229878253,
        908.993966247284,
        1480.65331834489,
        null,
        null,
        null,
        null,
      ],
      30000: [
        35.0,
        35.0,
        35.0,
        35.0,
        36.6666666666667,
        39.1666666666667,
        43.3333333333333,
        52.5,
        68.3333333333333,
        91.6666666666667,
        125.36350075013,
        143.065652949682,
        168.580957470598,
        212.69403103361,
        275.685273710352,
        379.624673535556,
        569.724592482963,
        784.660801103846,
        1084.82289325718,
        1769.03157555532,
        null,
        null,
        null,
        null,
      ],
      40000: [
        38.3333333333333,
        37.5,
        38.3333333333333,
        38.3333333333333,
        40.0,
        43.3333333333333,
        50.0,
        61.6666666666667,
        83.3333333333333,
        114.166666666667,
        157.5,
        181.944034991985,
        216.851900431467,
        276.54431630396,
        360.742720766471,
        499.479736087731,
        752.589215565656,
        1038.98598441133,
        1438.74911833031,
        2349.4941891538,
        null,
        null,
        null,
        null,
      ],
      50000: [
        40.8333333333333,
        40.8333333333333,
        41.6666666666667,
        41.6666666666667,
        44.1666666666667,
        47.5,
        55.8333333333333,
        70.8333333333333,
        97.5,
        136.666666666667,
        190.833333333333,
        220.491363312479,
        264.947681097151,
        340.400386635247,
        445.790332044206,
        619.294992575532,
        935.387320841292,
        1293.20406332754,
        1792.50095418776,
        2929.65688411899,
        null,
        null,
        null,
        null,
      ],
      60000: [
        41.6176559749625,
        41.587783595945,
        42.1729599569128,
        42.3211669247359,
        44.4460880272687,
        47.8611830409763,
        57.3235489531129,
        74.2897086318486,
        99.7723215186212,
        137.258166615228,
        221.590354724967,
        259.556475411943,
        313.160667632868,
        403.868269721601,
        530.33477166075,
        738.344448693008,
        1116.95023646182,
        1545.78409902523,
        2144.08534291543,
        3506.35988129233,
        null,
        null,
        null,
        null,
      ],
      70000: [
        42.4019786165916,
        42.3422338585567,
        42.6792532471589,
        42.9756671828051,
        44.7255093878708,
        48.2223660819526,
        58.8137645728925,
        77.7460839303639,
        112.100421245499,
        155.976220054588,
        253.768986744527,
        298.533268107174,
        361.551224246969,
        467.877297296652,
        615.576571054206,
        858.441277800807,
        1300.17360346771,
        1800.56474437943,
        2498.6181721043,
        4087.76454843087,
        null,
        null,
        null,
        null,
      ],
      80000: [
        43.1863012582208,
        43.0966841211684,
        43.185546537405,
        43.6301674408743,
        45.0049307484728,
        48.5835491229289,
        60.3039801926721,
        81.2024592288791,
        124.399397854763,
        174.457462543397,
        285.744015605477,
        337.453125583355,
        409.86844663887,
        531.784416259489,
        700.68674126998,
        978.354088776212,
        1483.10992513707,
        2054.9582828332,
        2852.60528027212,
        4668.276500556,
        null,
        null,
        null,
        null,
      ],
      90000: [
        46.015702541629,
        45.9150291566748,
        46.0151849248828,
        46.5157992534965,
        48.0634262162883,
        52.0866852087685,
        65.0989068876883,
        88.4738656010573,
        136.791384480339,
        193.189022310784,
        317.67893942597,
        375.899244895531,
        457.56006798525,
        594.80405439696,
        784.695493215722,
        1096.68228704201,
        1663.60203675471,
        2306.07208686105,
        3202.08683016181,
        5241.48266835369,
        null,
        null,
        null,
        null,
      ],
      100000: [
        48.8448949847579,
        48.7331363665063,
        48.8445764836011,
        49.4011993346549,
        51.1216326626404,
        55.5893654282467,
        69.8966238664802,
        95.7475590268997,
        149.182174419181,
        211.919049803103,
        349.854022857309,
        414.850702802556,
        505.910209176714,
        658.754310079778,
        869.863184943664,
        1216.63282448847,
        1846.60081474968,
        2560.66343069498,
        3556.47990198333,
        5822.85102046871,
        null,
        null,
        null,
        null,
      ],
      120000: [
        61.13585418584,
        60.9882016250501,
        61.1169869236214,
        61.7801113961859,
        63.852329920889,
        69.3018063364202,
        86.8365933145416,
        118.347440372545,
        183.629099498812,
        261.296085012239,
        432.63991456752,
        512.891603638611,
        625.372393887974,
        815.017211163958,
        1163.43609316478,
        1658.27047622872,
        2476.13667351398,
        3505.60909398548,
        4990.99403823393,
        8587.69690634659,
        null,
        null,
        null,
        null,
      ],
      140000: [
        67.8507407089291,
        67.678831135123,
        67.8287624397348,
        68.5999714590308,
        71.0117133290026,
        77.3436311442148,
        97.5877677765684,
        134.210180200349,
        209.974679815146,
        300.622901775275,
        499.815208956895,
        593.83777862119,
        725.447001975046,
        947.036016595117,
        1354.72708586375,
        1932.20914715538,
        2885.36412796005,
        4087.27737682837,
        5823.67753713149,
        10016.9255690395,
        null,
        null,
        null,
        null,
      ],
      160000: [
        74.6327489702951,
        74.4361718605148,
        74.6076463583096,
        75.4894035633626,
        78.2465394615179,
        85.4747106169861,
        108.390836012703,
        149.97250786511,
        235.980523107402,
        339.775511476358,
        567.171982842769,
        675.02922597797,
        825.858026812844,
        1079.53895210335,
        1545.66935878161,
        2205.84612809746,
        3295.24921805676,
        4669.13717323303,
        6653.87693674871,
        11446.3976090017,
        null,
        null,
        null,
        null,
      ],
      180000: [
        81.4151052221558,
        81.1940109148234,
        81.3867188844315,
        82.3785582617368,
        85.4808076869803,
        93.6047871634035,
        119.1928481595,
        165.854650399524,
        262.450211547927,
        378.978544153931,
        633.688534899323,
        755.169973721993,
        924.926312858831,
        1210.21038703985,
        1733.87922041196,
        2475.49403414649,
        3699.12258280835,
        5242.32956320276,
        7472.04976164331,
        12856.6547926985,
        null,
        null,
        null,
        null,
      ],
      200000: [
        88.1966024774408,
        87.9508483947277,
        88.1648293353713,
        89.2667143797964,
        92.7133909856163,
        101.731861273618,
        129.876580742053,
        181.612267797835,
        288.868107952661,
        418.43249971162,
        701.096158595399,
        836.417972617131,
        1025.40315806429,
        1342.79551027699,
        1924.91007300738,
        2749.25859622026,
        4109.22015336991,
        5824.58610992647,
        8303.00957277969,
        14288.3318880387,
        null,
        null,
        null,
        null,
      ],
    },
  },
}

export const funeralExtrasRates = {
  term10: {
    memorialOneYear: {
      bands: {
        age: [
          [1, 5],
          [6, 10],
          [11, 15],
          [16, 20],
          [21, 25],
          [26, 30],
          [31, 35],
          [36, 40],
          [41, 45],
          [46, 50],
          [51, 55],
          [56, 60],
          [61, 65],
          [66, 70],
          [71, 75],
          [76, 80],
          [81, 85],
          [86, 90],
          [91, 95],
          [96, 100],
          [101, 105],
          [106, 110],
          [111, 115],
          [116, 120],
        ],
      },
      covers: [
        5000, 7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 60000,
        70000, 80000, 90000, 100000, 120000, 140000, 160000, 180000, 200000,
      ],
      rates: {
        5000: [
          2.0, 2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 4.0, 6.0, 8.0, 12.0, 13.0, 14.0,
          20.0, 26.0, 35.0, 47.1133163175451, 63.0475907159727,
          85.0747698615938, 138.046954851074, 240.361529243523,
          302.915518928566, 303.077150749926, 303.077150749926,
        ],
        7500: [
          2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 4.0, 5.0, 8.0, 12.0, 18.0, 19.0, 21.0,
          29.0, 39.0, 52.0, 70.6506920288899, 94.5302175491532,
          127.543915757552, 206.989906798439, 360.512455249049,
          454.154898842075, 454.155782938668, 454.155782938668,
        ],
        10000: [
          3.0, 3.0, 3.0, 3.0, 3.0, 4.0, 5.0, 7.0, 11.0, 16.0, 24.0, 25.0, 27.0,
          39.0, 52.0, 69.0, 94.1836119693892, 126.018226179322,
          170.030708631337, 275.944636103848, 480.613964503121,
          605.453010590957, 605.453017651603, 605.453017651603,
        ],
        15000: [
          4.0, 4.0, 4.0, 4.0, 4.0, 5.0, 7.0, 10.0, 16.0, 24.0, 35.0, 38.0, 41.0,
          58.0, 78.0, 103.0, 141.301071124938, 189.05992636295,
          255.087098273798, 413.978941723503, 721.024289564734,
          908.307726383016, 908.307726422132, 908.307726422132,
        ],
        20000: [
          5.0, 5.0, 5.0, 5.0, 6.0, 7.0, 9.0, 13.0, 21.0, 31.0, 47.0, 50.0, 54.0,
          77.0, 103.0, 137.0, 188.36722085729, 252.036447475355,
          340.061410580414, 551.889264793809, 961.227923922, 1210.90600463983,
          1210.90600464014, 1210.90600464014,
        ],
        25000: [
          6.0, 6.0, 6.0, 6.0, 7.0, 8.0, 11.0, 16.0, 26.0, 39.0, 58.0, 63.0,
          68.0, 96.0, 129.0, 171.0, 235.529003106049, 315.133397615507,
          425.187033763089, 690.028578975698, 1200.01989299251,
          1510.39078790814, 1510.39078790816, 1510.39078790816,
        ],
        30000: [
          7.0, 7.0, 7.0, 7.0, 8.0, 10.0, 13.0, 20.0, 31.0, 47.0, 70.0, 75.0,
          81.0, 115.0, 155.0, 205.0, 282.359013562066, 377.802104822838,
          509.760960679593, 827.313613857707, 1440.89574014026,
          1815.13113115893, 1815.13113115893, 1815.13113115893,
        ],
        40000: [
          9.0, 9.0, 9.0, 10.0, 11.0, 13.0, 17.0, 26.0, 41.0, 62.0, 93.0, 100.0,
          108.0, 153.0, 206.0, 273.0, 376.732030938483, 504.069816566542,
          680.119034954359, 1103.77305038515, 1922.44646830215,
          2421.80007269563, 2421.80007269563, 2421.80007269563,
        ],
        50000: [
          11.0, 11.0, 11.0, 12.0, 13.0, 16.0, 22.0, 32.0, 51.0, 77.0, 116.0,
          125.0, 135.0, 192.0, 258.0, 341.0, 471.057999233219, 630.266787170615,
          850.374058330813, 1380.05714560952, 2400.03941658157,
          3020.78085210505, 3020.78085210505, 3020.78085210505,
        ],
        60000: [
          11.8393464065209, 11.8107484954557, 11.8236298616435,
          12.4194230286612, 13.2423019546547, 15.5533242024523,
          20.4168051373358, 29.3796109463238, 46.176932168272, 70.0469361521822,
          105.222298379861, 128.919412354012, 159.568854218882,
          228.416469617141, 295.851124535868, 402.418065292792,
          564.718026869003, 755.604209356632, 1019.52192103807, 1654.6272273,
          2881.79146789728, 3630.26223805517, 3630.26223805517,
          3630.26223805517,
        ],
        70000: [
          12.6786928130418, 12.6214969909113, 12.6472597232869,
          12.8388460573225, 13.4846039093095, 15.1066484049047,
          18.8336102746715, 26.7592218926475, 41.353864336544, 63.0938723043643,
          94.4445967597215, 132.838824708023, 186.287393387112,
          266.665714140615, 345.382459901029, 469.787364079436, 659.26293543752,
          882.095415439783, 1190.16808453749, 1931.53085551448,
          3364.13845584933, 4237.9596957945, 4237.9596957945, 4237.9596957945,
        ],
        80000: [
          14.4935224632251, 14.4281439664653, 14.4576049832031,
          14.6766164899717, 15.4148193701955, 17.269050685364, 21.5348526846636,
          30.5974311090914, 47.276160465043, 72.1261995163027, 107.965540913054,
          151.856719549481, 212.957484123713, 304.844985227722,
          394.828926877072, 537.049373767577, 753.655014186206,
          1008.37872407705, 1360.53629173, 2207.99259106045, 3845.6284470439,
          4844.50811778945, 4844.50811778945, 4844.50811778945,
        ],
        90000: [
          16.2838829714427, 16.2104134460123, 16.24347525866, 16.4895222320761,
          17.3187680117547, 19.4019542312563, 24.2142546281797,
          34.4266950966521, 53.1450892120473, 81.0327841149074,
          121.297007597099, 170.607738952127, 239.252051508193,
          342.479987819029, 443.580075125334, 603.350405641608,
          846.688415056135, 1132.88101980193, 1528.56714423879,
          2480.76526159835, 4320.78847977033, 5443.11889106528,
          5443.11889106528, 5443.11889106528,
        ],
        100000: [
          18.1023193263796, 18.0206651783537, 18.0574064191544,
          18.3307778207245, 19.2525351952608, 21.5684818143572,
          26.9115883567045, 38.2559223383969, 59.0709697874063,
          90.0806160254469, 134.83977501518, 189.655855586684, 265.957205441998,
          380.697931799247, 493.095664768179, 670.71462041523, 941.219877121441,
          1259.3844771696, 1699.25675131487, 2757.77947086777, 4803.31793564068,
          6051.01413441699, 6051.01413441699, 6051.01413441699,
        ],
        120000: [
          21.721327083581, 21.6233202303655, 21.6674225760228, 21.9956443821537,
          23.1018331515509, 25.880672936282, 32.2931197408507, 45.9105933656261,
          70.8853391827921, 108.088410390982, 161.794837267405,
          227.567411911348, 319.128032209945, 456.818238973264,
          591.685001252481, 804.813009290427, 1129.4030598179, 1511.16687234276,
          2038.99145903652, 3309.17528759768, 5763.68909493314,
          7260.83683443573, 7260.83683443573, 7260.83683443573,
        ],
        140000: [
          25.3574056842356, 25.2430140150031, 25.2945397321906,
          25.6777126682035, 26.96921231101, 30.2132854854672, 37.667217840743,
          53.5184494906013, 82.707709187453, 126.187686190524, 188.889101640568,
          265.677517241347, 372.574589757711, 533.331123920619, 690.76457107186,
          939.574268105895, 1318.52520198527, 1764.19000508724,
          2380.33517697314, 3863.06028819615, 6728.27873172636,
          8475.92479692397, 8475.92479692397, 8475.92479692397,
        ],
        160000: [
          28.9870451050101, 28.8562881114497, 28.9152101477413, 29.353233161876,
          30.8296387778104, 34.5381012683548, 43.0697053389801,
          61.1948622694811, 94.5523207530723, 144.252398483978,
          215.931080952243, 303.713437796994, 425.914966317285,
          609.689967396932, 789.657850303211, 1074.09874277866,
          1507.31002140669, 2016.75744012982, 2721.07257449954,
          4415.98516990104, 7691.25690920264, 9689.01628084816,
          9689.01628084816, 9689.01628084816,
        ],
        180000: [
          32.5677659662477, 32.4208269154015, 32.4869505411637,
          32.9790444881394, 34.6375360283526, 38.8039084489044,
          48.4285092498753, 68.8533901937641, 106.290178396815,
          162.065568156267, 242.594015076556, 341.215477727582,
          478.504102750944, 684.959975212604, 887.160149781128,
          1206.70081063283, 1693.37682915473, 2265.76203851354,
          3057.13428728107, 4961.53052160875, 8641.57696144816,
          10886.2377878856, 10886.2377878856, 10886.2377878856,
        ],
        200000: [
          36.2046386534223, 36.041330357371, 36.1148128390278, 36.661555642198,
          38.505070390667, 43.1369636282945, 53.8231767132067, 76.5118446767988,
          118.141939573999, 180.161232048714, 269.679550026431,
          379.311711167091, 531.914410873963, 761.395863582935,
          986.191329521106, 1341.42924081077, 1882.43975421237,
          2518.76895430534, 3398.51350259498, 5515.5589416906, 9606.63587133292,
          12102.0282689915, 12102.0282689915, 12102.0282689915,
        ],
      },
    },
    memorialFortyDay: {
      bands: {
        age: [
          [1, 5],
          [6, 10],
          [11, 15],
          [16, 20],
          [21, 25],
          [26, 30],
          [31, 35],
          [36, 40],
          [41, 45],
          [46, 50],
          [51, 55],
          [56, 60],
          [61, 65],
          [66, 70],
          [71, 75],
          [76, 80],
          [81, 85],
          [86, 90],
          [91, 95],
          [96, 100],
          [101, 105],
          [106, 110],
          [111, 115],
          [116, 120],
        ],
      },
      covers: [
        5000, 7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 60000,
        70000, 80000, 90000, 100000, 120000, 140000, 160000, 180000, 200000,
      ],
      rates: {
        5000: [
          2.0, 2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 4.0, 6.0, 8.0, 12.0, 13.0, 14.0,
          20.0, 26.0, 35.0, 47.1133163175451, 63.0475907159727,
          85.0747698615938, 138.046954851074, 240.361529243523,
          302.915518928566, 303.077150749926, 303.077150749926,
        ],
        7500: [
          2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 4.0, 5.0, 8.0, 12.0, 18.0, 19.0, 21.0,
          29.0, 39.0, 52.0, 70.6506920288899, 94.5302175491532,
          127.543915757552, 206.989906798439, 360.512455249049,
          454.154898842075, 454.155782938668, 454.155782938668,
        ],
        10000: [
          3.0, 3.0, 3.0, 3.0, 3.0, 4.0, 5.0, 7.0, 11.0, 16.0, 24.0, 25.0, 27.0,
          39.0, 52.0, 69.0, 94.1836119693892, 126.018226179322,
          170.030708631337, 275.944636103848, 480.613964503121,
          605.453010590957, 605.453017651603, 605.453017651603,
        ],
        15000: [
          4.0, 4.0, 4.0, 4.0, 4.0, 5.0, 7.0, 10.0, 16.0, 24.0, 35.0, 38.0, 41.0,
          58.0, 78.0, 103.0, 141.301071124938, 189.05992636295,
          255.087098273798, 413.978941723503, 721.024289564734,
          908.307726383016, 908.307726422132, 908.307726422132,
        ],
        20000: [
          5.0, 5.0, 5.0, 5.0, 6.0, 7.0, 9.0, 13.0, 21.0, 31.0, 47.0, 50.0, 54.0,
          77.0, 103.0, 137.0, 188.36722085729, 252.036447475355,
          340.061410580414, 551.889264793809, 961.227923922, 1210.90600463983,
          1210.90600464014, 1210.90600464014,
        ],
        25000: [
          6.0, 6.0, 6.0, 6.0, 7.0, 8.0, 11.0, 16.0, 26.0, 39.0, 58.0, 63.0,
          68.0, 96.0, 129.0, 171.0, 235.529003106049, 315.133397615507,
          425.187033763089, 690.028578975698, 1200.01989299251,
          1510.39078790814, 1510.39078790816, 1510.39078790816,
        ],
        30000: [
          7.0, 7.0, 7.0, 7.0, 8.0, 10.0, 13.0, 20.0, 31.0, 47.0, 70.0, 75.0,
          81.0, 115.0, 155.0, 205.0, 282.359013562066, 377.802104822838,
          509.760960679593, 827.313613857707, 1440.89574014026,
          1815.13113115893, 1815.13113115893, 1815.13113115893,
        ],
        40000: [
          9.0, 9.0, 9.0, 10.0, 11.0, 13.0, 17.0, 26.0, 41.0, 62.0, 93.0, 100.0,
          108.0, 153.0, 206.0, 273.0, 376.732030938483, 504.069816566542,
          680.119034954359, 1103.77305038515, 1922.44646830215,
          2421.80007269563, 2421.80007269563, 2421.80007269563,
        ],
        50000: [
          11.0, 11.0, 11.0, 12.0, 13.0, 16.0, 22.0, 32.0, 51.0, 77.0, 116.0,
          125.0, 135.0, 192.0, 258.0, 341.0, 471.057999233219, 630.266787170615,
          850.374058330813, 1380.05714560952, 2400.03941658157,
          3020.78085210505, 3020.78085210505, 3020.78085210505,
        ],
        60000: [
          11.8393464065209, 11.8107484954557, 11.8236298616435,
          12.4194230286612, 13.2423019546547, 15.5533242024523,
          20.4168051373358, 29.3796109463238, 46.176932168272, 70.0469361521822,
          105.222298379861, 128.919412354012, 159.568854218882,
          228.416469617141, 295.851124535868, 402.418065292792,
          564.718026869003, 755.604209356632, 1019.52192103807, 1654.6272273,
          2881.79146789728, 3630.26223805517, 3630.26223805517,
          3630.26223805517,
        ],
        70000: [
          12.6786928130418, 12.6214969909113, 12.6472597232869,
          12.8388460573225, 13.4846039093095, 15.1066484049047,
          18.8336102746715, 26.7592218926475, 41.353864336544, 63.0938723043643,
          94.4445967597215, 132.838824708023, 186.287393387112,
          266.665714140615, 345.382459901029, 469.787364079436, 659.26293543752,
          882.095415439783, 1190.16808453749, 1931.53085551448,
          3364.13845584933, 4237.9596957945, 4237.9596957945, 4237.9596957945,
        ],
        80000: [
          14.4935224632251, 14.4281439664653, 14.4576049832031,
          14.6766164899717, 15.4148193701955, 17.269050685364, 21.5348526846636,
          30.5974311090914, 47.276160465043, 72.1261995163027, 107.965540913054,
          151.856719549481, 212.957484123713, 304.844985227722,
          394.828926877072, 537.049373767577, 753.655014186206,
          1008.37872407705, 1360.53629173, 2207.99259106045, 3845.6284470439,
          4844.50811778945, 4844.50811778945, 4844.50811778945,
        ],
        90000: [
          16.2838829714427, 16.2104134460123, 16.24347525866, 16.4895222320761,
          17.3187680117547, 19.4019542312563, 24.2142546281797,
          34.4266950966521, 53.1450892120473, 81.0327841149074,
          121.297007597099, 170.607738952127, 239.252051508193,
          342.479987819029, 443.580075125334, 603.350405641608,
          846.688415056135, 1132.88101980193, 1528.56714423879,
          2480.76526159835, 4320.78847977033, 5443.11889106528,
          5443.11889106528, 5443.11889106528,
        ],
        100000: [
          18.1023193263796, 18.0206651783537, 18.0574064191544,
          18.3307778207245, 19.2525351952608, 21.5684818143572,
          26.9115883567045, 38.2559223383969, 59.0709697874063,
          90.0806160254469, 134.83977501518, 189.655855586684, 265.957205441998,
          380.697931799247, 493.095664768179, 670.71462041523, 941.219877121441,
          1259.3844771696, 1699.25675131487, 2757.77947086777, 4803.31793564068,
          6051.01413441699, 6051.01413441699, 6051.01413441699,
        ],
        120000: [
          21.721327083581, 21.6233202303655, 21.6674225760228, 21.9956443821537,
          23.1018331515509, 25.880672936282, 32.2931197408507, 45.9105933656261,
          70.8853391827921, 108.088410390982, 161.794837267405,
          227.567411911348, 319.128032209945, 456.818238973264,
          591.685001252481, 804.813009290427, 1129.4030598179, 1511.16687234276,
          2038.99145903652, 3309.17528759768, 5763.68909493314,
          7260.83683443573, 7260.83683443573, 7260.83683443573,
        ],
        140000: [
          25.3574056842356, 25.2430140150031, 25.2945397321906,
          25.6777126682035, 26.96921231101, 30.2132854854672, 37.667217840743,
          53.5184494906013, 82.707709187453, 126.187686190524, 188.889101640568,
          265.677517241347, 372.574589757711, 533.331123920619, 690.76457107186,
          939.574268105895, 1318.52520198527, 1764.19000508724,
          2380.33517697314, 3863.06028819615, 6728.27873172636,
          8475.92479692397, 8475.92479692397, 8475.92479692397,
        ],
        160000: [
          28.9870451050101, 28.8562881114497, 28.9152101477413, 29.353233161876,
          30.8296387778104, 34.5381012683548, 43.0697053389801,
          61.1948622694811, 94.5523207530723, 144.252398483978,
          215.931080952243, 303.713437796994, 425.914966317285,
          609.689967396932, 789.657850303211, 1074.09874277866,
          1507.31002140669, 2016.75744012982, 2721.07257449954,
          4415.98516990104, 7691.25690920264, 9689.01628084816,
          9689.01628084816, 9689.01628084816,
        ],
        180000: [
          32.5677659662477, 32.4208269154015, 32.4869505411637,
          32.9790444881394, 34.6375360283526, 38.8039084489044,
          48.4285092498753, 68.8533901937641, 106.290178396815,
          162.065568156267, 242.594015076556, 341.215477727582,
          478.504102750944, 684.959975212604, 887.160149781128,
          1206.70081063283, 1693.37682915473, 2265.76203851354,
          3057.13428728107, 4961.53052160875, 8641.57696144816,
          10886.2377878856, 10886.2377878856, 10886.2377878856,
        ],
        200000: [
          36.2046386534223, 36.041330357371, 36.1148128390278, 36.661555642198,
          38.505070390667, 43.1369636282945, 53.8231767132067, 76.5118446767988,
          118.141939573999, 180.161232048714, 269.679550026431,
          379.311711167091, 531.914410873963, 761.395863582935,
          986.191329521106, 1341.42924081077, 1882.43975421237,
          2518.76895430534, 3398.51350259498, 5515.5589416906, 9606.63587133292,
          12102.0282689915, 12102.0282689915, 12102.0282689915,
        ],
      },
    },
    memorialSevenDay: {
      bands: {
        age: [
          [1, 5],
          [6, 10],
          [11, 15],
          [16, 20],
          [21, 25],
          [26, 30],
          [31, 35],
          [36, 40],
          [41, 45],
          [46, 50],
          [51, 55],
          [56, 60],
          [61, 65],
          [66, 70],
          [71, 75],
          [76, 80],
          [81, 85],
          [86, 90],
          [91, 95],
          [96, 100],
          [101, 105],
          [106, 110],
          [111, 115],
          [116, 120],
        ],
      },
      covers: [
        5000, 7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 60000,
        70000, 80000, 90000, 100000, 120000, 140000, 160000, 180000, 200000,
      ],
      rates: {
        5000: [
          1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 2.0, 2.0, 4.0, 5.0, 7.0, 8.0, 9.0, 12.0,
          16.0, 21.0, 28.2881441650291, 37.8332942764619, 51.026343136896,
          82.7819827741882, 144.247376426864, 181.53553832695, 181.303942379835,
          181.303942379835,
        ],
        7500: [
          1.0, 1.0, 1.0, 2.0, 2.0, 2.0, 2.0, 3.0, 5.0, 7.0, 11.0, 12.0, 13.0,
          18.0, 24.0, 31.0, 42.3905664322489, 56.7181627957043,
          76.5262394958138, 124.193674614841, 216.307633686167,
          272.491741944111, 272.490444296221, 272.490444296221,
        ],
        10000: [
          2.0, 2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 4.0, 7.0, 10.0, 14.0, 15.0, 17.0,
          23.0, 31.0, 41.0, 56.5101686794264, 75.6109360218912,
          102.018424214984, 165.566779376245, 288.368379942678,
          363.271796791408, 363.271786427256, 363.271786427256,
        ],
        15000: [
          2.0, 2.0, 2.0, 3.0, 3.0, 3.0, 4.0, 6.0, 10.0, 14.0, 21.0, 23.0, 25.0,
          35.0, 47.0, 62.0, 84.7806426864391, 113.435955819937,
          153.052258958519, 248.387365020679, 432.614573745419, 544.98463577683,
          544.984635719413, 544.984635719413,
        ],
        20000: [
          3.0, 3.0, 3.0, 3.0, 4.0, 4.0, 6.0, 8.0, 13.0, 19.0, 28.0, 30.0, 33.0,
          46.0, 62.0, 82.0, 113.020332514487, 151.221868485234,
          204.036846348198, 331.133558876171, 576.73675435325, 726.543602783474,
          726.543602783016, 726.543602783016,
        ],
        25000: [
          4.0, 4.0, 4.0, 4.0, 4.0, 5.0, 7.0, 10.0, 16.0, 24.0, 35.0, 38.0, 41.0,
          58.0, 78.0, 103.0, 141.31740186363, 189.080038569304,
          255.112220257853, 414.017147385418, 720.011935795511,
          906.234472744862, 906.234472744834, 906.234472744834,
        ],
        30000: [
          4.0, 4.0, 4.0, 5.0, 5.0, 6.0, 8.0, 12.0, 19.0, 28.0, 42.0, 45.0, 49.0,
          69.0, 93.0, 123.0, 169.415408137239, 226.681262893703,
          305.856576407756, 496.388168314624, 864.537444084158,
          1089.07867869536, 1089.07867869536, 1089.07867869536,
        ],
        40000: [
          5.0, 6.0, 6.0, 6.0, 7.0, 8.0, 11.0, 16.0, 25.0, 37.0, 56.0, 60.0,
          65.0, 92.0, 124.0, 164.0, 226.03921856309, 302.441889939925,
          408.071420972615, 662.26383023109, 1153.46788098129, 1453.08004361738,
          1453.08004361738, 1453.08004361738,
        ],
        50000: [
          7.0, 7.0, 7.0, 7.0, 8.0, 10.0, 13.0, 20.0, 31.0, 47.0, 70.0, 75.0,
          81.0, 115.0, 155.0, 205.0, 282.634799539931, 378.160072302369,
          510.224434998488, 828.034287365712, 1440.02364994894,
          1812.46851126303, 1812.46851126303, 1812.46851126303,
        ],
        60000: [
          8.17349191579162, 8.16368691557169, 8.16810340561634,
          8.20094680013173, 9.168789626658, 11.1611387558972, 14.3714758149208,
          21.7301528134801, 33.660660787496, 51.1018016734735, 76.1904944263344,
          87.0580729064012, 101.363536264947, 144.285524907482,
          192.065534663302, 256.249222980505, 355.274845490107,
          475.353490980936, 641.363959453544, 1040.86312815885,
          1729.07488073837, 2178.1573428331, 2178.1573428331, 2178.1573428331,
        ],
        70000: [
          9.34698383158323, 9.32737383114338, 9.33620681123268,
          9.40189360026345, 10.337579253316, 12.3222775117944, 15.7429516298417,
          23.4603056269602, 36.3213215749919, 55.203603346947, 82.3809888526688,
          99.1161458128024, 121.727072529893, 173.571049814963,
          229.131069326605, 307.498445961011, 427.914891440284,
          572.546909659504, 772.5034839086, 1253.69196895199, 2018.48307350959,
          2542.7758174767, 2542.7758174767, 2542.7758174767,
        ],
        80000: [
          10.5204757473748, 10.4910607467151, 10.504310216849, 10.6028404003952,
          11.506368879974, 13.4834162676916, 17.1144274447625, 25.1904584404403,
          38.9819823624879, 59.3054050204206, 88.5714832790031,
          111.174218719204, 142.09060879484, 202.856574722445, 266.196603989907,
          358.747668941516, 500.55493739046, 669.740328338072, 903.643008363657,
          1466.52080974513, 2307.37706822634, 2906.70487067367,
          2906.70487067367, 2906.70487067367,
        ],
        90000: [
          11.6939676631665, 11.6547476622868, 11.6724136224654,
          11.8037872005269, 12.675158506632, 14.6445550235888, 18.4859032596833,
          26.9206112539204, 41.6426431499839, 63.4072066938941,
          94.7619777053375, 123.232291625605, 162.454145059786,
          232.142099629927, 303.262138653209, 409.996891922021,
          573.194983340636, 766.93374701664, 1034.78253281871, 1679.34965053827,
          2592.47308786219, 3265.87133463917, 3265.87133463917,
          3265.87133463917,
        ],
        100000: [
          12.8674595789581, 12.8184345778584, 12.8405170280817,
          13.0047340006586, 13.84394813329, 15.805693779486, 19.8573790746042,
          28.6507640674005, 44.3033039374798, 67.5090083673676,
          100.952472131672, 135.290364532006, 182.817681324733,
          261.427624537408, 340.327673316512, 461.246114902526,
          645.835029290812, 864.127165695208, 1165.92205727377,
          1892.17849133141, 2881.99076138441, 3630.60848065019,
          3630.60848065019, 3630.60848065019,
        ],
        120000: [
          14.0409514947497, 13.9821214934301, 14.008620433698, 14.2056808007904,
          15.012737759948, 16.9668325353832, 21.228854889525, 30.3809168808807,
          46.9639647249758, 71.6108100408411, 107.142966558006,
          147.348437438407, 203.18121758968, 290.71314944489, 377.393207979814,
          512.495337883032, 718.475075240989, 961.320584373776,
          1297.06158172883, 2105.00733212455, 3458.21345695988,
          4356.50210066143, 4356.50210066143, 4356.50210066143,
        ],
        140000: [
          15.2144434105413, 15.1458084090018, 15.1767238393144,
          15.4066276009221, 16.181527386606, 18.1279712912804, 22.6003307044459,
          32.1110696943608, 49.6246255124718, 75.7126117143146,
          113.333460984341, 159.406510344808, 223.544753854626,
          319.998674352371, 414.458742643116, 563.744560863537,
          791.115121191165, 1058.51400305234, 1428.20110618388,
          2317.83617291769, 4036.96723903582, 5085.55487815438,
          5085.55487815438, 5085.55487815438,
        ],
        160000: [
          17.3922270630061, 17.3137728668698, 17.3491260886448,
          17.6119398971256, 18.4977832666863, 20.7228607610129,
          25.8418232033881, 36.7169173616887, 56.7313924518432, 86.551439090387,
          129.558648571346, 182.228062678196, 255.548979790371, 365.81398043816,
          473.794710181927, 644.459245667198, 904.386012844016,
          1210.05446407789, 1632.64354469972, 2649.59110194062,
          4614.75414552159, 5813.40976850889, 5813.40976850889,
          5813.40976850889,
        ],
        180000: [
          19.5406595797486, 19.4524961492409, 19.4921703246982,
          19.7874266928836, 20.7825216170116, 23.2823450693426,
          29.0571055499252, 41.3120341162585, 63.7741070380893,
          97.2393408937605, 145.556409045934, 204.729286636549,
          287.102461650566, 410.975985127562, 532.296089868676,
          724.020486379698, 1016.02609749284, 1359.45722310813,
          1834.28057236864, 2976.91831296525, 5184.9461768689, 6531.74267273138,
          6531.74267273138, 6531.74267273138,
        ],
        200000: [
          21.7227831920533, 21.6247982144226, 21.6688877034167,
          21.9969333853188, 23.1030422344002, 25.8821781769768, 32.293906027924,
          45.9071068060792, 70.8851637443998, 108.096739229229,
          161.807730015859, 227.587026700254, 319.148646524378,
          456.837518149761, 591.714797712664, 804.857544486461,
          1129.46385252742, 1511.26137258321, 2039.10810155699,
          3309.33536501436, 5763.98152279976, 7261.21696139492,
          7261.21696139492, 7261.21696139492,
        ],
      },
    },
    doubleAccidental: {
      bands: {
        age: [
          [1, 5],
          [6, 10],
          [11, 15],
          [16, 20],
          [21, 25],
          [26, 30],
          [31, 35],
          [36, 40],
          [41, 45],
          [46, 50],
          [51, 55],
          [56, 60],
          [61, 65],
          [66, 70],
          [71, 75],
          [76, 80],
          [81, 85],
          [86, 90],
          [91, 95],
          [96, 100],
          [101, 105],
          [106, 110],
          [111, 115],
          [116, 120],
        ],
      },
      covers: [
        5000, 7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 60000,
        70000, 80000, 90000, 100000, 120000, 140000, 160000, 180000, 200000,
      ],
      rates: {
        5000: [
          4.0, 4.0, 4.0, 4.0, 4.0, 4.0, 4.0, 5.0, 7.0, 9.0, 12.0, 8.0, 3.0, 3.0,
          6.0, 11.0, 15.0, 21.0, 32.0, 59.0, 1.70451845753267, 1.72099946066383,
          1.72097556230512, 1.72097556230512,
        ],
        7500: [
          5.0, 5.0, 5.0, 5.0, 5.0, 6.0, 6.0, 8.0, 10.0, 13.0, 18.0, 12.0, 4.0,
          4.0, 9.0, 16.0, 22.0, 32.0, 47.0, 89.0, 2.55626649846224,
          2.58103359325692, 2.58103346082467, 2.58103346082467,
        ],
        10000: [
          7.0, 7.0, 7.0, 7.0, 7.0, 7.0, 8.0, 10.0, 13.0, 17.0, 23.0, 16.0, 6.0,
          6.0, 12.0, 21.0, 29.0, 42.0, 63.0, 118.0, 3.40786450945526,
          3.44089221017426, 3.44089220911929, 3.44089220911929,
        ],
        15000: [
          10.0, 10.0, 10.0, 10.0, 10.0, 11.0, 12.0, 15.0, 19.0, 25.0, 35.0,
          24.0, 8.0, 8.0, 17.0, 31.0, 43.0, 63.0, 94.0, 177.0, 5.11252640196823,
          5.16206102316511, 5.1620610231592, 5.1620610231592,
        ],
        20000: [
          13.0, 13.0, 13.0, 13.0, 13.0, 14.0, 16.0, 19.0, 25.0, 33.0, 46.0,
          32.0, 11.0, 11.0, 23.0, 41.0, 58.0, 84.0, 125.0, 235.0,
          6.81572896532486, 6.8817843712501, 6.88178437125006, 6.88178437125006,
        ],
        25000: [
          16.0, 16.0, 16.0, 16.0, 17.0, 17.0, 20.0, 24.0, 31.0, 41.0, 57.0,
          40.0, 13.0, 13.0, 28.0, 51.0, 72.0, 104.0, 157.0, 294.0,
          8.52163386771214, 8.60418805786512, 8.60418805786512,
          8.60418805786512,
        ],
        30000: [
          19.0, 19.0, 19.0, 20.0, 20.0, 21.0, 24.0, 29.0, 37.0, 49.0, 69.0,
          47.0, 16.0, 16.0, 34.0, 61.0, 86.0, 125.0, 188.0, 353.0,
          10.2173482314968, 10.3163350562929, 10.3163350562929,
          10.3163350562929,
        ],
        40000: [
          26.0, 26.0, 26.0, 26.0, 26.0, 27.0, 31.0, 38.0, 49.0, 66.0, 92.0,
          63.0, 21.0, 21.0, 45.0, 81.0, 115.0, 167.0, 250.0, 470.0,
          13.6313949710929, 13.763506313286, 13.763506313286, 13.763506313286,
        ],
        50000: [
          32.0, 32.0, 32.0, 32.0, 33.0, 34.0, 39.0, 48.0, 61.0, 82.0, 114.0,
          79.0, 26.0, 26.0, 56.0, 102.0, 143.0, 208.0, 313.0, 588.0,
          17.0432676013787, 17.2083759837982, 17.2083759837982,
          17.2083759837982,
        ],
        60000: [
          38.4, 38.4, 38.4, 38.4, 39.6, 40.8, 46.8, 57.6, 73.2, 98.4, 136.8,
          94.8, 31.2, 31.2, 67.2, 122.4, 171.6, 249.6, 375.6, 705.6,
          20.4519211216544, 20.6500511805579, 20.6500511805579,
          20.6500511805579,
        ],
        70000: [
          44.8, 44.8, 44.8, 44.8, 46.2, 47.6, 54.6, 67.2, 85.4, 114.8, 159.6,
          110.6, 36.4, 36.4, 78.4, 142.8, 200.2, 291.2, 438.2, 823.2,
          23.8605746419301, 24.0917263773175, 24.0917263773175,
          24.0917263773175,
        ],
        80000: [
          51.2, 51.2, 51.2, 51.2, 52.8, 54.4, 62.4, 76.8, 97.6, 131.2, 182.4,
          126.4, 41.6, 41.6, 89.6, 163.2, 228.8, 332.8, 500.8, 940.8,
          27.2692281622059, 27.5334015740772, 27.5334015740772,
          27.5334015740772,
        ],
        90000: [
          57.6, 57.6, 57.6, 57.6, 59.4, 61.2, 70.2, 86.4, 109.8, 147.6, 205.2,
          142.2, 46.8, 46.8, 100.8, 183.6, 257.4, 374.4, 563.4, 1058.4,
          30.6778816824816, 30.9750767708368, 30.9750767708368,
          30.9750767708368,
        ],
        100000: [
          64.0, 64.0, 64.0, 64.0, 66.0, 68.0, 78.0, 96.0, 122.0, 164.0, 228.0,
          158.0, 52.0, 52.0, 112.0, 204.0, 286.0, 416.0, 626.0, 1176.0,
          34.0865352027573, 34.4167519675965, 34.4167519675965,
          34.4167519675965,
        ],
        120000: [
          76.8, 76.8, 76.8, 76.8, 79.2, 81.6, 93.6, 115.2, 146.4, 196.8, 273.6,
          189.6, 62.4, 62.4, 134.4, 244.8, 343.2, 499.2, 751.2, 1411.2,
          40.9038422433088, 41.3001023611158, 41.3001023611158,
          41.3001023611158,
        ],
        140000: [
          89.6, 89.6, 89.6, 89.6, 92.4, 95.2, 109.2, 134.4, 170.8, 229.6, 319.2,
          221.2, 72.8, 72.8, 156.8, 285.6, 400.4, 582.4, 876.4, 1646.4,
          47.7211492838603, 48.1834527546351, 48.1834527546351,
          48.1834527546351,
        ],
        160000: [
          102.4, 102.4, 102.4, 102.4, 105.6, 108.8, 124.8, 153.6, 195.2, 262.4,
          364.8, 252.8, 83.2, 83.2, 179.2, 326.4, 457.6, 665.6, 1001.6, 1881.6,
          54.5384563244117, 55.0668031481543, 55.0668031481543,
          55.0668031481543,
        ],
        180000: [
          115.2, 115.2, 115.2, 115.2, 118.8, 122.4, 140.4, 172.8, 219.6, 295.2,
          410.4, 284.4, 93.6, 93.6, 201.6, 367.2, 514.8, 748.8, 1126.8, 2116.8,
          61.3557633649632, 61.9501535416736, 61.9501535416736,
          61.9501535416736,
        ],
        200000: [
          128.0, 128.0, 128.0, 128.0, 132.0, 136.0, 156.0, 192.0, 244.0, 328.0,
          456.0, 316.0, 104.0, 104.0, 224.0, 408.0, 572.0, 832.0, 1252.0,
          2352.0, 68.1730704055147, 68.8335039351929, 68.8335039351929,
          68.8335039351929,
        ],
      },
    },
  },
  term15: {
    memorialOneYear: {
      bands: {
        age: [
          [1, 5],
          [6, 10],
          [11, 15],
          [16, 20],
          [21, 25],
          [26, 30],
          [31, 35],
          [36, 40],
          [41, 45],
          [46, 50],
          [51, 55],
          [56, 60],
          [61, 65],
          [66, 70],
          [71, 75],
          [76, 80],
          [81, 85],
          [86, 90],
          [91, 95],
          [96, 100],
        ],
      },
      covers: [
        2500, 3750, 5000, 7500, 10000, 12500, 15000, 20000, 25000, 30000, 35000,
        40000, 45000, 50000, 60000, 70000, 80000, 90000, 100000,
      ],
      rates: {
        2500: [
          1.0, 1.0, 1.0, 1.0, 1.0, 2.0, 2.0, 3.0, 4.0, 7.0, 10.0, 11.0, 12.0,
          17.0, 23.0, 31.0, 43.4509740659558, 60.447123387427, 84.1573421946017,
          138.030819214121,
        ],
        3750: [
          2.0, 2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 4.0, 6.0, 10.0, 14.0, 16.0, 17.0,
          25.0, 34.0, 46.0, 65.2069186513545, 90.6883855837952,
          126.205534492908, 206.985749861734,
        ],
        5000: [
          2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 4.0, 5.0, 8.0, 13.0, 19.0, 21.0, 23.0,
          33.0, 45.0, 62.0, 86.9263067728559, 120.896962292693,
          168.246653527179, 275.939199632378,
        ],
        7500: [
          3.0, 3.0, 3.0, 3.0, 3.0, 4.0, 5.0, 8.0, 12.0, 19.0, 28.0, 31.0, 34.0,
          49.0, 67.0, 92.0, 130.414002546939, 181.376804475776,
          252.410648799729, 413.970787028676,
        ],
        10000: [
          4.0, 4.0, 4.0, 4.0, 4.0, 5.0, 7.0, 10.0, 16.0, 25.0, 37.0, 41.0, 45.0,
          65.0, 89.0, 123.0, 173.852615101924, 241.793924963558,
          336.493303231068, 551.87839325059,
        ],
        12500: [
          5.0, 5.0, 5.0, 5.0, 5.0, 6.0, 9.0, 13.0, 20.0, 31.0, 46.0, 51.0, 56.0,
          81.0, 112.0, 153.0, 217.382859665135, 302.326806704924,
          420.725854636727, 690.014986611254,
        ],
        15000: [
          5.0, 5.0, 6.0, 6.0, 6.0, 8.0, 10.0, 15.0, 24.0, 36.0, 55.0, 60.0,
          67.0, 97.0, 134.0, 184.0, 260.593157465836, 362.445970209495,
          504.412084896409, 827.297316649553,
        ],
        20000: [
          7.0, 7.0, 7.0, 8.0, 8.0, 10.0, 14.0, 20.0, 32.0, 49.0, 73.0, 81.0,
          89.0, 129.0, 178.0, 245.0, 347.70275864823, 483.58486277065,
          672.98285545325, 1103.75130740022,
        ],
        25000: [
          9.0, 9.0, 9.0, 9.0, 10.0, 12.0, 17.0, 25.0, 39.0, 61.0, 92.0, 101.0,
          111.0, 161.0, 223.0, 306.0, 434.765711802688, 604.653605574531,
          841.451700160938, 1380.02996088085,
        ],
        30000: [
          9.60345163895796, 9.58937896656336, 9.60376744397654,
          9.67540051630622, 10.5633681489081, 12.4622073335255,
          17.0847164319993, 24.9409735445461, 38.7043507429743,
          60.0336573895633, 90.4416276625721, 108.571140706119,
          131.450382790893, 191.189076835579, 254.65927844908, 358.730655467192,
          521.18631464206, 724.891940133173, 1008.82416947451, 1654.5946328837,
        ],
        35000: [
          10.2069032779159, 10.1787579331267, 10.2075348879531,
          10.3508010326124, 11.1267362978162, 12.9244146670509,
          17.1694328639986, 24.8819470890923, 38.4087014859485,
          59.0673147791266, 88.8832553251441, 116.142281412238, 153.47229487183,
          223.22099469583, 297.307066057486, 418.804471568955, 608.463383939627,
          846.24779510707, 1177.6803990249, 1931.4928067922,
        ],
        40000: [
          10.8103549168739, 10.7681368996901, 10.8113023319296,
          11.0262015489187, 11.6901044467243, 13.3866220005764,
          17.2541492959978, 24.8229206336384, 38.1130522289228, 58.10097216869,
          87.3248829877162, 123.713422118357, 175.450273775659,
          255.189914544466, 339.877667066967, 478.774304163337,
          695.589031835142, 967.399907248371, 1346.26121126974,
          2207.94909752687,
        ],
        45000: [
          12.1453922576348, 12.0979247341674, 12.1465011738449,
          12.3879032944099, 13.1336505009643, 15.0389077732269,
          19.3830154539547, 27.8856255242931, 42.8552123989332,
          65.3106927278726, 98.1025002307645, 138.980939344263,
          197.095128879337, 286.65657090853, 381.814440387766, 537.852608305858,
          781.423556822286, 1086.8347719481, 1512.52880128776, 2480.71639279462,
        ],
        50000: [
          13.5015070193656, 13.4487324055702, 13.5026870288375,
          13.7709850225845, 14.5999808025985, 16.7178083432477,
          21.5465823367927, 30.99815353337, 47.6262276892708, 72.5886332838749,
          109.053163728569, 154.493646360727, 219.09640716518, 318.653474646056,
          424.437759340796, 597.906654587678, 868.672846017871,
          1208.19725985933, 1681.42788956275, 2757.72514813494,
        ],
        60000: [
          16.2007707623581, 16.1374288016574, 16.2021879513294,
          16.5241578397746, 17.5188073482593, 20.059722346578, 25.8538522998907,
          37.194818177918, 57.0920389281567, 87.0437668001554, 130.85112013153,
          185.373450097689, 262.89120510769, 382.363289115505, 509.301484161685,
          717.438329250258, 1042.33949194726, 1449.74307696907, 2017.5965041471,
          3309.11010031546,
        ],
        70000: [
          18.9132466351995, 18.8393366449594, 18.9148730286547,
          19.2908502711696, 20.4522871606596, 23.4198433025926, 30.185681990236,
          43.4268079930241, 66.6714689905091, 101.640759470503,
          152.773292796029, 216.433357888467, 306.94437108647, 446.441645362305,
          594.613763119542, 837.608446150818, 1216.92605651118,
          1692.49477709653, 2355.35981617044, 3862.9841907789,
        ],
        80000: [
          21.6207097561227, 21.5362737205001, 21.6226045859984,
          22.0524030167634, 23.3802088041336, 26.7732438600563,
          34.5082983659937, 49.6458409273493, 76.2261044008984,
          116.201944100734, 174.64976495024, 247.426842683972, 350.900545217944,
          510.379825040777, 679.755330015296, 957.548602697614,
          1391.17805593067, 1934.79980672813, 2692.52241366961,
          4415.89818283412,
        ],
        90000: [
          24.2907845048485, 24.1958494578037, 24.2930023373591,
          24.7758065779817, 26.2673009899212, 30.0778155267725,
          38.7660308753625, 55.7712509997413, 85.7104247685611,
          130.621385400978, 196.205000315747, 277.961878466121,
          394.190257562357, 573.313141619443, 763.628880438783,
          1075.70521580355, 1562.84711253623, 2173.66954282576, 3025.057601391,
          4961.43278400131,
        ],
        100000: [
          27.0030140384149, 26.8974648108199, 27.0053740573615,
          27.5419700448373, 29.1999616048227, 33.4356166858327,
          43.0931646724466, 61.99630706504, 95.2524553775144, 145.177266565846,
          218.106327452385, 308.987292713979, 438.192814322813,
          637.306949282595, 848.875518668242, 1195.81330914893, 1737.3456920006,
          2416.39451968653, 3362.8557790911, 5515.45029622493,
        ],
      },
    },
    memorialFortyDay: {
      bands: {
        age: [
          [1, 5],
          [6, 10],
          [11, 15],
          [16, 20],
          [21, 25],
          [26, 30],
          [31, 35],
          [36, 40],
          [41, 45],
          [46, 50],
          [51, 55],
          [56, 60],
          [61, 65],
          [66, 70],
          [71, 75],
          [76, 80],
          [81, 85],
          [86, 90],
          [91, 95],
          [96, 100],
        ],
      },
      covers: [
        2500, 3750, 5000, 7500, 10000, 12500, 15000, 20000, 25000, 30000, 35000,
        40000, 45000, 50000, 60000, 70000, 80000, 90000, 100000,
      ],
      rates: {
        2500: [
          1.0, 1.0, 1.0, 1.0, 1.0, 2.0, 2.0, 3.0, 4.0, 7.0, 10.0, 11.0, 12.0,
          17.0, 23.0, 31.0, 43.4509740659558, 60.447123387427, 84.1573421946017,
          138.030819214121,
        ],
        3750: [
          2.0, 2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 4.0, 6.0, 10.0, 14.0, 16.0, 17.0,
          25.0, 34.0, 46.0, 65.2069186513545, 90.6883855837952,
          126.205534492908, 206.985749861734,
        ],
        5000: [
          2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 4.0, 5.0, 8.0, 13.0, 19.0, 21.0, 23.0,
          33.0, 45.0, 62.0, 86.9263067728559, 120.896962292693,
          168.246653527179, 275.939199632378,
        ],
        7500: [
          3.0, 3.0, 3.0, 3.0, 3.0, 4.0, 5.0, 8.0, 12.0, 19.0, 28.0, 31.0, 34.0,
          49.0, 67.0, 92.0, 130.414002546939, 181.376804475776,
          252.410648799729, 413.970787028676,
        ],
        10000: [
          4.0, 4.0, 4.0, 4.0, 4.0, 5.0, 7.0, 10.0, 16.0, 25.0, 37.0, 41.0, 45.0,
          65.0, 89.0, 123.0, 173.852615101924, 241.793924963558,
          336.493303231068, 551.87839325059,
        ],
        12500: [
          5.0, 5.0, 5.0, 5.0, 5.0, 6.0, 9.0, 13.0, 20.0, 31.0, 46.0, 51.0, 56.0,
          81.0, 112.0, 153.0, 217.382859665135, 302.326806704924,
          420.725854636727, 690.014986611254,
        ],
        15000: [
          5.0, 5.0, 6.0, 6.0, 6.0, 8.0, 10.0, 15.0, 24.0, 36.0, 55.0, 60.0,
          67.0, 97.0, 134.0, 184.0, 260.593157465836, 362.445970209495,
          504.412084896409, 827.297316649553,
        ],
        20000: [
          7.0, 7.0, 7.0, 8.0, 8.0, 10.0, 14.0, 20.0, 32.0, 49.0, 73.0, 81.0,
          89.0, 129.0, 178.0, 245.0, 347.70275864823, 483.58486277065,
          672.98285545325, 1103.75130740022,
        ],
        25000: [
          9.0, 9.0, 9.0, 9.0, 10.0, 12.0, 17.0, 25.0, 39.0, 61.0, 92.0, 101.0,
          111.0, 161.0, 223.0, 306.0, 434.765711802688, 604.653605574531,
          841.451700160938, 1380.02996088085,
        ],
        30000: [
          9.60345163895796, 9.58937896656336, 9.60376744397654,
          9.67540051630622, 10.5633681489081, 12.4622073335255,
          17.0847164319993, 24.9409735445461, 38.7043507429743,
          60.0336573895633, 90.4416276625721, 108.571140706119,
          131.450382790893, 191.189076835579, 254.65927844908, 358.730655467192,
          521.18631464206, 724.891940133173, 1008.82416947451, 1654.5946328837,
        ],
        35000: [
          10.2069032779159, 10.1787579331267, 10.2075348879531,
          10.3508010326124, 11.1267362978162, 12.9244146670509,
          17.1694328639986, 24.8819470890923, 38.4087014859485,
          59.0673147791266, 88.8832553251441, 116.142281412238, 153.47229487183,
          223.22099469583, 297.307066057486, 418.804471568955, 608.463383939627,
          846.24779510707, 1177.6803990249, 1931.4928067922,
        ],
        40000: [
          10.8103549168739, 10.7681368996901, 10.8113023319296,
          11.0262015489187, 11.6901044467243, 13.3866220005764,
          17.2541492959978, 24.8229206336384, 38.1130522289228, 58.10097216869,
          87.3248829877162, 123.713422118357, 175.450273775659,
          255.189914544466, 339.877667066967, 478.774304163337,
          695.589031835142, 967.399907248371, 1346.26121126974,
          2207.94909752687,
        ],
        45000: [
          12.1453922576348, 12.0979247341674, 12.1465011738449,
          12.3879032944099, 13.1336505009643, 15.0389077732269,
          19.3830154539547, 27.8856255242931, 42.8552123989332,
          65.3106927278726, 98.1025002307645, 138.980939344263,
          197.095128879337, 286.65657090853, 381.814440387766, 537.852608305858,
          781.423556822286, 1086.8347719481, 1512.52880128776, 2480.71639279462,
        ],
        50000: [
          13.5015070193656, 13.4487324055702, 13.5026870288375,
          13.7709850225845, 14.5999808025985, 16.7178083432477,
          21.5465823367927, 30.99815353337, 47.6262276892708, 72.5886332838749,
          109.053163728569, 154.493646360727, 219.09640716518, 318.653474646056,
          424.437759340796, 597.906654587678, 868.672846017871,
          1208.19725985933, 1681.42788956275, 2757.72514813494,
        ],
        60000: [
          16.2007707623581, 16.1374288016574, 16.2021879513294,
          16.5241578397746, 17.5188073482593, 20.059722346578, 25.8538522998907,
          37.194818177918, 57.0920389281567, 87.0437668001554, 130.85112013153,
          185.373450097689, 262.89120510769, 382.363289115505, 509.301484161685,
          717.438329250258, 1042.33949194726, 1449.74307696907, 2017.5965041471,
          3309.11010031546,
        ],
        70000: [
          18.9132466351995, 18.8393366449594, 18.9148730286547,
          19.2908502711696, 20.4522871606596, 23.4198433025926, 30.185681990236,
          43.4268079930241, 66.6714689905091, 101.640759470503,
          152.773292796029, 216.433357888467, 306.94437108647, 446.441645362305,
          594.613763119542, 837.608446150818, 1216.92605651118,
          1692.49477709653, 2355.35981617044, 3862.9841907789,
        ],
        80000: [
          21.6207097561227, 21.5362737205001, 21.6226045859984,
          22.0524030167634, 23.3802088041336, 26.7732438600563,
          34.5082983659937, 49.6458409273493, 76.2261044008984,
          116.201944100734, 174.64976495024, 247.426842683972, 350.900545217944,
          510.379825040777, 679.755330015296, 957.548602697614,
          1391.17805593067, 1934.79980672813, 2692.52241366961,
          4415.89818283412,
        ],
        90000: [
          24.2907845048485, 24.1958494578037, 24.2930023373591,
          24.7758065779817, 26.2673009899212, 30.0778155267725,
          38.7660308753625, 55.7712509997413, 85.7104247685611,
          130.621385400978, 196.205000315747, 277.961878466121,
          394.190257562357, 573.313141619443, 763.628880438783,
          1075.70521580355, 1562.84711253623, 2173.66954282576, 3025.057601391,
          4961.43278400131,
        ],
        100000: [
          27.0030140384149, 26.8974648108199, 27.0053740573615,
          27.5419700448373, 29.1999616048227, 33.4356166858327,
          43.0931646724466, 61.99630706504, 95.2524553775144, 145.177266565846,
          218.106327452385, 308.987292713979, 438.192814322813,
          637.306949282595, 848.875518668242, 1195.81330914893, 1737.3456920006,
          2416.39451968653, 3362.8557790911, 5515.45029622493,
        ],
      },
    },
    memorialSevenDay: {
      bands: {
        age: [
          [1, 5],
          [6, 10],
          [11, 15],
          [16, 20],
          [21, 25],
          [26, 30],
          [31, 35],
          [36, 40],
          [41, 45],
          [46, 50],
          [51, 55],
          [56, 60],
          [61, 65],
          [66, 70],
          [71, 75],
          [76, 80],
          [81, 85],
          [86, 90],
          [91, 95],
          [96, 100],
        ],
      },
      covers: [
        1500, 2250, 3000, 4500, 6000, 7500, 9000, 12000, 15000, 18000, 21000,
        24000, 27000, 30000, 36000, 42000, 48000, 54000, 60000,
      ],
      rates: {
        1500: [
          1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 2.0, 3.0, 4.0, 6.0, 7.0, 7.0, 10.0,
          15.0, 20.0, 26.0959773062448, 36.3017848289037, 50.5131758702457,
          82.7953371075996,
        ],
        2250: [
          1.0, 1.0, 1.0, 1.0, 1.0, 2.0, 2.0, 3.0, 4.0, 6.0, 9.0, 10.0, 10.0,
          15.0, 22.0, 30.0, 39.1243356021325, 54.4132558363235,
          75.7234397109715, 124.191317408383,
        ],
        3000: [
          1.0, 1.0, 2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 5.0, 8.0, 11.0, 13.0, 14.0,
          20.0, 30.0, 40.0, 52.155785964718, 72.5381795478363, 100.947993237563,
          165.563518694505,
        ],
        4500: [
          2.0, 2.0, 2.0, 2.0, 2.0, 3.0, 3.0, 5.0, 8.0, 11.0, 17.0, 19.0, 20.0,
          29.0, 44.0, 59.0, 78.2484015421273, 108.826082700145, 151.44638928706,
          248.382472210976,
        ],
        6000: [
          2.0, 2.0, 3.0, 3.0, 3.0, 3.0, 4.0, 6.0, 10.0, 15.0, 22.0, 25.0, 27.0,
          39.0, 59.0, 79.0, 104.3115690613, 145.076354978277, 201.895981938709,
          331.127035950303,
        ],
        7500: [
          3.0, 3.0, 3.0, 3.0, 3.0, 4.0, 5.0, 8.0, 12.0, 19.0, 28.0, 31.0, 34.0,
          49.0, 73.0, 99.0, 130.429715799081, 181.396084022955,
          252.435512782036, 414.008991966752,
        ],
        9000: [
          3.0, 3.0, 4.0, 4.0, 4.0, 5.0, 6.0, 9.0, 14.0, 22.0, 33.0, 36.0, 40.0,
          58.0, 87.0, 118.0, 156.355894479502, 217.467582125697,
          302.647250937845, 496.378389989732,
        ],
        12000: [
          4.0, 4.0, 5.0, 5.0, 5.0, 6.0, 8.0, 12.0, 19.0, 29.0, 44.0, 49.0, 54.0,
          78.0, 117.0, 157.0, 208.621655188938, 290.15091766239,
          403.78971327195, 662.250784440134,
        ],
        15000: [
          5.0, 5.0, 6.0, 6.0, 6.0, 8.0, 10.0, 15.0, 24.0, 37.0, 55.0, 61.0,
          67.0, 97.0, 146.0, 197.0, 260.859427081613, 362.792163344719,
          504.871020096563, 828.017976528507,
        ],
        18000: [
          5.90684971158853, 5.90051456956795, 6.76413197388469,
          6.79635859467168, 6.89591032805654, 8.86455799736509,
          11.1587727420202, 16.5794406851163, 26.2861259134722,
          40.4263508117574, 60.2377108110882, 70.8371449618686,
          83.7380889502689, 121.409283888198, 176.109751124532,
          240.652152527213, 327.901742342341, 456.035692332319,
          634.634572897378, 1040.84262480548,
        ],
        21000: [
          6.81369942317707, 6.80102913913591, 7.52826394776937,
          7.59271718934336, 7.79182065611308, 9.72911599473017,
          12.3175454840405, 18.1588813702327, 28.5722518269444,
          43.8527016235148, 65.4754216221765, 80.6742899237371,
          100.476177900538, 145.818567776395, 206.219502249064,
          284.304305054426, 394.944057603069, 549.279221319918,
          764.398125698192, 1253.66727308246,
        ],
        24000: [
          7.7205491347656, 7.70154370870386, 8.29239592165406, 8.38907578401504,
          8.68773098416962, 10.5936739920953, 13.4763182260607, 19.738322055349,
          30.8583777404166, 47.2790524352723, 70.7131324332647,
          90.5114348856057, 117.214266850807, 170.227851664593,
          236.329253373596, 327.956457581639, 461.986372863797,
          642.522750307518, 894.161678499007, 1466.49192135944,
        ],
        27000: [
          8.62739884635413, 8.60205827827181, 9.05652789553874,
          9.18543437868672, 9.58364131222617, 11.4582319894603,
          14.6350909680809, 21.3177627404654, 33.1445036538888,
          50.7054032470297, 75.9508432443529, 100.348579847474,
          133.952355801076, 194.63713555279, 266.439004498129, 371.608610108852,
          529.028688124526, 735.766279295118, 1023.92523129982,
          1679.31656963641,
        ],
        30000: [
          9.53424855794267, 9.50257284783976, 9.82065986942343, 9.9817929733584,
          10.4795516402827, 12.3227899868254, 15.7938637101011,
          22.8972034255817, 35.430629567361, 54.1317540587871, 81.1885540554411,
          110.185724809343, 150.690444751344, 219.046419440988,
          296.548755622661, 415.260762636065, 596.071003385254,
          829.009808282718, 1153.68878410064, 1892.14121791339,
        ],
        36000: [
          10.4410982695312, 10.4030874174077, 10.5847918433081,
          10.7781515680301, 11.3754619683393, 13.1873479841905,
          16.9526364521214, 24.4766441106981, 37.7167554808333,
          57.5581048705445, 86.4262648665294, 120.022869771211,
          167.428533701613, 243.455703329185, 326.658506747193,
          458.912915163278, 663.113318645982, 922.253337270317,
          1283.45233690145, 2104.96586619036,
        ],
        42000: [
          11.3479479811197, 11.3036019869757, 11.3489238171928,
          11.5745101627018, 12.2713722963958, 14.0519059815556,
          18.1114091941416, 26.0560847958144, 40.0028813943055, 60.984455682302,
          91.6639756776176, 129.86001473308, 184.166622651882, 267.864987217383,
          356.768257871725, 502.565067690491, 730.15563390671, 1015.49686625792,
          1413.21588970227, 2317.79051446734,
        ],
        48000: [
          12.9724258536736, 12.9217642323001, 12.973562751599, 13.231441810058,
          14.0281252824801, 16.0639463160338, 20.7049790195962,
          29.7875045564096, 45.7356626405391, 69.7211664604407,
          104.789858970144, 148.456105610383, 210.540327130767,
          306.227895024466, 407.853198009178, 574.529161618568,
          834.706833558403, 1160.87988403688, 1615.51344820177,
          2649.53890970047,
        ],
        54000: [
          14.5744707029091, 14.5175096746822, 14.5758014024154,
          14.8654839467891, 15.7603805939527, 18.0466893160635,
          23.2596185252175, 33.4627505998448, 51.4262548611367, 78.372831240587,
          117.723000189448, 166.777127079672, 236.514154537414,
          343.987884971666, 458.177328263269, 645.423129482129,
          937.708267521737, 1304.20172569546, 1815.0345608346, 2976.85967040079,
        ],
        60000: [
          16.2018084230489, 16.1384788864919, 16.2032244344169,
          16.5251820269024, 17.5199769628936, 20.0613700114996, 25.855898803468,
          37.197784239024, 57.1514732265086, 87.1063599395077, 130.863796471431,
          185.392375628388, 262.915688593688, 382.384169569557,
          509.325311200946, 717.48798548936, 1042.40741520036, 1449.83671181192,
          2017.71346745466, 3309.27017773496,
        ],
      },
    },
    doubleAccidental: {
      bands: {
        age: [
          [1, 5],
          [6, 10],
          [11, 15],
          [16, 20],
          [21, 25],
          [26, 30],
          [31, 35],
          [36, 40],
          [41, 45],
          [46, 50],
          [51, 55],
          [56, 60],
          [61, 65],
          [66, 70],
          [71, 75],
          [76, 80],
          [81, 85],
          [86, 90],
          [91, 95],
          [96, 100],
        ],
      },
      covers: [
        5000, 7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 60000,
        70000, 80000, 90000, 100000, 120000, 140000, 160000, 180000, 200000,
      ],
      rates: {
        5000: [
          3.0, 3.0, 3.0, 3.0, 3.0, 3.0, 4.0, 4.0, 5.0, 7.0, 10.0, 7.0, 2.0, 2.0,
          5.0, 9.0, 14.0, 21.0, 31.0, 59.0,
        ],
        7500: [
          4.0, 4.0, 4.0, 4.0, 4.0, 4.0, 5.0, 6.0, 8.0, 10.0, 14.0, 10.0, 3.0,
          3.0, 7.0, 14.0, 20.0, 31.0, 47.0, 89.0,
        ],
        10000: [
          5.0, 5.0, 5.0, 5.0, 5.0, 6.0, 7.0, 8.0, 10.0, 13.0, 19.0, 13.0, 4.0,
          4.0, 10.0, 18.0, 27.0, 41.0, 62.0, 118.0,
        ],
        15000: [
          8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 10.0, 11.0, 15.0, 20.0, 28.0, 19.0, 6.0,
          6.0, 14.0, 27.0, 40.0, 61.0, 93.0, 177.0,
        ],
        20000: [
          10.0, 10.0, 10.0, 10.0, 10.0, 11.0, 13.0, 15.0, 19.0, 26.0, 37.0,
          25.0, 8.0, 8.0, 19.0, 36.0, 53.0, 81.0, 124.0, 235.0,
        ],
        25000: [
          12.0, 12.0, 12.0, 12.0, 13.0, 14.0, 16.0, 19.0, 24.0, 33.0, 46.0,
          31.0, 10.0, 10.0, 24.0, 45.0, 67.0, 101.0, 155.0, 294.0,
        ],
        30000: [
          15.0, 15.0, 15.0, 15.0, 15.0, 16.0, 19.0, 22.0, 29.0, 39.0, 55.0,
          38.0, 12.0, 12.0, 28.0, 54.0, 80.0, 121.0, 186.0, 353.0,
        ],
        40000: [
          19.0, 19.0, 19.0, 19.0, 20.0, 22.0, 25.0, 30.0, 38.0, 52.0, 73.0,
          50.0, 16.0, 16.0, 37.0, 72.0, 106.0, 161.0, 248.0, 470.0,
        ],
        50000: [
          24.0, 24.0, 24.0, 24.0, 25.0, 27.0, 31.0, 37.0, 48.0, 65.0, 91.0,
          62.0, 19.0, 19.0, 47.0, 90.0, 133.0, 201.0, 310.0, 588.0,
        ],
        60000: [
          28.8, 28.8, 28.8, 28.8, 30.0, 32.4, 37.2, 44.4, 57.6, 78.0, 109.2,
          74.4, 22.8, 22.8, 56.4, 108.0, 159.6, 241.2, 372.0, 705.6,
        ],
        70000: [
          33.6, 33.6, 33.6, 33.6, 35.0, 37.8, 43.4, 51.8, 67.2, 91.0, 127.4,
          86.8, 26.6, 26.6, 65.8, 126.0, 186.2, 281.4, 434.0, 823.2,
        ],
        80000: [
          38.4, 38.4, 38.4, 38.4, 40.0, 43.2, 49.6, 59.2, 76.8, 104.0, 145.6,
          99.2, 30.4, 30.4, 75.2, 144.0, 212.8, 321.6, 496.0, 940.8,
        ],
        90000: [
          43.2, 43.2, 43.2, 43.2, 45.0, 48.6, 55.8, 66.6, 86.4, 117.0, 163.8,
          111.6, 34.2, 34.2, 84.6, 162.0, 239.4, 361.8, 558.0, 1058.4,
        ],
        100000: [
          48.0, 48.0, 48.0, 48.0, 50.0, 54.0, 62.0, 74.0, 96.0, 130.0, 182.0,
          124.0, 38.0, 38.0, 94.0, 180.0, 266.0, 402.0, 620.0, 1176.0,
        ],
        120000: [
          57.6, 57.6, 57.6, 57.6, 60.0, 64.8, 74.4, 88.8, 115.2, 156.0, 218.4,
          148.8, 45.6, 45.6, 112.8, 216.0, 319.2, 482.4, 744.0, 1411.2,
        ],
        140000: [
          67.2, 67.2, 67.2, 67.2, 70.0, 75.6, 86.8, 103.6, 134.4, 182.0, 254.8,
          173.6, 53.2, 53.2, 131.6, 252.0, 372.4, 562.8, 868.0, 1646.4,
        ],
        160000: [
          76.8, 76.8, 76.8, 76.8, 80.0, 86.4, 99.2, 118.4, 153.6, 208.0, 291.2,
          198.4, 60.8, 60.8, 150.4, 288.0, 425.6, 643.2, 992.0, 1881.6,
        ],
        180000: [
          86.4, 86.4, 86.4, 86.4, 90.0, 97.2, 111.6, 133.2, 172.8, 234.0, 327.6,
          223.2, 68.4, 68.4, 169.2, 324.0, 478.8, 723.6, 1116.0, 2116.8,
        ],
        200000: [
          96.0, 96.0, 96.0, 96.0, 100.0, 108.0, 124.0, 148.0, 192.0, 260.0,
          364.0, 248.0, 76.0, 76.0, 188.0, 360.0, 532.0, 804.0, 1240.0, 2352.0,
        ],
      },
    },
  },
}

export const additionalLivesTransitionRates = {
  spouse: {
    bands: {
      age: [
        [18, 25],
        [26, 30],
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
        [56, 60],
        [61, 65],
        [66, 70],
        [71, 75],
        [76, 80],
        [81, 85],
        [86, 90],
        [91, 95],
        [96, 100],
      ],
    },
    covers: [10000, 15000, 20000, 25000, 30000, 50000, 70000, 100000],
    rates: {
      10000: [
        2.16, 2.77, 3.79, 5.58, 8.56, 12.34, 17.63, 25.88, 37.8, 55.04, 79.97,
        115.55, 165.25, 232.35, 322.34, 496.87,
      ],
      15000: [
        3.24, 4.15, 5.69, 8.37, 12.83, 18.49, 26.43, 38.76, 56.61, 82.46,
        119.83, 173.14, 247.51, 348.21, 483.35, 745.3,
      ],
      20000: [
        4.32, 5.53, 7.58, 11.15, 17.1, 24.64, 35.22, 51.66, 75.44, 109.91,
        159.72, 230.79, 329.92, 464.17, 644.35, 993.59,
      ],
      25000: [
        5.4, 6.92, 9.48, 13.95, 21.39, 30.83, 44.06, 64.62, 94.36, 137.47,
        199.75, 288.62, 412.58, 580.42, 805.66, 1240.38,
      ],
      30000: [
        6.47, 8.29, 11.37, 16.74, 25.67, 37.0, 52.88, 77.56, 113.15, 164.73,
        239.36, 345.83, 494.38, 695.68, 965.89, 1489.38,
      ],
      50000: [
        10.79, 13.84, 18.97, 27.9, 42.78, 61.66, 88.12, 129.26, 188.75, 274.96,
        399.54, 577.29, 825.23, 1159.97, 1609.36, 2481.77,
      ],
      70000: [
        15.1, 19.38, 26.55, 39.06, 59.9, 86.33, 123.38, 180.97, 264.0, 384.38,
        558.58, 807.11, 1153.74, 1623.32, 2253.74, 3475.38,
      ],
      100000: [
        21.59, 27.68, 37.93, 55.79, 85.56, 123.32, 176.25, 258.51, 377.49,
        549.92, 799.07, 1154.55, 1650.42, 2321.78, 3219.73, 4961.29,
      ],
    },
  },
  children: {
    bands: {
      age: [
        [1, 5],
        [6, 10],
        [11, 15],
        [16, 21],
      ],
    },
    covers: [10000, 15000, 20000, 25000, 30000, 50000, 70000, 100000],
    rates: {
      10000: [1.77, 1.82, 1.99, 14.59],
      15000: [2.65, 2.73, 2.98, 15.12],
      20000: [3.53, 3.64, 3.98, 15.65],
      25000: [4.41, 4.55, 4.97, 16.18],
      30000: [5.29, 5.46, 5.96, 16.7],
      50000: [8.81, 9.1, 9.93, 18.81],
      70000: [12.35, 12.74, 13.91, 20.92],
      100000: [17.64, 18.19, 19.85, 24.08],
    },
  },
  parentsGuardians: {
    bands: {
      age: [
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
        [56, 60],
        [61, 65],
        [66, 70],
        [71, 75],
        [76, 80],
        [81, 85],
        [86, 90],
        [91, 95],
        [96, 100],
      ],
    },
    covers: [10000, 15000, 20000, 25000, 30000, 50000, 70000, 100000],
    rates: {
      10000: [
        4.85, 6.91, 10.41, 15.38, 22.54, 33.11, 48.48, 70.84, 103.37, 150.55,
        218.21, 313.99, 453.33, 794.27,
      ],
      15000: [
        7.27, 10.35, 15.59, 23.04, 33.78, 49.63, 72.63, 106.1, 154.89, 225.62,
        327.03, 470.47, 679.34, 1190.29,
      ],
      20000: [
        9.69, 13.79, 20.78, 30.71, 45.01, 66.15, 96.8, 141.42, 206.45, 300.74,
        435.91, 627.14, 905.6, 1586.75,
      ],
      25000: [
        12.12, 17.25, 25.99, 38.42, 56.31, 82.74, 121.08, 176.88, 258.2, 376.11,
        545.14, 784.24, 1132.39, 1980.43,
      ],
      30000: [
        14.54, 20.71, 31.2, 46.11, 67.58, 99.31, 145.31, 212.08, 309.4, 450.69,
        653.23, 939.79, 1357.29, 2378.43,
      ],
      50000: [
        24.24, 34.51, 51.99, 76.84, 112.63, 165.5, 242.18, 353.79, 516.45,
        752.29, 1090.36, 1566.87, 2261.29, 3962.8,
      ],
      70000: [
        33.93, 48.31, 72.79, 107.58, 157.68, 231.72, 339.06, 494.87, 721.99,
        1051.76, 1524.48, 2193.02, 3166.98, 5549.95,
      ],
      100000: [
        48.47, 69.01, 103.99, 153.68, 225.25, 331.01, 484.35, 707.57, 1032.89,
        1504.55, 2180.68, 3137.12, 4524.7, 7922.35,
      ],
    },
  },
  grandparents: {
    bands: {
      age: [
        [44, 50],
        [51, 55],
        [56, 60],
        [61, 65],
        [66, 70],
        [71, 75],
        [76, 80],
        [81, 85],
        [86, 90],
        [91, 95],
        [96, 100],
      ],
    },
    covers: [10000, 15000, 20000, 25000, 30000, 50000, 70000, 100000],
    rates: {
      10000: [
        15.02, 22.85, 33.6, 49.23, 71.94, 105.0, 153.08, 222.43, 321.58, 468.71,
        817.35,
      ],
      15000: [
        22.52, 34.26, 50.37, 73.74, 107.74, 157.33, 229.42, 333.37, 481.94,
        702.57, 1224.44,
      ],
      20000: [
        30.01, 45.65, 67.14, 98.28, 143.6, 209.7, 305.8, 444.37, 642.42, 936.55,
        1632.26,
      ],
      25000: [
        37.54, 57.11, 83.98, 122.93, 179.61, 262.27, 382.44, 555.72, 803.37,
        1171.11, 2037.4,
      ],
      30000: [
        45.06, 68.54, 100.79, 147.53, 215.36, 314.28, 458.29, 665.93, 962.7,
        1403.61, 2446.67,
      ],
      50000: [
        75.1, 114.23, 167.97, 245.88, 359.26, 524.59, 764.94, 1111.54, 1606.85,
        2340.22, 4076.29,
      ],
      70000: [
        105.14, 159.93, 235.17, 344.24, 502.51, 733.34, 1069.44, 1554.08,
        2246.67, 3275.3, 5709.08,
      ],
      100000: [
        150.19, 228.45, 335.94, 491.75, 718.51, 1049.16, 1529.86, 2223.03,
        3213.64, 4684.62, 8154.98,
      ],
    },
  },
  sibling: {
    bands: {
      age: [
        [1, 5],
        [6, 10],
        [11, 15],
        [16, 20],
        [21, 25],
        [26, 30],
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
        [56, 60],
        [61, 65],
        [66, 70],
        [71, 75],
        [76, 80],
        [81, 85],
        [86, 90],
        [91, 95],
        [96, 100],
      ],
    },
    covers: [10000, 15000, 20000, 25000, 30000, 50000, 70000, 100000],
    rates: {
      10000: [
        2.08, 2.1, 2.16, 2.33, 2.68, 3.38, 4.64, 6.85, 10.54, 15.21, 21.77,
        32.0, 46.83, 68.35, 99.56, 144.37, 207.5, 294.39, 415.67, 715.66,
      ],
      15000: [
        3.12, 3.14, 3.24, 3.49, 4.02, 5.07, 6.96, 10.27, 15.8, 22.81, 32.64,
        47.95, 70.14, 102.41, 149.21, 216.35, 310.86, 441.26, 622.78, 1071.74,
      ],
      20000: [
        4.15, 4.19, 4.32, 4.65, 5.36, 6.75, 9.28, 13.69, 21.05, 30.39, 43.5,
        63.9, 93.49, 136.5, 198.89, 288.38, 414.37, 588.23, 830.24, 1428.71,
      ],
      25000: [
        5.2, 5.24, 5.4, 5.81, 6.71, 8.45, 11.61, 17.12, 26.34, 38.02, 54.41,
        79.93, 116.93, 170.72, 248.73, 360.64, 518.18, 735.53, 1038.07, 1783.14,
      ],
      30000: [
        6.23, 6.28, 6.48, 6.97, 8.04, 10.13, 13.93, 20.55, 31.61, 45.63, 65.3,
        95.93, 140.2, 204.56, 298.03, 432.11, 620.94, 881.68, 1244.57, 2141.41,
      ],
      50000: [
        10.38, 10.46, 10.8, 11.62, 13.41, 16.89, 23.22, 34.25, 52.68, 76.05,
        108.83, 159.88, 233.88, 341.46, 497.51, 721.34, 1036.43, 1470.09,
        2073.73, 3568.19,
      ],
      70000: [
        14.53, 14.65, 15.11, 16.25, 18.77, 23.65, 32.51, 47.95, 73.75, 106.47,
        152.36, 223.84, 327.15, 477.36, 695.55, 1008.48, 1449.02, 2057.3,
        2904.01, 4996.86,
      ],
      100000: [
        20.78, 20.95, 21.61, 23.25, 26.83, 33.79, 46.44, 68.5, 105.35, 152.09,
        217.65, 319.76, 467.76, 682.92, 994.99, 1442.64, 2072.82, 2939.38,
        4145.59, 7133.03,
      ],
    },
  },
}

export const oldAgeRates = {
  bands: {
    age: [
      [18, 25],
      [26, 30],
      [31, 35],
      [36, 40],
      [41, 45],
      [46, 50],
      [51, 55],
      [56, 60],
      [61, 65],
      [66, 70],
    ],
  },
  mainLife: {
    5: [
      0.132043736799436, 0.224899190711655, 0.366517721059937,
      0.588180159629427, 0.995256787768867, 1.75575295172906, 2.94892301028342,
      4.75863222751526, 7.44000430685875, 11.0289585491465,
    ],
    6: [
      0.102613336794539, 0.174101579550685, 0.283479215975708,
      0.457287257687376, 0.781306277790314, 1.38159106665388, 2.33676008930156,
      3.81615267745352, 6.05309654123728, 9.16726323224872,
    ],
    7: [
      0.0945314445684653, 0.159756420524789, 0.259580967870042,
      0.42006014209206, 0.721207849737631, 1.2739103146807, 2.15408672598984,
      3.52627404308758, 5.60765832362898, 8.5372313543032,
    ],
    8: [
      0.0890249906087868, 0.15002870513854, 0.243727135184364,
      0.395579950354565, 0.681083884742866, 1.20241636838158, 2.03294579543312,
      3.33263798470926, 5.31112579283597, 8.12273032529404,
    ],
    9: [
      0.0836424980896592, 0.140761810592394, 0.22868327860243,
      0.372428567229213, 0.64280281246741, 1.13481419348835, 1.92284737273655,
      3.15885378984306, 5.051093123296, 7.77724957898779,
    ],
    10: [
      0.0813240759340405, 0.13678129717089, 0.222247863196324, 0.36304633465413,
      0.627138494322606, 1.10579974710528, 1.87360023266955, 3.07663862895619,
      4.93152295839636, 7.62196695057808,
    ],
    11: [
      0.0797616109353796,
      0.134009310436058,
      0.218110502962953,
      0.357066826548583,
      0.616597825833384,
      1.08605987047139,
      null,
      null,
      null,
      null,
    ],
    12: [
      0.0780384842740956,
      0.131010197110932,
      0.213360619835536,
      0.34997648116557,
      0.604710495248331,
      1.06492065943361,
      null,
      null,
      null,
      null,
    ],
    13: [
      0.0770333247225767,
      0.129270910351236,
      0.21063963508649,
      0.345891341656691,
      0.597792418221973,
      1.05257860637356,
      null,
      null,
      null,
      null,
    ],
    14: [
      0.0761995316735919,
      0.127846513370997,
      0.208432553582229,
      0.342508041824223,
      0.591999778466461,
      1.04239329039884,
      null,
      null,
      null,
      null,
    ],
    15: [
      0.0754506553941195,
      0.126579803929592,
      0.206258805071462,
      0.339256512431888,
      0.586827955521927,
      1.03353228339096,
      null,
      null,
      null,
      null,
    ],
    16: [
      0.0750211174643829,
      0.125859516342357,
      0.205175663899177,
      0.33758161756625,
      0.583927954707631,
      null,
      null,
      null,
      null,
      null,
    ],
    17: [
      0.0747063214060598,
      0.12533828574516,
      0.204396027516499,
      0.336380921358495,
      0.581857570371456,
      null,
      null,
      null,
      null,
      null,
    ],
    18: [
      0.0744359476707369,
      0.124896185981434,
      0.203726940721667,
      0.335350133866523,
      0.580115400334381,
      null,
      null,
      null,
      null,
      null,
    ],
    19: [
      0.0742813541726859,
      0.124649807544567,
      0.20336158623666,
      0.334786196814001,
      0.579139668942632,
      null,
      null,
      null,
      null,
      null,
    ],
    20: [
      0.0741723629901656,
      0.124481197783546,
      0.203110387945323,
      0.334392315882392,
      0.578459821044871,
      null,
      null,
      null,
      null,
      null,
    ],
  },
}

export const rates = {
  bands: {
    single: {
      age: [
        [18, 25],
        [26, 30],
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
        [56, 60],
        [61, 65],
        [66, 70],
      ],
    },
    joint: {
      male: [
        [18, 25],
        [26, 30],
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
        [56, 60],
        [61, 65],
        [66, 70],
      ],
      female: [
        [18, 25],
        [26, 30],
        [31, 35],
        [36, 40],
        [41, 45],
        [46, 50],
        [51, 55],
        [56, 60],
        [61, 65],
        [66, 70],
      ],
    },
  },
  single: {
    1: {
      5: [
        1.3670735674842012, 1.5648276550386222, 1.7432180732104303,
        1.9909630068537376, 2.659471824324276, 3.6747221863672825,
        6.221700555358624, 9.625451858451713, 14.045387460043413,
        20.994353132036064,
      ],
      6: [
        0.8426552306827394, 0.9664961998264174, 1.0800495660219038,
        1.2385745664493915, 1.6646139989876487, 2.3022860600636355,
        3.894362664685657, 6.0412327817013765, 8.833939966198633,
        13.209002143377573,
      ],
      7: [
        0.7072276883550423, 0.8126349395224456, 0.9103933259618616,
        1.0472568157851567, 1.4115558196198983, 1.954584145149423,
        3.308109363661834, 5.141619646901038, 7.529166825168933,
        11.259876609741672,
      ],
      8: [
        0.6271264381045091, 0.7216493659204402, 0.81040168510135,
        0.934514445952174, 1.2622681772935451, 1.749049603389179,
        2.961175448111092, 4.608164833268464, 6.754207304259659,
        10.101759308033103,
      ],
      9: [
        0.5629214113498755, 0.6494053847833071, 0.7306486850491405,
        0.8432265085715678, 1.1405798342651627, 1.580915738980943,
        2.6768980358341343, 4.1693519113050295, 6.114662087066053,
        9.14528694312464,
      ],
      10: [
        0.5325108877275442, 0.6147908275551817, 0.6927713491411528,
        0.8006739404521079, 1.0840669114007981, 1.5028156198468967,
        2.544791672958392, 3.9659215949120283, 5.818772654362226,
        8.702487896747567,
      ],
      11: [
        0.5124630313913835,
        0.5921800212448103,
        0.6679101252947659,
        0.7723982886399631,
        1.0461661921958771,
        1.4815397239980252,
        null,
        null,
        null,
        null,
      ],
      12: [
        0.4947005353757798,
        0.5720082292198166,
        0.6457512502163373,
        0.7480234897471375,
        1.0124602713313509,
        1.4619133641153674,
        null,
        null,
        null,
        null,
      ],
      13: [
        0.4845652843571022,
        0.5605203379936439,
        0.6331014325491663,
        0.7335588339337354,
        0.9929102446531235,
        1.450907080849351,
        null,
        null,
        null,
        null,
      ],
      14: [
        0.47704040273839915,
        0.5519539635137914,
        0.6235768441433872,
        0.7225615221816871,
        0.9778871633995014,
        1.4424178611287077,
        null,
        null,
        null,
        null,
      ],
      15: [
        0.4706225600365282,
        0.5446292808646316,
        0.615402000186339,
        0.7130719254075777,
        0.9648936420592839,
        1.4350732676966909,
        null,
        null,
        null,
        null,
      ],
      16: [
        0.4668008103874027,
        0.5402906176199391,
        0.6105731819929314,
        0.7074644558420312,
        0.961753277066553,
        null,
        null,
        null,
        null,
        null,
      ],
      17: [
        0.46402189189087206,
        0.5371402223444142,
        0.6070630555983036,
        0.7033780150847161,
        0.9594611216071678,
        null,
        null,
        null,
        null,
        null,
      ],
      18: [
        0.4617062916890641,
        0.5345100952288908,
        0.6041198656622722,
        0.6999394449507603,
        0.957530328171232,
        null,
        null,
        null,
        null,
        null,
      ],
      19: [
        0.4603029248629775,
        0.5329262296503324,
        0.6023524313644628,
        0.697866232108609,
        0.956363458932414,
        null,
        null,
        null,
        null,
        null,
      ],
    },
    2: {
      5: [
        0.8604900672573738, 1.0071001859130766, 1.084993149290211,
        1.1338516661845786, 1.36447578476497, 1.695904261663887,
        2.6675514351080665,
      ],
      6: [
        0.5331089955264294, 0.6256297796798278, 0.6764886037196918,
        0.7120653516772891, 0.8667024777245949, 1.0935908140232649,
        2.2734240181809384,
      ],
      7: [
        0.44864096367492784, 0.5281625780389271, 0.5722275247698028,
        0.6038144736400086, 0.7390695916116671, 0.9386126393081147,
        2.171809197702128,
      ],
      8: [
        0.39895618410130745, 0.4700357964385708, 0.5101290243633131,
        0.5399257575832507, 0.6635593412403278, 0.8465462492185164,
        2.1112933193899934,
      ],
      9: [
        0.3591596906346026, 0.42334776361716875, 0.46016236169495317,
        0.4883343908023344, 0.6021944305304432, 0.7712363016475083,
        2.061679693698891,
      ],
      10: [
        0.34056471978011915, 0.4013753031990826, 0.43670404312706057,
        0.4648960273058903, 0.5743818980389264, 0.7365079883758754,
        2.038839862233826,
      ],
      11: [
        0.3283790905642363,
        0.3870742596019026,
        0.4213796361868592,
        0.4489481992373428,
        0.5553913601286967,
        0.7264438969149601,
        null,
      ],
      12: [
        0.3175832077493182,
        0.37437399663855425,
        0.4077831115375878,
        0.4347923155881294,
        0.5382276706782975,
        0.7172277930724638,
        null,
      ],
      13: [
        0.3115405042943719,
        0.3672486466708664,
        0.4001330306802142,
        0.42682435401808316,
        0.5284816314573606,
        0.7119548486888899,
        null,
      ],
      14: [
        0.30709432114456536,
        0.3619874350225758,
        0.3944392382340334,
        0.4208385414850534,
        0.521146069151262,
        0.7079917281434988,
        null,
      ],
      15: [
        0.3032820628570842,
        0.3574795633098822,
        0.38956669189409393,
        0.41571544382553793,
        0.514935692427405,
        0.7046665337273676,
        null,
      ],
      16: [
        0.3010640595374274,
        0.3548537607008861,
        0.3867304433442186,
        0.41273262677354217,
        0.5133456746522167,
        null,
        null,
      ],
      17: [
        0.29946686978527126,
        0.35296290560816423,
        0.3846886973863935,
        0.41058593242804814,
        0.5122014680781602,
        null,
        null,
      ],
      18: [
        0.29813181174380055,
        0.3513854681179817,
        0.3829872933918096,
        0.4088017956280436,
        0.5112523460772639,
        null,
        null,
      ],
      19: [
        0.29735095937105105,
        0.3504601165061837,
        0.3819887524611811,
        0.4077523719581742,
        0.51069310791664,
        null,
        null,
      ],
    },
    3: {
      5: [
        0.9726510813173758, 1.2148010611416056, 1.446008573092514,
        1.6847089752648274, 2.317018198774315, 3.4020920370501657,
        6.095749126438629, 9.966358392800055, 14.836987007687801,
        21.15905690558194,
      ],
      6: [
        0.6049582397778619, 0.7598602559360871, 0.9085153916807165,
        1.0688618306367843, 1.4940106538266826, 2.2260709739066398,
        4.072397935537381, 6.839156764934122, 10.5232934761881,
        15.66511604951698,
      ],
      7: [
        0.5099495194601269, 0.6426588887096054, 0.7707189647631744,
        0.9116783340804987, 1.2839598141044346, 1.9246672452339912,
        3.5318380265975997, 5.963614480888069, 9.25073732080888,
        13.931570828341512,
      ],
      8: [
        0.45414527619159345, 0.5735385214822546, 0.6906350169639794,
        0.8200282285591795, 1.1592797623059001, 1.7427019313484589,
        3.2069557563269013, 5.43941108823602, 8.48585511539055,
        12.890984809701278,
      ],
      9: [
        0.40983440212532013, 0.5178363495647421, 0.6248147136052725,
        0.7448366203766883, 1.0576198275026867, 1.5942292185053049,
        2.9438878328508453, 5.019999942299638, 7.888006665184161,
        12.106357123036222,
      ],
      10: [
        0.38894615845682173, 0.4918936541447661, 0.5942703876216966,
        0.7106188764952067, 1.0115444997505743, 1.5259304705629866,
        2.8217382956307047, 4.821979969346731, 7.59995068897733,
        11.723482354388496,
      ],
      11: [
        0.37528314938272744,
        0.47473077673571107,
        0.5739340618500076,
        0.6879692207531946,
        0.9809460300753889,
        1.5084057345900925,
        null,
        null,
        null,
        null,
      ],
      12: [
        0.36311820519576177,
        0.45952719538128106,
        0.5558885637107124,
        0.6671391872347625,
        0.9522640981026239,
        1.4920253263123102,
        null,
        null,
        null,
        null,
      ],
      13: [
        0.3562892934691101,
        0.4509288625266553,
        0.5457137323352542,
        0.6553052760594081,
        0.9357721158085717,
        1.4825736975649086,
        null,
        null,
        null,
        null,
      ],
      14: [
        0.35122857977421373,
        0.4445112125233407,
        0.538072556695704,
        0.6462927412935593,
        0.9230639783601919,
        1.475274558485826,
        null,
        null,
        null,
        null,
      ],
      15: [
        0.3468906464559995,
        0.43900848922803243,
        0.5315362999353165,
        0.6386248609318503,
        0.9122516768504089,
        1.4690577756093905,
        null,
        null,
        null,
        null,
      ],
      16: [
        0.3443655862424144,
        0.43580647903191827,
        0.5277587187852896,
        0.6342350599452095,
        0.9098001084680133,
        null,
        null,
        null,
        null,
        null,
      ],
      17: [
        0.3425451476652057,
        0.4335017338168374,
        0.5250381361784976,
        0.6310824186537161,
        0.9080443543799172,
        null,
        null,
        null,
        null,
        null,
      ],
      18: [
        0.3410224319335477,
        0.4315774850663956,
        0.5227673797776599,
        0.628460191262449,
        0.9065878625909035,
        null,
        null,
        null,
        null,
        null,
      ],
      19: [
        0.3401333622099671,
        0.43045792937675087,
        0.5214485948618613,
        0.6269312622456354,
        0.9057362118492726,
        null,
        null,
        null,
        null,
        null,
      ],
    },
    4: {
      5: [
        1.8699238951361263, 2.2954068681912916, 2.795209975678108,
        3.4478445278641847, 4.8440093998468186, 6.921922364198408,
        11.837162256730181, 17.49669293426034,
      ],
      6: [
        1.1625640198638494, 1.4334920012064292, 1.7595242420418542,
        2.1870624546987947, 3.109416581712306, 4.518053548014501,
        7.900498618160095, 11.914462077563108,
      ],
      7: [
        0.9791380049536281, 1.2107851990861538, 1.4903974624018999,
        1.8603827364526069, 2.6609557875359555, 3.8857698309582287,
        6.803990964501341, 10.317934624678402,
      ],
      8: [
        0.8703146223209457, 1.0786199894028687, 1.3309892100924352,
        1.6672895903018647, 2.3952652823640594, 3.5096626842374037,
        6.149522464499728, 9.362189195001285,
      ],
      9: [
        0.7826911765511249, 0.9720662676618839, 1.202502019403991,
        1.5113410262410056, 2.1797292596128477, 3.2047847996011387,
        5.624716081097212, 8.603121884166919,
      ],
      10: [
        0.7407990287806939, 0.9215355769702158, 1.1422437400099905,
        1.439090802765541, 2.080045640388884, 3.062523220231189,
        5.37513641143811, 8.238476566079079,
      ],
      11: [
        0.7133579017851678,
        0.8880123365222785,
        1.1019525869263818,
        1.3908984579439998,
        2.013435365671307,
        3.0245161499040045,
        null,
        null,
      ],
      12: [
        0.6889950781556243,
        0.8585235907172277,
        1.0664961163250224,
        1.3472294630977195,
        1.9521343929659345,
        2.9896023534064216,
        null,
        null,
      ],
      13: [
        0.6749282905695624,
        0.8415267956229818,
        1.0461280611563282,
        1.322162837892658,
        1.9165844516674062,
        2.9692123669324966,
        null,
        null,
      ],
      14: [
        0.6644267410530705,
        0.8287345135067162,
        1.03066657047138,
        1.3032165267084161,
        1.8894376371715944,
        2.953495316522143,
        null,
        null,
      ],
      15: [
        0.6554644384814933,
        0.8178007071167922,
        1.0174951886786965,
        1.2870719523938758,
        1.8666896680876792,
        2.9404795923623475,
        null,
        null,
      ],
      16: [
        0.6501097670381666,
        0.8113187687801767,
        1.0097051258826322,
        1.2775133017390774,
        1.8612771509813812,
        null,
        null,
        null,
      ],
      17: [
        0.6462067513393667,
        0.806603546943222,
        1.004059835556794,
        1.2706000142100897,
        1.8573681497657233,
        null,
        null,
        null,
      ],
      18: [
        0.6429669897904615,
        0.8026902383152132,
        0.999374086078926,
        1.2648934498028965,
        1.854152913084049,
        null,
        null,
        null,
      ],
      19: [
        0.6409878045929902,
        0.8003224404856102,
        0.996556283701147,
        1.261447009382004,
        1.8522052505150426,
        null,
        null,
        null,
      ],
    },
    5: {
      5: [
        1.507639099635999, 1.7854835811590908, 2.055778279240325,
        2.3962129720807983, 3.2295250314789814, 4.439722323187026,
        7.412685163501383, 10.286730518930435,
      ],
      6: [
        0.9347734044674256, 1.1135016646717861, 1.2867552447500905,
        1.5070000652557527, 2.0556756943805943, 2.86393682027966,
        4.8437945389019, 6.730899235129797,
      ],
      7: [
        0.7879837200630875, 0.9405191345418472, 1.087827563184866,
        1.279265619934512, 1.7528057165624515, 2.4504757089049,
        4.123532314999157, 5.734542113558601,
      ],
      8: [
        0.6999721397247642, 0.8368620682177439, 0.9703631313093318,
        1.1467185980264887, 1.5753686878013504, 2.2050123344850068,
        3.6955476463614962, 5.142074496149093,
      ],
      9: [
        0.6292443232087866, 0.7533537794663753, 0.8755620822421797,
        1.0376362701670423, 1.4292532553989576, 2.0049267716536057,
        3.3517741902263447, 4.668766620002246,
      ],
      10: [
        0.5963539562735841, 0.7137279469723198, 0.8309835665696418,
        0.9867891987083973, 1.361337943479886, 1.9116324327035883,
        3.187678480557544, 4.441369668176506,
      ],
      11: [
        0.5742024158386825,
        0.6877178086785658,
        0.8014268817871422,
        0.9527765266723994,
        1.3158015699794474,
        1.886088743624058,
        null,
        null,
      ],
      12: [
        0.5545559628367855,
        0.6646192961687665,
        0.7753479814197016,
        0.9222653983677365,
        1.2740704538978418,
        1.8626022343607747,
        null,
        null,
      ],
      13: [
        0.5432763923082988,
        0.6513803683225271,
        0.7603961897750067,
        0.9049329803191651,
        1.2502026219351834,
        1.8490335797605577,
        null,
        null,
      ],
      14: [
        0.5348656668476643,
        0.641463936727021,
        0.7490721230427569,
        0.8916798371441971,
        1.2321445405441782,
        1.8388599539934016,
        null,
        null,
      ],
      15: [
        0.5276981631251779,
        0.6330043820803074,
        0.7394109307790518,
        0.8803482748172032,
        1.216705010245749,
        1.8301754725028172,
        null,
        null,
      ],
      16: [
        0.5234183107531238,
        0.6279764425047843,
        0.7336680686892121,
        0.8736181840784203,
        1.2129414327816734,
        null,
        null,
        null,
      ],
      17: [
        0.520303422472004,
        0.6243267163096261,
        0.7295011657756327,
        0.8687304202246021,
        1.2102076539006132,
        null,
        null,
        null,
      ],
      18: [
        0.5177127948938637,
        0.621289940158888,
        0.7260271882889202,
        0.8646635308184821,
        1.2079381798504067,
        null,
        null,
        null,
      ],
      19: [
        0.5161369281010781,
        0.6194530774116517,
        0.7239577851466467,
        0.8622269542879675,
        1.2065632306409169,
        null,
        null,
        null,
      ],
    },
    6: {
      5: [
        1.4751308714421463, 1.7690184387028955, 2.0796051141386465,
        2.468136815728111, 3.400749636440767, 4.850955934960697,
        8.43224218817372, 13.410498194109666, 19.40259342939925,
        27.347115925078572,
      ],
      6: [
        1.0687090667221504, 1.282638890260507, 1.5015534169039826,
        1.7861229279568773, 2.4808403768425715, 3.5926151923330663,
        6.404068021587468, 10.69921744184281, 16.793637826390984,
        26.23150236348408,
      ],
      7: [
        1.0608729372248986, 1.2751833705213984, 1.4948385107172844,
        1.7811896329292998, 2.4810796337326244, 3.596358388904277,
        6.410541050443456, 10.713167340172792, 16.80985386764578,
        26.247812939354237,
      ],
      8: [
        1.060189749866846, 1.2758135942692899, 1.4974346997157837,
        1.7891294239288271, 2.4958946168035046, 3.616439076088642,
        6.4454344475567815, 10.769738528479738, 16.88667493295873,
        26.34702625258923,
      ],
      9: [
        1.0632633805900626, 1.2807478806737698, 1.50490893861993,
        1.8005377247550731, 2.5151251775207384, 3.6445568185686246,
        6.4932916300348085, 10.844562138427277, 16.988166035742157,
        26.47710601605526,
      ],
      10: [
        1.0648811914487377, 1.2837034206600026, 1.5097646227462818,
        1.8085588549256328, 2.528522528862734, 3.6634486719645243,
        6.525104672690903, 10.892855025717486, 17.050822060325228,
        26.553607356856286,
      ],
      11: [
        1.068820929543727,
        1.2893966805986028,
        1.5178235244459901,
        1.8200436587342117,
        2.545975851500695,
        3.6733863946901333,
        null,
        null,
        null,
        null,
      ],
      12: [
        1.072956555390838,
        1.2951328901583177,
        1.5257180598486566,
        1.8309286848359434,
        2.562537194518156,
        3.682961106758857,
        null,
        null,
        null,
        null,
      ],
      13: [
        1.0757464931295064,
        1.2991480051386943,
        1.5313837644744472,
        1.838985478073298,
        2.5746707614787256,
        3.6898565095176648,
        null,
        null,
        null,
        null,
      ],
      14: [
        1.078362491491901,
        1.3028471304827602,
        1.5365447823976952,
        1.8461750046657897,
        2.5852369919329705,
        3.6958080736302894,
        null,
        null,
        null,
        null,
      ],
      15: [
        1.0808206147241635,
        1.306258739554008,
        1.5412217476566406,
        1.852493249628849,
        2.5942740343851374,
        3.700865926690562,
        null,
        null,
        null,
        null,
      ],
      16: [
        1.0826387682728793,
        1.3088180554808844,
        1.544847737027447,
        1.8572462983512765,
        2.5970513690904826,
        null,
        null,
        null,
        null,
        null,
      ],
      17: [
        1.0842389829154064,
        1.3110463145429292,
        1.5479449563409562,
        1.8612612075738943,
        2.599351385356312,
        null,
        null,
        null,
        null,
        null,
      ],
      18: [
        1.0856339524412761,
        1.3129459898708251,
        1.5505341609158965,
        1.8645789930400907,
        2.6012408696241502,
        null,
        null,
        null,
        null,
        null,
      ],
      19: [
        1.0866971211799419,
        1.3144115973942176,
        1.5525163281300414,
        1.867072493268253,
        2.602649718675451,
        null,
        null,
        null,
        null,
        null,
      ],
    },
    7: {
      5: [
        0.531430753675874,
        0.5318137021101506,
        0.5782064403877905,
        0.7013183705718941,
        0.8865063703573255,
        1.1660860602530432,
        1.3815708173855008,
        null,
        null,
        null,
      ],
      6: [
        0.393532506828866,
        0.39570148676657424,
        0.43347100335134225,
        0.5269057374575475,
        0.670418076071963,
        0.8825245610798855,
        1.2156400568947974,
        null,
        null,
        null,
      ],
      7: [
        0.348919974543217,
        0.3520557576187927,
        0.3876921876087084,
        0.4722722393649011,
        0.6026999627987921,
        0.7908628707660585,
        1.160962294656851,
        null,
        null,
        null,
      ],
      8: [
        0.31936994581413247,
        0.3230879148092961,
        0.3571971516958692,
        0.43613653198790503,
        0.5575762190822957,
        0.7289850743183692,
        1.12409963289722,
        null,
        null,
        null,
      ],
      9: [
        0.29353397883859916,
        0.29758973823383017,
        0.33001542361231895,
        0.4038843970150794,
        0.5170289854980289,
        0.6737952749925193,
        1.091637186844336,
        null,
        null,
        null,
      ],
      10: [
        0.28056565745591794,
        0.28493494803433894,
        0.3166481424800235,
        0.3882218461487347,
        0.49722437731087504,
        0.6457141170991771,
        1.0748220545243572,
        null,
        null,
        null,
      ],
      11: [
        0.2713521516255589,
        0.2761029343764269,
        0.3072582593014154,
        0.377249900365656,
        0.483270364651283,
        0.6376800324550276,
        null,
        null,
        null,
        null,
      ],
      12: [
        0.2629986721284268,
        0.2678723423549648,
        0.2984437043836322,
        0.36679872275266784,
        0.46985392237500057,
        0.6300077392100987,
        null,
        null,
        null,
        null,
      ],
      13: [
        0.25800998116286844,
        0.2629196773019854,
        0.29316849572093034,
        0.36051880614412674,
        0.4616734442013633,
        0.625308067635562,
        null,
        null,
        null,
        null,
      ],
      14: [
        0.2542279201981086,
        0.259125239729835,
        0.28905987822313683,
        0.3555932328532522,
        0.45524317161380423,
        0.621628636172606,
        null,
        null,
        null,
        null,
      ],
      15: [
        0.25101454705565907,
        0.25592249865655725,
        0.28555965164810515,
        0.3513356752857172,
        0.44969145461374116,
        0.6184630998478815,
        null,
        null,
        null,
        null,
      ],
      16: [
        0.24902283021674604,
        0.2539450286114254,
        0.2834136978307147,
        0.34871561719692035,
        0.44821134386794537,
        null,
        null,
        null,
        null,
        null,
      ],
      17: [
        0.24754801145484734,
        0.25248272994130416,
        0.2818227743933192,
        0.34675723390789265,
        0.44710275943353395,
        null,
        null,
        null,
        null,
        null,
      ],
      18: [
        0.2463239261007281,
        0.25126779590998244,
        0.280492314327385,
        0.34510941019375535,
        0.44617054090050645,
        null,
        null,
        null,
        null,
        null,
      ],
      19: [
        0.2455411269026372,
        0.2504960779789295,
        0.27964919373730635,
        0.344053858368918,
        0.44557014095821246,
        null,
        null,
        null,
        null,
        null,
      ],
    },
  },
  jointFirst: {
    1: {
      5: {
        0: [
          2.103345353311863, 2.2199631658582484, 2.543868084127416,
          3.183943312096723, 4.246984621810634, 5.940208874211985,
          8.33893453336784, 11.70101089705563, 16.98171431508956,
          24.344979151541732,
        ],
        1: [
          2.169556169911158, 2.273816692612939, 2.5933510162517175,
          3.233053078123403, 4.296198703832523, 5.989789461044041,
          8.389307386293419, 11.750904309118402, 17.030831826485713,
          24.394897938816687,
        ],
        2: [
          2.4010287121367284, 2.4733678601444877, 2.7223140716823067,
          3.3593667358163923, 4.423034137354926, 6.116811003719418,
          8.517922506604453, 11.87692202903132, 17.15701980220994,
          24.522966692388074,
        ],
        3: [
          2.938523215598453, 3.0043206026850813, 3.1252333880218224,
          3.6205835330776672, 4.696468735305398, 6.393701491935092,
          8.795409813263554, 12.156636631257236, 17.366925148306287,
          24.79963648070065,
        ],
        4: [
          3.891180742489084, 3.95690571944582, 4.077348330666486,
          4.323136145017813, 5.207919651728944, 6.920261822050874,
          9.32549498931841, 12.690559897267772, 17.903615354983792,
          25.26731543840911,
        ],
        5: [
          5.426830202625466, 5.4928370706318494, 5.613637567522938,
          5.8748398308471454, 6.374957450398007, 7.793940396504227,
          10.204806109571923, 13.573166334707217, 18.793519495506867,
          26.157132043998732,
        ],
        6: [
          7.703035322976621, 7.769508536117021, 7.89042690427487,
          8.152799944908478, 8.66975715861844, 9.539179317758883,
          11.540020613258095, 14.909147843004877, 20.137879811970684,
          27.50414756655708,
        ],
        7: [
          10.779823180509975, 10.846281443160693, 10.968666504831841,
          11.230931884872408, 11.749242511998034, 12.61539298771412,
          13.975609931641266, 16.857964868855213, 22.062883945116987,
          29.434105930284368,
        ],
        8: [
          15.36204692081114, 15.42816814607366, 15.55041561876793,
          15.81278455704934, 16.331598672911163, 17.199957179135602,
          18.527432683981147, 20.61015639730898, 25.038639035782694,
          32.362863067428364,
        ],
        9: [
          22.634238392472753, 22.701049149707313, 22.82343594962575,
          23.088608026647947, 23.606988643664426, 24.477558447595612,
          25.803004081988675, 27.78977436654752, 30.942713394180394,
          37.14753332626571,
        ],
      },
      6: {
        0: [
          1.298986932358031, 1.3717551420241225, 1.573835934115818,
          1.9779235958951622, 2.6394726253474032, 3.704379345653172,
          5.216801110902322, 7.331852300683099, 10.61483602188458,
          15.246863047753275,
        ],
        1: [
          1.3426354346164542, 1.4083065776698702, 1.606443211245192,
          2.007084036273641, 2.672082763307726, 3.729010595969443,
          5.249317836238862, 7.364341746248918, 10.64732719602013,
          15.279308393037255,
        ],
        2: [
          1.4884346290630275, 1.5357098518107966, 1.6917118072541122,
          2.089196903781022, 2.754732976801784, 3.812048359693637,
          5.323547388681572, 7.446542633573514, 10.729519216225011,
          15.361401772382976,
        ],
        3: [
          1.8299465458046253, 1.8721391380136292, 1.9477397578986277,
          2.2661160320389833, 2.9318697381261196, 3.9906573166198003,
          5.489735853898328, 7.622936848480935, 10.905959851544452,
          15.537661669317107,
        ],
        4: [
          2.427603614899933, 2.4697243093436856, 2.548079475936264,
          2.7153183198155344, 3.2672851908612053, 4.3280701449167065,
          5.829390513412184, 7.933038282320084, 11.240733627134281,
          15.836619038388097,
        ],
        5: [
          3.3836867198732445, 3.426050357305171, 3.504612761843671,
          3.674140148240528, 4.009477173266599, 4.886021134865743,
          6.389050286609928, 8.494748472096974, 11.758298878772441,
          16.39664655069968,
        ],
        6: [
          4.8030014533912695, 4.845779650065106, 4.9245118445270935,
          5.094837260227127, 5.426580614153378, 5.98836682156999,
          7.242158696318334, 9.340793695402468, 12.607632184532132,
          17.219836669538793,
        ],
        7: [
          6.729786453135395, 6.772290614032554, 6.851804120546815,
          7.021789309201182, 7.354780157334077, 7.911337799580707,
          8.79163050292074, 10.603509566313942, 13.831009194928331,
          18.44431265943322,
        ],
        8: [
          9.603309108905297, 9.646522424011742, 9.725094624940951,
          9.895393709367731, 10.22886169024093, 10.782460577915124,
          11.6423223925222, 12.992278581626785, 15.771801760585811,
          20.33506324602801,
        ],
        9: [
          14.157038471396623, 14.197909613006068, 14.277762072935136,
          14.449671992224168, 14.783057084987933, 15.338587099337222,
          16.181819828667948, 17.4734580657709, 19.51576824592324,
          23.433671580658206,
        ],
      },
      7: {
        0: [
          1.0908893119567336, 1.1527570573765216, 1.3266975975244735,
          1.666921176416059, 2.2277953146392395, 3.128592659796432,
          4.408397148705324, 6.200657086735251, 8.981391226442414,
          12.909741467458582,
        ],
        1: [
          1.1295626920173705, 1.1857637231670748, 1.356087992156834,
          1.6958847235265, 2.2570294921063625, 3.157558340052085,
          4.43735440608163, 6.22960957259464, 9.0103553948343,
          12.938668818180961,
        ],
        2: [
          1.2545001774630438, 1.2959132993411164, 1.428525113924668,
          1.768127811352938, 2.329541210226557, 3.2242908342253216,
          4.509590080352168, 6.301838462943314, 9.08260599831478,
          13.010840746915836,
        ],
        3: [
          1.5446731043132225, 1.5815471543314672, 1.6530137605500053,
          1.920463609428934, 2.4840334201855674, 3.3797971777077613,
          4.64917671663397, 6.455705905086058, 9.236504462753162,
          13.164593811617655,
        ],
        4: [
          2.052421807505721, 2.08899845419575, 2.1579098674879855,
          2.3108702227095983, 2.776635403031304, 3.671553580069528,
          4.942369700632307, 6.725550244021429, 9.525953148725675,
          13.453818588073936,
        ],
        5: [
          2.8628678487356223, 2.8995616357755685, 2.9685887841058385,
          3.1170266642276294, 3.412662723900173, 4.155925999181004,
          5.423373740119586, 7.207899295048303, 9.991305894207368,
          13.905889768291583,
        ],
        6: [
          4.06365582498988, 4.100547936245301, 4.169901828425667,
          4.318847525560064, 4.606594224722317, 5.09797729594708,
          6.163496695450984, 7.936481319241631, 10.699328308169365,
          14.629244098767593,
        ],
        7: [
          5.699175218281918, 5.736163409015765, 5.805427253017788,
          5.954612811392375, 6.243517696591776, 6.7276564723102705,
          7.494451754026118, 9.037517099105788, 11.761571949199377,
          15.669878662697268,
        ],
        8: [
          8.141106802589864, 8.178107706056839, 8.247701721496774,
          8.396880788978777, 8.684782817839215, 9.16657003977415,
          9.91648565322307, 11.090179235234757, 13.455046861975465,
          17.31884254920808,
        ],
        9: [
          12.004225611006127, 12.041288996632435, 12.111009848166336,
          12.260803783796563, 12.549210843037603, 13.025623711131672,
          13.761576269931684, 14.888010782868218, 16.663180325587,
          20.009708318258337,
        ],
      },
      8: {
        0: [
          0.9673272799378584, 1.02285832251023, 1.1782373212173165,
          1.4823789041661517, 1.9833184050843111, 2.7861209013729815,
          3.927206790707528, 5.527121713826791, 8.008642777892483,
          11.517424248227027,
        ],
        1: [
          1.0031204608332833, 1.0538117863219987, 1.2057107278906338,
          1.509325354525088, 2.010382116676502, 2.8130786318397014,
          3.9541355285346595, 5.554048912822546, 8.035571189939699,
          11.544314581496161,
        ],
        2: [
          1.1159314403895693, 1.1539285131571737, 1.2753652954665036,
          1.5757635505696552, 2.0771779407775774, 2.8796655477466,
          4.020578916078093, 5.620502481646229, 8.102027104133983,
          11.610688538670356,
        ],
        3: [
          1.3756695111887098, 1.4097840257922278, 1.4765779920427677,
          1.7189057269501773, 2.2181958780419273, 3.0167898313499295,
          4.1611271367163685, 5.7610552783863875, 8.2425835298318,
          11.751094953313562,
        ],
        4: [
          1.8295283851621296, 1.8628982512950634, 1.9275141799174849,
          2.069521992019741, 2.4866852392131156, 3.2811534912100995,
          4.41449372479915, 6.014028858127544, 8.504908429942821,
          12.013187018931465,
        ],
        5: [
          2.553063779872116, 2.58651839274039, 2.650035099629326,
          2.7879008011090862, 3.0592790632392246, 3.723648663326662,
          4.850588431095435, 6.442751400528014, 8.925410181493973,
          12.423100982162737,
        ],
        6: [
          3.6238742321351, 3.6574791241334683, 3.721371911417353,
          3.857376866465672, 4.121711084333883, 4.570089570331965,
          5.524124172133801, 7.105040374693704, 9.56571858205556,
          13.076199817990517,
        ],
        7: [
          5.085499000867096, 5.119151587303718, 5.183286681915028,
          5.320492816938332, 5.584195690595557, 6.026408517718918,
          6.724177455426734, 8.108020784013004, 10.535073249593449,
          14.023731398069113,
        ],
        8: [
          7.269980983183975, 7.303522763466726, 7.36745320731992,
          7.505006032599464, 7.768786600510328, 8.208563036826089,
          8.892323486012335, 9.95922424275021, 12.078454930535884,
          15.528623167409663,
        ],
        9: [
          10.740705349353096, 10.774036997753484, 10.819487756501726,
          10.95615333151148, 11.219706826832578, 11.6550557408078,
          12.326165508220662, 13.352977443536684, 14.966216886630548,
          17.97294711278363,
        ],
      },
      9: {
        0: [
          0.8679416163029969, 0.9183497510061989, 1.0586589807459883,
          1.3331756527768697, 1.7848779900396083, 2.507771050743223,
          3.535571055576545, 4.978005783810312, 7.214566553058569,
          10.379137071310975,
        ],
        1: [
          0.9011953624521105, 0.9473544972466396, 1.0843481414166953,
          1.3582828951296737, 1.8101223297757483, 2.5328492683358212,
          3.560655306805092, 5.003103922307747, 7.239659137292648,
          10.40420077694037,
        ],
        2: [
          1.0040255657596497, 1.0390374939272473, 1.1494161863607888,
          1.419913052662051, 1.871832714099644, 2.594385454859494,
          3.6220672579117723, 5.064494402039685, 7.301065509484668,
          10.465524854625704,
        ],
        3: [
          1.2389844680839222, 1.2706541547291739, 1.3330791519140526,
          1.5527957744746823, 2.001919691994405, 2.7204548644975795,
          3.7510583895697494, 5.193503890720178, 7.430071044524846,
          10.594395332246478,
        ],
        4: [
          1.6485327386674316, 1.6795423902971431, 1.740094443249595,
          1.8718749879070673, 2.2491865647986855, 2.9629248167046964,
          3.9829314899058703, 5.424728838485925, 7.669307855750846,
          10.833407189160754,
        ],
        5: [
          2.3005420069676106, 2.3313028535298033, 2.3909120343354298,
          2.519068541307847, 2.768735797622502, 3.3685062641639627,
          4.382369778883726, 5.817177475427233, 8.052155542933065,
          11.225918997047422,
        ],
        6: [
          3.2651482101357496, 3.296043342105256, 3.354935338826505,
          3.481568574877131, 3.7250111734315614, 4.135790315995642,
          4.99813440813604, 6.422922130338338, 8.638770305563042,
          11.804337517336908,
        ],
        7: [
          4.584545464102629, 4.615525931879908, 4.675244790698333,
          4.802272927981605, 5.045369251737495, 5.450527039432574,
          6.088576964808909, 7.340863449845553, 9.527161023545222,
          12.674016745092562,
        ],
        8: [
          6.557314789833693, 6.588666244519869, 6.648630621727511,
          6.77636243446277, 7.019610704856481, 7.42283844019434,
          8.048152257896517, 9.022960417084741, 10.93962755062839,
          14.052521015669747,
        ],
        9: [
          9.688007048364327, 9.719247286795952, 9.7787053045414,
          9.890535387075797, 10.133152165384956, 10.532439460251858,
          11.146983496649964, 12.086246812853481, 13.560064641823473,
          16.2842637055278,
        ],
      },
      10: {
        0: [
          0.8203263355817183, 0.8684602880139266, 1.0016118529851163,
          1.2621522038966049, 1.6905770976696226, 2.3753203902025897,
          3.349319660592343, 4.717213790423383, 6.83769049935073,
          9.839599654610453,
        ],
        1: [
          0.8525520488762426, 0.8966951298996665, 1.026884522587598,
          1.2866045038600997, 1.7151721761742866, 2.399831875605605,
          3.373786153506837, 4.741674523745173, 6.862160617751119,
          9.864037591082916,
        ],
        2: [
          0.9509706197658758, 0.9848435138671671, 1.090311914309368,
          1.3468378967226262, 1.774847246489663, 2.459371799359607,
          3.4331983981757332, 4.80108926588193, 6.921585614827423,
          9.923583639902002,
        ],
        3: [
          1.1745581188364203, 1.2053105584455777, 1.2662829757695868,
          1.475678006176904, 1.901136231847564, 2.580932274376236,
          3.5572811962335456, 4.925228727659361, 7.045671974560129,
          10.048268899904262,
        ],
        4: [
          1.5633649846087927, 1.5935327567032997, 1.6527371069255743,
          1.7805116210871121, 2.139296643070474, 2.814618585159246,
          3.780605735393314, 5.1552672170267995, 7.274766475197882,
          10.2780423752622,
        ],
        5: [
          2.181423786812222, 2.2114193910425173, 2.2697047872460865,
          2.3941354359902927, 2.634449833844138, 3.2040003822787417,
          4.164246353643332, 5.524786492816391, 7.650567459055983,
          10.65433188658664,
        ],
        6: [
          3.095263553865979, 3.125326987500528, 3.1831744676130445,
          3.306142579063711, 3.5406187204079735, 3.9347518427277475,
          4.754400007576108, 6.105783364936819, 8.206137192269006,
          11.209659382366201,
        ],
        7: [
          4.3482225741861065, 4.378492923861061, 4.436915737319184,
          4.560208706980475, 4.7945820636442456, 5.183298952335559,
          5.794762308454356, 6.986134125514484, 9.058923902806658,
          12.045245913844258,
        ],
        8: [
          6.223224357752331, 6.253617409443343, 6.312397735102448,
          6.436191184409223, 6.670523880717862, 7.057668388461334,
          7.657135491769785, 8.590891414452775, 10.413548916286954,
          13.368054193265463,
        ],
        9: [
          9.194695353826955, 9.224858507997757, 9.28310467544075,
          9.405558414759444, 9.625803066757129, 10.009646383675712,
          10.598636285501403, 11.49937938814778, 12.910949186592795,
          15.504617498740394,
        ],
      },
      11: {
        0: [
          0.7890059147370375,
          0.8356766886516869,
          0.9641812728842278,
          1.2147801168773733,
          1.6267534545101623,
          2.3381474796736716,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.8204522003865027,
          0.8632678059062979,
          0.9889896502036399,
          1.2388224588401222,
          1.650933152011896,
          2.362614531616333,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.9156524259111042,
          0.9486280863542799,
          1.0507453934693645,
          1.2979778213231128,
          1.7095614359084552,
          2.421866274528616,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.131261233091723,
          1.1613677196355587,
          1.2212943623715216,
          1.42372575081711,
          1.8331361471038603,
          2.5427287056576824,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.5058296871898957,
          1.5354301288371426,
          1.593788154464149,
          1.7188289529109304,
          2.0650224653845237,
          2.774424268842165,
          null,
          null,
          null,
          null,
        ],
        5: [
          2.1483753236807837,
          2.178083101330062,
          2.23612634443635,
          2.359970437626835,
          2.5981965212813414,
          3.1595628076648277,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.7612188965027971,
          0.8065458309873371,
          0.9308576839215448,
          1.1729529996403303,
          1.5705767236231682,
          2.3055973092722253,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7919795808552597,
          0.8336585660261506,
          0.955281650719565,
          1.196667366491471,
          1.594211004095655,
          2.3298820475382556,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.8844932014086438,
          0.9166455046599307,
          1.0157516097891233,
          1.2543297108189053,
          1.651415642900341,
          2.3886236023903775,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.0931217867742051,
          1.1224809134091547,
          1.1807130440989753,
          1.3764150022284358,
          1.7711200199274622,
          2.508349927108082,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.4546551246529567,
          1.4835195921632396,
          1.5402329242390458,
          1.6616547198042517,
          1.995915749922596,
          2.7373541835346584,
          null,
          null,
          null,
          null,
        ],
        5: [
          2.118867052507655,
          2.148236256629942,
          2.205837014347141,
          2.328503528557288,
          2.56435869935137,
          3.1181479685619364,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.7451996655025301,
          0.7897538965474586,
          0.9116620227220222,
          1.1487421970386746,
          1.5380323504723692,
          2.2866657476797347,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7755968669888709,
          0.816606468992574,
          0.9358863309753578,
          1.1722887354112523,
          1.561516825668695,
          2.31094791658761,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.8665244056585278,
          0.8982927899143611,
          0.9956112757830199,
          1.2293277532453823,
          1.6180236461873645,
          2.3695525770885455,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.0710434906227968,
          1.1000833952283937,
          1.157680266603676,
          1.3495432887561207,
          1.7360150931441076,
          2.4887323831395918,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.4251746350756935,
          1.4537303236161065,
          1.5098138487535722,
          1.6289296044777593,
          1.9562606314326092,
          2.7164910827577824,
          null,
          null,
          null,
          null,
        ],
        5: [
          2.1018996011287143,
          2.131127707719842,
          2.1885616201654443,
          2.310774999386498,
          2.544780009715801,
          3.0940854631978336,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.7332786862440448,
          0.7772586061014275,
          0.897291103405518,
          1.1305285956052735,
          1.5134118326759274,
          2.272321639894761,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7633545459636458,
          0.803842532085814,
          0.9213356389364322,
          1.153908725026835,
          1.536693351454253,
          2.296581750821608,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.8530488654869334,
          0.8844455900030878,
          0.9804036392979476,
          1.210369475745174,
          1.592645737158016,
          2.3550065903464774,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.0543725033481433,
          1.0831601289737105,
          1.14012351177398,
          1.3290963948960133,
          1.7092278753487338,
          2.473774058928202,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.4027831502027315,
          1.431064782361064,
          1.4866212972460455,
          1.6042451210592668,
          1.926416244031056,
          2.700556518335789,
          null,
          null,
          null,
          null,
        ],
        5: [
          2.0889738310370474,
          2.118100896675554,
          2.1753737752339974,
          2.2972165049918596,
          2.5301533565787064,
          3.0761341886309777,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.7231375084281431,
          0.766614222139502,
          0.8850111904668212,
          1.1149775569086118,
          1.4923467003262925,
          2.260041522649758,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7528986410329558,
          0.7929575411213119,
          0.9088971929304462,
          1.1381899293459625,
          1.5155055913564088,
          2.2842734356363894,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.841480053344221,
          0.8725841609101708,
          0.9673585958515312,
          1.1941107708164762,
          1.5709559907395407,
          2.3426029997086797,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.0400988493292733,
          1.068598585552272,
          1.125010579931402,
          1.3114566091405182,
          1.6861445876449475,
          2.4610079125637983,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.3835851483213264,
          1.411627244516733,
          1.4666464330052953,
          1.5829437378221405,
          1.9006514240603338,
          2.6867971696260975,
          null,
          null,
          null,
          null,
        ],
        5: [
          2.0779138564713078,
          2.1069313792032482,
          2.164063376073209,
          2.2855222375816977,
          2.5175255605078593,
          3.060655762877237,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.7170300517468867,
          0.7602077743238616,
          0.877679744381143,
          1.1056451196858204,
          1.4870793238578888,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7466460046988135,
          0.7864552873928164,
          0.9014718147444516,
          1.1287878590167684,
          1.5102350596882226,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.8346075196923186,
          0.8655317941002256,
          0.9596148989822291,
          1.1844233594222895,
          1.5656209011339497,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.0315459312101278,
          1.0599487693833147,
          1.1160513443206719,
          1.3009838164251573,
          1.680589789946176,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.3787751198963085,
          1.4067696320417071,
          1.461716497100638,
          1.5777946458753918,
          1.8945409888550753,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.7125580819373958,
          0.7555484947475992,
          0.872316155212212,
          1.0988160103579505,
          1.4832206636675178,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7420778866147053,
          0.7817119068282752,
          0.8960518457230766,
          1.1219235491949227,
          1.5063775085661621,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.829549540433113,
          0.8603891348205176,
          0.9539647178444635,
          1.177339602997772,
          1.5617278333742592,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.0253002315461155,
          1.0535986670129667,
          1.1095072887871538,
          1.2933225387355805,
          1.6765247962986924,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.3752499979688568,
          1.403216318481465,
          1.4581102022523593,
          1.5740326641534417,
          1.8900658916978768,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.7088440690397799,
          0.7516636572109425,
          0.8678326128396052,
          1.0931047296716923,
          1.479992001176873,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7382646446369261,
          0.7777478767087809,
          0.8915176582359262,
          1.1161691937275484,
          1.5031482996581176,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.8253522642767783,
          0.8560786747372403,
          0.9492201862151755,
          1.171393380890303,
          1.5584575598753716,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.020070891014976,
          1.048291550691147,
          1.103996419899287,
          1.2868656694554017,
          1.673106758466587,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.3722952215796986,
          1.4002298057357152,
          1.4550838885626582,
          1.5708593037945282,
          1.8862892174055632,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.7066032557385356,
          0.7492830955368068,
          0.8650934818872362,
          1.0895928704997457,
          1.4780008025396314,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7359307615405147,
          0.7753340376953459,
          0.8887553744162751,
          1.112647099916406,
          1.5011615680421386,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.8227793278679291,
          0.8534600500955196,
          0.9463409919919152,
          1.1677693280643,
          1.556455887888379,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.0168517231566305,
          1.0450473898726493,
          1.1006546469120075,
          1.2829400322877897,
          1.6710226992913144,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.3704800898942047,
          1.3984037173443133,
          1.4532339608407419,
          1.568934288277045,
          1.8839920232663934,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
    },
    2: {
      5: {
        0: [
          1.0886109658350638, 1.1741884521553345, 1.3011544460959041,
          1.532201349227253, 1.888633721679174, 2.376661703723284,
          2.98882591977387,
        ],
        1: [
          1.15768418957594, 1.2416703127414577, 1.361031845670385,
          1.5827393036220654, 1.9382902315852073, 2.424884560697783,
          3.041666937740942,
        ],
        2: [
          1.2585402087168276, 1.3307586573625976, 1.4342977309577805,
          1.6422211647062093, 1.99529262488296, 2.479645711034867,
          3.1021920288615394,
        ],
        3: [
          1.4346464523266498, 1.4996297196996573, 1.5788530433600036,
          1.7430389876824464, 2.0829068784414186, 2.565904268853903,
          3.197568343511682,
        ],
        4: [
          1.7536635497062751, 1.809085112924722, 1.8753732769152838,
          1.9863103875874566, 2.2598586698438394, 2.733740902626441,
          3.3791875249818144,
        ],
        5: [
          2.2321651035731, 2.2848739894961394, 2.347136186476192,
          2.446620341210261, 2.646885149447384, 3.0585637266304455,
          3.7009416187706465,
        ],
        6: [
          2.8753690225501654, 2.9332276831610127, 2.999177731386418,
          3.101954776667042, 3.2978981566054837, 3.6515922702976664,
          4.248044100072203,
        ],
      },
      6: {
        0: [
          0.6810070238498862, 0.7345246517328724, 0.8170424414101111,
          0.9655731304324147, 1.198365074583371, 1.5307431728977345,
          2.527654246691794,
        ],
        1: [
          0.7262904415257908, 0.7783361947284697, 0.8565289586218459,
          0.9992750099970644, 1.2315233423015581, 1.5307431728977345,
          2.527654246691794,
        ],
        2: [
          0.789597760199934, 0.8365461341947908, 0.9059526602207771,
          1.0404997113828742, 1.2705257237787642, 1.5635280510640268,
          2.573791547842243,
        ],
        3: [
          0.9048294692624363, 0.9477559032750991, 1.0008002477224307,
          1.1123849490381934, 1.3345973820950316, 1.5635280510640268,
          2.573791547842243,
        ],
        4: [
          1.1145585542767695, 1.1521057606138958, 1.1981292308236637,
          1.2767601622560776, 1.4630688696561092, 1.599326455279527,
          2.626428179763927,
        ],
        5: [
          1.4361555735921874, 1.4726569994354262, 1.5165079084344888,
          1.5892232417118413, 1.7337596359491476, 1.599326455279527,
          2.626428179763927,
        ],
        6: [
          2.435538336086784, 2.486145274141015, 2.543416891193441,
          2.637436128893447, 2.8164011427999056, 1.6629880953227005,
          2.71146099354419,
        ],
      },
      7: {
        0: [
          0.575067727745538, 0.6206417709929427, 0.690853325757453,
          0.81753060870806, 1.0182581491156812, 1.3079228584684297,
          2.4054460650088956,
        ],
        1: [
          0.6138680982499436, 0.6582977684031232, 0.7249778268375273,
          0.8470650391813017, 1.0468702159635868, 1.3079228584684297,
          2.4054460650088956,
        ],
        2: [
          0.6682755928767369, 0.7085820480049838, 0.7683548560936031,
          0.8838113911953442, 1.0818029940261715, 1.336561810298913,
          2.4497991598336344,
        ],
        3: [
          0.7679008869514992, 0.8049876609372175, 0.8513832332185232,
          0.9485394258526538, 1.1403386639820035, 1.336561810298913,
          2.4497991598336344,
        ],
        4: [
          0.9489646778402065, 0.9818343635694566, 1.0226677762081822,
          1.0930935504469637, 1.2560075294455606, 1.371382432183674,
          2.500342325009675,
        ],
        5: [
          1.2286577986686003, 1.2607417978268876, 1.300013560094825,
          1.365653539088608, 1.4949248312166956, 1.371382432183674,
          2.500342325009675,
        ],
        6: [
          2.322761597018421, 2.3691774605044578, 2.4240132695093903,
          2.5156131841615705, 2.6901022547978726, 1.4293760600150205,
          2.5868000154372535,
        ],
      },
      8: {
        0: [
          0.5123893262982263, 0.5532055740248103, 0.6161821520296743,
          0.7300478732232625, 0.9128695233370645, 1.1769986673467372,
          2.332931180744593,
        ],
        1: [
          0.547261792686122, 0.5870316497318399, 0.6470704756014036,
          0.7569720645465225, 0.9375488317293064, 1.1769986673467372,
          2.332931180744593,
        ],
        2: [
          0.5964727050974652, 0.6337670078566013, 0.6867845331900646,
          0.7910733204017062, 0.9700754113190582, 1.2031526977232399,
          2.376079730191899,
        ],
        3: [
          0.6868438646062065, 0.7203697671718121, 0.7638941581789245,
          0.8514361853181217, 1.025171184046216, 1.2031526977232399,
          2.376079730191899,
        ],
        4: [
          0.8508690853355065, 0.8808535913122628, 0.9185530133349595,
          0.9840863649206317, 1.1330138844395465, 1.2341519845670867,
          2.425386877462341,
        ],
        5: [
          1.1074819754628829, 1.1367580448936185, 1.173152712312128,
          1.2346483432018325, 1.3550970246273868, 1.2341519845670867,
          2.425386877462341,
        ],
        6: [
          2.2543411369237845, 2.3015619189712275, 2.3549818084793315,
          2.445085762172773, 2.6172386815820596, 1.288779971541294,
          2.510725344397617,
        ],
      },
      9: {
        0: [
          0.4619116103134332, 0.4988144297562195, 0.556060694830113,
          0.6596410834016565, 0.8266222927017558, 1.0697138241129027,
          2.2741530776172456,
        ],
        1: [
          0.4935228782181028, 0.5295319082759964, 0.5841868654393876,
          0.6843426468981899, 0.8506455081421731, 1.0697138241129027,
          2.2741530776172456,
        ],
        2: [
          0.5385178012002918, 0.5723928633206371, 0.6208895762704965,
          0.7161469888539361, 0.8810957043814222, 1.0938121223976784,
          2.3162432233351113,
        ],
        3: [
          0.621317882228722, 0.651875052251593, 0.6920589587740402,
          0.772611051577051, 0.9330062290640704, 1.0938121223976784,
          2.3162432233351113,
        ],
        4: [
          0.7715027028627398, 0.7989549644073719, 0.8340477414868976,
          0.8952577128340573, 1.0326934909586356, 1.1242446374763637,
          2.3645447511621693,
        ],
        5: [
          1.0073875837388653, 1.0343187188862226, 1.0682933468012412,
          1.126117498164269, 1.2386784897972016, 1.1242446374763637,
          2.3645447511621693,
        ],
        6: [
          2.1987459259455786, 2.244803473292344, 2.2970631658915934,
          2.385997868166113, 2.555820462783661, 1.1758739055689598,
          2.4488969302912142,
        ],
      },
      10: {
        0: [
          0.4380687294580113, 0.47304841874889647, 0.5276400341019803,
          0.6264439516002687, 0.7860861160282365, 1.0194859489097072,
          2.246717903147057,
        ],
        1: [
          0.46806041440014606, 0.5022894288713007, 0.5544842224805158,
          0.65011312219288, 0.8091252368752869, 1.0194859489097072,
          2.246717903147057,
        ],
        2: [
          0.5118304572568093, 0.5434234087994192, 0.589890128904671,
          0.680976088374732, 0.8387472321236151, 1.0426112908323233,
          2.2882792485667296,
        ],
        3: [
          0.5905880485240895, 0.6203597013401196, 0.6584500144365917,
          0.7358643845583721, 0.8894132397065971, 1.0426112908323233,
          2.2882792485667296,
        ],
        4: [
          0.734360907025641, 0.760631555754949, 0.7946263947702148,
          0.8540288794977675, 0.9876333954015213, 1.0722204536409752,
          2.336132478939338,
        ],
        5: [
          0.9606775413632374, 0.9864906279863968, 1.019438581716428,
          1.0757474912578275, 1.1848126399258538, 1.0722204536409752,
          2.336132478939338,
        ],
        6: [
          2.1728378726215247, 2.218317901426552, 2.2700597896249377,
          2.358547169366707, 2.52698993279602, 1.122647776964758,
          2.4200966786617686,
        ],
      },
      11: {
        0: [
          0.42236982812414064,
          0.456080041535104,
          0.5089314542148046,
          0.6044094369263421,
          0.7588922467563334,
          1.0045465273650769,
          null,
        ],
        1: [
          0.451261107144428,
          0.4841502644994536,
          0.5347398072620362,
          0.627313684362637,
          0.7812586051317719,
          1.0045465273650769,
          null,
        ],
        2: [
          0.4936855800109791,
          0.5240509635710923,
          0.5691104763045608,
          0.6574753493817891,
          0.81034402676028,
          1.0273163474526577,
          null,
        ],
        3: [
          0.5700143767450552,
          0.598781848204404,
          0.6359013303838528,
          0.71120332125868,
          0.8601769876588403,
          1.0273163474526577,
          null,
        ],
        4: [
          0.7094436335632108,
          0.7349071091376422,
          0.7681668201814595,
          0.8263675834200384,
          0.9564086370554117,
          1.0566341004882698,
          null,
        ],
        5: [
          0.9471077575953043,
          0.9725132954892773,
          1.0050932471946097,
          1.0610582695600395,
          1.1693538333175755,
          1.0566341004882698,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.408535440505908,
          0.44118351359874824,
          0.4924313830438758,
          0.5850652936626082,
          0.7349321110240153,
          0.9912775606446267,
          null,
        ],
        1: [
          0.43654740096095024,
          0.46839005032125075,
          0.5175110380800421,
          0.6072663084207859,
          0.7565935053509869,
          0.9912775606446267,
          null,
        ],
        2: [
          0.4777743503563969,
          0.5072110900082913,
          0.5509322217300676,
          0.6366004900398277,
          0.7849501219183252,
          1.0136686199196892,
          null,
        ],
        3: [
          0.5519417302714122,
          0.5797153047207884,
          0.6157966590891868,
          0.689033136374082,
          0.8336772061316629,
          1.0136686199196892,
          null,
        ],
        4: [
          0.6871690140295443,
          0.7118332163410257,
          0.7442633766520852,
          0.8011464646110537,
          0.927855944135811,
          1.0426718593168693,
          null,
        ],
        5: [
          0.9347946471906001,
          0.9598222673550127,
          0.9920851929965466,
          1.0476804599411274,
          1.1552202200981077,
          1.0426718593168693,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.40073430436547497,
          0.43274418976303997,
          0.48308531651757436,
          0.5740775841121502,
          0.721332420647598,
          0.9837656766031848,
          null,
        ],
        1: [
          0.4282192900043674,
          0.45945664999384994,
          0.507713736422032,
          0.5959127402033274,
          0.7426627045034839,
          0.9837656766031848,
          null,
        ],
        2: [
          0.46875919498853247,
          0.49764984496639014,
          0.5406674353533908,
          0.6248784049010505,
          0.770633438489309,
          1.0059766978723983,
          null,
        ],
        3: [
          0.5417062358586163,
          0.5689961509106501,
          0.6044347776297339,
          0.6764129099720904,
          0.8186176158058098,
          1.0059766978723983,
          null,
        ],
        4: [
          0.6745014774061677,
          0.6986820306265003,
          0.730702539500023,
          0.7867212839208892,
          0.9113643721803422,
          1.0348237202752353,
          null,
        ],
        5: [
          0.9278854085826593,
          0.9526085155914907,
          0.9846088218066293,
          1.039990609758091,
          1.147043091136906,
          1.0348237202752353,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.3949741289493408,
          0.426499975492729,
          0.47614509472551236,
          0.5658692122590243,
          0.7111190627101938,
          0.978111876433897,
          null,
        ],
        1: [
          0.42204513769907864,
          0.4528328790334065,
          0.5004252743623302,
          0.587417597327279,
          0.7321868131432976,
          0.978111876433897,
          null,
        ],
        2: [
          0.462066335869364,
          0.49052875784788574,
          0.5330015432427881,
          0.6160984813253104,
          0.7598900892767905,
          1.0001851112850517,
          null,
        ],
        3: [
          0.5340634477404789,
          0.5609612121048335,
          0.5960019752528107,
          0.6669623233769606,
          0.8073354675068476,
          1.0001851112850517,
          null,
        ],
        4: [
          0.6651105626249952,
          0.6889682349630125,
          0.7204615629627684,
          0.7759032367570735,
          0.898908050283546,
          1.028909735157191,
          null,
        ],
        5: [
          0.9227456378006023,
          0.9473028625528298,
          0.9791501351517731,
          1.0341705573242224,
          1.1408411538182213,
          1.028909735157191,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.3900399258038427,
          0.42116934905615,
          0.4702280019629681,
          0.5588786281223456,
          0.7024774928223436,
          0.9733369215043344,
          null,
        ],
        1: [
          0.4167795602237601,
          0.4471760133459133,
          0.49422197212416075,
          0.5802044625296763,
          0.7233172385032345,
          0.9733369215043344,
          null,
        ],
        2: [
          0.45635458216907343,
          0.4844671351657288,
          0.5264697786242818,
          0.6086399640259454,
          0.7508147769404054,
          0.9952976924997408,
          null,
        ],
        3: [
          0.5275502088212201,
          0.5541271125164937,
          0.5888389106937628,
          0.6590545882596457,
          0.7979168548206922,
          0.9952976924997408,
          null,
        ],
        4: [
          0.6571579988273675,
          0.6807491646201675,
          0.711919301242931,
          0.7667661831951417,
          0.8885358303062585,
          1.0239239994671965,
          null,
        ],
        5: [
          0.9183739874186256,
          0.9428293723127008,
          0.9745501518378639,
          1.0293856597604973,
          1.1356155008886135,
          1.0239239994671965,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.3871408490003959,
          0.41803633084165037,
          0.4667479832649635,
          0.5547679880927927,
          0.7002652252802604,
          null,
          null,
        ],
        1: [
          0.41368581678683713,
          0.44383730629916696,
          0.49057582557053003,
          0.5759424937129187,
          0.7210338003357588,
          null,
          null,
        ],
        2: [
          0.4529957393203061,
          0.4809073549257754,
          0.522626920652364,
          0.6042364019072608,
          0.7484573667405477,
          null,
          null,
        ],
        3: [
          0.5237280572624988,
          0.5501160871060442,
          0.5846228035148471,
          0.6544216871638113,
          0.7954872854350448,
          null,
          null,
        ],
        4: [
          0.655113347608477,
          0.678613050875535,
          0.7097168385359666,
          0.7644570237157796,
          0.885969935881719,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.38504085945549404,
          0.41577020706976936,
          0.4642333792069613,
          0.5517962758936247,
          0.6986677507105692,
          null,
          null,
        ],
        1: [
          0.4114483137415744,
          0.44144495422379315,
          0.4879425148287678,
          0.5728773601018895,
          0.7193854255852252,
          null,
          null,
        ],
        2: [
          0.4505723625254469,
          0.47833695931005227,
          0.519877229258467,
          0.6010708743246567,
          0.7467676710175146,
          null,
          null,
        ],
        3: [
          0.52096844532705,
          0.5472179462643142,
          0.581592596875295,
          0.6510912709487016,
          0.7937463326036003,
          null,
          null,
        ],
        4: [
          0.6536422050442858,
          0.6770856749622942,
          0.7081241621814895,
          0.7628025449624432,
          0.8841292932747953,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.3832940132828938,
          0.4138811883009567,
          0.46214173381747614,
          0.549337927481455,
          0.6973477295274617,
          null,
          null,
        ],
        1: [
          0.40958366169815197,
          0.43945427492366873,
          0.48575579896219745,
          0.5703424630201956,
          0.7180247268629043,
          null,
          null,
        ],
        2: [
          0.4485543266267788,
          0.47620159988368926,
          0.5175869719792183,
          0.5984522648723944,
          0.7453737727951583,
          null,
          null,
        ],
        3: [
          0.5186805633168623,
          0.5448201556024762,
          0.5790799228926564,
          0.6483452187156715,
          0.7923081161896673,
          null,
          null,
        ],
        4: [
          0.6524233035523789,
          0.675825049031912,
          0.706811923085307,
          0.7614314937720701,
          0.8826195645067871,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.3822535258543277,
          0.412756117082573,
          0.460893521286702,
          0.5478679800259509,
          0.6965564371489512,
          null,
          null,
        ],
        1: [
          0.4084656061302936,
          0.43826804847961265,
          0.4844514917028775,
          0.568826888681585,
          0.7172103509324612,
          null,
          null,
        ],
        2: [
          0.4473555746379625,
          0.47492534891373966,
          0.5162280342739012,
          0.5969082172654693,
          0.744540074827045,
          null,
          null,
        ],
        3: [
          0.5173177793620621,
          0.5433934679495065,
          0.5775912525586033,
          0.646713944235245,
          0.7914680567000137,
          null,
          null,
        ],
        4: [
          0.6516964298427681,
          0.6750599069267721,
          0.7060305168911772,
          0.7606210518795207,
          0.8817215950362476,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
    },
    3: {
      5: {
        0: [
          1.3197522450369128, 1.4848936088358125, 1.764149156674974,
          2.222507249310078, 2.999268993228853, 4.3616661351687105,
          6.4136912076207455, 9.471826247301337, 13.939692114936381,
          19.732928909095598,
        ],
        1: [
          1.4752636587905301, 1.637431999967708, 1.9143083987605332,
          2.3560166370240476, 3.1253055691215277, 4.484883049175623,
          6.535805991561654, 9.59023215634681, 14.04590137161398,
          19.81948848933433,
        ],
        2: [
          1.7366291929832043, 1.8906468837106913, 2.1457421561177634,
          2.5785564785271964, 3.3273674127774253, 4.680057523132113,
          6.721289006873216, 9.769595775397317, 14.20218231442496,
          19.944599888124657,
        ],
        3: [
          2.151063715039265, 2.306191252533836, 2.545186487575788,
          2.938693043946907, 3.6636310500444456, 4.988493857429568,
          7.026451051654765, 10.03949083958423, 14.43483347133396,
          20.1276843649264,
        ],
        4: [
          2.895586828375363, 3.0405931686494307, 3.2690025533769105,
          3.639480649304554, 4.316355824941473, 5.597262586809508,
          7.582650656890457, 10.542831043902709, 14.848869551863075,
          20.45114238350143,
        ],
        5: [
          4.2386652880214655, 4.382761162194957, 4.605472261840398,
          4.952605211642686, 5.587907679313902, 6.7881205241804965,
          8.70870085349047, 11.51930351368651, 15.670246288981428,
          21.11032033904564,
        ],
        6: [
          6.329395631007184, 6.465806644526497, 6.676808918787263,
          6.999134302822101, 7.5997478097420395, 8.707787376984623,
          10.465904197705363, 13.117420975765853, 17.013355957985723,
          22.21050816529892,
        ],
        7: [
          9.37034940305725, 9.494240095408793, 9.682228159502984,
          9.965024316252954, 10.469947058658926, 11.472607883922269,
          13.05135366034521, 15.431349120548324, 19.01391058752622,
          23.87688711696586,
        ],
        8: [
          13.796785615606746, 13.901689684993533, 14.059635055120854,
          14.29455781554812, 14.71135930802319, 15.53656835443249,
          16.88541074292264, 18.94854518705533, 22.126463936263367,
          26.545064758519068,
        ],
        9: [
          19.6069682239515, 19.69221445889319, 19.819109260655488,
          20.004196644694105, 20.330099019408944, 20.99285193410202,
          22.097650900560545, 23.81877312029708, 26.545883412206514,
          30.451529351921824,
        ],
      },
      6: {
        0: [
          0.8265162552423693, 0.9333051557930767, 1.1137771952956133,
          1.4127935291218254, 1.933236841761714, 2.862480022749024,
          4.303423981993615, 6.519825327037413, 9.909879673077768,
          14.636565734670912,
        ],
        1: [
          0.9277483247887897, 1.0359059260297712, 1.2123978939368687,
          1.5022536890390747, 2.0190772621073654, 2.9480582308535954,
          4.3897839120984266, 6.607024890008171, 9.992115847111247,
          14.708785900477679,
        ],
        2: [
          1.0976292699956092, 1.198665135450385, 1.3682564381095608,
          1.6509167087653613, 2.156957277484562, 3.0845296658028483,
          4.523408219483768, 6.740454000271749, 10.115948931144409,
          14.816475579769804,
        ],
        3: [
          1.373763966802965, 1.473002324516393, 1.6312284646644712,
          1.8944989851258587, 2.388778510288212, 3.303898126833679,
          4.747041457618508, 6.947560256378273, 10.306186289081008,
          14.980029917659708,
        ],
        4: [
          1.8719191359069545, 1.9691280398893674, 2.122614119292331,
          2.3744740870627785, 2.844330700121265, 3.742073874155567,
          5.163121575237757, 7.340816815793767, 10.654004839451137,
          15.277806109863615,
        ],
        5: [
          2.7818194445679487, 2.880207084778011, 3.03955720544713,
          3.2824849591125225, 3.7366549765081203, 4.592946142624469,
          5.974922598544028, 8.094759772838547, 11.330431851903036,
          15.867434627611043,
        ],
        6: [
          4.240076977486956, 4.336194520908828, 4.485894141026507,
          4.726422369103724, 5.155898542344891, 5.9710633590775855,
          7.283609427693315, 9.314114550253631, 12.434696235482212,
          16.841719825980135,
        ],
        7: [
          6.447552115283206, 6.538569225749239, 6.67758440407358,
          6.892918360200035, 7.2869985192769775, 8.04241853896461,
          9.266726595830107, 11.17221021765225, 14.13046544491549,
          18.35209157917809,
        ],
        8: [
          9.810989022849352, 9.89292034375177, 10.017505938171212,
          10.20871017588573, 10.55783499622798, 11.236074928030693,
          12.345658827918953, 14.086957087997584, 16.828787796467086,
          20.798791672036536,
        ],
        9: [
          14.545888570734231, 14.617678450581035, 14.726230098042553,
          14.89063990256218, 15.189724174249593, 15.781101868849372,
          16.760044363800674, 18.3117519644811, 20.79922435838901,
          24.468062759928568,
        ],
      },
      7: {
        0: [
          0.6996390541470774, 0.7932218168457494, 0.9475009965644736,
          1.2042638382674151, 1.6611184841806335, 2.4699241763038957,
          3.728161172216161, 5.688551981301641, 8.716209242646446,
          13.023600908070737,
        ],
        1: [
          0.7886026766133408, 0.8801518592190967, 1.0332908666836649,
          1.2823171804826516, 1.7331805852130313, 2.545045782276136,
          3.804174159115476, 5.765657495955658, 8.789895842860028,
          13.089771216095711,
        ],
        2: [
          0.9331757412929876, 1.0220071037710754, 1.1666220361297872,
          1.4114398993521244, 1.8537475759775095, 2.66167718916695,
          3.9220387445567044, 5.884041030033966, 8.901481448042933,
          13.189268615720891,
        ],
        3: [
          1.1728290836758712, 1.2587913522581315, 1.395586722764166,
          1.6248179379920846, 2.0616048971584453, 2.8561152868145703,
          4.120604352520197, 6.069978768231467, 9.07497216447117,
          13.342534003390327,
        ],
        4: [
          1.6087046428834668, 1.6929725543227803, 1.8261654786554984,
          2.0462375803448674, 2.4655273021200594, 3.248838000396743,
          4.49279907429363, 6.425197706876856, 9.39561259169115,
          13.62494166044522,
        ],
        5: [
          2.4062576609392585, 2.492327286472906, 2.6253785238247134,
          2.8389021169447246, 3.2406355161211424, 3.99902611222009,
          5.212313618362356, 7.101348811664398, 10.013611468802246,
          14.178069789214415,
        ],
        6: [
          3.679131520027286, 3.763129253837551, 3.894486420632258,
          4.1016369326464215, 4.4847382034779075, 5.207060437842999,
          6.3728887360637145, 8.19495185331056, 11.021614575903236,
          15.089333681854338,
        ],
        7: [
          5.624950664280224, 5.705279736698408, 5.828171844703546,
          6.02078842164067, 6.376762549002675, 7.053969699755694,
          8.153447859510232, 9.881165511971826, 12.58641831593756,
          16.515897710829613,
        ],
        8: [
          8.630596417293626, 8.704149034340297, 8.816312238324395,
          8.990591926716661, 9.312053333579563, 9.931585141488608,
          10.945286121978906, 12.55019257260033, 15.09503426055036,
          18.839251073336158,
        ],
        9: [
          12.944175986625737, 13.01008988389751, 13.11026911973554,
          13.264295024905842, 13.547635464489865, 14.101996428419525,
          15.018292216380917, 16.48177365752266, 18.83955988306252,
          22.363886829665304,
        ],
      },
      8: {
        0: [
          0.6248153563741923, 0.709258948685612, 0.848350876031932,
          1.0810482569078024, 1.4976060669905682, 2.234209141047586,
          3.385260955494205, 5.190392935264904, 7.998388287729209,
          12.055269999113332,
        ],
        1: [
          0.7052170095286903, 0.7879318760053204, 0.9260895287284341,
          1.1521886510644497, 1.5662883262560017, 2.3029829245891893,
          3.4549686401803754, 5.261376902778786, 8.066893181026067,
          12.117865581677716,
        ],
        2: [
          0.8370195817094178, 0.9163901096779226, 1.0471504440093597,
          1.2696935948535162, 1.6767191196837072, 2.4127045858220906,
          3.5633246615358365, 5.370692466737337, 8.171074074193974,
          12.212558559117728,
        ],
        3: [
          1.0540427872416351, 1.1319512137755992, 1.2560321998905286,
          1.4652146687356713, 1.8647221727563053, 2.5924784531814993,
          3.746862736770445, 5.544039415062624, 8.334806019728962,
          12.360054946682968,
        ],
        4: [
          1.4521686316124185, 1.5287124269746422, 1.6497434209296726,
          1.854630272120421, 2.2359666350452025, 2.951863549679133,
          4.092314491229084, 5.876161164391049, 8.639066071087615,
          12.633774626740184,
        ],
        5: [
          2.179054648682418, 2.257199760649012, 2.3784104426772075,
          2.5744472619877525, 2.9479630343381533, 3.640193837116622,
          4.755996188146888, 6.50521641797503, 9.222045457915636,
          13.165796932553356,
        ],
        6: [
          3.3414122147836895, 3.418096350544859, 3.538150938798249,
          3.7291753246624593, 4.084049658424545, 4.750205004218633,
          5.827899138350787, 7.523634237866084, 10.172972584564302,
          14.041336243905917,
        ],
        7: [
          5.1323626603851515, 5.20623035588118, 5.3194123429720985,
          5.498550289948337, 5.831289429742011, 6.461243699793309,
          7.485806509536276, 9.106282691835105, 11.660141864598952,
          15.420761139677568,
        ],
        8: [
          7.921056522813327, 7.9894919686677985, 8.094151719757173,
          8.258432508363871, 8.563430789213808, 9.147494890348003,
          10.10424808105457, 11.628134613635643, 14.057673844447441,
          17.676408339778103,
        ],
        9: [
          11.982864540490763, 12.045340586584388, 12.140563432112955,
          12.288625591804031, 12.563042347210676, 13.096077069864771,
          13.976468223522255, 15.390231660053788, 17.67663865672779,
          21.12894625662816,
        ],
      },
      9: {
        0: [
          0.5644007068451325, 0.6413410375040987, 0.7681050208169246,
          0.9814967484060472, 1.3649693839354367, 2.042880775490398,
          3.108248734892284, 4.792427627195106, 7.4381908852705525,
          11.326119386976561,
        ],
        1: [
          0.6378098270911949, 0.7132413039527189, 0.839194144819845,
          1.0468741140586602, 1.4283154907049203, 2.1065124046435986,
          3.173020061931055, 4.858834575233558, 7.503075657799779,
          11.386562508051835,
        ],
        2: [
          0.7581272902464833, 0.830678929307711, 0.9501646861423254,
          1.15479734136587, 1.5302378280410873, 2.208166511305641,
          3.273966097085408, 4.961442252308538, 7.602204101979991,
          11.478413603839538,
        ],
        3: [
          0.957770509814793, 1.02908411652768, 1.1427823314977978,
          1.3357746862206303, 1.7049372661779256, 2.3761552619291417,
          3.4461748716867424, 5.12579582125609, 7.7596568288382155,
          11.62320241205938,
        ],
        4: [
          1.3248425559008479, 1.39721889321421, 1.5087950407456028,
          1.6960428996923083, 2.049627256103586, 2.7115445220431904,
          3.7708311645216828, 5.441050084957552, 8.053272430527866,
          11.89300790807194,
        ],
        5: [
          1.9939834529804745, 2.0659428427142483, 2.179833788683551,
          2.3625468683673496, 2.708120120515564, 3.351073456763033,
          4.391585456178359, 6.035488198134782, 8.612586815938185,
          12.413451605167785,
        ],
        6: [
          3.068570982934226, 3.1395767749586714, 3.2508772782836006,
          3.4296754445900848, 3.762740977340886, 4.385689302595761,
          5.396950188368427, 6.999845445091827, 9.525718157418058,
          13.269410661766347,
        ],
        7: [
          4.73912277356246, 4.808120587472155, 4.914118436862033,
          5.083587387269123, 5.3993189362988385, 5.994436218751907,
          6.964874475611071, 8.51009661362734, 10.963384736573861,
          14.62523032369755,
        ],
        8: [
          7.367300745742437, 7.432188859928672, 7.531670384941555,
          7.689503976456564, 7.983680835998993, 8.543847890019634,
          9.462570730952484, 10.934331793175135, 13.294294043077912,
          16.849605188787898,
        ],
        9: [
          11.259132250138832, 11.319466320098332, 11.41177209661694,
          11.556897856736347, 11.827227411552713, 12.348499011960893,
          13.209090421770195, 14.597162506722853, 16.849669901746477,
          20.28012242012397,
        ],
      },
      10: {
        0: [
          0.5367098717918231, 0.6096067994046983, 0.7306983704702797,
          0.9357582519727623, 1.3041977556033881, 1.9542394409467645,
          2.979074337876134, 4.6040364599103984, 7.1678498384555605,
          10.970108859942503,
        ],
        1: [
          0.6062802876071556, 0.6791525161320497, 0.7988232350200384,
          0.9985614727643591, 1.365159384145393, 2.015531010879185,
          3.0415213547299147, 4.668201783106192, 7.23091779408073,
          11.029382716196782,
        ],
        2: [
          0.7214077356292861, 0.790900048440049, 0.9052400968367349,
          1.1021553017773964, 1.4632070458076503, 2.113431322305341,
          3.1389138263047265, 4.76747799533633, 7.327472812726388,
          11.119872659127125,
        ],
        3: [
          0.913636021598887, 0.981987070839625, 1.0909766825200042,
          1.2787512698628727, 1.6323039378057744, 2.276403034605445,
          3.3060111612858583, 4.927660319573585, 7.481912174954461,
          11.263448118578381,
        ],
        4: [
          1.2686106081405308, 1.3361640176677574, 1.4432117011562968,
          1.6240111551520058, 1.9665573591720285, 2.6006680777384714,
          3.620832891830226, 5.234682816432251, 7.770234021355762,
          11.531435065276849,
        ],
        5: [
          1.9103759592454157, 1.9795185654109608, 2.0870132760987543,
          2.263710475150859, 2.5974678935221855, 3.216329577161261,
          4.2201640027681515, 5.811467212319373, 8.317237544930178,
          12.045876162644776,
        ],
        6: [
          2.9415237355327006, 3.009781400861737, 3.1168597654488277,
          3.29012419642637, 3.612795344657334, 4.214188144864356,
          5.1926245083705105, 6.748661565618475, 9.2111983821545,
          12.892275369621487,
        ],
        7: [
          4.553086427324206, 4.619684631526937, 4.72215835837844,
          4.887077185787813, 5.194553131275903, 5.771967485839738,
          6.715147540156551, 8.222045712702192, 10.62381789664256,
          14.23687847966109,
        ],
        8: [
          7.100244668528848, 7.163327439657377, 7.2601666537069045,
          7.414994019204016, 7.703753165246258, 8.251535279371403,
          9.151018208990518, 10.596295642262554, 12.921057753472923,
          16.44697301863966,
        ],
        9: [
          10.90582499490353, 10.965073783607245, 11.055887046225426,
          11.199826034295107, 11.468141393536454, 11.983245355843406,
          12.834282630706744, 14.21014208043891, 16.44710364969162,
          19.871357581706068,
        ],
      },
      11: {
        0: [
          0.5180634391319411,
          0.588401229949677,
          0.705642040165247,
          0.9052499379818499,
          1.2635063442458045,
          1.9306701208563175,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.5852450074511469,
          0.6558171250050157,
          0.7716991992631457,
          0.9662481700364525,
          1.3228275760145989,
          1.9913379034431715,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.6968156693810443,
          0.7641628617967239,
          0.875135888114526,
          1.0669673121772738,
          1.4183264451068627,
          2.088202396068165,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.8842330281245623,
          0.9505178345474896,
          1.0563310186499746,
          1.2396209884112985,
          1.5837724539483315,
          2.2497546808366637,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.229694347973211,
          1.295257081059372,
          1.3993260015589608,
          1.5758832268771168,
          1.9098326141434714,
          2.5719909654505835,
          null,
          null,
          null,
          null,
        ],
        5: [
          1.8879303494281758,
          1.9563177849210396,
          2.062605211591459,
          2.2375928095705633,
          2.5689397378279417,
          3.1817278415231156,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.5014941279849796,
          0.5696631614510846,
          0.6833792657936055,
          0.8774872291930426,
          1.225868564586143,
          1.9089038046292968,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.5665881222592848,
          0.634769157215042,
          0.747226426672946,
          0.9366431455370641,
          1.2835745021918827,
          1.9689588905126862,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.6747587642387902,
          0.7399793386179345,
          0.8475783804733086,
          1.0344989200569308,
          1.3767264956374818,
          2.0648710315966645,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.8571779366149652,
          0.9214385462023293,
          1.0243341890534103,
          1.2031668333265788,
          1.5385835502404668,
          2.2251192100447734,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.1934706074336292,
          1.2571628264434183,
          1.3585015888052956,
          1.5310501178690663,
          1.8570714751556692,
          2.54527057048776,
          null,
          null,
          null,
          null,
        ],
        5: [
          1.86707811205634,
          1.9347532982176567,
          2.0399388099199136,
          2.213372638630914,
          2.5423497938044877,
          3.14980801501248,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.4921102527319988,
          0.5590253777931042,
          0.6708119850722011,
          0.8615844711160364,
          1.205102217056294,
          1.8962622829420606,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.5560309314277889,
          0.6229835088583868,
          0.733449689354315,
          0.9197496325047826,
          1.2608377288715449,
          1.9559418419891121,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.6623988053788279,
          0.7262740645629648,
          0.8320161395116485,
          1.0159724036212452,
          1.3525901422313504,
          2.0513063049658133,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.8418106233029043,
          0.9049317859511674,
          1.005965849156817,
          1.182086760736222,
          1.5123054552297506,
          2.210769284242458,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.172506206541552,
          1.2350935281255826,
          1.3348426826543693,
          1.5049621495748444,
          1.826225319396415,
          2.5296714101025213,
          null,
          null,
          null,
          null,
        ],
        5: [
          1.854981367886288,
          1.9222128206675284,
          2.0267607129810044,
          2.1992728502759036,
          2.5268146239745453,
          3.131078740118081,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.48512494939026396,
          0.5510849420727179,
          0.6613754228116229,
          0.8497131857289867,
          1.188686988127027,
          1.8866279957606675,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.5481427055626951,
          0.6141445363394771,
          0.7231629322110475,
          0.9069566270105146,
          1.2436534507213497,
          1.9460152650996867,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.6531279616057863,
          0.7161235751542323,
          0.8204571855099569,
          1.0020479313322868,
          1.3342235637180986,
          2.040954449850285,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.8301707472078148,
          0.8924342731697286,
          0.992201973314262,
          1.1662242891869903,
          1.492276510999418,
          2.1998357279710397,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.156516761107341,
          1.2182638840699136,
          1.316802968345302,
          1.4850509137277896,
          1.8026559267058957,
          2.517728448234016,
          null,
          null,
          null,
          null,
        ],
        5: [
          1.8457353630727833,
          1.9126291560025468,
          2.0166920930963026,
          2.188511713970204,
          2.5149267555416133,
          3.1167724303693785,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.4791505535673136,
          0.544307290737605,
          0.6533466763842781,
          0.8407083050030157,
          1.1748038477287492,
          1.8785053720646339,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.5414129156945655,
          0.60660095516053,
          0.7144492236393936,
          0.8973303755877668,
          1.2302269284743184,
          1.9376543349690696,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.645237570709383,
          0.7075059499896639,
          0.8107131403973826,
          0.9915539962595052,
          1.3200008528640925,
          2.0322649574430574,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.8203698333234248,
          0.8818290220525533,
          0.9805830698856428,
          1.1528931186575828,
          1.476747364634265,
          2.190692471665911,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.1430867661445792,
          1.2041329732376258,
          1.3016420745355732,
          1.4683692265133739,
          1.7830496728590168,
          2.507771642365873,
          null,
          null,
          null,
          null,
        ],
        5: [
          1.8379279725209252,
          1.9045483257415259,
          2.008229350466745,
          2.179518974856497,
          2.5050119925131646,
          3.104982128507755,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.4756500693514767,
          0.5403231802603968,
          0.6486795847317255,
          0.8348562622741269,
          1.1706239806343883,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.5374561099160633,
          0.6021762450284813,
          0.7093411284078411,
          0.8911101837797792,
          1.226852284703471,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.6406373478341756,
          0.7024693321925854,
          0.8050504699952656,
          0.9847976571613302,
          1.31641322669631,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.8147167329969649,
          0.8756247987802603,
          0.9738213746635288,
          1.1451505771987855,
          1.4728792065150578,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.1400037533646414,
          1.200877530770775,
          1.2980194105870382,
          1.4644323747227697,
          1.7784936141522474,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.4731113369472631,
          0.5374414613037937,
          0.6452993422768881,
          0.8306325272238141,
          1.1683226388796524,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.5346031112379954,
          0.5989817269334918,
          0.7056592135260553,
          0.8866280484581919,
          1.2244255174873966,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.6373207219584988,
          0.6988361341411811,
          0.8009762048382705,
          0.9799483593861023,
          1.3138420440979917,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.8106499381417887,
          0.8712614269234072,
          0.9701905418454966,
          1.1396104289154718,
          1.4701080481379265,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.1378055549404833,
          1.198541856839396,
          1.295515568993486,
          1.4628434165002564,
          1.7752456350050752,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.47099532745543327,
          0.5350533592878298,
          0.6424919291807323,
          0.827141690393782,
          1.1664250473424922,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.5322271468735633,
          0.596331600376939,
          0.7026031429405197,
          0.8829305223960522,
          1.222427204462387,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.6345616005768591,
          0.6958218236995475,
          0.7976078343149989,
          0.9759506870437553,
          1.3117271965540378,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.8072810966400565,
          0.8676559333031395,
          0.9662555063583128,
          1.1350799521638044,
          1.4678330028291442,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.1359581035147976,
          1.196615262221871,
          1.2934548970672746,
          1.460599774551484,
          1.7726081143915877,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.4697369589481285,
          0.5336375126671062,
          0.6408381680253781,
          0.8250825105877111,
          1.1653023991743916,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.5308276501609004,
          0.5947650297567184,
          0.7008073122401626,
          0.8807510791140557,
          1.2212450164056181,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.6329319322635394,
          0.6940528304352611,
          0.7956281608979983,
          0.9736013309585926,
          1.3104808341716994,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.8052976187693912,
          0.8655275619096061,
          0.9639415356900851,
          1.132414734503212,
          1.46649427494128,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.1348801825019286,
          1.1954787564127498,
          1.292241339453613,
          1.4592770797430932,
          1.7710528134937933,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
    },
    4: {
      5: {
        0: [
          3.020753242041601, 3.3792542215964847, 4.159589900985444,
          5.517835093974767, 7.613299527762827, 10.936408637127602,
          15.181600142786703,
        ],
        1: [
          3.2493606181510817, 3.579636049977116, 4.356281080102738,
          5.70845874251137, 7.796952769709222, 11.038025675773781,
          15.326179144815686,
        ],
        2: [
          3.850050877958915, 4.0538649414933134, 4.682685655122279,
          6.026142165665078, 8.099987955618538, 11.318792141679697,
          15.532503592320767,
        ],
        3: [
          5.011556141466758, 5.221346959747642, 5.525737563461119,
          6.577710715509635, 8.625138524487493, 11.801302678630194,
          15.958800392404726,
        ],
        4: [
          6.921098154391847, 7.121741892054697, 7.423600534392691,
          7.943765312814642, 9.580143473146428, 12.678936337801272,
          16.732335413019563,
        ],
        5: [
          9.927309295893055, 10.111531758670822, 10.389429969722979,
          10.86780501066778, 11.770219923876065, 14.213902460676799,
          18.103600373136786,
        ],
        6: [
          14.115700967981098, 14.279851667950954, 14.526327938699714,
          14.948000529732782, 15.750157615959138, 17.248121956285452,
          20.374579328047645,
        ],
      },
      6: {
        0: [
          1.8940488484150608, 2.1297900175384012, 2.6248512868079885,
          3.4956718537459457, 4.892157333690238, 7.1067849985813085,
          10.095417528877661,
        ],
        1: [
          2.040453992684262, 2.2620400881414096, 2.7558509188733136,
          3.6254678711222406, 5.016695110682964, 7.1067849985813085,
          10.095417528877661,
        ],
        2: [
          2.428099860195551, 2.5715589964131027, 2.975866451813988,
          3.8424094262326536, 5.215736193947187, 7.22409349327881,
          10.184992968490945,
        ],
        3: [
          3.1817444880418426, 3.322674543555529, 3.538290944738711,
          4.224671594903484, 5.587770922030041, 7.22409349327881,
          10.184992968490945,
        ],
        4: [
          4.442521397271803, 4.579883994543216, 4.789926509805639,
          5.162899580284002, 6.278726600146037, 7.421288103580488,
          10.37009201686693,
        ],
        5: [
          6.465692346076144, 6.597174093453745, 6.797352749396526,
          7.149903224401301, 7.833892658823116, 7.421288103580488,
          10.37009201686693,
        ],
        6: [
          9.381732425951009, 9.504058453315878, 9.690537811469056,
          10.020666068767794, 10.656411321965145, 7.745915787343608,
          10.695795554914122,
        ],
      },
      7: {
        0: [
          1.6009471532530926, 1.7996036769030876, 2.220880340279111,
          2.965102425731213, 4.170577130722324, 6.07249970664952,
          8.654735627109453,
        ],
        1: [
          1.7315989301091421, 1.915539658555009, 2.3352239184027472,
          3.0784808520218974, 4.274026756295649, 6.07249970664952,
          8.654735627109453,
        ],
        2: [
          2.0606549012631277, 2.1859962218282836, 2.528411902613774,
          3.2690543275284525, 4.4583957343848795, 6.176468544665954,
          8.752593965574805,
        ],
        3: [
          2.703440774770378, 2.825783447303664, 3.017123829212438,
          3.607655794043545, 4.779865050539503, 6.176468544665954,
          8.752593965574805,
        ],
        4: [
          3.788924531855193, 3.908785738913669, 4.094525680734436,
          4.431241699742278, 5.400720745612103, 6.351716950713271,
          8.903544353323179,
        ],
        5: [
          5.5354653486281356, 5.65095791570178, 5.829003687651454,
          6.14905248157338, 6.770296298223871, 6.351716950713271,
          8.903544353323179,
        ],
        6: [
          8.052185792716287, 8.161375535163172, 8.328576420946742,
          8.627686903479532, 9.212963957150142, 6.6521446527204535,
          9.198690554745838,
        ],
      },
      8: {
        0: [
          1.424734256106694, 1.602883698226853, 1.9804777335845072,
          2.6539470602917605, 3.7356760755485396, 5.454170017144138,
          7.790284071259455,
        ],
        1: [
          1.5439400230871827, 1.7093920915369596, 2.0847261502390024,
          2.7528629166804244, 3.835447123926609, 5.454170017144138,
          7.790284071259455,
        ],
        2: [
          1.8399558583494813, 1.9551438206204699, 2.2629511639942694,
          2.9274679875963514, 4.000527107458302, 5.550124031881069,
          7.881471315664546,
        ],
        3: [
          2.418796572407235, 2.5306834506766225, 2.7086537145369682,
          3.2422075696219332, 4.299032363270205, 5.550124031881069,
          7.881471315664546,
        ],
        4: [
          3.3991125983726826, 3.5090839553578044, 3.681959582284729,
          3.9970881405875764, 4.878753805808774, 5.7123164527556005,
          8.023109176397327,
        ],
        5: [
          4.979725974278143, 5.08601545168645, 5.252850272205557,
          5.554300914144564, 6.13608261633976, 5.7123164527556005,
          8.023109176397327,
        ],
        6: [
          7.2546408960513205, 7.355838160745602, 7.512697001704248,
          7.797130163191405, 8.35045761756978, 5.992491177642895,
          8.299736379577915,
        ],
      },
      9: {
        0: [
          1.2826862065988376, 1.4444368957672555, 1.7866108870217643,
          2.398861868148924, 3.3856144188506825, 4.958510359701498,
          7.102561407684199,
        ],
        1: [
          1.3924355253722176, 1.5430176586631739, 1.8827789856389017,
          2.4903670750201745, 3.4781265543116726, 4.958510359701498,
          7.102561407684199,
        ],
        2: [
          1.6621422410096074, 1.7686752161573194, 2.0490232306838823,
          2.6526089411110068, 3.6319407515935085, 5.048141425861365,
          7.188610093310902,
        ],
        3: [
          2.189414839290203, 2.2932091910926387, 2.4595359311378164,
          2.9479755554345792, 3.913489012337192, 5.048141425861365,
          7.188610093310902,
        ],
        4: [
          3.0852772935201456, 3.187621382652863, 3.3499103299964665,
          3.6465568810341256, 4.458828884707016, 5.200126406526065,
          7.334499449678644,
        ],
        5: [
          4.534467802799501, 4.63395309432547, 4.791617004065262,
          5.0773225591115985, 5.626474773881062, 5.200126406526065,
          7.334499449678644,
        ],
        6: [
          6.620836256136682, 6.716740072357922, 6.866247920981737,
          7.138708787682048, 7.666188113461326, 5.4740634484263255,
          7.587435613879666,
        ],
      },
      10: {
        0: [
          1.2145481029039407, 1.3687149809611983, 1.6940279521343975,
          2.277291110722451, 3.218450801195526, 4.72018207738564,
          6.767617537507643,
        ],
        1: [
          1.320320892522839, 1.4640994381171537, 1.7869990877466189,
          2.365669581146063, 3.30768263961425, 4.72018207738564,
          6.767617537507643,
        ],
        2: [
          1.578022574925027, 1.680867095757686, 1.9484770076251927,
          2.523149079689033, 3.457412057701778, 4.8071539838945645,
          6.851334358536127,
        ],
        3: [
          2.081547885101035, 2.1818488329916246, 2.3434623009253857,
          2.810988024657503, 3.7325023705772598, 4.8071539838945645,
          6.851334358536127,
        ],
        4: [
          2.937494838518353, 3.036514399571097, 3.1944206324484394,
          3.4835640724741785, 4.262704371073719, 4.955280101187063,
          6.994430850178661,
        ],
        5: [
          4.323307451960358, 4.419934278409642, 4.573505416110058,
          4.8526326377961855, 5.387056781876648, 4.955280101187063,
          6.994430850178661,
        ],
        6: [
          6.315648687308352, 6.408822363429913, 6.55565247052901,
          6.822921821706922, 7.338494438333029, 5.223619362876864,
          7.243597021174535,
        ],
      },
      11: {
        0: [
          1.1694235579404357,
          1.3182603971272322,
          1.6319329051136524,
          2.1953560582287928,
          3.105360176033045,
          4.654052567839381,
          null,
        ],
        1: [
          1.2720629012221534,
          1.4111535330472353,
          1.7226639431329474,
          2.281778110395788,
          3.1928381192462103,
          4.654052567839381,
          null,
        ],
        2: [
          1.5215163433982024,
          1.6216807189454367,
          1.8808573941273408,
          2.4362866644534105,
          3.3402784454310988,
          4.7403604038705245,
          null,
        ],
        3: [
          2.0089828774957126,
          2.106955422400823,
          2.2655165610552075,
          2.719212113471187,
          3.611236913253809,
          4.7403604038705245,
          null,
        ],
        4: [
          2.8381308310788214,
          2.935010205552042,
          3.0899895443516407,
          3.3741717863509915,
          4.1310757535458436,
          4.887501224255077,
          null,
        ],
        5: [
          4.2655997088661355,
          4.361354113599473,
          4.513875692552608,
          4.791333581105567,
          5.322496065565041,
          4.887501224255077,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      12: {
        0: [
          1.1295906275039025,
          1.2739213293425533,
          1.5779226130495791,
          2.1240393208285977,
          3.006752682252807,
          4.596377651433232,
          null,
        ],
        1: [
          1.2296589180357,
          1.3645235116248269,
          1.6663996452761634,
          2.2110721132496196,
          3.092176288433042,
          4.596377651433232,
          null,
        ],
        2: [
          1.471804463019205,
          1.569218519560573,
          1.8206156814532364,
          2.358815828200953,
          3.2390439253836742,
          4.681956969246686,
          null,
        ],
        3: [
          1.9444447667653968,
          2.03972317309581,
          2.194758401868935,
          2.6357896812552353,
          3.5016246269073505,
          4.681956969246686,
          null,
        ],
        4: [
          2.748795083487205,
          2.8432682525909145,
          2.99517895025066,
          3.2742132445914613,
          4.01168476707192,
          4.827875804771332,
          null,
        ],
        5: [
          4.2136839239428365,
          4.308644127660682,
          4.459859886467292,
          4.735756784745383,
          5.263629035302105,
          4.827875804771332,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      13: {
        0: [
          1.1064332906374803,
          1.2481344434404846,
          1.5463732061768534,
          2.0824405888896464,
          2.949409365090874,
          4.562914596485223,
          null,
        ],
        1: [
          1.2050083907182851,
          1.3374951863377684,
          1.6337667163725267,
          2.168299167206584,
          3.033876105606244,
          4.562914596485223,
          null,
        ],
        2: [
          1.4430067297497917,
          1.53903323390207,
          1.7861387219180203,
          2.3145016674517787,
          3.1792496999859416,
          4.648127897024354,
          null,
        ],
        3: [
          1.9073868645402932,
          2.001346788964298,
          2.153973227245106,
          2.587456541417948,
          3.438078856450643,
          4.648127897024354,
          null,
        ],
        4: [
          2.697266601351706,
          2.790364541225952,
          2.9403033466885113,
          3.215678919257707,
          3.941259722906251,
          4.793501639702289,
          null,
        ],
        5: [
          4.183671984545762,
          4.277986212096496,
          4.428421768641592,
          4.703073673973439,
          5.228950441618447,
          4.793501639702289,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      14: {
        0: [
          1.0890914490507906,
          1.2287958016792349,
          1.522776902985572,
          2.0511035370483057,
          2.906230927745294,
          4.5377222622412585,
          null,
        ],
        1: [
          1.1864826732713163,
          1.3171571258668666,
          1.609185939110052,
          2.1361714224675934,
          2.9899374518033137,
          4.5377222622412585,
          null,
        ],
        2: [
          1.4213007086188767,
          1.5162213886822902,
          1.760056628994431,
          2.2810687541821206,
          3.1341107750271853,
          4.622651054805987,
          null,
        ],
        3: [
          1.879352377818917,
          1.9723036315724827,
          2.123448838879673,
          2.5511727934146258,
          3.39066811873705,
          4.622651054805987,
          null,
        ],
        4: [
          2.6587135061524303,
          2.750862564368398,
          2.899227799310661,
          3.171592574989982,
          3.888249597123691,
          4.7675920457363725,
          null,
        ],
        5: [
          4.161428884878385,
          4.255237048360662,
          4.405199607366059,
          4.67882326898828,
          5.202559064098232,
          4.7675920457363725,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      15: {
        0: [
          1.0744175909450622,
          1.2124504292961082,
          1.5028947723169521,
          2.0248328590835682,
          2.8703358197336826,
          4.51687458311385,
          null,
        ],
        1: [
          1.170798206482612,
          1.2999589624037635,
          1.5884898416052242,
          2.1092465555538853,
          2.9534396076103095,
          4.51687458311385,
          null,
        ],
        2: [
          1.4029565758015758,
          1.4969467740967508,
          1.738079341734101,
          2.253038616903317,
          3.096680063905051,
          4.601576452237997,
          null,
        ],
        3: [
          1.8557336850086328,
          1.9478462573806046,
          2.0978107531858607,
          2.5210130224852403,
          3.351696249319863,
          4.601576452237997,
          null,
        ],
        4: [
          2.626488988271812,
          2.7179104768777793,
          2.865227269764845,
          3.1350777107497914,
          3.8448892467026132,
          4.74618575088744,
          null,
        ],
        5: [
          4.142857298208373,
          4.236329872188176,
          4.385949942683633,
          4.658968586762972,
          5.1808585244693734,
          4.74618575088744,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      16: {
        0: [
          1.0655675035925807,
          1.2026299626463857,
          1.4909357070924207,
          2.0091275217294653,
          2.861434241571552,
          null,
          null,
        ],
        1: [
          1.1613835799798609,
          1.2896663033544218,
          1.576133699585185,
          2.093096827135569,
          2.944388719089676,
          null,
          null,
        ],
        2: [
          1.3920039434086355,
          1.485471669816674,
          1.7250245431573359,
          2.2363719036814045,
          3.0874108069850354,
          null,
          null,
        ],
        3: [
          1.8416378641321267,
          1.9332897636191468,
          2.0826088735565627,
          2.5031404943384894,
          3.342128868100355,
          null,
          null,
        ],
        4: [
          2.618508907859659,
          2.70972339955941,
          2.8568103854464653,
          3.1262973627104786,
          3.8345289371283395,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      17: {
        0: [
          1.0591102241790245,
          1.195475418259587,
          1.4822725949900268,
          1.997729936711821,
          2.8549940625459636,
          null,
          null,
        ],
        1: [
          1.1545321358316873,
          1.2821913817261146,
          1.5671573941522436,
          2.0814375534154657,
          2.937845682621198,
          null,
          null,
        ],
        2: [
          1.3840551708983848,
          1.477154086354107,
          1.7155912460756495,
          2.2243128687814853,
          3.080725438792257,
          null,
          null,
        ],
        3: [
          1.831426225231427,
          1.9227657584963191,
          2.071626898536456,
          2.490308758924777,
          3.3352233687175703,
          null,
          null,
        ],
        4: [
          2.6127406918675846,
          2.7038079177328447,
          2.8507308075156494,
          3.1199634919480994,
          3.827116563175518,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      18: {
        0: [
          1.053770210487373,
          1.18957049674942,
          1.4751401680667577,
          1.9884164345220903,
          2.8497445673714332,
          null,
          null,
        ],
        1: [
          1.148870393388182,
          1.2760276497147358,
          1.5597888788471523,
          2.0719243629741557,
          2.9325197920632524,
          null,
          null,
        ],
        2: [
          1.3774865210580718,
          1.4703157839954217,
          1.70784814562559,
          2.214499646476959,
          3.075293939795827,
          null,
          null,
        ],
        3: [
          1.8230527903423606,
          1.9141396263712651,
          2.0626766769055074,
          2.479943885108722,
          3.3296273941495285,
          null,
          null,
        ],
        4: [
          2.6080265390602735,
          2.6989783164039958,
          2.8457347325560733,
          3.1148223446331356,
          3.8211880983658295,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      19: {
        0: [
          1.0504784532007991,
          1.1859462485849477,
          1.4707683224555332,
          1.9827105896578046,
          2.84651823842228,
          null,
          null,
        ],
        1: [
          1.1454042379238958,
          1.2722670739074373,
          1.5552992459237451,
          2.0661087247393985,
          2.9292581923477146,
          null,
          null,
        ],
        2: [
          1.3734865620367342,
          1.4661660794241151,
          1.703153389691944,
          2.208539357059353,
          3.071981014710043,
          null,
          null,
        ],
        3: [
          1.817950253898811,
          1.9089025610676233,
          2.057259544440319,
          2.473628114025473,
          3.32623244388691,
          null,
          null,
        ],
        4: [
          2.605144802611017,
          2.696036836954411,
          2.842745648703193,
          3.1117103601485896,
          3.817560788219343,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
    },
    5: {
      5: {
        0: [
          2.355181607311071, 2.5522237754518464, 2.991901111339231,
          3.8092264162745613, 5.110643953168887, 7.076221814169427,
          9.632306397620994,
        ],
        1: [
          2.484187974872368, 2.6618491169793153, 3.0905839309727767,
          3.905813964908463, 5.204158844879805, 7.164998859026779,
          9.714645212663246,
        ],
        2: [
          2.803452656784371, 2.9350175515586283, 3.276490245615804,
          4.080538653950561, 5.373615651506972, 7.325605884916286,
          9.86545977997399,
        ],
        3: [
          3.485968958584821, 3.6043109745107604, 3.7807170659982914,
          4.417139725149857, 5.699589826581471, 7.637353752378036,
          10.151832631735807,
        ],
        4: [
          4.674993014134969, 4.775657468171516, 4.94638735284394,
          5.270941493217915, 6.3094943731067925, 8.218759925155277,
          10.694452887178553,
        ],
        5: [
          6.487295123918213, 6.59523864560952, 6.7564553428924885,
          7.061310479160976, 7.661203625720443, 9.189902514793433,
          11.605085699193502,
        ],
        6: [
          9.015729566143811, 9.116487954449866, 9.266515571895292,
          9.550138312525615, 10.105131197941159, 11.088938085864498,
          13.088104037256024,
        ],
      },
      6: {
        0: [
          1.4693656324067264, 1.5942223246610836, 1.8778187314688815,
          2.401525402585283, 3.2368671408473118, 4.522304085169917,
          6.237947930716511,
        ],
        1: [
          1.554161555565119, 1.6678382481750922, 1.9439190749617183,
          2.4656827522719773, 3.300298107627442, 4.522304085169917,
          6.237947930716511,
        ],
        2: [
          1.7585165985807711, 1.8455775973237416, 2.068659762880795,
          2.583342544132141, 3.416133713521206, 4.584770044514892,
          6.296823237823637,
        ],
        3: [
          2.2038030646452693, 2.280822201660879, 2.4016060018219574,
          2.8125678076468317, 3.6406221083635626, 4.584770044514892,
          6.296823237823637,
        ],
        4: [
          2.9663082868162487, 3.0414286972315674, 3.1563357890065658,
          3.384997672973954, 4.064643247600747, 4.697627621115237,
          6.405610418016109,
        ],
        5: [
          4.153949715799128, 4.227320781011946, 4.339271352241675,
          4.555119417073113, 4.985626701059926, 4.697627621115237,
          6.405610418016109,
        ],
        6: [
          5.843142808303018, 5.913904632298513, 6.02103741583012,
          6.228178695985771, 6.636106169158632, 4.91644428383162,
          6.614739306764449,
        ],
      },
      7: {
        0: [
          1.2387652577917545, 1.3448794030637439, 1.5854609953605436,
          2.0320109017648225, 2.746077811982672, 3.8471739169524115,
          5.306524065153058,
        ],
        1: [
          1.3126878779419404, 1.4097842172365533, 1.6436345283237057,
          2.0882187266744676, 2.801693526915777, 3.8471739169524115,
          5.306524065153058,
        ],
        2: [
          1.4879220858914688, 1.5638290847341716, 1.7540404528364015,
          2.1916718018010424, 2.903795342542254, 3.9017014638093594,
          5.3520012650332145,
        ],
        3: [
          1.8678552066494292, 1.9353830943029338, 2.0435146394108794,
          2.3958826873677026, 3.1018370775717052, 3.9017014638093594,
          5.3520012650332145,
        ],
        4: [
          2.52040627770939, 2.5855466941668777, 2.688373549620073,
          2.894269822226224, 3.479702151756711, 4.0015439063775355,
          5.448703526028503,
        ],
        5: [
          3.5384815503448035, 3.602331305919929, 3.701381015029867,
          3.8969250753923514, 4.282245107751688, 4.0015439063775355,
          5.448703526028503,
        ],
        6: [
          4.966881587764255, 5.0289408508431475, 5.1247237714332305,
          5.310052097167475, 5.6745949221138705, 4.195307030081669,
          5.635858797849718,
        ],
      },
      8: {
        0: [
          1.1015805603100786, 1.196615616341063, 1.4117826668757827,
          1.812260297059241, 2.453754024423887, 3.449776223239233,
          4.7441940283136415,
        ],
        1: [
          1.1690045459847218, 1.2562859687879155, 1.4651818405271655,
          1.8637431971298908, 2.5046667373632348, 3.449776223239233,
          4.7441940283136415,
        ],
        2: [
          1.3273308935848251, 1.3963330123682591, 1.5676609758490492,
          1.9590319964749134, 2.5987516051811808, 3.4937971030087063,
          4.7926710920640625,
        ],
        3: [
          1.6687409454777917, 1.7306953221476782, 1.831267524744584,
          2.1493303747016315, 2.782089337832536, 3.4937971030087063,
          4.7926710920640625,
        ],
        4: [
          2.2550851625494714, 2.315052681545421, 2.4111974366024804,
          2.6032351796521014, 3.1325780572763415, 3.586267919838047,
          4.876393883716084,
        ],
        5: [
          3.171198631991599, 3.23004097136061, 3.3228824537722392,
          3.5062027218477363, 3.8635020110387037, 3.586267919838047,
          4.876393883716084,
        ],
        6: [
          4.443325537904033, 4.500035980430634, 4.5894238359941175,
          4.762579430397496, 5.101658143276543, 3.7652308630013303,
          5.050656216366067,
        ],
      },
      9: {
        0: [
          0.9910152327160936, 1.0771512223760582, 1.271863608879388,
          1.634892159586358, 2.217348817569042, 3.123541710144443,
          4.293996716904141,
        ],
        1: [
          1.052975070450937, 1.1323536513706522, 1.3213982357925378,
          1.6824210727767581, 2.2646577723521397, 3.123541710144443,
          4.293996716904141,
        ],
        2: [
          1.1992474271139644, 1.2608930820773616, 1.417086993077029,
          1.7715693957801217, 2.3521479786072783, 3.1696616004024376,
          4.339159780034524,
        ],
        3: [
          1.509694571719923, 1.5668702315119647, 1.6591874428795508,
          1.9495085907654577, 2.5241365850300053, 3.1696616004024376,
          4.339159780034524,
        ],
        4: [
          2.0409811153196773, 2.0965521716338884, 2.1868195795110346,
          2.3665312775823795, 2.8507175066738943, 3.251117318874618,
          4.423163546223946,
        ],
        5: [
          2.875325189195411, 2.9299672091096776, 3.017533090311617,
          3.190020908119865, 3.5235061305057673, 3.251117318874618,
          4.423163546223946,
        ],
        6: [
          4.023992382848808, 4.076869904283917, 4.16102316559728,
          4.324045573316347, 4.642874332789304, 3.4190272820046372,
          4.5814836255089535,
        ],
      },
      10: {
        0: [
          0.9379125621018194, 1.0199933062955682, 1.2050756384342454,
          1.5502038827435707, 2.1046329401226886, 2.967409255758727,
          4.080622228786802,
        ],
        1: [
          0.997538245033206, 1.0733125818159706, 1.2532126717164238,
          1.5963259185815253, 2.1502082042439548, 2.967409255758727,
          4.080622228786802,
        ],
        2: [
          1.1376716221286558, 1.1985038225653373, 1.3462334961988582,
          1.6833238288684367, 2.2355948751272168, 3.012016458266423,
          4.119021876665668,
        ],
        3: [
          1.4337233536754428, 1.488886009346768, 1.5803717574951475,
          1.8562510721346093, 2.4030123980146985, 3.012016458266423,
          4.119021876665668,
        ],
        4: [
          1.9398988783377251, 1.9935796167572037, 2.0816243844351523,
          2.256256914457679, 2.719062538327848, 3.0915950741300104,
          4.200585420765491,
        ],
        5: [
          2.735118637372742, 2.7880082717902193, 2.8735657368123793,
          3.0415522304984832, 3.364284234692472, 3.0915950741300104,
          4.200585420765491,
        ],
        6: [
          3.8215011182418452, 3.8724689848141844, 3.9544187493174325,
          4.113840160695785, 4.423481987893273, 3.2552281515004324,
          4.35498616902548,
        ],
      },
      11: {
        0: [
          0.9028066105158258,
          0.9820891851301282,
          1.160827341204549,
          1.4934909945017074,
          2.0282506226223513,
          2.9232599160688024,
          null,
        ],
        1: [
          0.960475910960065,
          1.0337526635861691,
          1.2076469700790256,
          1.538703780534919,
          2.072962632561535,
          2.9232599160688024,
          null,
        ],
        2: [
          1.096305803479382,
          1.1553225562797824,
          1.29852371532993,
          1.6241416219803804,
          2.1571406199250505,
          2.967546737115245,
          null,
        ],
        3: [
          1.3826293980460633,
          1.4363426600069622,
          1.526156224959788,
          1.793467302304855,
          2.321480362981465,
          2.967546737115245,
          null,
        ],
        4: [
          1.871648734523555,
          1.9241174860972765,
          2.0107361967760147,
          2.181929459578146,
          2.6303183652612185,
          3.0466373316718296,
          null,
        ],
        5: [
          2.696075114572878,
          2.7483621930799416,
          2.833329211538043,
          3.000508207983198,
          3.320723272780792,
          3.0466373316718296,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.8717864991985173,
          0.9487363497831423,
          1.1218828118637278,
          1.4439822792443322,
          1.9616315316833264,
          2.8872971301506416,
          null,
        ],
        1: [
          0.928051984641235,
          0.9991432921420602,
          1.167742941837035,
          1.4881317916478916,
          2.005317400087614,
          2.8872971301506416,
          null,
        ],
        2: [
          1.0600654258508049,
          1.1174521320577104,
          1.256406663192935,
          1.5715591719853768,
          2.0874516898353406,
          2.9285501668191385,
          null,
        ],
        3: [
          1.3374246956094404,
          1.3897519579298319,
          1.4771989778366137,
          1.7365860935266064,
          2.247803666761375,
          2.9285501668191385,
          null,
        ],
        4: [
          1.8108633783773158,
          1.8619539550323556,
          1.9465851951860904,
          2.113730904514725,
          2.5491257872068886,
          3.0069876881979747,
          null,
        ],
        5: [
          2.6611649283957286,
          2.7128235628422317,
          2.7970908797566407,
          2.9630501983040896,
          3.280739673969975,
          3.0069876881979747,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.8538133494245975,
          0.9293962813054699,
          1.099288356195337,
          1.4151662783556316,
          1.9229778569174587,
          2.864849943115333,
          null,
        ],
        1: [
          0.9092382143080873,
          0.9791438124508008,
          1.1445992356330588,
          1.4588464217886445,
          1.9662452545718172,
          2.864849943115333,
          null,
        ],
        2: [
          1.0390407275834135,
          1.0955784744329242,
          1.2321953372426775,
          1.54136380349424,
          2.0475717587107383,
          2.9060516659536524,
          null,
        ],
        3: [
          1.311329167911632,
          1.3629517806050635,
          1.4492944603511098,
          1.7038395919284812,
          2.205581917249312,
          2.9060516659536524,
          null,
        ],
        4: [
          1.7759792416022737,
          1.8264033721480486,
          1.909874436676823,
          2.074325412591037,
          2.501751326807045,
          2.984241768129539,
          null,
        ],
        5: [
          2.6411997670951153,
          2.6925288713338253,
          2.776462950780303,
          2.9416092767075908,
          3.2572998791138525,
          2.984241768129539,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.8403925801032668,
          0.9149376997664909,
          1.0823442952659457,
          1.393487227889432,
          1.8939328764513936,
          2.8479375439377823,
          null,
        ],
        1: [
          0.8951451982418162,
          0.9641163898424342,
          1.1272029916618072,
          1.4367617772308638,
          1.9367545925485046,
          2.8479375439377823,
          null,
        ],
        2: [
          1.0232455609370037,
          1.0790899946896468,
          1.2138687874138752,
          1.5184834581005675,
          2.0173300579056264,
          2.8891706233599113,
          null,
        ],
        3: [
          1.2915897876263074,
          1.3426534677951327,
          1.428150369900032,
          1.679212013536238,
          2.173756430024656,
          2.8891706233599113,
          null,
        ],
        4: [
          1.7495384008692538,
          1.7994543206655018,
          1.8821581297716539,
          2.044561694761252,
          2.4662323889665956,
          2.96706371801515,
          null,
        ],
        5: [
          2.626040535516526,
          2.677153732634128,
          2.760828559538721,
          2.925493254386353,
          3.2396473252920006,
          2.96706371801515,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.8289827361673443,
          0.9026489274295548,
          1.067992037586544,
          1.3751686633246214,
          1.8693804274557806,
          2.833751617099222,
          null,
        ],
        1: [
          0.8831477306414064,
          0.951337841479355,
          1.1124362001298804,
          1.4180821175149327,
          1.9119836462327173,
          2.833751617099222,
          null,
        ],
        2: [
          1.0097989489205683,
          1.0650514548943224,
          1.1983106889788449,
          1.4991439043785788,
          1.991902755322835,
          2.874884003175615,
          null,
        ],
        3: [
          1.2748628101025734,
          1.3254337130783922,
          1.4101846866463013,
          1.6583743195800014,
          2.147026757835081,
          2.874884003175615,
          null,
        ],
        4: [
          1.7271940750649288,
          1.7766810970086993,
          1.8587469772744365,
          2.0197065541127817,
          2.4367506945011788,
          2.95268264386785,
          null,
        ],
        5: [
          2.613260148847286,
          2.6641739320987834,
          2.747631185927557,
          2.9119105625122623,
          3.2250805446968847,
          2.95268264386785,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.8221184753444489,
          0.8952814730337157,
          1.059386750130083,
          1.3641514153473597,
          1.863207814618638,
          null,
          null,
        ],
        1: [
          0.8759631508432792,
          0.9436990170388864,
          1.1036155916255503,
          1.4068818366589366,
          1.9057315255897889,
          null,
          null,
        ],
        2: [
          1.0017567418328925,
          1.0566926029177948,
          1.1890449355568067,
          1.4875845653768591,
          1.9855356274734683,
          null,
          null,
        ],
        3: [
          1.2648433369582714,
          1.3151588553154303,
          1.3995007722813542,
          1.6459530895914845,
          2.1404224582270936,
          null,
          null,
        ],
        4: [
          1.7215745978146173,
          1.7709487482480508,
          1.8528846327688897,
          2.013589088625786,
          2.4295579745203537,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.8171072672986648,
          0.8899133599612832,
          1.0531226940510918,
          1.3561472665383336,
          1.8587161492598199,
          null,
          null,
        ],
        1: [
          0.8707270024371712,
          0.9381419143206622,
          1.0972062841872758,
          1.3987612628345638,
          1.9011961472622367,
          null,
          null,
        ],
        2: [
          0.9959015165495525,
          1.0506184724756442,
          1.1823213193172732,
          1.4792057750849368,
          1.9809302075335746,
          null,
          null,
        ],
        3: [
          1.257565301826895,
          1.3076965874799398,
          1.3917546798596812,
          1.6369550630943546,
          2.1356408061999055,
          null,
          null,
        ],
        4: [
          1.7175075956596775,
          1.7667901632107337,
          1.848631891668438,
          2.0091581402683714,
          2.424351071786398,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.8129405151403153,
          0.8854639681785539,
          1.0479377078572756,
          1.3495568805899891,
          1.8549990749420961,
          null,
          null,
        ],
        1: [
          0.8663835170304992,
          0.9335345368630774,
          1.0919018432062608,
          1.3920633726103608,
          1.8974750630980954,
          null,
          null,
        ],
        2: [
          0.991046548791283,
          1.0455808738925079,
          1.1767542983908474,
          1.4723036607376108,
          1.9771385972836366,
          null,
          null,
        ],
        3: [
          1.2515378355489155,
          1.3015296859289087,
          1.38534905748351,
          1.6295520383234687,
          2.1317119332330945,
          null,
          null,
        ],
        4: [
          1.7141438665595874,
          1.763351541463412,
          1.8451242927661173,
          2.0055010727956493,
          2.420082448386456,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.8103807888642001,
          0.882732585205263,
          1.0447574671748883,
          1.345489751422476,
          1.8527167727468647,
          null,
          null,
        ],
        1: [
          0.863722533013733,
          0.9307216345786182,
          1.0886596483094886,
          1.3879578494622846,
          1.8951727086614545,
          null,
          null,
        ],
        2: [
          0.9880781766489133,
          1.0425150617429413,
          1.1733694652087259,
          1.4680849619741962,
          1.974814460430925,
          null,
          null,
        ],
        3: [
          1.2478522926692168,
          1.2977674722975754,
          1.3814581828857269,
          1.6250463029759339,
          2.1293098621285713,
          null,
          null,
        ],
        4: [
          1.7120625660488586,
          1.7612501122745483,
          1.8429855740580665,
          2.0032789958845836,
          2.4174830141012906,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
    },
    6: {
      5: {
        0: [
          2.2879781267303443, 2.506867255412356, 2.9855119330111437,
          3.861337635150309, 5.264162394532159, 7.5060804726722505,
          10.585969654960344, 14.61291185633998, 20.26271701086722,
          27.152705590100126,
        ],
        1: [
          2.4415108611354164, 2.6421321288582034, 3.103615519512826,
          3.971742302323942, 5.36975943313583, 7.604351514363742,
          10.672816190717562, 14.68660558613946, 20.323634864858604,
          27.203484324201796,
        ],
        2: [
          2.805644642416298, 2.9597636002483725, 3.336006716162947,
          4.177872496423644, 5.564967984318011, 7.785879786510169,
          10.834422028293172, 14.827334017501524, 20.43706881346381,
          27.29764122972873,
        ],
        3: [
          3.5379199805561736, 3.668706800075631, 3.8983200680837102,
          4.552772042083214, 5.918646255204633, 8.111549223350318,
          11.125903265057168, 15.086109898891813, 20.647022244143656,
          27.48203591975173,
        ],
        4: [
          4.798259232452575, 4.921801680554083, 5.112502023153577,
          5.514760956237416, 6.593319291564692, 8.731211452978787,
          11.679303349063835, 15.575994905089157, 21.04769652770967,
          27.825430104282283,
        ],
        5: [
          6.847204791966346, 6.961467899058411, 7.151969402019333,
          7.494600815202585, 8.246678883895225, 9.957187224350086,
          12.7549410713053, 16.51658379838718, 21.813491070910516,
          28.476432620309097,
        ],
        6: [
          9.794366695395679, 9.897013834359473, 10.07194803547224,
          10.392869307351255, 11.042589467385294, 12.38234759575855,
          14.737592411153468, 18.189964261153015, 23.15163413915866,
          29.599654245394326,
        ],
        7: [
          13.611112143424155, 13.70745668809118, 13.871789944908084,
          14.17125686930071, 14.76961982652979, 15.966635552495278,
          17.996162965736872, 21.058838705162962, 25.476410186863212,
          31.535965907297516,
        ],
        8: [
          18.842093181044177, 18.927519526594256, 19.06923923476586,
          19.34955336917001, 19.878893465940738, 20.951062853790912,
          22.732552139768966, 25.41209757971493, 29.34550206796677,
          34.75496827293842,
        ],
        9: [
          25.87699665037122, 25.95321132320808, 26.076375806408382,
          26.29749352904009, 26.736472171343237, 27.600469030445844,
          29.105247738860506, 31.364348064256575, 34.75345979769748,
          39.539017956768134,
        ],
      },
      6: {
        0: [
          1.4152245811541317, 1.5536921871206189, 1.860647977721528,
          2.416598509587101, 3.3160571097714877, 4.786377070061948,
          6.8664187896432285, 9.727929682161975, 13.963366754631473,
          19.546462228677306,
        ],
        1: [
          1.515367735535159, 1.6432413691232903, 1.9376158975373121,
          2.489829281538479, 3.3875251954053756, 4.854837108805284,
          6.930435713939157, 9.78732822411145, 14.017727323209886,
          19.595235858103706,
        ],
        2: [
          1.7478180816806477, 1.8488441622268132, 2.088676149917723,
          2.626497360987907, 3.5200736506448935, 4.981652925614819,
          7.049843857448706, 9.899762387510133, 14.118862597862627,
          19.68627811448564,
        ],
        3: [
          2.2197500301506325, 2.3074888714857202, 2.4569275432967226,
          2.8888578016595092, 3.767166916422374, 5.214627406094346,
          7.270850430717342, 10.107942617518358, 14.30491449857996,
          19.861104276928884,
        ],
        4: [
          3.0362104850495686, 3.120784222564307, 3.2639010800060584,
          3.5360765866429844, 4.268823646208769, 5.670364549792169,
          7.695568818601094, 10.50827836874926, 14.661047725299461,
          20.18917748488649,
        ],
        5: [
          4.378130361732824, 4.459242525840482, 4.595391234500358,
          4.853043246519373, 5.386801782213718, 6.571353750070395,
          8.510920172599718, 11.261934036113807, 15.326006301954074,
          20.798665768995736,
        ],
        6: [
          6.369806043720663, 6.4462474516708355, 6.576414756469226,
          6.816924107572805, 7.301311555565115, 8.27677752714034,
          9.986942835691831, 12.577421108858516, 16.462298111911856,
          21.826400694632866,
        ],
        7: [
          9.090590937769525, 9.165089521236908, 9.293038809437482,
          9.527002904579222, 9.992786277992167, 10.905719746543829,
          12.44967243705647, 14.839580160691563, 18.420059614695777,
          23.57632660453413,
        ],
        8: [
          13.036178420440645, 13.10638675903581, 13.223717738919461,
          13.453516143191486, 13.889938602422848, 14.752158167678427,
          16.180333486459986, 18.377546731385433, 21.7054567059214,
          26.48828007553802,
        ],
        9: [
          18.68338269242301, 18.750014201059756, 18.859314030848083,
          19.057350279753933, 19.447012861906895, 20.19810528353855,
          21.485972756541848, 23.458029979863213, 26.486638380238148,
          30.91243951969944,
        ],
      },
      7: {
        0: [
          1.1857201086763487, 1.3028235820094096, 1.56086014663023,
          2.0304321252119384, 2.7942060727925044, 4.044822161730938,
          5.827464856199597, 8.31607185353253, 12.05186825916002,
          17.09164766334532,
        ],
        1: [
          1.2720751255819516, 1.380787409764063, 1.628035320482645,
          2.0935042428702157, 2.855992556352638, 4.104457977206016,
          5.884798398785536, 8.370561998539772, 12.102698722143199,
          17.138335184118894,
        ],
        2: [
          1.4697315009525849, 1.556829765932119, 1.7637047195684497,
          2.2136953703191606, 2.9718318185716806, 4.215878773713474,
          5.991526281952891, 8.47368265087164, 12.19672720301481,
          17.225377676243586,
        ],
        3: [
          1.8698904005831865, 1.9464189203687168, 2.081414368830819,
          2.4488142176890917, 3.1917202014747206, 4.424058580320748,
          6.190616088735833, 8.664068841395203, 12.370703117686851,
          17.391260114109226,
        ],
        4: [
          2.565547461128434, 2.6396723058352403, 2.7656220243654763,
          3.009486091543335, 3.634716282607454, 4.831130555975656,
          6.574126453662446, 9.029601660474574, 12.702190015889276,
          17.7039960988494,
        ],
        5: [
          3.7109816275825303, 3.7824580583732024, 3.9031236265865004,
          4.13162654375634, 4.601243319700952, 5.624275604300442,
          7.301006106998404, 9.710585733552648, 13.316568753402073,
          18.27926048661083,
        ],
        6: [
          5.419971378602439, 5.48796990393725, 5.604128445844651,
          5.819662398107891, 6.250859660504398, 7.107749786296176,
          8.603285273542342, 10.889042464209865, 14.357199598058697,
          19.24383343637249,
        ],
        7: [
          7.791127887234236, 7.857979039091586, 7.972842514130127,
          8.183691575788336, 8.602181613075754, 9.413293473349187,
          10.7815087233476, 12.914774768677457, 16.14758942000288,
          20.883693311727576,
        ],
        8: [
          11.279765697877457, 11.343777024200666, 11.450851574632782,
          11.660024797223285, 12.057469430684604, 12.834745052205317,
          14.11980026953954, 16.112134767006257, 19.16192292217059,
          23.619577714512282,
        ],
        9: [
          16.364252992967835, 16.425785324850672, 16.52755916381748,
          16.712640470853493, 17.07604992599096, 17.77031327136916,
          18.955270501132052, 20.78360451193562, 23.617923556595102,
          27.822514548715304,
        ],
      },
      8: {
        0: [
          1.0499071522996428, 1.1544464785726243, 1.38344785982869,
          1.8013758452721642, 2.4838848861619134, 3.603342025479392,
          5.209899810079941, 7.476328449130211, 10.910210051798607,
          15.62501539015733,
        ],
        1: [
          1.128063735943571, 1.2253544396880462, 1.4452136484834794,
          1.8592778480521304, 2.540715256320384, 3.6583912064738913,
          5.263488506552614, 7.527721033714668, 10.958782412300906,
          15.670436576295817,
        ],
        2: [
          1.305284874882551, 1.3839783040765732, 1.56916574269035,
          1.9700641246098618, 2.647876270413985, 3.7621274485534193,
          5.3631458486172825, 7.624721003104471, 11.048923635332246,
          15.754992662841875,
        ],
        3: [
          1.6632529164921723, 1.7329643217722077, 1.8562366542680122,
          2.1862301228325256, 2.8511439119284985, 3.95567964706383,
          5.549639923459983, 7.803985470799411, 11.21520124003421,
          15.916193653004498,
        ],
        4: [
          2.287001831953832, 2.354753379711929, 2.4703808609343207,
          2.694069395027898, 3.258061285359306, 4.332498483301442,
          5.907126255150044, 8.147779164468655, 11.531858059031098,
          16.219803247454635,
        ],
        5: [
          3.3153439669700457, 3.3809338659529082, 3.4922296473832386,
          3.703017915243362, 4.1334272843299615, 5.059666965943792,
          6.5793438481748225, 8.783709483836677, 12.114496598421216,
          16.775267309547292,
        ],
        6: [
          4.8558392938167625, 4.91862593448265, 5.026366397976702,
          5.226466207479962, 5.624936611956923, 6.409763824454632,
          7.776260981979753, 9.878614571670392, 13.097282966527827,
          17.702818556314,
        ],
        7: [
          7.016288153680582, 7.078340345347857, 7.185204442593706,
          7.3822829778987415, 7.771546298406787, 8.52079152293435,
          9.78309484089526, 11.762331437866473, 14.787878085249023,
          19.28014964025109,
        ],
        8: [
          10.228634429069327, 10.288647738632303, 10.389592644890207,
          10.586362406135823, 10.960426823986445, 11.686179148298175,
          12.885705305563405, 14.756575416480036, 17.643322854566417,
          21.918303448506002,
        ],
        9: [
          14.976543584737415, 15.035330349510698, 15.13266175289325,
          15.310103790922605, 15.658275261265398, 16.319171075796437,
          17.44407692595383, 19.19053310342163, 21.91661525068565,
          26.00646851172643,
        ],
      },
      9: {
        0: [
          0.9419592874995122, 1.0364494409966931, 1.242795467690406,
          1.620137812774254, 2.23883241488291, 3.2559971494937523,
          4.726956357216114, 6.825746537839903, 10.042117159431132,
          14.543460575176626,
        ],
        1: [
          1.0133583109360005, 1.1015451173710438, 1.299938803333902,
          1.673985015492756, 2.2918523218825126, 3.3077813074720734,
          4.777708756738526, 6.874863610493879, 10.089275242137251,
          14.588175214061089,
        ],
        2: [
          1.174178530590651, 1.2460889469835466, 1.4141317359628998,
          1.7767939459158644, 2.391697987525564, 3.4049917547239965,
          4.872028226743939, 6.9674838699323995, 10.176692947224566,
          14.671569926390891,
        ],
        3: [
          1.4988541472693964, 1.562954102984575, 1.6765618661592094,
          1.9771397814120588, 2.5812054456574636, 3.5865834301635626,
          5.048267445524177, 7.138673257853686, 10.338172425004986,
          14.830244109624786,
        ],
        4: [
          2.0656976033123864, 2.128214077301279, 2.235350790966839,
          2.442550073914343, 2.95851762726638, 3.9389417463675933,
          5.385391590493276, 7.466302337504259, 10.645053542439276,
          15.129507900944905,
        ],
        5: [
          3.0019670398401344, 3.062855110478728, 3.16654723334213,
          3.3631313701909007, 3.762371574624648, 4.614204801520817,
          6.015728211745488, 8.0692068985515, 11.20687092871083,
          15.674911714843446,
        ],
        6: [
          4.412470878256673, 4.471190833544694, 4.572291931195164,
          4.760484305171831, 5.133563949793253, 5.8635529899206595,
          7.134635951619929, 9.104974948037391, 12.152226805991784,
          16.584053497843158,
        ],
        7: [
          6.413310643523662, 6.47188729388138, 6.572980419365993,
          6.759663685091951, 7.1276014430694445, 7.831632416719232,
          9.018255151888503, 10.890756154375108, 13.779787590406913,
          18.132887766109565,
        ],
        8: [
          9.425304391756631, 9.482615632976874, 9.579404854429686,
          9.767847584418409, 10.12600548759755, 10.816764475434788,
          11.95908574112193, 13.751560845469399, 16.5420970756825,
          20.729661660495353,
        ],
        9: [
          13.948076536366356, 14.00519754601117, 14.100060762184434,
          14.27355621949814, 14.613166577378745, 15.254734660006564,
          16.346098331816073, 18.05046973874639, 20.72804174906438,
          24.78649917180784,
        ],
      },
      10: {
        0: [
          0.8912177958226393, 0.9810277578010198, 1.1767445235300138,
          1.534848492671172, 2.1225116939495803, 3.0897839271285195,
          4.494917355676396, 6.511096854796541, 9.621817962924617,
          14.018471232697324,
        ],
        1: [
          0.9592310928815728, 1.0430631219205033, 1.2316578021657112,
          1.5867948022934084, 2.1737023828570785, 3.139971120155009,
          4.544248933436037, 6.559055921458968, 9.668130374152046,
          14.063003572605066,
        ],
        2: [
          1.1138069998157787, 1.182272746819682, 1.3408222518734725,
          1.6857210436651244, 2.269980721044936, 3.2340247538329705,
          4.635812103492079, 6.649271538833189, 9.75394990567936,
          14.145788992577,
        ],
        3: [
          1.422918172580454, 1.484183863398108, 1.5929329623158743,
          1.878341188822776, 2.4526775054859673, 3.4096304482477655,
          4.806788499730129, 6.816160233516603, 9.912534462276547,
          14.303451116366563,
        ],
        4: [
          1.9605730182650813, 2.020487000605804, 2.123548561398595,
          2.323012488149672, 2.8155915402598843, 3.749047091641005,
          5.132692559454671, 7.134282467594504, 10.213444865885844,
          14.600528482155472,
        ],
        5: [
          2.851879420578253, 2.9103404750339283, 3.010060831960903,
          3.1998639010377534, 3.5840186002299665, 4.398508517432107,
          5.740238756182879, 7.718446481168669, 10.76268422171539,
          15.139989888624338,
        ],
        6: [
          4.199084731454984, 4.255677453012993, 4.353112538745112,
          4.534492600240964, 4.894852454691282, 5.5970973796437296,
          6.81937804016659, 8.722783555199777, 11.687601074138781,
          16.03920681209629,
        ],
        7: [
          6.11982682912692, 6.176449320577236, 6.274296713936245,
          6.455112729203108, 6.811016477237004, 7.491917101106573,
          8.64062080592466, 10.459759206037592, 13.28434390305876,
          17.57286961842818,
        ],
        8: [
          9.031282429315395, 9.087089906175445, 9.181443972702002,
          9.365148966889253, 9.714399156725516, 10.387526122207479,
          11.50197890860947, 13.257589206352794, 16.002297459341797,
          20.150020835623486,
        ],
        9: [
          13.446262732877752, 13.502515478376456, 13.596099433334679,
          13.76746720902634, 14.102509318208888, 14.734846964009288,
          15.809436939592842, 17.49341250495165, 20.148510141600898,
          24.195036043184956,
        ],
      },
      11: {
        0: [
          0.8573139925636662,
          0.9440782183523082,
          1.1329278340708504,
          1.4786349045709475,
          2.0463797747926473,
          3.0454155737636617,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.9234297031147987,
          1.0045349192917716,
          1.1865568086456464,
          1.5295061383757331,
          2.0965818706255446,
          3.095280258100601,
          null,
          null,
          null,
          null,
        ],
        2: [
          1.0730214490996068,
          1.139548287014218,
          1.2930125088256932,
          1.6262517375927363,
          2.190872118484996,
          3.188708726225184,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.3721621731276612,
          1.4318061116421055,
          1.5376689544424587,
          1.8141019053330105,
          2.369600317295319,
          3.363030410761323,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.8921792800688098,
          1.9505833382205249,
          2.050947383516693,
          2.244664763356782,
          2.721785200201806,
          3.6998756099151024,
          null,
          null,
          null,
          null,
        ],
        5: [
          2.81237065899386,
          2.87025978555715,
          2.9690550151543307,
          3.157118677268088,
          3.5372949558411904,
          4.341804537234792,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.8280986286853362,
          0.912264614794849,
          1.0952986725799432,
          1.4304650013560645,
          1.9813682308185203,
          3.0076762085428825,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.8924421274056542,
          0.9712101500147949,
          1.1476903537846175,
          1.4802907806676657,
          2.0306240064345507,
          3.057198816287703,
          null,
          null,
          null,
          null,
        ],
        2: [
          1.0378162321940745,
          1.1025601976119628,
          1.2517096957319218,
          1.575058300421613,
          2.1231516518090494,
          3.150014805994233,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.3283329030964062,
          1.3865293175076174,
          1.4899642786355314,
          1.758869224917003,
          2.2984545764491937,
          3.3232529911661164,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.8333165674388252,
          1.8903917167136557,
          1.9886422528130137,
          2.178278045869586,
          2.642891559929838,
          3.6579332471806154,
          null,
          null,
          null,
          null,
        ],
        5: [
          2.7784747848876417,
          2.8358365138602637,
          2.933862027277322,
          3.1206390011989096,
          3.4981710707818756,
          4.294736544516521,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.8117252986775292,
          0.8944892270724332,
          1.07432337312504,
          1.3206273743930064,
          1.7474738395748592,
          2.5786963977769792,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.8751607025757855,
          0.9526477835593969,
          1.1261442049608246,
          1.3672441280620844,
          1.792210260079567,
          2.623222706106608,
          null,
          null,
          null,
          null,
        ],
        2: [
          1.0182668581562173,
          1.0821164270254777,
          1.2289056274637358,
          1.4556457838435974,
          1.876296938508616,
          2.706505939878321,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.3040767067453438,
          1.3615445461856828,
          1.463760237260803,
          1.6267468958530829,
          2.03500981490835,
          2.8621100894342684,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.8007195622835188,
          1.8571169840719546,
          1.9543164074950792,
          2.0157614540782154,
          2.3462362305610465,
          3.160379015172606,
          null,
          null,
          null,
          null,
        ],
        5: [
          2.7596863941501457,
          2.8167602147361137,
          2.914401993023997,
          2.8040223807316753,
          3.0218964410838782,
          3.7267972761604398,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.7242203490050573,
          0.7986653773629491,
          0.9602540637365944,
          1.256050996684057,
          1.7442076902055326,
          2.57682390496678,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7813745513567436,
          0.8511360799274023,
          1.0072429545723558,
          1.3010998619195893,
          1.7889619432632318,
          2.6213625616315337,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.9102258197919383,
          0.9678362260339658,
          1.1002853267617962,
          1.3865996389414004,
          1.8730845120052717,
          2.70466300586087,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.1672603462915816,
          1.2193700756611126,
          1.3121463343336646,
          1.5516684411728547,
          2.031841078346707,
          2.8602939825124745,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.6147996320535238,
          1.6662206167875828,
          1.7549986270388294,
          1.9262651615729633,
          2.3427460244385885,
          3.158588836131945,
          null,
          null,
          null,
          null,
        ],
        5: [
          2.3819701477839574,
          2.4330611840794036,
          2.520739585794705,
          2.686633807280976,
          3.020171558393293,
          3.724782100607092,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.723097260841348,
          0.7975007704554069,
          0.9589950663254179,
          1.2545898163381337,
          1.742374272316015,
          2.575777514212538,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7802457369571558,
          0.8499762782305833,
          1.0060019442668964,
          1.299665778450869,
          1.7871722530032579,
          2.6203276562895432,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.9090678149125548,
          0.9666745582561815,
          1.099084605903843,
          1.3852191685991353,
          1.8713591584094191,
          2.703658714899703,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.165969694303851,
          1.2180939032642817,
          1.310913774322255,
          1.5502976217663729,
          2.030196478520488,
          2.8593344832421907,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.6132205525272734,
          1.6646680945040484,
          1.7534966257145634,
          1.92475043267847,
          2.34099192543127,
          3.1576735940000376,
          null,
          null,
          null,
          null,
        ],
        5: [
          2.381088850424118,
          2.432183210229209,
          2.519884069589407,
          2.685812236229874,
          3.019303500622328,
          3.723783836843546,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.7222042221136837,
          0.7965773071345288,
          0.957999951173122,
          1.2534247003026349,
          1.741739531033522,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7793498647225747,
          0.8490587436760912,
          1.0050257118263637,
          1.2985282746673508,
          1.7865407880637156,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.9081507833294753,
          0.9657568412058735,
          1.0981338772631672,
          1.3841311407201609,
          1.8707494109945872,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.1649447825621377,
          1.217081651181441,
          1.3099374397319272,
          1.549205806600857,
          2.0296178755743215,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.6126652908056034,
          1.6641132330546204,
          1.752955037534781,
          1.9242369949236346,
          2.340389529007162,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.721651728778891,
          0.7960052079574829,
          0.9574013686546071,
          1.252746667415125,
          1.7413699164323553,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7787968585893444,
          0.8485032823799689,
          1.0044480026696252,
          1.297875854010416,
          1.7861820036152005,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.9076045048215531,
          0.9652220554973416,
          1.0975980627734252,
          1.3835282929869406,
          1.8704080293571517,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.1643558737786839,
          1.2165137956032317,
          1.3094121876177467,
          1.548636652061706,
          2.029309369253774,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.612348935253432,
          1.6638018750617352,
          1.7526601744827341,
          1.9239718231770309,
          2.340085294096141,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.7213243434424914,
          0.7956710667495528,
          0.9570664624885691,
          1.2523855071687477,
          1.741179192723603,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7784749882322863,
          0.8481911461053584,
          1.0041342225982208,
          1.2975435698733193,
          1.785998341444009,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.9073044452573598,
          0.9649400095229483,
          1.0973312744607904,
          1.3832373355854013,
          1.8702436295801648,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.16405473724326,
          1.2162357273600395,
          1.3091753864455136,
          1.548397173908835,
          2.029172345295435,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.612189828368723,
          1.6636500568461265,
          1.7525247038691543,
          1.9238627647799822,
          2.33996727737984,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.7210644395229364,
          0.7954076829179796,
          0.9568020779877386,
          1.2520984326713256,
          1.7410217474394676,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.7782213382759964,
          0.8479455207068304,
          1.0038967554522351,
          1.2972778118008401,
          1.7858516982398085,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.9070667983681914,
          0.964717817827444,
          1.0971195271616014,
          1.3830141548711334,
          1.8701108266261133,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          1.1638133606892478,
          1.2160133494466911,
          1.3089842389050945,
          1.5482005950760032,
          2.029061097933629,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          1.6120614644566058,
          1.6635277338189742,
          1.7524156697946978,
          1.9237727853701692,
          2.339868859101539,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
    },
    7: {
      5: {
        0: [
          0.2642769432850824, 0.2665427810035715, 0.27185932563151743,
          0.2852918912971792, 0.31043149994874714, 0.3535757769769886,
          0.8414930513718087, 1.3721971801130128, 1.6381312895984403,
          2.0592936309523795,
        ],
        1: [
          0.2657217198936017, 0.26778519145550306, 0.27309723317540213,
          0.286536174811855, 0.31239980786665505, 0.3560551982678911,
          0.8449088074548732, 1.3763102158328928, 1.6422237431591586,
          2.063385178346074,
        ],
        2: [
          0.2693162155034786, 0.2705889056039865, 0.27486708324804776,
          0.2883116887336917, 0.31539345386084955, 0.3598039436549684,
          0.8498174189510738, 1.38202427738217, 1.6480487409388462,
          2.069266302459132,
        ],
        3: [
          0.2780619480352514, 0.2793272614230829, 0.2811191634644636,
          0.2919454553882611, 0.3206280495782414, 0.366339051737981,
          0.8580695337156237, 1.3916037183812895, 1.6573595810549802,
          2.0785995237185997,
        ],
        4: [
          0.29757837858517094, 0.299602547989677, 0.3026840234132392,
          0.3081098900942335, 0.3315891319348865, 0.3785072039005031,
          0.8743351179610754, 1.4095000740596733, 1.675589877858843,
          2.0964923546036918,
        ],
        5: [
          0.33574027313696997, 0.33826485567002545, 0.3421106080198633,
          0.348842368813132, 0.3614725726617369, 0.39926909503951735,
          0.903451432764662, 1.4426454753587121, 1.7087761139167736,
          2.1299494734586792,
        ],
        6: [
          0.3862366913229959, 0.38877091321248036, 0.39259800723747096,
          0.3992866921141872, 0.411834734702332, 0.434018883498723,
          0.9495928283927136, 1.4973970664957172, 1.7638013635601713,
          2.1849959969250548,
        ],
        7: [
          0.41985517015004814, 0.42239571827186456, 0.4262358183416822,
          0.4329618515170902, 0.44557840705335294, 0.4672135899683335,
          0.9360256441720012, 1.4875838830185275, 1.7540159785208647,
          2.1743606998645886,
        ],
        8: [
          0.4945711494428616, 0.4971195702893162, 0.5009699678934696,
          0.5077130676377518, 0.5203877126369276, 0.542121900095241,
          1.0961039947745428, 1.5703466741874894, 1.7757783000151859,
          2.19643955638072,
        ],
        9: [
          0.6560244772907002, 0.6584609873955947, 0.6620898401728194,
          0.6684101779483066, 0.6804050251815539, 1.3670711941744218,
          1.4147756616284481, 1.9747170880116163, 2.059032141174348,
          2.365053350721932,
        ],
      },
      6: {
        0: [
          0.5072153056565234, 0.511818218827875, 0.5222111846314779,
          0.5487272929322492, 0.5970126482959714, 0.6720144894072182,
          0.7627153427050668, 0.8553180954494726, 1.0246498112059517,
          1.2959182972694452,
        ],
        1: [
          0.5103395153089971, 0.514596839522933, 0.5249407196625319,
          0.5515409054900899, 0.6008861192604309, 0.6748161925462017,
          0.7655196180587405, 0.8581161759550402, 1.027456804560014,
          1.2987424183496057,
        ],
        2: [
          0.5175752236586193, 0.5203920980884458, 0.5289663053205846,
          0.5555256478767494, 0.6049345575720972, 0.6788533039001567,
          0.7695698509199196, 0.8621478998113762, 1.0315179815827973,
          1.3028346507223016,
        ],
        3: [
          0.5350129391283669, 0.5377735446552541, 0.5418960456643613,
          0.5621777813385371, 0.6115345558464376, 0.6855050563159275,
          0.7762060533716965, 0.868779548215167, 1.0381477330232027,
          1.3094209793606795,
        ],
        4: [
          0.573624947853121, 0.5764917633843532, 0.5805245799525285,
          0.587302202844667, 0.6242321175086618, 0.6982227778466115,
          0.7889711497585434, 0.881542289695852, 1.050867648242247,
          1.32223629730314,
        ],
        5: [
          0.6389991826969608, 0.6418863087952746, 0.6460280104824034,
          0.6526615458429987, 0.6654260860689791, 0.7213240958866747,
          0.8121001977351276, 0.9045863886613051, 1.0740895039214557,
          1.3454271147665606,
        ],
        6: [
          0.7273555380461152, 0.7301968080217442, 0.7343268172824431,
          0.7411063957762873, 0.7538985340484172, 0.7771900612911873,
          0.8472222658012061, 0.9395633935569757, 1.1091392602856167,
          1.3806144143216474,
        ],
        7: [
          0.7746699116619252, 0.7775367219019536, 0.7816584746906591,
          0.788417474523595, 0.8012831664541491, 0.8246590522636223,
          0.8632607950950035, 0.9393327016912205, 1.1067963589121446,
          1.3813382918031198,
        ],
        8: [
          0.8708173355000943, 0.8736905851173931, 0.8777857269042232,
          0.8845520967680247, 0.8975041457193875, 0.9209190275631591,
          0.9596304884152864, 0.9968368981012922, 1.1313197022845214,
          1.4038728397767068,
        ],
        9: [
          1.1315386445297424, 1.1344097610308213, 1.1385792906029644,
          1.1453452268724373, 1.1582487619209458, 1.1817548325635192,
          1.2205817190416481, 1.2579521772040427, 1.3166428432547002,
          1.5174394916178093,
        ],
      },
      7: {
        0: [
          0.4245896933959106, 0.4285726487082371, 0.4373782562740483,
          0.4599587604050044, 0.5022058643729117, 0.5656499309327283,
          0.642321515341883, 0.7223278750826346, 0.8697215402134506,
          1.1072287313238027,
        ],
        1: [
          0.4273950103304883, 0.43109067546041413, 0.4398880484687471,
          0.4624818500454456, 0.5047286345453177, 0.5681809709429911,
          0.644857203618431, 0.724867461851286, 0.8722633642410311,
          1.1097698813325834,
        ],
        2: [
          0.4336227786310842, 0.43619910787961935, 0.44352886519659507,
          0.466147467036617, 0.5084048481260153, 0.5718505263884254,
          0.6485542255602392, 0.7285130466033092, 0.8759661395416908,
          1.1134629172699926,
        ],
        3: [
          0.44855679323133035, 0.4511181314450406, 0.45479674757046556,
          0.47226350424321717, 0.5145092844553868, 0.5779936751530707,
          0.6546911834303623, 0.7346471203961739, 0.882056437613917,
          1.1196321819163757,
        ],
        4: [
          0.4818135778129339, 0.4843936656936221, 0.48811851739896844,
          0.4943047801478322, 0.5262179663747505, 0.5897746625071342,
          0.6664844871393573, 0.7464309618668836, 0.8938755277271978,
          1.1314409047610292,
        ],
        5: [
          0.5381437426625139, 0.5407246813247422, 0.5443793017029933,
          0.5506480459196059, 0.5635244582786626, 0.610908813410636,
          0.687710690253539, 0.7689337952639715, 0.9151060343625224,
          1.1527137056616676,
        ],
        6: [
          0.6111068065761219, 0.6136909425948693, 0.6174235807520881,
          0.6235660896331805, 0.6355675608251667, 0.6579704398615924,
          0.7164222788657921, 0.7977436036448637, 0.9451620294035925,
          1.181517962693266,
        ],
        7: [
          0.6529302918808522, 0.6555226417780935, 0.6592549933668808,
          0.6654871300743155, 0.6774285519944685, 0.6988493874653242,
          0.7323016461254863, 0.7985979283627835, 0.9459150491023315,
          1.1823580657685029,
        ],
        8: [
          0.7406471801439676, 0.7432413339843033, 0.7469961196677699,
          0.7532233516983238, 0.7652100466846339, 0.7867063465715365,
          0.8201506720839637, 0.8542409537023331, 0.9727284065901752,
          1.2089065498024378,
        ],
        9: [
          0.968942238182475, 0.9715420743123162, 0.9752934615952181,
          0.9815485900989522, 0.991725422162437, 1.0132792214958637,
          1.046795591899071, 1.0810143254714086, 1.1365271011132712,
          1.315760389643543,
        ],
      },
      8: {
        0: [
          0.37607522819362615, 0.379675789445142, 0.387560338582126,
          0.4078304430259193, 0.4458108605400526, 0.5029914334626338,
          0.5713879115822351, 0.6448554425136496, 0.7789828277440246,
          0.9936050144770749,
        ],
        1: [
          0.37865807453649314, 0.382033731979322, 0.38991156908757635,
          0.4101613899401697, 0.4481735149940055, 0.5053529348444469,
          0.5737550878318978, 0.6472233799124792, 0.7813544823394825,
          0.9959763888633593,
        ],
        2: [
          0.3843274817972068, 0.3867124913472908, 0.39335916358719236,
          0.4136328080148135, 0.4516205852454892, 0.5088221306336568,
          0.5772170622155267, 0.6507014937130342, 0.7848265583849428,
          0.9994543381095595,
        ],
        3: [
          0.3977938167327092, 0.4002060743617972, 0.4036710767718815,
          0.4194664282505878, 0.45744078716282954, 0.514651239611887,
          0.5830578788341603, 0.6565581258647157, 0.79072038709774,
          1.0053154378062188,
        ],
        4: [
          0.42785261595184987, 0.43024425526692944, 0.43376422188273955,
          0.43966199737228684, 0.46860585635259644, 0.5258589740476021,
          0.5943000770292783, 0.6677991768249882, 0.8019852308486906,
          1.016598732711564,
        ],
        5: [
          0.47875197406890513, 0.48188655526162316, 0.485423276500461,
          0.4913719308062452, 0.5027760346340028, 0.5458670165334184,
          0.6143534430643869, 0.6879059730664497, 0.8220980408540234,
          1.036707331827431,
        ],
        6: [
          0.5428769809043443, 0.5452949318664768, 0.5495500266453887,
          0.555491046350282, 0.5668815591615404, 0.5872142354492996,
          0.6396317227652548, 0.7132386547679075, 0.8474407287495478,
          1.0620540743157294,
        ],
        7: [
          0.5814802843429315, 0.5838988566106722, 0.5874183813226028,
          0.5933560304462367, 0.6047043455631127, 0.624995168531882,
          0.655383944342262, 0.7158507021026358, 0.8498977627447957,
          1.0646424688516092,
        ],
        8: [
          0.6638471456251618, 0.6662627259602771, 0.6697883769179451,
          0.6757370824784653, 0.6871275095279549, 0.7074493911679693,
          0.7379147358981639, 0.7700025400051715, 0.8787675596977498,
          1.093210331132775,
        ],
        9: [
          0.8714007393757983, 0.8738335926290024, 0.8773635195708986,
          0.8833172107882483, 0.8947258948196817, 0.9150909683160778,
          0.9440821404170578, 0.9762563033883802, 1.0296514339815535,
          1.1940483254294172,
        ],
      },
      9: {
        0: [
          0.3375151875474207, 0.3407974183263699, 0.34795625192031565,
          0.36629638279834786, 0.40074410702266505, 0.45265938230373026,
          0.5142870535104318, 0.5811962470635497, 0.7038579189095011,
          0.8998710342076416,
        ],
        1: [
          0.33990413922351853, 0.3429783635578798, 0.35013472090455533,
          0.36848764544176693, 0.4029420622710769, 0.45486041571642066,
          0.5164905020495, 0.5834031339968998, 0.7060698433548792,
          0.9020834430690094,
        ],
        2: [
          0.34507116653988007, 0.3473058360783188, 0.3533610356940168,
          0.37172964758850535, 0.40617247889218344, 0.4581148292505641,
          0.5197434437927282, 0.5866685367110503, 0.7093398671056319,
          0.9053542360802942,
        ],
        3: [
          0.3573791882215757, 0.3596003247308678, 0.36333896153847894,
          0.3772518501836194, 0.4116913762239006, 0.46364059578018096,
          0.5253060111623677, 0.5922256965765706, 0.7149098998917145,
          0.9109226754157381,
        ],
        4: [
          0.38472672947677966, 0.3869655294257993, 0.3902530575804729,
          0.39632263534197054, 0.42223475446816294, 0.47423005839738425,
          0.5359182695743132, 0.6028740359943093, 0.7255561842755731,
          0.9215664471998415,
        ],
        5: [
          0.4316700449653756, 0.4339300358601589, 0.4372491153898971,
          0.4428896992270178, 0.4536629235058336, 0.49302155536383785,
          0.5547466292062524, 0.6217565642854753, 0.7444614462288102,
          0.9404620256088545,
        ],
        6: [
          0.48892787855093844, 0.49117999580322713, 0.49449724033209463,
          0.5001433537843809, 0.5109046336446856, 0.5300294635090044,
          0.5774135305136466, 0.6444611923273917, 0.7671989302677122,
          0.9631999921025192,
        ],
        7: [
          0.523969094472657, 0.5262226999005999, 0.5295300638073412,
          0.535146997682401, 0.5458631905671305, 0.5656946290705749,
          0.5936123917942906, 0.6481159988668941, 0.7707309049116629,
          0.9668401849453399,
        ],
        8: [
          0.6008819649532935, 0.603155553027621, 0.6064744562218197,
          0.6121215163593324, 0.6228854180031601, 0.6419662257289391,
          0.6706098384346413, 0.7007836917075868, 0.8000506130498202,
          0.9959163689645096,
        ],
        9: [
          0.7906303603053711, 0.7928911053922401, 0.796217701104349,
          0.8018721351531611, 0.8126645895211639, 0.8318132919150414,
          0.8597437364688361, 0.8899005818132428, 0.939279828557299,
          1.0906141113897996,
        ],
      },
      10: {
        0: [
          0.31969389723265157, 0.3228408383574367, 0.3296629572792038,
          0.3471047039087515, 0.37978364517274, 0.4290511843053304,
          0.4873642499868647, 0.5512965104170267, 0.6688572612440866,
          0.8566194069061579,
        ],
        1: [
          0.3219932328214673, 0.3249361968776157, 0.3317518775670843,
          0.34920336097915977, 0.38188043118327575, 0.43117418768932864,
          0.48951113284012426, 0.5534564420545423, 0.6710125059702237,
          0.8587747428820866,
        ],
        2: [
          0.3269400377063053, 0.3290817208691482, 0.3348338575913655,
          0.3523257898966107, 0.3849917474177068, 0.4343282122063082,
          0.4927041568824525, 0.556655622383248, 0.6742171959682774,
          0.861979563320521,
        ],
        3: [
          0.33867712553194856, 0.3412415736670118, 0.3444216225521606,
          0.3576677834851264, 0.3903555927912641, 0.4397620786306072,
          0.49818812724507444, 0.5621520835208216, 0.6797213750887758,
          0.8674842046990324,
        ],
        4: [
          0.3646878614292085, 0.36683089902064697, 0.37042556425357265,
          0.3758922382019295, 0.40064746014241626, 0.45010893054377843,
          0.5086161205693268, 0.572610094888799, 0.6901838735834054,
          0.8779485327782159,
        ],
        5: [
          0.4093071350087689, 0.4114912095167583, 0.41471800200470865,
          0.42025202509080983, 0.43077153624889064, 0.4684756565021843,
          0.5270356539602944, 0.5910727518333339, 0.7086916025658154,
          0.8964398333599728,
        ],
        6: [
          0.46315540928230203, 0.46535297639973516, 0.4686017626115624,
          0.4741714829712981, 0.48475054652634275, 0.5034400871554574,
          0.5485310340535189, 0.6126272598980798, 0.7302536634284914,
          0.9180313449275286,
        ],
        7: [
          0.4970576474345705, 0.49925242619438404, 0.5024919028458597,
          0.5080419765938271, 0.5192400725171493, 0.5379535745352937,
          0.564756861670599, 0.6170505616462687, 0.7345866397977476,
          0.9224447888720513,
        ],
        8: [
          0.571914887655973, 0.5741135455354716, 0.5773691182971199,
          0.5829440052112895, 0.5935230978208772, 0.6128648742253828,
          0.639701741334455, 0.669155234297079, 0.764748855370794,
          0.952396628490342,
        ],
        9: [
          0.7537859386382393, 0.7559912060377372, 0.7592485726761767,
          0.7648391324917521, 0.7754486566432479, 0.7941839266023771,
          0.8210226394955679, 0.8504559471320715, 0.8992349009692604,
          1.045020998319265,
        ],
      },
      11: {
        0: [
          0.30779426607295846,
          0.31085149014554814,
          0.317453109581555,
          0.33432788854358386,
          0.36590640209609826,
          0.42177730362066346,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.31004202855960106,
          0.3128951769546173,
          0.3194953239897769,
          0.33637046180319163,
          0.3679629639474062,
          0.4238854916564629,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.3148611076913507,
          0.31694643849786436,
          0.3225326045985857,
          0.33944169250260303,
          0.37102944701027574,
          0.42701880325683306,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.32626030764294645,
          0.3287586407595967,
          0.331878785905125,
          0.34474472781146737,
          0.37635507389661826,
          0.4324329518364233,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.35145176321554045,
          0.3535344271747054,
          0.357064611128871,
          0.3624888530909149,
          0.3863602446301364,
          0.4427629787805535,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.40240080871963924,
          0.4045624255309558,
          0.40776453735738305,
          0.4132832152789213,
          0.42378140936806497,
          0.4608715238449075,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.2974115152187795,
          0.30036257004033384,
          0.30674711555521156,
          0.32304187779583804,
          0.3535443353985869,
          0.4152703482908261,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2995870839468114,
          0.30234859081664833,
          0.3087259235986648,
          0.32503386213362073,
          0.3555367947918129,
          0.4173509341145135,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.30424816065161686,
          0.3062773857919754,
          0.31168940976514586,
          0.32802182348806463,
          0.35853934984147395,
          0.4204464172039948,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.3152994148487914,
          0.31770150925391205,
          0.32074845697865595,
          0.33319605415359127,
          0.36372070996340333,
          0.42583309402986236,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.33963147676216093,
          0.34166361963319736,
          0.345085214832452,
          0.35037384923794157,
          0.37348188274680544,
          0.43606669872213705,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.396211299087719,
          0.3983477042109641,
          0.40151229410991796,
          0.4069868907523104,
          0.4173962593982872,
          0.4540156668567793,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.2916489653715217,
          0.29452975131552483,
          0.3007671228473411,
          0.31669232759811317,
          0.34650539933043056,
          0.41154409382718465,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.29377364478172474,
          0.29647018942275755,
          0.30269924799308073,
          0.31863822276211495,
          0.3484630894031743,
          0.4136062624981875,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2983284166458743,
          0.30030926397187585,
          0.3055946453897968,
          0.3215627618688598,
          0.351393373661283,
          0.41668691916652206,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.3094808704293992,
          0.3114755954153362,
          0.3144550758735356,
          0.32662129181316396,
          0.35646614754133654,
          0.42202845906827924,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.33290940190572693,
          0.33524373356880666,
          0.33823919060438545,
          0.34341493468163997,
          0.36601125715461164,
          0.43219013152410557,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.39267317933536494,
          0.39478884339239795,
          0.39792528652816417,
          0.40336149828271906,
          0.4136973721465942,
          0.4499970769019081,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.287453524221295,
          0.290274710886648,
          0.2963880393230391,
          0.31201047240648105,
          0.3412687579098049,
          0.4087546588691068,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.28953244518321886,
          0.29217243056183984,
          0.2982774168706873,
          0.31391375638716973,
          0.3431811137648333,
          0.4108082667963056,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2939935247158563,
          0.2959306091956622,
          0.3011237759260894,
          0.31677391643703046,
          0.3460490808696808,
          0.4138608599975475,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.30492523425680407,
          0.3068760982821179,
          0.3097904007235905,
          0.32173581352504604,
          0.35100932230867266,
          0.4191652212329662,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.32790373619153845,
          0.33018591380651535,
          0.3331156023287428,
          0.33817742117416766,
          0.36034472288470726,
          0.42925329185413563,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.39002483785916503,
          0.3921228575836535,
          0.3952334250319479,
          0.40062976168794073,
          0.410891199201439,
          0.4469235512108767,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.28386012671526306,
          0.2866313113403936,
          0.29264047980590474,
          0.3080070288833852,
          0.33678956931420767,
          0.40637976089085537,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.28590084267540283,
          0.2884932150095625,
          0.29449369709749784,
          0.3098744127781805,
          0.33866539168649534,
          0.4084135851834375,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.29028283014019474,
          0.2921829292267373,
          0.29728832061133126,
          0.3126803107173079,
          0.34148437337869925,
          0.41144423795940516,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.30102844759958836,
          0.30294222419052397,
          0.3058007321712094,
          0.3175499528499126,
          0.3463496512835912,
          0.41672094524023784,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.3236269925344937,
          0.32586472871342603,
          0.32873987727767306,
          0.33370327337836864,
          0.35550755943587287,
          0.42674653672515395,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.3877634186289058,
          0.3898480348698039,
          0.392935052921659,
          0.39829877272134184,
          0.40849543627916585,
          0.4443012223067646,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.28177023982979593,
          0.28451003280356024,
          0.29045356234313285,
          0.305660791663302,
          0.33556445464399676,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.28378675974997336,
          0.28634906496060253,
          0.2922846978199548,
          0.30750570662974597,
          0.33743123671061875,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.28811941816653075,
          0.2899969466322835,
          0.2950464238013137,
          0.31027692075962243,
          0.340237694675373,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.2987477439800423,
          0.3006383008448986,
          0.3034626420730079,
          0.31508793679237057,
          0.34508134664448165,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.3224544054070707,
          0.3246775937998702,
          0.3275388733382325,
          0.3324813176178072,
          0.3541997759836353,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.28026327423748265,
          0.2829799744624714,
          0.2888753884166449,
          0.3039637205304793,
          0.33467754484039647,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2822620077435699,
          0.28480213689029676,
          0.29068922622878,
          0.305792249327473,
          0.33653751963853695,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2865581515854988,
          0.28841837208871635,
          0.29342753810305544,
          0.30853745748772493,
          0.33933421553894266,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.2971002698477692,
          0.2989735543145602,
          0.30177197146088924,
          0.3133063442353549,
          0.3441623847319271,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.3216065975440846,
          0.3238193804168992,
          0.32667040895956945,
          0.33159722551025855,
          0.3532520480301762,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.2790005457398713,
          0.28169805836010775,
          0.28755429896931833,
          0.30254578662219506,
          0.33393635484029255,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2809849457147091,
          0.28350690522689526,
          0.28935422127448884,
          0.3043595650930238,
          0.3357917415649345,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2852513833171493,
          0.2870969244805915,
          0.2920734592467146,
          0.30708398124891134,
          0.33857929483769345,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.2957222736493714,
          0.29758180392435923,
          0.30035840955971643,
          0.3118180933620095,
          0.3433947177076989,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.32089775414934485,
          0.32310186047041484,
          0.3259447406417647,
          0.33085867483610953,
          0.3524609336844181,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.27826084507406246,
          0.28094652730241315,
          0.2867766073428548,
          0.3017047664964087,
          0.3334954530801571,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.28023606840876314,
          0.2827459852385582,
          0.28857924341305746,
          0.3035102011428809,
          0.33534700321506483,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2844825074887545,
          0.2863195417698787,
          0.2912745466080514,
          0.30623229435110877,
          0.3381299165205909,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.29490828138646896,
          0.29675875593513895,
          0.2995216900882975,
          0.31093259421686315,
          0.34293687864674377,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.3204777719078523,
          0.3226764456953065,
          0.3255144057043978,
          0.3304197292905373,
          0.35198770196575024,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
    },
  },
  jointLast: {
    1: {
      5: {
        0: [
          0.6783067985894083, 0.6881239660001643, 0.721987509326462,
          0.7849712827067556, 0.872262000749841, 1.0082656409749533,
          1.189997812918167, 1.4226033015998305, 1.799031455610872,
          2.277995028040681,
        ],
        1: [
          0.6804692221237123, 0.688252866922856, 0.7221039600739307,
          0.7850137807843207, 0.8723158052469198, 1.0083794360379672,
          1.1900775719131396, 1.4226813216313698, 1.7991237509812255,
          2.278145450035703,
        ],
        2: [
          0.7005017110431253, 0.7006941589656016, 0.7221758977241018,
          0.7850522152051058, 0.8723783128367053, 1.0084800808995982,
          1.1901850536890497, 1.4228229934828343, 1.7993270516647475,
          2.2784645993548605,
        ],
        3: [
          0.7448178408398163, 0.7447528902029187, 0.7447756168834685,
          0.7851058730545843, 0.8724412104885827, 1.0086162772313831,
          1.190374350260457, 1.423104892855123, 1.7997504488457468,
          2.279117887974971,
        ],
        4: [
          0.8145104743468297, 0.8146189773810366, 0.8145498860090057,
          0.8146571076081011, 0.8724868941077194, 1.0087796358314574,
          1.1906828037056782, 1.423610956312022, 1.8005355591180052,
          2.2802951959659987,
        ],
        5: [
          0.9233394918421678, 0.9234267482223438, 0.923416618376884,
          0.9235489856051764, 0.9237168974741552, 1.0091106701250836,
          1.1912336408816822, 1.4244553304406102, 1.80183724208955,
          2.2823782579481957,
        ],
        6: [
          1.0768470802466557, 1.0767667277958506, 1.0768590908881195,
          1.0770504512740624, 1.0771681294423268, 1.07789363793738,
          1.1921841575425378, 1.4257742148028245, 1.8038178644698106,
          2.285428341478933,
        ],
        7: [
          1.2674492898193879, 1.2676232690393825, 1.2676073444865072,
          1.26793140300473, 1.2683110000552977, 1.269092694108634,
          1.2706053273954592, 1.4277167311279098, 1.8067199833400824,
          2.289875233198444,
        ],
        8: [
          1.5477596846733106, 1.5479367079549873, 1.5480253962390464,
          1.5484739276084745, 1.5491822776967634, 1.5504306926129816,
          1.5525528183063935, 1.5554904301412145, 1.805076883483832,
          2.296705171492197,
        ],
        9: [
          2.014384668376498, 2.0146515427933913, 2.0147981758038895,
          2.015445648287512, 2.0165896949528763, 2.0185470318563756,
          2.0216421558115925, 2.026116431961201, 2.032838097402381,
          2.3009091971653346,
        ],
      },
      6: {
        0: [
          0.4128413280423424, 0.4188869887613221, 0.439537948073616,
          0.47788733616138546, 0.5326622372884664, 0.6156340854066533,
          0.7248762842664211, 0.8667425565717781, 1.0963473397220032,
          1.3884214872323544,
        ],
        1: [
          0.41405574374035603, 0.4188989986844627, 0.4395483171155531,
          0.4778950312267587, 0.5326720644059193, 0.615651243476451,
          0.7249026198317498, 0.8667798603797651, 1.096402578554896,
          1.388508849499369,
        ],
        2: [
          0.4263770892860652, 0.42638652878168165, 0.4395605693075052,
          0.477910505799244, 0.5326945821015359, 0.6156846925484609,
          0.7249595838094749, 0.8668673376065859, 1.096535546359633,
          1.388711795215742,
        ],
        3: [
          0.45330766585549565, 0.45332062501132775, 0.4533271808486288,
          0.4779351558190146, 0.5327394034163173, 0.6157410778080461,
          0.7250636386486631, 0.8670429704323197, 1.0968104791284217,
          1.3891060875567987,
        ],
        4: [
          0.4958474924752484, 0.49586352470257167, 0.4958854653263304,
          0.495923255519941, 0.5328277983452685, 0.6159000370696568,
          0.7252797980838788, 0.8673803222194538, 1.0973336814522596,
          1.389955640368552,
        ],
        5: [
          0.5622259589775231, 0.562246088380525, 0.5622811064737372,
          0.5623501716053383, 0.5624924695506763, 0.61617398886272,
          0.725672338813979, 0.8679513404186268, 1.0981923567750314,
          1.3912462236591034,
        ],
        6: [
          0.657785861901214, 0.6578144547282434, 0.6578683153764593,
          0.6579817888299663, 0.6582023893338973, 0.6585560919147808,
          0.7262399629224141, 0.8688037992050144, 1.0994793953583442,
          1.3932968168275894,
        ],
        7: [
          0.7740797915952684, 0.7741264564036658, 0.7742036808958324,
          0.7743826140888831, 0.7747315648718627, 0.7752272088490336,
          0.7761611636718928, 0.87003268384526, 1.1013891403921834,
          1.3962770869556493,
        ],
        8: [
          0.9430137524159995, 0.9430823826820807, 0.9432100983216485,
          0.943479051718126, 0.944007253002454, 0.9448292520770595,
          0.9461159667536432, 0.9480943586199142, 1.104260657702139,
          1.4006776423268934,
        ],
        9: [
          1.2276289091557238, 1.2277541945542871, 1.227922503640992,
          1.2283378567476562, 1.229137185252791, 1.2304123406537144,
          1.2323640527450355, 1.235330285861653, 1.2397206735960793,
          1.407355692916682,
        ],
      },
      7: {
        0: [
          0.3439609335423752, 0.34899867514006755, 0.36614283894257715,
          0.39799497229859476, 0.443511652700204, 0.5124680480751909,
          0.6032436794616992, 0.7211269587532995, 0.9119160366567864,
          1.154607108583142,
        ],
        1: [
          0.3449368331200318, 0.3495551206725004, 0.3661514734515982,
          0.39800461741128185, 0.44351891609920546, 0.5124635385628246,
          0.603261989616235, 0.721159330282246, 0.9119644018560426,
          1.1546609753894144,
        ],
        2: [
          0.3552036198024638, 0.3551814156288307, 0.36671549945030085,
          0.3980044705765417, 0.4435395279255105, 0.5125160357530334,
          0.60330735677003, 0.7212330474472404, 0.9120839790815376,
          1.154872162124721,
        ],
        3: [
          0.37822804905953344, 0.37822957095548637, 0.3782474168045108,
          0.39804423059228167, 0.44358041416610083, 0.5125473636180871,
          0.6034131814082804, 0.7214004782013719, 0.9123346502936751,
          1.1552190262693682,
        ],
        4: [
          0.4135786930947364, 0.4136003895716539, 0.41361565470382533,
          0.4136543665867134, 0.4436571287573085, 0.512696863202925,
          0.6035879688676034, 0.7216893535531574, 0.912794423368465,
          1.1559660472921371,
        ],
        5: [
          0.46808444224716717, 0.4680948048983191, 0.4681360897156385,
          0.4681965922358674, 0.46831838793710223, 0.512898543809873,
          0.603932819257258, 0.7221970492580142, 0.9135528621852691,
          1.157129455569021,
        ],
        6: [
          0.5474835837648996, 0.5475051914763902, 0.5475585652676194,
          0.5476599137221433, 0.5478538776238036, 0.5481699552497632,
          0.6044179590285016, 0.7229393669103856, 0.9146862671860365,
          1.158894733885187,
        ],
        7: [
          0.6441150656012687, 0.6441722160612153, 0.6442411683542991,
          0.6443984321650513, 0.6446618157886645, 0.6452137860885665,
          0.6459069678964546, 0.7240479513649515, 0.9163725747437176,
          1.1614963415558346,
        ],
        8: [
          0.7845031522683459, 0.784557588415667, 0.7846873410611643,
          0.7849240520600591, 0.7853707802644114, 0.7861112891483011,
          0.7872798954636, 0.7889566077546377, 0.9188973412343932,
          1.1653715201693655,
        ],
        9: [
          1.0209959417758252, 1.0210839827281015, 1.0212677569666946,
          1.0216360750648645, 1.0223365811368401, 1.023469749675048,
          1.0252159457599042, 1.0277844022744993, 1.0316921003551158,
          1.1712686836735187,
        ],
      },
      8: {
        0: [
          0.3038433407144572, 0.30879213630447455, 0.3238507948701004,
          0.3513735306401812, 0.3913773605356038, 0.45269854772422913,
          0.5324911816462534, 0.6354030901272832, 0.8030883695748331,
          1.0163901568749036,
        ],
        1: [
          0.30476651886372397, 0.3087617390338874, 0.323868082513031,
          0.3513667351515771, 0.391385469930299, 0.45271021436095304,
          0.5325220492173779, 0.6354295950284923, 0.8031354147420511,
          1.0164860072584325,
        ],
        2: [
          0.3137824987698604, 0.3137670852533404, 0.3238714155475103,
          0.3513938473836932, 0.39140667957835973, 0.4527433680943448,
          0.5325664289758953, 0.6355130785753351, 0.8032530192405736,
          1.0166555045745498,
        ],
        3: [
          0.3339969562895427, 0.3339994626201348, 0.3340083666396341,
          0.3514119295291106, 0.39144586855108615, 0.45280665768820105,
          0.5326668677279845, 0.6356628945849478, 0.8034868792499206,
          1.0170252445889072,
        ],
        4: [
          0.3650826335805095, 0.3650872533221723, 0.3650995024939009,
          0.3651447659305982, 0.3915207865111092, 0.45292444519433994,
          0.532856847909536, 0.6359487330698126, 0.8039205435547895,
          1.017700034548759,
        ],
        5: [
          0.41299672486042927, 0.41300334011710177, 0.4130258345993353,
          0.4130847628379326, 0.4132095061327402, 0.4531135089463182,
          0.5331484483166626, 0.6364073343708482, 0.8046155360009117,
          1.0187670011147623,
        ],
        6: [
          0.4827741780180389, 0.48279354644771433, 0.48283642508174135,
          0.48293242539679426, 0.4831165495428501, 0.4834103467629009,
          0.5335864073236833, 0.6370845396268001, 0.8056562561569618,
          1.0203808747084033,
        ],
        7: [
          0.5677348104848399, 0.5677626554206996, 0.5678237195631199,
          0.5679974601508087, 0.5682722196757888, 0.5687211333831583,
          0.5694054841347179, 0.6380949731725656, 0.8072054717930606,
          1.0227669885077633,
        ],
        8: [
          0.691144537981778, 0.6911807713412604, 0.6912764658928862,
          0.6915172119560375, 0.6919630179368041, 0.6926466277225262,
          0.6936905329971992, 0.6952526930126222, 0.8095390563469529,
          1.0263818444242556,
        ],
        9: [
          0.8989758469389515, 0.8990625220360542, 0.8992182570577398,
          0.8995705199115245, 0.9002449689244183, 0.9012902111369107,
          0.9028814362423427, 0.9052598274861633, 0.9088388336125737,
          1.0318332212075008,
        ],
      },
      9: {
        0: [
          0.2728946883561969, 0.277269308926678, 0.2907112955613265,
          0.3152289988890614, 0.35089656057853436, 0.4055667977611399,
          0.4767084186594277, 0.568429195312885, 0.7178892915949877,
          0.9079668959963918,
        ],
        1: [
          0.2736785237613686, 0.27728159026992344, 0.29070944340994886,
          0.31523987007275145, 0.3509046878098808, 0.4055798837429704,
          0.4767238753175017, 0.5684615957259909, 0.7179352977148772,
          0.9080286772486816,
        ],
        2: [
          0.28170576802474845, 0.28171451620670185, 0.2907129481515296,
          0.31524469398682164, 0.3509214438978381, 0.40560790106461747,
          0.47676677870686046, 0.5685261623483528, 0.718038985493392,
          0.9081870044060107,
        ],
        3: [
          0.29973965954773923, 0.29974588691066917, 0.29975990001573577,
          0.31526546142775835, 0.3509588673464159, 0.40566737060975955,
          0.4768619146187556, 0.5686686037857904, 0.7182578964734736,
          0.9085296644710311,
        ],
        4: [
          0.32745893570074036, 0.32747553912673877, 0.3274854425267549,
          0.32752992207017917, 0.35102878818382866, 0.4057763927029073,
          0.47703752963333645, 0.5689331956485274, 0.7186573625525944,
          0.9091516904843711,
        ],
        5: [
          0.37016937804925126, 0.37018751472503847, 0.37021908282755844,
          0.37027350750974053, 0.37038147421561096, 0.40595085386226903,
          0.4773066910635312, 0.5693537170543599, 0.7192949152030318,
          0.9101315289516354,
        ],
        6: [
          0.4323710826059921, 0.4323944118694061, 0.4324397618780276,
          0.43252823077315977, 0.4326965523049746, 0.4329589085464496,
          0.4777096452091149, 0.5699785751078357, 0.7202492025911855,
          0.9115839372028307,
        ],
        7: [
          0.5080991806175527, 0.5081469870359994, 0.508200500698572,
          0.5083550817508095, 0.5092960626478323, 0.509016268328595,
          0.5096280876090862, 0.5709091089426706, 0.7216750211849059,
          0.913812030908721,
        ],
        8: [
          0.6180735543500029, 0.6181353616699663, 0.6182412105272157,
          0.6184520948322425, 0.6188459477496293, 0.6201713652123229,
          0.6204283061331279, 0.6218651325160882, 0.7238191298041858,
          0.917128575127979,
        ],
        9: [
          0.8033351937714601, 0.8034212927189367, 0.8035777330532341,
          0.8039025114644733, 0.8045012042155726, 0.8054570747004295,
          0.8069168248802212, 0.8091016663009618, 0.8123985710247856,
          0.9220861247196411,
        ],
      },
      10: {
        0: [
          0.2583292004100461, 0.26245616280152306, 0.2751094264982463,
          0.29820384386264204, 0.3317745859431084, 0.38324023615112035,
          0.45022182365435115, 0.5365842958251721, 0.6772870772370401,
          0.8562702971683536,
        ],
        1: [
          0.25907848099230907, 0.26245744803817783, 0.2751112044351768,
          0.2982070370769917, 0.33178194345242873, 0.3832523117087734,
          0.45024038943269756, 0.5366126707142647, 0.6773312395718529,
          0.8563377530669143,
        ],
        2: [
          0.2666463081401025, 0.26663922520886807, 0.27511811501683875,
          0.2982171346244763, 0.3317998388904274, 0.3832809598614187,
          0.45028505802977675, 0.5366809947924563, 0.6774360406346684,
          0.8564998661923043,
        ],
        3: [
          0.28360852815944815, 0.28361153962072383, 0.28362365982285237,
          0.2982400101372168, 0.33183686877795626, 0.38333970818274277,
          0.4503770240703158, 0.5368218737808224, 0.6776509876417639,
          0.8568331611293911,
        ],
        4: [
          0.30971376490374436, 0.30972523079113223, 0.3097390608797069,
          0.30977651649367033, 0.3319028594271972, 0.3834451060961029,
          0.45054071924980454, 0.5370749426954387, 0.6780409806163268,
          0.8574376317741317,
        ],
        5: [
          0.3499347381123892, 0.3499450720943683, 0.3499739044280449,
          0.3500284456500055, 0.3501337310992875, 0.38361288707513114,
          0.4508045559168366, 0.5374790247527763, 0.6786545068417928,
          0.8583901143920366,
        ],
        6: [
          0.4084822974699798, 0.4085017548231554, 0.40854538143418023,
          0.4086330805617246, 0.4087964833669346, 0.40905583278647084,
          0.45120043850469627, 0.5380889309974232, 0.6795840092788556,
          0.8598245895864813,
        ],
        7: [
          0.4804288361862271, 0.47983426688222275, 0.48052675652596694,
          0.4800353878332583, 0.4802855025918502, 0.4806863898934951,
          0.4812954011361764, 0.5389960205708489, 0.6809681036441553,
          0.8619640850806247,
        ],
        8: [
          0.5833574051657493, 0.5840357425318559, 0.5835179171373048,
          0.5843448703854075, 0.5841003555675951, 0.584728815810331,
          0.5856447172284367, 0.5870523622910946, 0.6830466580861889,
          0.8651688053393938,
        ],
        9: [
          0.7577503866979874, 0.7578245121101395, 0.7579849127704629,
          0.7583088948247962, 0.7588841610424857, 0.7598246611199546,
          0.7612515909660574, 0.7633628020868123, 0.7665667891820018,
          0.869991611559003,
        ],
      },
      11: {
        0: [
          0.24869095024847604,
          0.25264511957146374,
          0.2647623669967726,
          0.2868915219642061,
          0.3190338186868332,
          0.3764276165447252,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.24940750110592858,
          0.2526402496922957,
          0.26476309309560453,
          0.28688531694342634,
          0.31903966187477795,
          0.3764384148935114,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.25664958661404175,
          0.25665271849025495,
          0.26477160901375063,
          0.28689590501758266,
          0.31905781487434004,
          0.3764671290050339,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.27289786401812577,
          0.272903131913567,
          0.27291465847000523,
          0.2869204075875289,
          0.31909498049733276,
          0.37652606552523227,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.2979066055350217,
          0.2979166988655085,
          0.2979339082742368,
          0.297967158451489,
          0.3191600897241381,
          0.3766313352165376,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.3437071144298974,
          0.3437222154474844,
          0.3437434461085448,
          0.34380682227338166,
          0.3439078224754403,
          0.376798181352896,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.24040327179566157,
          0.24420676888324086,
          0.2558734768833995,
          0.27715913978326123,
          0.3080940826521604,
          0.37057841660821494,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.24110711708099763,
          0.24420987036967134,
          0.25588536802943795,
          0.27716480507582936,
          0.30810301122180483,
          0.37059067110680316,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.24807317857047712,
          0.24807891791796888,
          0.25589426354963474,
          0.2771849169136972,
          0.3081225246230461,
          0.37062070829617844,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.26370222171985885,
          0.2637106812005745,
          0.2637177768325657,
          0.2772071458116967,
          0.3081580998281215,
          0.37067935817861997,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.28777813556736354,
          0.2877796027336701,
          0.2878009819569598,
          0.2878292551751326,
          0.3082213315349225,
          0.3707832814215432,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.33836599613376456,
          0.3383887525330875,
          0.33841082734130357,
          0.338468732255901,
          0.33856455554093656,
          0.3709495748406976,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.23588082377260738,
          0.23959725544351812,
          0.25100086078951306,
          0.2718026517249772,
          0.30203133389971243,
          0.36732743256134287,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.236567549295265,
          0.23960010779660354,
          0.25101091693982475,
          0.27180804626651056,
          0.3020400068066937,
          0.36733970814393857,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2433759288937621,
          0.2433810035443239,
          0.2510110844636242,
          0.27182483290619514,
          0.3020579692959553,
          0.3673694734555113,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.25864905260074467,
          0.2586568112838975,
          0.25866418750664955,
          0.2718392612668166,
          0.30209243471305824,
          0.3674268863924194,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.28217897209232357,
          0.28218169809071747,
          0.28219790990502147,
          0.2822392190682608,
          0.3021561818030539,
          0.36753117985468553,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.33540912437008463,
          0.33543040250405143,
          0.3354512333252987,
          0.3355062686542052,
          0.33561562204961615,
          0.3676973418090072,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.2326383927664406,
          0.2362910568349496,
          0.24750056961876526,
          0.2679456480970415,
          0.29765466195105694,
          0.3649774790175431,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.23331284421101184,
          0.23629374772491496,
          0.24750947178925015,
          0.2679508557730391,
          0.2976631546904742,
          0.3649897669790163,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.24000484531533128,
          0.24000963921585625,
          0.2475103057534092,
          0.267966596125891,
          0.29768096621429263,
          0.3650193414541273,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.2550158383894581,
          0.255023177609225,
          0.25503097274364306,
          0.26798174944366193,
          0.2977153536204352,
          0.36507681238084067,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.27814419104351235,
          0.2781477369141072,
          0.2781643630479206,
          0.2782030552799969,
          0.29777831566925317,
          0.3651809181938223,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.33327605009521943,
          0.3332963900964137,
          0.3333169876323302,
          0.3333733650460178,
          0.33348014566540374,
          0.3653463971053206,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.2298666585555282,
          0.23346502787918993,
          0.24451022873331885,
          0.26465275990403647,
          0.2939221300163677,
          0.36297474464015117,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.23053067113607417,
          0.2334675958108809,
          0.2445182754895408,
          0.26465782678077954,
          0.29393048633619234,
          0.36298703776805963,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.23712405280901358,
          0.23712859258898394,
          0.24451927049892508,
          0.26467272108788076,
          0.29394809702390357,
          0.3630164680021512,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.2519129308632733,
          0.2519199375123856,
          0.2519280908700037,
          0.2646881647075615,
          0.29398235003332235,
          0.36307389417951375,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.27470058550376164,
          0.2747047852953263,
          0.2747219213977019,
          0.274762715844453,
          0.2940449466244778,
          0.3631778524844835,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.3314560476380908,
          0.33147567206335743,
          0.33149643174715526,
          0.33155372818943435,
          0.33166263321774486,
          0.3633429673923373,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.22828482536819308,
          0.23184947752248536,
          0.24279278253213504,
          0.2627470344627485,
          0.29291709160049517,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.22894239950896317,
          0.23185196642444092,
          0.2428002233538687,
          0.2627520336084489,
          0.2929254594909194,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.23547450853224877,
          0.23547898270701506,
          0.24280131620135595,
          0.2627663239941617,
          0.29294297532345814,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.25012467957669304,
          0.2501315292081837,
          0.25013990297354516,
          0.2627819915833881,
          0.2929772376022684,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.2737619455950341,
          0.2737660571159009,
          0.2737831675383778,
          0.273822311256822,
          0.2930398745328341,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.22715690210978928,
          0.23069629949977433,
          0.2415640673609426,
          0.26140197893415495,
          0.292217619925765,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2278097673863718,
          0.23069876867382,
          0.2415712915642796,
          0.26140696894551996,
          0.2922259635359899,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.23429616632773703,
          0.23430058493427353,
          0.24157217662298774,
          0.2614207969264165,
          0.2922434451239354,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.24885869828524887,
          0.24886539459102,
          0.24887377083751439,
          0.2614362073441099,
          0.29227746889027834,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.27310352308338537,
          0.27310759208769864,
          0.27312460756139273,
          0.27316265211648527,
          0.2923400242159606,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.22622579163108483,
          0.22975415474796385,
          0.24057262248619987,
          0.26030247153830177,
          0.2916373500996008,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.22687493417245447,
          0.2297566059062314,
          0.24057982370517744,
          0.26030739058154373,
          0.2916457173529099,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.23333605912176134,
          0.23334025308230524,
          0.24057976567895287,
          0.260321197911707,
          0.29166315187257874,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.24782741879152126,
          0.2478341495282541,
          0.2478424714379369,
          0.2603358134980044,
          0.29169716963513226,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.2725617690811706,
          0.2725659234907529,
          0.27258296986400343,
          0.2726203476604392,
          0.2917598588274837,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.22571036932141672,
          0.22922610372749258,
          0.2400068340733872,
          0.2596649538730581,
          0.29129818893798864,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.22635723332331123,
          0.2292284843022036,
          0.24001378789403663,
          0.25966980255449057,
          0.2913065583732306,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2327959138471325,
          0.23279552152729568,
          0.24001387565054255,
          0.2596833947072492,
          0.29132396526856563,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.24723454458163835,
          0.24724054209501384,
          0.2472450561877107,
          0.2596981899502785,
          0.29135801476916867,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.27224783675692044,
          0.2722519632338571,
          0.27226837913857316,
          0.27230598555020324,
          0.2914207041507113,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
    },
    2: {
      5: {
        0: [
          0.622657268272063, 0.6262149955580318, 0.6376475661661413,
          0.6591748558304718, 0.6851651471443616, 0.7082851607651908,
          0.7084751225275101,
        ],
        1: [
          0.6229433670208163, 0.6256488891469951, 0.6370464855494875,
          0.6584828513009373, 0.6844942661075428, 0.7077241687472464,
          0.7079975256684357,
        ],
        2: [
          0.6292826450947364, 0.628676359207214, 0.6374876760166268,
          0.6569510103776349, 0.6831717611552517, 0.7064091383590916,
          0.7067378137055267,
        ],
        3: [
          0.6450924128087174, 0.6442281288650286, 0.6432281549037533,
          0.656121886512617, 0.6801861471725055, 0.7036247596552623,
          0.7040704282024008,
        ],
        4: [
          0.6653767954322464, 0.664717826125163, 0.6635678185096573,
          0.6610445318775677, 0.675315982207423, 0.6986065950296402,
          0.699232599474945,
        ],
        5: [
          0.6890040557769095, 0.6883893051452464, 0.6872218327913535,
          0.6846202100138468, 0.6798162824587103, 0.69063866287706,
          0.6916459169846592,
        ],
        6: [
          0.7029001247979576, 0.7023065394647958, 0.7011244835873257,
          0.6986217659979239, 0.693893403707565, 0.6862451874344859,
          0.6805120241944775,
        ],
      },
      6: {
        0: [
          0.3810770106871991, 0.3834077545114436, 0.3917635334534211,
          0.40568748178993963, 0.4220062190165037, 0.43883151161624,
          0.5727261649683549,
        ],
        1: [
          0.381396457166966, 0.3832758784444426, 0.3916336194806603,
          0.4055131947410742, 0.4219023266681403, 0.43883151161624,
          0.5727261649683549,
        ],
        2: [
          0.3856955137559668, 0.38550149440455217, 0.39120234987022257,
          0.40503163476448656, 0.421440897109452, 0.4386559611915983,
          0.572373735016448,
        ],
        3: [
          0.39601943651224164, 0.39583146629815225, 0.39541658009651043,
          0.40418202057084773, 0.4204765915360676, 0.4386559611915983,
          0.572373735016448,
        ],
        4: [
          0.4108049332094242, 0.4106012997087503, 0.41018455267119364,
          0.40929254962153433, 0.4188339666881731, 0.43817930227616275,
          0.5713633075021946,
        ],
        5: [
          0.4277930494357739, 0.4275823397545455, 0.4271439778942864,
          0.42625601449495143, 0.4245938342867701, 0.43817930227616275,
          0.5713633075021946,
        ],
        6: [
          0.5697999646992016, 0.5694490616062147, 0.5685225663050593,
          0.566571780207073, 0.5629359113745847, 0.4372212419525742,
          0.5692745655009211,
        ],
      },
      7: {
        0: [
          0.3180125858632492, 0.319985119170475, 0.32698703199178125,
          0.3386489764869921, 0.3525449513269753, 0.3669288543868007,
          0.536355379872542,
        ],
        1: [
          0.31830389602517706, 0.3198477686004415, 0.3268497273612657,
          0.3385028155762563, 0.35239857412031905, 0.3669288543868007,
          0.536355379872542,
        ],
        2: [
          0.3218802201395987, 0.32168119311204046, 0.3265366919313114,
          0.33818912730945394, 0.35206470588531047, 0.366782114206767,
          0.5359682417501144,
        ],
        3: [
          0.33059361410002464, 0.3304342430254713, 0.33010010114859295,
          0.3375406051337824, 0.35140501799157375, 0.366782114206767,
          0.5359682417501144,
        ],
        4: [
          0.3431408535231656, 0.34299042314786554, 0.3426901341968977,
          0.34206670083807617, 0.3502371215240089, 0.36645276005795097,
          0.5349947565244558,
        ],
        5: [
          0.3577166034226132, 0.3575541689373678, 0.3572619232265077,
          0.35661016107012744, 0.35548423955281844, 0.36645276005795097,
          0.5349947565244558,
        ],
        6: [
          0.5342588718687861, 0.5338534190347991, 0.5328913311333673,
          0.5309923781041748, 0.5275538688342986, 0.36577490954175484,
          0.5330154619580781,
        ],
      },
      8: {
        0: [
          0.2813166245864721, 0.283067089628219, 0.2892570151316528,
          0.2995937712182451, 0.3119830616921435, 0.32491820798657955,
          0.5150674090642874,
        ],
        1: [
          0.28158265160234175, 0.2829557292645233, 0.2891452277678114,
          0.29947701493535017, 0.31185352689371026, 0.32491820798657955,
          0.5150674090642874,
        ],
        2: [
          0.2851595915700919, 0.28468280421868086, 0.28889656599049773,
          0.29920544713534514, 0.31159712648637616, 0.3247822409167412,
          0.5146862498627234,
        ],
        3: [
          0.2924979779621233, 0.29279151556642813, 0.29219769973653253,
          0.29872767776497455, 0.3110706501742512, 0.3247822409167412,
          0.5146862498627234,
        ],
        4: [
          0.3036968588604636, 0.30358762870721934, 0.30335750868060485,
          0.3028746459021474, 0.3102296247863774, 0.3245188167831916,
          0.513717483260622,
        ],
        5: [
          0.3168026438764827, 0.3166971017611584, 0.3164554791226937,
          0.3159602937607381, 0.31510170234424306, 0.3245188167831916,
          0.513717483260622,
        ],
        6: [
          0.5133475032797323, 0.5129929272803866, 0.5120990040130892,
          0.5102076031004492, 0.5068321185577905, 0.3240180433947295,
          0.5117918362903922,
        ],
      },
      9: {
        0: [
          0.2530521118491003, 0.2546336528582026, 0.26020348277145666,
          0.26954564753155025, 0.2808134379554412, 0.29270812512636546,
          0.4987675812141372,
        ],
        1: [
          0.25330514133335863, 0.2545526504145579, 0.26012308852996235,
          0.26946033746843345, 0.2807285406069529, 0.29270812512636546,
          0.4987675812141372,
        ],
        2: [
          0.2565465555878165, 0.25646840000712845, 0.2599528638069394,
          0.26932224156269313, 0.28055078882296564, 0.29262491385928124,
          0.49839583387987785,
        ],
        3: [
          0.2635556294378041, 0.26348236722650886, 0.26332062520700555,
          0.26892752857439484, 0.28022775922099463, 0.29262491385928124,
          0.49839583387987785,
        ],
        4: [
          0.2734025126021651, 0.2733261047442047, 0.27316283819944376,
          0.2728288540814149, 0.2795951975379568, 0.29245444684695876,
          0.4974709696676429,
        ],
        5: [
          0.2854504296365197, 0.28537737386899464, 0.28521361939292483,
          0.2848714044328441, 0.28430777600414836, 0.29245444684695876,
          0.4974709696676429,
        ],
        6: [
          0.4973936213971154, 0.49703733869769234, 0.49617547043627863,
          0.49432244889375826, 0.4912016595285461, 0.29208656261155075,
          0.4956039303927971,
        ],
      },
      10: {
        0: [
          0.23974274696473818, 0.2412370493886405, 0.24650845632822152,
          0.25532853305391223, 0.26603653532938676, 0.2773672749900504,
          0.4909919577781914,
        ],
        1: [
          0.2400068802814147, 0.24117219806223994, 0.24642657611552035,
          0.2552794846898982, 0.2659442940427002, 0.2773672749900504,
          0.4909919577781914,
        ],
        2: [
          0.2430653453039419, 0.24300615074437137, 0.24629784312658753,
          0.255162899018417, 0.2658136267540132, 0.27729926399074784,
          0.4906154588514811,
        ],
        3: [
          0.24970452367999874, 0.2496392679483703, 0.24949709389372787,
          0.25484965225849804, 0.2655533911044007, 0.27729926399074784,
          0.4906154588514811,
        ],
        4: [
          0.2590508991370619, 0.25898675422122197, 0.2588439810625781,
          0.2585610201485587, 0.2650484544777485, 0.27714822728510147,
          0.48970730504815124,
        ],
        5: [
          0.2705329723526161, 0.270467415540506, 0.2703250427267435,
          0.2700426229946342, 0.26958633172033597, 0.27714822728510147,
          0.48970730504815124,
        ],
        6: [
          0.4897832400120862, 0.4894256753741564, 0.48857341606287186,
          0.4867562430219108, 0.48367759861076787, 0.27685517474318744,
          0.48784710353447736,
        ],
      },
      11: {
        0: [
          0.23097154362604533,
          0.2324078471924344,
          0.23745835224921114,
          0.24595203407708466,
          0.2562583586481487,
          0.27235886967619194,
          null,
        ],
        1: [
          0.23120386307928573,
          0.2323514781634955,
          0.23739014465035363,
          0.24590527026885564,
          0.256186743247834,
          0.27235886967619194,
          null,
        ],
        2: [
          0.2341423860648718,
          0.23410134794605864,
          0.23726794344036622,
          0.24576607787171692,
          0.2560660530916833,
          0.27229492923342324,
          null,
        ],
        3: [
          0.24053959759690002,
          0.24048285631305555,
          0.24035670231114142,
          0.24552519079333446,
          0.25580934295815955,
          0.27229492923342324,
          null,
        ],
        4: [
          0.24954751170423722,
          0.2494941916911238,
          0.2493665871785236,
          0.24912500218071149,
          0.255415648305487,
          0.2721487937103224,
          null,
        ],
        5: [
          0.2656901897710289,
          0.2656286855880121,
          0.26548749451506165,
          0.26521883126647294,
          0.2647903201921327,
          0.2721487937103224,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.2234394326401201,
          0.22482992308397848,
          0.22970416087246653,
          0.2379422083852676,
          0.24791787557265582,
          0.2681010214362663,
          null,
        ],
        1: [
          0.2236811387413537,
          0.22478961547837478,
          0.2296615215566713,
          0.2378962503908995,
          0.24788131854765894,
          0.2681010214362663,
          null,
        ],
        2: [
          0.22652958132358897,
          0.22648896126963491,
          0.22955389044067698,
          0.23778251352593527,
          0.24777358314176717,
          0.2680446066559655,
          null,
        ],
        3: [
          0.2327222611718189,
          0.23267262205629904,
          0.2325653866019791,
          0.2375783815287073,
          0.2475678751421957,
          0.2680446066559655,
          null,
        ],
        4: [
          0.2414701062162099,
          0.24142350588768102,
          0.2413145382354364,
          0.24111987876252003,
          0.24724695742256228,
          0.26790319831982956,
          null,
        ],
        5: [
          0.2615799975025168,
          0.26152993023986115,
          0.26138450584016304,
          0.2611300031518299,
          0.26073390149213393,
          0.26790319831982956,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.21936574315086116,
          0.2207281414808847,
          0.22548620043024445,
          0.23357500592395727,
          0.24335510164580249,
          0.2657582978750355,
          null,
        ],
        1: [
          0.21959272281575032,
          0.22068941397442182,
          0.22545621400635424,
          0.23352204037748614,
          0.2433321560609812,
          0.2657582978750355,
          null,
        ],
        2: [
          0.22238030682234358,
          0.2223415901841207,
          0.2253461396691806,
          0.23341280037760787,
          0.24322156029732644,
          0.2657054915544279,
          null,
        ],
        3: [
          0.22844847766584775,
          0.2284000336898119,
          0.22830097255075396,
          0.23322954399714996,
          0.24303594151067875,
          0.2657054915544279,
          null,
        ],
        4: [
          0.2370361635808258,
          0.2369920704432928,
          0.23689022496409334,
          0.23671803437280575,
          0.24275833129893767,
          0.2655645369991533,
          null,
        ],
        5: [
          0.25931963487338777,
          0.2592693871740818,
          0.25912651237229944,
          0.2588787874348882,
          0.25849772891027434,
          0.2655645369991533,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.2164384662062161,
          0.2177789916919973,
          0.22246841402221068,
          0.23043225074111967,
          0.24008677862859384,
          0.2640822634441707,
          null,
        ],
        1: [
          0.21667141431492398,
          0.21774635066729425,
          0.22243322328599274,
          0.2303880939368213,
          0.24005944073041152,
          0.2640822634441707,
          null,
        ],
        2: [
          0.21941534768453883,
          0.21937915133872196,
          0.22234199429001367,
          0.23029119491067818,
          0.23996462059421197,
          0.26402767300384844,
          null,
        ],
        3: [
          0.2253950861645461,
          0.22535212951679037,
          0.22525449611551435,
          0.23012326698820795,
          0.239800040752579,
          0.26402767300384844,
          null,
        ],
        4: [
          0.23386747304772387,
          0.23382793937679036,
          0.23373440920146585,
          0.23357627244401047,
          0.2395561234807183,
          0.2638924744612243,
          null,
        ],
        5: [
          0.25770399115114395,
          0.2576539734102828,
          0.2575150362406199,
          0.2572709694438662,
          0.25690298647167137,
          0.2638924744612243,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.21394428932760845,
          0.21526925373845168,
          0.21990324646369705,
          0.22776750544725488,
          0.23732788629057372,
          0.26267047322890535,
          null,
        ],
        1: [
          0.21418396640266177,
          0.2152446291671097,
          0.21986807586601556,
          0.22773223354180822,
          0.2372936772246529,
          0.26267047322890535,
          null,
        ],
        2: [
          0.21689408599450838,
          0.21686579874502593,
          0.21979576687328806,
          0.2276469872376885,
          0.23722041568172852,
          0.2626157210057563,
          null,
        ],
        3: [
          0.22280685148924925,
          0.22276739134431855,
          0.22268572588601376,
          0.22750213107539557,
          0.23707721332297876,
          0.2626157210057563,
          null,
        ],
        4: [
          0.23119247425590736,
          0.2311578484602802,
          0.2310760536126493,
          0.23094212420848373,
          0.23687477033574533,
          0.2624816037346628,
          null,
        ],
        5: [
          0.256342989268047,
          0.25629405838009267,
          0.256158299301667,
          0.25592393172483846,
          0.2555683700616691,
          0.2624816037346628,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.21253241778974047,
          0.21384592557090512,
          0.21844129967729595,
          0.2262441903495453,
          0.2365553883070132,
          null,
          null,
        ],
        1: [
          0.21277453437039132,
          0.21380614371347756,
          0.21840292757761967,
          0.2262010538164589,
          0.23651837441656115,
          null,
          null,
        ],
        2: [
          0.21546096138931226,
          0.21543572943352401,
          0.2183243210257462,
          0.226127279843399,
          0.23643726664816492,
          null,
          null,
        ],
        3: [
          0.22132854468914986,
          0.22129029956396074,
          0.22121303168133863,
          0.22599720008816482,
          0.23630724035152428,
          null,
          null,
        ],
        4: [
          0.23043934031086905,
          0.23040575812570913,
          0.23032456088066616,
          0.23019417328173059,
          0.23611228324829592,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.2115301268201385,
          0.21281886411168408,
          0.21740109848550523,
          0.2251607153128264,
          0.23600618356460865,
          null,
          null,
        ],
        1: [
          0.21177401640112098,
          0.21279658958637837,
          0.21734865317976992,
          0.2251180369458637,
          0.23596640795697413,
          null,
          null,
        ],
        2: [
          0.21444346455165203,
          0.21442101472566827,
          0.21729156040027106,
          0.22505308543122057,
          0.2358884756813706,
          null,
          null,
        ],
        3: [
          0.22027921587729848,
          0.22024198465903633,
          0.2201697357618732,
          0.22493437737195077,
          0.2357632422791673,
          null,
          null,
        ],
        4: [
          0.2299043683366358,
          0.22987180994588577,
          0.22979112979275407,
          0.2296650300771233,
          0.2355763739130482,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.21070313554209408,
          0.2120076395164632,
          0.21655644290942896,
          0.22429061824420643,
          0.23556772133785425,
          null,
          null,
        ],
        1: [
          0.2109250359562469,
          0.2119665573859597,
          0.21652936523876298,
          0.224256680142742,
          0.23552681271133613,
          null,
          null,
        ],
        2: [
          0.2136052628300118,
          0.21357318813058404,
          0.2164508271406433,
          0.22419307562024526,
          0.23545099978358253,
          null,
          null,
        ],
        3: [
          0.2194286031322621,
          0.21939770310830833,
          0.21933332252666654,
          0.22408624872678018,
          0.23533031407911076,
          null,
          null,
        ],
        4: [
          0.2294765058910658,
          0.2294404892846163,
          0.22936677369470465,
          0.2292446304034886,
          0.23514963650367987,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.21022899031791586,
          0.2115253233795188,
          0.21607583728740282,
          0.22379871037235377,
          0.23531680206643188,
          null,
          null,
        ],
        1: [
          0.2104591410650946,
          0.21148808832378363,
          0.21604072642861477,
          0.22376255159911945,
          0.23527594242557898,
          null,
          null,
        ],
        2: [
          0.2131389371776344,
          0.21310744400943665,
          0.2159762700723007,
          0.22370430495459664,
          0.2352006680015396,
          null,
          null,
        ],
        3: [
          0.21895356940015093,
          0.2189233329212482,
          0.2188610265199334,
          0.22360231230249708,
          0.235081894663211,
          null,
          null,
        ],
        4: [
          0.22923897617005745,
          0.22919823297951186,
          0.22912509027774516,
          0.22900448890250058,
          0.23490421099209025,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
    },
    3: {
      5: {
        0: [
          0.6349986528135381, 0.6391439387034257, 0.6551607634262577,
          0.6832967864360746, 0.7196950951758769, 0.7752451090974146,
          0.8449106475761847, 0.9259088215563138, 1.0528345324759152,
          1.197862120042343,
        ],
        1: [
          0.6353535910969563, 0.6382654697007013, 0.6544775571766074,
          0.6827328561031545, 0.7191583256186761, 0.7745805894649411,
          0.8443578074852018, 0.9254693434007111, 1.052288066852817,
          1.1975398307315592,
        ],
        2: [
          0.6446326727229233, 0.6419267697604263, 0.6530024311204732,
          0.6814535128919872, 0.7178300880230017, 0.7732248056477937,
          0.8429482421493576, 0.9240029497168813, 1.0509436302327986,
          1.1962744645629602,
        ],
        3: [
          0.6617135108417124, 0.6629476171753415, 0.6600005628328331,
          0.6787626706287089, 0.7150071797404768, 0.7702702201691851,
          0.8399101505868456, 0.9209307094077916, 1.0477614672312687,
          1.193268452221564,
        ],
        4: [
          0.69168786675657, 0.6908182218248398, 0.6898900606837632,
          0.6873373172529263, 0.7099254582139256, 0.7649104082912519,
          0.8343420901037839, 0.9153688608203217, 1.0420807815061774,
          1.1879005675669618,
        ],
        5: [
          0.732640468389774, 0.7320374342663607, 0.7308197086716804,
          0.7281068562740907, 0.7232519814717671, 0.7565780607353132,
          0.8257402094836743, 0.9067141600020935, 1.0334357196453223,
          1.1798634861403607,
        ],
        6: [
          0.7906804828698469, 0.7901007173419619, 0.7889010703296137,
          0.786015955680025, 0.7811195796546837, 0.773213492282665,
          0.8133537416328804, 0.8942959729726793, 1.0211158370564655,
          1.168572294860586,
        ],
        7: [
          0.8581607731861636, 0.8576131069611257, 0.8564570545472625,
          0.8537392560684292, 0.8485588254676825, 0.8409356131143062,
          0.8297620891237087, 0.8772567896780669, 1.0041886117240608,
          1.153455433079166,
        ],
        8: [
          0.9448089482013489, 0.9442970444257663, 0.9432580748757582,
          0.9406648238514237, 0.9358301647744334, 0.9283984223343031,
          0.9178473952423559, 0.9036168955755699, 0.981776541223893,
          1.133681829332235,
        ],
        9: [
          1.0837091923452546, 1.0832825179721406, 1.0822796317422139,
          1.079897852368273, 1.0753243813820548, 1.0685777590419687,
          1.058954942451878, 1.046244998912201, 1.029890578354202,
          1.1078532278631434,
        ],
      },
      6: {
        0: [
          0.38858453446500424, 0.3920809666969366, 0.4014692198750568,
          0.41957497433818536, 0.44347826364131365, 0.48041998325164437,
          0.5280632617646921, 0.5855956961323838, 0.6772050472516172,
          0.7882043891303018,
        ],
        1: [
          0.38905526812042435, 0.3918281428483872, 0.4020243031624669,
          0.41937308327512507, 0.44331396756967295, 0.4802075190158295,
          0.5278759542609603, 0.5854683097680872, 0.6770800370870689,
          0.7881806341951366,
        ],
        2: [
          0.3950012999076662, 0.3947874272978937, 0.40158737731618593,
          0.41894445046212947, 0.4428305854025275, 0.47977867707814603,
          0.5274187478681476, 0.5850229302498119, 0.6767050260764911,
          0.7878707366320894,
        ],
        3: [
          0.40743350733686234, 0.4072644177213389, 0.4069310354746989,
          0.4180315158430802, 0.44191160307090316, 0.4787540694623278,
          0.5264094402332639, 0.5840239704635396, 0.6756952101995297,
          0.7870220368350811,
        ],
        4: [
          0.4262528653294946, 0.4260388423384903, 0.4256836029620171,
          0.42484396046769546, 0.44025893204344346, 0.4770395681206552,
          0.5246173649583716, 0.5822602790277329, 0.6739956436267771,
          0.7855427884620075,
        ],
        5: [
          0.45527816088827694, 0.4550811140726405, 0.4546853348958505,
          0.4538007350165031, 0.45215618287671866, 0.4743394679628763,
          0.5218912567329924, 0.5796410352462629, 0.6715577015508012,
          0.7836262829348366,
        ],
        6: [
          0.4953828133529409, 0.4952339231581035, 0.49481302136950844,
          0.49390874372037874, 0.492245336781187, 0.489806487142197,
          0.5179832173076686, 0.5759574469000048, 0.6682130549079587,
          0.7811606238925299,
        ],
        7: [
          0.5427582373194872, 0.5425888765907949, 0.5422648534751977,
          0.541369048970418, 0.5398157152861602, 0.5374847593609124,
          0.5342869898520373, 0.5709833757659897, 0.6638827647278308,
          0.7783136203857166,
        ],
        8: [
          0.6092045217862384, 0.6091133893802154, 0.6088075054924993,
          0.6080125313360282, 0.6066069631222675, 0.6046347485489814,
          0.6019559188516161, 0.5985573350870721, 0.6583808350532204,
          0.7752621189703177,
        ],
        9: [
          0.7164067712026829, 0.7163659479988884, 0.7161577268956221,
          0.7154732840802409, 0.7142848147417025, 0.7127940561815422,
          0.7109388887979713, 0.707765746599987, 0.7060514970677478,
          0.7719053585503788,
        ],
      },
      7: {
        0: [
          0.3242743598238399, 0.3271514822443964, 0.3356388547168815,
          0.3502061823188529, 0.37039394027925443, 0.4016345237763763,
          0.4421887961318255, 0.4915846853747067, 0.5706340167700764,
          0.6677965979997109,
        ],
        1: [
          0.3246935805576151, 0.3270332196335202, 0.3355101848808924,
          0.3500769736343371, 0.37027378392778265, 0.4015169587037591,
          0.4420520496775101, 0.49147858531141, 0.5705546574523503,
          0.6678222675979457,
        ],
        2: [
          0.32967887177372374, 0.32949367712593114, 0.33520034376938435,
          0.34976120104469, 0.3699420419582622, 0.4011943874009525,
          0.44173785098916546, 0.4911910236401018, 0.5703014348484281,
          0.6676564005935903,
        ],
        3: [
          0.3401346306729678, 0.33994869626667623, 0.3397254532034535,
          0.3491154618804332, 0.369279739225296, 0.40050331811383105,
          0.4410449167526532, 0.49054283760867773, 0.569690460882677,
          0.6671913974195962,
        ],
        4: [
          0.35607895556524083, 0.3558859710412543, 0.3555640947142308,
          0.35502600552135954, 0.36812323642559364, 0.3993238296443361,
          0.4398647938722408, 0.4894086594624161, 0.5686913527490844,
          0.6664608681175956,
        ],
        5: [
          0.3806633260076081, 0.3805240162337413, 0.3802321276703906,
          0.37961916647122473, 0.378544356812935, 0.39755319533885025,
          0.4381321579643897, 0.4878482633277579, 0.5673558113327455,
          0.6656804103274506,
        ],
        6: [
          0.41489193123517065, 0.4147309528364749, 0.41448241406614444,
          0.4138936134237433, 0.412797033519797, 0.4112583561351707,
          0.4356917457773996, 0.4856819784485694, 0.5656626563672338,
          0.6648983738787491,
        ],
        7: [
          0.45568817916678894, 0.45559762115576813, 0.45532027607006753,
          0.45478497506636795, 0.4538308467205321, 0.45244374469441506,
          0.4506105982161543, 0.4828397652465961, 0.5635929991450567,
          0.6644044698906222,
        ],
        8: [
          0.5133871742722378, 0.5133492884092344, 0.5131702452978661,
          0.5126916423057957, 0.5119052949429006, 0.5108875253560035,
          0.509630931433875, 0.5082259640533374, 0.5612795292434452,
          0.6645919428855922,
        ],
        9: [
          0.607087750158849, 0.6071086680273944, 0.6070289907803317,
          0.6066803618414172, 0.6061502569730697, 0.6056701462757197,
          0.6052912163417079, 0.6053891695087019, 0.6055214146712491,
          0.6658314737813718,
        ],
      },
      8: {
        0: [
          0.28689865850504953, 0.2894205486786092, 0.2968866578655971,
          0.30978530803234394, 0.32773913240189534, 0.3555321722182132,
          0.391761543040971, 0.43620792029833444, 0.5076045286560317,
          0.5963343984959963,
        ],
        1: [
          0.2875872880919072, 0.2893083299949497, 0.2967631239739099,
          0.3096666170969832, 0.328076855839581, 0.3554421144354816,
          0.3916701104845782, 0.4361454019632601, 0.507576681975899,
          0.5963729363804355,
        ],
        2: [
          0.2919970613224987, 0.29189562625975407, 0.29652367134360935,
          0.3094089529568427, 0.32734959586126855, 0.3556506356189918,
          0.3914206384997633, 0.43594337964839913, 0.5074235345250993,
          0.5963193043845256,
        ],
        3: [
          0.30086543240813113, 0.30077557704307734, 0.30057005695710415,
          0.3089252538394217, 0.326853213406057, 0.35467387313235266,
          0.39093357985699295, 0.43548194255605865, 0.507032043584622,
          0.5960864724741237,
        ],
        4: [
          0.31505185302429556, 0.3149177913426797, 0.31472039744904234,
          0.3142666775146272, 0.3260044798047298, 0.35382553627638824,
          0.39010654319502974, 0.43475116338162156, 0.5064481002010186,
          0.5957961211349738,
        ],
        5: [
          0.33702895124225385, 0.33692743882328147, 0.3367145898316426,
          0.33625788041106697, 0.3354797945370563, 0.35257330904655715,
          0.38893326253148475, 0.4337728428048157, 0.5057554693411321,
          0.5957073617930322,
        ],
        6: [
          0.3676560585152845, 0.3675988251400978, 0.3674018960273057,
          0.3669566884467116, 0.3662163078916879, 0.3651775022328576,
          0.3873044904909386, 0.4324533022444465, 0.5049695264366887,
          0.5958744771291142,
        ],
        7: [
          0.4044725133784691, 0.40439110782108234, 0.4042539396322419,
          0.4038641022201255, 0.40324162802100727, 0.4024099267020307,
          0.40133848199100713, 0.43086183383957677, 0.5042526127031981,
          0.5967538760411447,
        ],
        8: [
          0.4568180123243129, 0.4568065318274615, 0.45671436166845814,
          0.456417450642326, 0.45598247919928014, 0.45553626093363336,
          0.4550782583921774, 0.454823491937819, 0.5037952225187995,
          0.5989097248704918,
        ],
        9: [
          0.5422666095005858, 0.5423272403403834, 0.5423298853072908,
          0.5421803780114605, 0.5420354058754009, 0.5421496943986399,
          0.5426372010218281, 0.5439562532989035, 0.5466919982605316,
          0.6028854409702304,
        ],
      },
      9: {
        0: [
          0.25834757992153634, 0.26064423500606115, 0.2670038207072055,
          0.278626968875971, 0.29528687834559686, 0.3205346485877473,
          0.3531543374182518, 0.39401745947238276, 0.4599723975408116,
          0.5430131444375874,
        ],
        1: [
          0.2586676285551557, 0.2605703010581365, 0.26693504204514945,
          0.27855061740624987, 0.29520953949369777, 0.32046689200054823,
          0.35310205086333835, 0.39399488964717533, 0.4599907641788147,
          0.5431057786720488,
        ],
        2: [
          0.2626626676618862, 0.26259017273276664, 0.26677010192212813,
          0.27839049182795994, 0.29504648760674723, 0.32030599793338976,
          0.3529529451613894, 0.393876438065469, 0.459937627316253,
          0.5431536427276225,
        ],
        3: [
          0.27075559666702886, 0.27065625621652334, 0.27049761090294877,
          0.2780615913854927, 0.2947129088203211, 0.31997763964523507,
          0.3526508160038421, 0.3936347095438495, 0.45977069483003496,
          0.5431525956477965,
        ],
        4: [
          0.2835697879995178, 0.2835495645722009, 0.2833626456388489,
          0.28304657079454776, 0.2941698241140107, 0.3194434473632975,
          0.35216735487853745, 0.3932543844067522, 0.4595779541190473,
          0.5432860743892809,
        ],
        5: [
          0.3035598457492067, 0.3035113456487266, 0.30336404386070015,
          0.30306379933171024, 0.30257813533146083, 0.31869504518258523,
          0.3515177413412771, 0.3928258198639566, 0.4594860098411484,
          0.5438046174472404,
        ],
        6: [
          0.3315713648632963, 0.331541225690533, 0.3314180021932473,
          0.33113862991936016, 0.33073520046846616, 0.3301669063336081,
          0.35066726987944974, 0.39233832422459136, 0.4595771425697266,
          0.54489508038858,
        ],
        7: [
          0.36549007798137273, 0.3654760904094313, 0.3654056872303728,
          0.3651945624747589, 0.36489514665195666, 0.364593966629773,
          0.3642416096908495, 0.3918801665577705, 0.46009209745474555,
          0.5470582253676411,
        ],
        8: [
          0.41412474231440055, 0.41415833139443153, 0.41414416764526363,
          0.4140391690478012, 0.41394721630986886, 0.4140254220903675,
          0.4143314749155569, 0.4151494447447016, 0.4613617747138863,
          0.5509827240983641,
        ],
        9: [
          0.4939986785969719, 0.49410096523458924, 0.49418706410684987,
          0.49424347233713817, 0.49446642584206274, 0.49513576596925046,
          0.4964228762430841, 0.4988670772581116, 0.5031851828918155,
          0.557510057273692,
        ],
      },
      10: {
        0: [
          0.2447368173932879, 0.24691830212153665, 0.2529277693386025,
          0.26390582418400116, 0.2796759678491716, 0.30362338290976176,
          0.3346240319134544, 0.3736094518901318, 0.43669221865413843,
          0.5165986359394344,
        ],
        1: [
          0.24506003063392529, 0.24685286084602676, 0.25286212009804465,
          0.2638467292011283, 0.27961795344019647, 0.3035675450403438,
          0.33458970737978244, 0.37358777433095014, 0.43671997701619286,
          0.5167129947318381,
        ],
        2: [
          0.24882454819919236, 0.24876630869837102, 0.2527144660539973,
          0.26369813266524333, 0.27947335433482673, 0.30343215215205227,
          0.3344694889265969, 0.37350992909645964, 0.4366916613262646,
          0.5167948686810748,
        ],
        3: [
          0.2564601553573457, 0.2564226050658893, 0.2562719790141881,
          0.26342337733382376, 0.2791981913139032, 0.3031694532332839,
          0.33423664121752583, 0.37334139410875566, 0.4366212199650211,
          0.5168985654334499,
        ],
        4: [
          0.2686513886020406, 0.2686018635642724, 0.2684902325498284,
          0.26821721635731965, 0.27876750940778305, 0.3027578803937807,
          0.33388823388526656, 0.3731039975594116, 0.4365978467270328,
          0.5172212640006815,
        ],
        5: [
          0.287616949559219, 0.28757218367286375, 0.28745928862813586,
          0.28721525969165695, 0.28684890948104136, 0.302204679654042,
          0.3334513804718442, 0.3729169281667971, 0.43675898480102004,
          0.5180293563383715,
        ],
        6: [
          0.3142914611379989, 0.31426356650284293, 0.3141556350838804,
          0.31395063974719223, 0.3136498586496022, 0.31328118614439915,
          0.3329136824019303, 0.3727739007242671, 0.43724440003441845,
          0.5195394017934408,
        ],
        7: [
          0.3466700338012191, 0.34667901680386615, 0.34662900034553223,
          0.34647876270800915, 0.3463159944118772, 0.346196971065464,
          0.34616396008973893, 0.37279272825430754, 0.43829614913496495,
          0.5222959996647453,
        ],
        8: [
          0.3932561853056541, 0.3933021389236355, 0.3933181946260556,
          0.3932956080474987, 0.39335268939245793, 0.39364711911289885,
          0.3942821335526705, 0.39557737092786915, 0.4403375305807663,
          0.5270616168759543,
        ],
        9: [
          0.47007374273581426, 0.470189661553307, 0.4703131463555388,
          0.4704628582244771, 0.4708551810488796, 0.47177715736814535,
          0.4734359421494534, 0.476408602102368, 0.48148307400582924,
          0.534825353142969,
        ],
      },
      11: {
        0: [
          0.23576488134404858,
          0.23784130087297434,
          0.24361584615541715,
          0.2541640873495181,
          0.269330757145375,
          0.2982626325761173,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.23606216795064416,
          0.2377795180789377,
          0.24354964450607414,
          0.2541075838251566,
          0.26927795167296,
          0.2982079770965763,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.23967846492579575,
          0.23962149309038622,
          0.24341530470429137,
          0.25397234962139154,
          0.26914937516663906,
          0.2980782675983805,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.24702842729097074,
          0.24697822776889689,
          0.24685714312950108,
          0.2537327722892588,
          0.26891642438606334,
          0.29782882639392105,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.25877945710615285,
          0.2587219770806518,
          0.25860982175986513,
          0.2583930937225236,
          0.26856443850808004,
          0.29744751698728655,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.28253817862533614,
          0.2824993060705564,
          0.2823816359974042,
          0.282154747920629,
          0.28181354065753494,
          0.29694631415224343,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.22807354006610156,
          0.23006985157117893,
          0.2356415815290171,
          0.24584327340028683,
          0.2605279486712354,
          0.29370934991167175,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2283727081629027,
          0.23001668145239218,
          0.2355885459152819,
          0.24579167060030646,
          0.2604818639324249,
          0.2936571544829776,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.23185378693564457,
          0.2318079729027424,
          0.2354739582454075,
          0.24568108133849112,
          0.2603807979890801,
          0.2935354186621414,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.23898315425786348,
          0.238943267713442,
          0.2388373974724183,
          0.24548941841361432,
          0.26019765779465476,
          0.2933033918801808,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.2503898714210973,
          0.25032879787411566,
          0.2502419686994986,
          0.2500654034786771,
          0.25993881939462593,
          0.2929581840508795,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.27822893324060843,
          0.2781850438177515,
          0.2780793026414931,
          0.27786654924305065,
          0.27755882853417035,
          0.29251560196156656,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.2238865948088576,
          0.22583147763797135,
          0.23128410841715435,
          0.24127874024418539,
          0.25567368441207405,
          0.29119075175612275,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2243953971245244,
          0.22578130988065953,
          0.23123582408268512,
          0.24122784714233797,
          0.25562895199530944,
          0.2911396760279122,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2275791403496052,
          0.2275407544420198,
          0.23113631389536882,
          0.24113332338905097,
          0.25554134709876497,
          0.2910214083342637,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.23457530733184317,
          0.23454877439888427,
          0.23444282193210297,
          0.24096588270077574,
          0.25538604175954105,
          0.29079805292998606,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.24573235408486485,
          0.2457141864259234,
          0.24564144962858075,
          0.24548014680197805,
          0.2551689101039555,
          0.2904702436387022,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.2758415932942522,
          0.2758084254217764,
          0.27570595889428734,
          0.2754993587293937,
          0.27520978313731326,
          0.29005677355888326,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.22087932858778425,
          0.22280110917717022,
          0.22816220352524136,
          0.23800221237841718,
          0.2521924299609099,
          0.2893866679117246,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.22139076125833124,
          0.2227550045990967,
          0.22812436107222642,
          0.2379588123895086,
          0.2521512861742988,
          0.2893363149834828,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.22452689968122744,
          0.22448787249692653,
          0.22803082768209337,
          0.2378772220094954,
          0.252077208701433,
          0.28922097151198267,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.23142828335326554,
          0.23138775039840043,
          0.23129987919495604,
          0.23772754782471844,
          0.2519421632450294,
          0.28900477609483743,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.24243358089483136,
          0.24241165967288947,
          0.24233298298077577,
          0.2422058206624595,
          0.25176186599418593,
          0.2886914845051598,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.27414283719143007,
          0.2741082389885082,
          0.27400435282797253,
          0.27380685689654916,
          0.27353296205117983,
          0.2883018894340773,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.2183164819246897,
          0.2202206388843405,
          0.22551633813654007,
          0.23523375172984987,
          0.24925747167899737,
          0.28786760216291984,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.21860485264578014,
          0.2201793372936637,
          0.22548236171411198,
          0.23519834155149663,
          0.24922535243611277,
          0.28781891594230874,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.221931902830789,
          0.2218952993389886,
          0.2253979484223291,
          0.23512519061152068,
          0.24916130714152782,
          0.28770756444498946,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.2287636987505543,
          0.22871445301975943,
          0.2286422390785452,
          0.23499699654195222,
          0.24905034725924569,
          0.2875001872819117,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.23965356512951347,
          0.23963296480909566,
          0.23955070027306982,
          0.23944813757438074,
          0.24891158284088866,
          0.28720358555125297,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.27271174528878106,
          0.27267762673732154,
          0.2725779025489892,
          0.27238650276428833,
          0.27212279516228655,
          0.2868403280210837,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.21686392858365494,
          0.2187500266340801,
          0.22400421445510615,
          0.23364330206955183,
          0.24844144272638735,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.21715767023897903,
          0.2187111718398005,
          0.22396416838914485,
          0.23360698559622345,
          0.24840996985150865,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2204525084856983,
          0.22041664277003242,
          0.22389221125426645,
          0.2335368454708888,
          0.24834423733269956,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.22724011198242214,
          0.22718820540489937,
          0.22714880224772213,
          0.23342578819219312,
          0.24824064516956307,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.2388848765936613,
          0.23886098788779703,
          0.2387736860673443,
          0.23870325985560248,
          0.2481101314391287,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.21583486786641082,
          0.21770627847550994,
          0.22292809798317975,
          0.23252105163786807,
          0.24786931067562168,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.21634116959379285,
          0.2176664239915322,
          0.22288946894133535,
          0.23248572942251583,
          0.24783885811120904,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.21940008164266864,
          0.2193668421812595,
          0.22281991264440565,
          0.23242258877008395,
          0.2477748576299873,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.22615461877052428,
          0.22610735642479735,
          0.22606707486359723,
          0.23232399971712037,
          0.24767663438514143,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.23830811461755452,
          0.23830501909655422,
          0.23822513023585262,
          0.2381528585054939,
          0.24755529831228706,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.21498465665385502,
          0.21685175213949878,
          0.22205518862417764,
          0.23161562814163822,
          0.2474089029303331,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2154932658571474,
          0.21681502669498084,
          0.22202012060332543,
          0.23158278524077902,
          0.2473778577336559,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.21854523525344013,
          0.21851582331136415,
          0.2219586456605926,
          0.23152639954540702,
          0.24731642175603885,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.22525445427887925,
          0.22524420181122337,
          0.22520418393831199,
          0.23144033436545278,
          0.24722204911837986,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.23786466043649704,
          0.23783634885519644,
          0.23779188279817648,
          0.23771731368888668,
          0.24710755368504334,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.21451074293518718,
          0.21637980777572016,
          0.2215676425086615,
          0.23109862124069358,
          0.24714330075750204,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.21502389882367945,
          0.21634360628348243,
          0.22153248518048613,
          0.2310676964230695,
          0.2471118454347998,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.21806533974433512,
          0.21803885780019303,
          0.22147301438080128,
          0.2310130214732205,
          0.24705155934005246,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.22476246001074995,
          0.22475399055270256,
          0.22471400270473518,
          0.2309321246441717,
          0.24695925918244221,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.23761449415493757,
          0.23758610588037668,
          0.23754688779356703,
          0.23746772131234894,
          0.2468482567265226,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
    },
    4: {
      5: {
        0: [
          0.7572004139195367, 0.7796858118732694, 0.8534812608905178,
          0.9881339813460139, 1.1758746176852373, 1.4487648393434156,
          1.7641254822443837,
        ],
        1: [
          0.7615720472517391, 0.7797095086338064, 0.8535145887421742,
          0.9881080914533977, 1.1760092567587566, 1.4489911476040471,
          1.7643743402450591,
        ],
        2: [
          0.8063483817815436, 0.8063210399963934, 0.8533528016675171,
          0.9881352811539789, 1.1760530170088095, 1.4492755107979165,
          1.7649176270986286,
        ],
        3: [
          0.9053470587891241, 0.9054053274588105, 0.9055879138221237,
          0.9881386757264974, 1.1763449293522172, 1.4497819895603166,
          1.7657993091272557,
        ],
        4: [
          1.052497632267609, 1.0528913971386433, 1.052982273011326,
          1.0532433179955787, 1.1771706926580139, 1.4510454406401032,
          1.768016597451949,
        ],
        5: [
          1.2719084346684233, 1.272244016171229, 1.2727190829901496,
          1.273102223009486, 1.27438169621565, 1.453218688025805,
          1.7715064073451614,
        ],
        6: [
          1.5718056260315545, 1.5721391509735207, 1.5729233835306262,
          1.5737381796531518, 1.5757032182809412, 1.5793601839227378,
          1.7770862736572557,
        ],
      },
      6: {
        0: [
          0.46091130288811744, 0.4758231195811246, 0.5221119445151434,
          0.6029679662019406, 0.7162015620132589, 0.8826694333754543,
          1.0775135069631676,
        ],
        1: [
          0.4636882598456007, 0.47583864587246316, 0.5221444327594199,
          0.6030196030183599, 0.7162805554624292, 0.8826694333754543,
          1.0775135069631676,
        ],
        2: [
          0.4909297941009995, 0.4909667523652243, 0.5222010839814458,
          0.6031102516033999, 0.7164271818610898, 0.8828048481596882,
          1.077737755461892,
        ],
        3: [
          0.5512862600528823, 0.5513368666976437, 0.5514225136529829,
          0.6032670530946018, 0.716687295666304, 0.8828048481596882,
          1.077737755461892,
        ],
        4: [
          0.6426990317560591, 0.6427855511423017, 0.6429205066051327,
          0.6431749003630106, 0.7171603652360462, 0.8830445059405163,
          1.0781243233905444,
        ],
        5: [
          0.7765111088809247, 0.7766309663127376, 0.7769306705998038,
          0.7772862866785799, 0.7780967075308716, 0.8830445059405163,
          1.0781243233905444,
        ],
        6: [
          0.9577801526038594, 0.958021843532662, 0.9584145679328856,
          0.9591416971687676, 0.9603818017463104, 0.8834741851016259,
          1.078822487214817,
        ],
      },
      7: {
        0: [
          0.3839255181446418, 0.3963049962170272, 0.43474759927432,
          0.5019517039061973, 0.5960607240059217, 0.734389173676308,
          0.896289690328431,
        ],
        1: [
          0.38681096862491093, 0.3963120184210305, 0.43477220259179844,
          0.5019697378087951, 0.5961067500727024, 0.734389173676308,
          0.896289690328431,
        ],
        2: [
          0.40883141688247937, 0.40947434698784646, 0.43482083553048323,
          0.502055366932939, 0.5962157362456801, 0.734493806762589,
          0.8964823010829366,
        ],
        3: [
          0.45898476523158155, 0.45902407161355935, 0.45909260378704303,
          0.5021981948346612, 0.5964621641584331, 0.734493806762589,
          0.8964823010829366,
        ],
        4: [
          0.5349504711025155, 0.5350260637103845, 0.5351433121747279,
          0.5353676781443224, 0.5968910682573436, 0.7346898274941038,
          0.8968120985158533,
        ],
        5: [
          0.647390945231975, 0.6475196552431064, 0.6477269354896656,
          0.6481013428695189, 0.6488167433087559, 0.7346898274941038,
          0.8968120985158533,
        ],
        6: [
          0.7980133372686307, 0.798251001358165, 0.7985623126508539,
          0.7991609003055845, 0.8003427782067393, 0.7350859643372685,
          0.8974370070310481,
        ],
      },
      8: {
        0: [
          0.3395035765788792, 0.35037751252927307, 0.3836722806507181,
          0.4427339826382112, 0.5254626017572538, 0.6470552633014407,
          0.7893616933236035,
        ],
        1: [
          0.3415364296801767, 0.3503965092989559, 0.38369814345077624,
          0.44278217119209456, 0.5255181590813021, 0.6470552633014407,
          0.7893616933236035,
        ],
        2: [
          0.36144569634035384, 0.3614708779176429, 0.38374748863806846,
          0.4428695166747354, 0.5256577146911738, 0.6471591879602734,
          0.7895371161920701,
        ],
        3: [
          0.40499001981116634, 0.40503318912732134, 0.4050995775317674,
          0.44297546408028876, 0.5258680497149129, 0.6471591879602734,
          0.7895371161920701,
        ],
        4: [
          0.47176004789076226, 0.47183408913289004, 0.47194569395775643,
          0.472157991693561, 0.5262559597277108, 0.6473730498519901,
          0.7898611162506677,
        ],
        5: [
          0.5705938550928882, 0.5707141835644731, 0.5709066010572748,
          0.5712628968397879, 0.5719345924561692, 0.6473730498519901,
          0.7898611162506677,
        ],
        6: [
          0.7030122826671864, 0.7031981014043267, 0.7035144757452483,
          0.7040905124201436, 0.7051785299734831, 0.6477340498126466,
          0.7904434786457482,
        ],
      },
      9: {
        0: [
          0.30464459608479744, 0.31434547353700226, 0.3440289062336453,
          0.39669320597505797, 0.4704324999438809, 0.5788167715730028,
          0.7056548897763187,
        ],
        1: [
          0.30646954825786055, 0.31436425091844444, 0.34405546213071325,
          0.39673895152015276, 0.47050770399333497, 0.5788167715730028,
          0.7056548897763187,
        ],
        2: [
          0.3242106599890787, 0.3242350687175966, 0.3440969134834211,
          0.39679016689249835, 0.47061159328611585, 0.578932598096594,
          0.705830083896921,
        ],
        3: [
          0.363034423577854, 0.3630743209579367, 0.3631353991584638,
          0.3969118102215262, 0.47079967211648094, 0.578932598096594,
          0.705830083896921,
        ],
        4: [
          0.42256384884693754, 0.4226311498968878, 0.42273625313300534,
          0.4229335195024257, 0.4711758280781593, 0.5791141924741736,
          0.7061248968479956,
        ],
        5: [
          0.510667522884995, 0.5107787124976447, 0.5109582379563429,
          0.5112914559031183, 0.5119159610591262, 0.5791141924741736,
          0.7061248968479956,
        ],
        6: [
          0.6286836842560282, 0.6288567050859133, 0.6291421627673061,
          0.6296844629699134, 0.6306763488523464, 0.5794418710510499,
          0.7066531847471229,
        ],
      },
      10: {
        0: [
          0.28822192175889016, 0.297357758136522, 0.3253058410621092,
          0.3748902017132947, 0.44431962916191825, 0.5463654537901845,
          0.6657730746648307,
        ],
        1: [
          0.28995363595329393, 0.29737534959986034, 0.32533113813211334,
          0.3749284077352567, 0.4443904934217757, 0.5463654537901845,
          0.6657730746648307,
        ],
        2: [
          0.3066480313690412, 0.3066725301852531, 0.3253732399404539,
          0.3749940736953224, 0.4444985528010478, 0.5464764842770669,
          0.6659443575717576,
        ],
        3: [
          0.3432052495609741, 0.34324306655984754, 0.343303544694348,
          0.375114171576344, 0.4446985050513319, 0.5464764842770669,
          0.6659443575717576,
        ],
        4: [
          0.3992482858682462, 0.39931209427626246, 0.3994170031756262,
          0.39961176367255863, 0.44506742532376864, 0.5466650015824923,
          0.6662331037747464,
        ],
        5: [
          0.48219228371972533, 0.48230076107077335, 0.4824782718433944,
          0.4828078661978715, 0.4834242065262967, 0.5466650015824923,
          0.6662331037747464,
        ],
        6: [
          0.5933137670415507, 0.5934876988162232, 0.5937636668676607,
          0.5942987333728433, 0.5952814074019471, 0.546993470993867,
          0.6667649688102455,
        ],
      },
      11: {
        0: [
          0.27733970232631927,
          0.28606968120972753,
          0.3128389757057571,
          0.3603406161326637,
          0.42685722822909267,
          0.5367119081462609,
          null,
        ],
        1: [
          0.2789637024285574,
          0.2860858004442658,
          0.31286186793469006,
          0.36037414267007284,
          0.426909589860459,
          0.5367119081462609,
          null,
        ],
        2: [
          0.29496988803767354,
          0.2949947779079499,
          0.31290335810047665,
          0.3604388330803554,
          0.42701477128127446,
          0.5368186259671249,
          null,
        ],
        3: [
          0.3299833797725271,
          0.33002545422757135,
          0.33008793391222113,
          0.36055053332506587,
          0.4272136676882453,
          0.5368186259671249,
          null,
        ],
        4: [
          0.3836547535953233,
          0.3837227770815601,
          0.38382794271854376,
          0.3840234089862835,
          0.4275720692576469,
          0.5370055727267542,
          null,
        ],
        5: [
          0.4737075987783267,
          0.4738172401488785,
          0.4739944262121282,
          0.4743245443093359,
          0.4749378268866999,
          0.5370055727267542,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.26797224873312536,
          0.2763757341915616,
          0.30213507754488134,
          0.34786523745605286,
          0.41186870049866847,
          0.5284343509705673,
          null,
        ],
        1: [
          0.2695545050421222,
          0.27639150000868173,
          0.3021581934129553,
          0.34789283408176913,
          0.4119303313569882,
          0.5284343509705673,
          null,
        ],
        2: [
          0.2849420742413872,
          0.2849667012884094,
          0.30219838786123554,
          0.347956125329957,
          0.4120274105234439,
          0.5285421736757849,
          null,
        ],
        3: [
          0.31863964591223337,
          0.3186791950519174,
          0.3187413805248456,
          0.3480751418890743,
          0.4122247138962295,
          0.5285421736757849,
          null,
        ],
        4: [
          0.37028770888312534,
          0.37035240407743564,
          0.37045715691520387,
          0.3706508820559039,
          0.4125860330518014,
          0.5287246437165728,
          null,
        ],
        5: [
          0.4664363585943443,
          0.4665446926090737,
          0.4667216793967435,
          0.46705085808246244,
          0.46766314021209254,
          0.5287246437165728,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.26281922857154916,
          0.27103239935139845,
          0.2962060979763169,
          0.34089785830521957,
          0.4034518837138067,
          0.5237723301762227,
          null,
        ],
        1: [
          0.2643722948980788,
          0.2710486841495553,
          0.29622951381899665,
          0.3409441907091787,
          0.4035173835059014,
          0.5237723301762227,
          null,
        ],
        2: [
          0.2794043490635928,
          0.27942818570338496,
          0.29627061834820484,
          0.34100234863650986,
          0.4036279200648896,
          0.5238762415229996,
          null,
        ],
        3: [
          0.3123386049740053,
          0.3123755556412746,
          0.3124404090924192,
          0.34111820291826733,
          0.40381931630505496,
          0.5238762415229996,
          null,
        ],
        4: [
          0.3628162329297864,
          0.362877056777419,
          0.3629824398226792,
          0.36317736494678216,
          0.40417418734261845,
          0.5240689929645719,
          null,
        ],
        5: [
          0.4623597409866677,
          0.4624680217629398,
          0.4626436162674879,
          0.46297372007164256,
          0.46358419404495366,
          0.5240689929645719,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.25911658764092665,
          0.2671864867171426,
          0.2919290249420686,
          0.33586327159847046,
          0.39734971456121704,
          0.5203850674395952,
          null,
        ],
        1: [
          0.2606445574659293,
          0.2672025547588287,
          0.29195219479038437,
          0.3358983858495275,
          0.39740882016874296,
          0.5203850674395952,
          null,
        ],
        2: [
          0.27541545196671746,
          0.27543923554762306,
          0.2919928706443842,
          0.33596223263441793,
          0.397513579677527,
          0.5204886484033322,
          null,
        ],
        3: [
          0.3077873100688273,
          0.3078236582177175,
          0.3078862778516319,
          0.33608274227271584,
          0.39771003312896763,
          0.5204886484033322,
          null,
        ],
        4: [
          0.3574000646013481,
          0.35746107331580995,
          0.35756529455518704,
          0.3577570814486155,
          0.3980666066048391,
          0.5206753157918428,
          null,
        ],
        5: [
          0.45940152546342944,
          0.4595081545678601,
          0.45968473517130415,
          0.46001359360495053,
          0.46062322233677283,
          0.5206753157918428,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.25595508011635904,
          0.26390300075793116,
          0.28828118152985216,
          0.3315728381740999,
          0.3921593981638072,
          0.5175081948306177,
          null,
        ],
        1: [
          0.2574627748524946,
          0.2639191576583486,
          0.28830420624872055,
          0.3316090086250764,
          0.39221637466551246,
          0.5175081948306177,
          null,
        ],
        2: [
          0.27201310801113276,
          0.2720350304817496,
          0.28834589460688376,
          0.3316803141732928,
          0.3923261504459498,
          0.5176105479508639,
          null,
        ],
        3: [
          0.3039091173571708,
          0.303944870203692,
          0.3040060119943728,
          0.3317936894651548,
          0.3925229004268231,
          0.5176105479508639,
          null,
        ],
        4: [
          0.3527888148345195,
          0.3528502051999971,
          0.35295239457817623,
          0.35314308367100944,
          0.3928683070085759,
          0.5177964574675418,
          null,
        ],
        5: [
          0.4568827399084644,
          0.4569896481432594,
          0.45716529639516795,
          0.4574942596329712,
          0.4581020574254615,
          0.5177964574675418,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.254130921729109,
          0.2620021296960715,
          0.28616811532140957,
          0.3290879897070752,
          0.39082066277429633,
          null,
          null,
        ],
        1: [
          0.25562612937905993,
          0.26201804917918137,
          0.28619083375980275,
          0.3291235502815997,
          0.39087588712879384,
          null,
          null,
        ],
        2: [
          0.27003682382960004,
          0.2700589819513307,
          0.2862320222638154,
          0.32919360966019817,
          0.3909853705228449,
          null,
          null,
        ],
        3: [
          0.3016574496867572,
          0.3016925142110062,
          0.3017508404954578,
          0.3293075636293814,
          0.39118100334680517,
          null,
          null,
        ],
        4: [
          0.3515782921225145,
          0.3516388337594234,
          0.351741373639083,
          0.3519286739287788,
          0.39152735437592656,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.25283799204000057,
          0.26067150750353135,
          0.284688283160099,
          0.32734563421649454,
          0.38987569929968874,
          null,
          null,
        ],
        1: [
          0.2543126719619344,
          0.26068681381866465,
          0.28471084134175506,
          0.32737492045979544,
          0.38993736971411963,
          null,
          null,
        ],
        2: [
          0.26865744476936726,
          0.26868049925094983,
          0.2847509746107988,
          0.3274431406208481,
          0.3900397951016421,
          null,
          null,
        ],
        3: [
          0.3000784077203257,
          0.30011642466502486,
          0.3001768544339342,
          0.32755895709869876,
          0.39023438550935496,
          null,
          null,
        ],
        4: [
          0.35072190384715674,
          0.35078409068232225,
          0.3508879143262871,
          0.35107673823167673,
          0.3905827221303313,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.25178604327433274,
          0.2595735188855238,
          0.28345642929528325,
          0.3258809461121302,
          0.38908246809777436,
          null,
          null,
        ],
        1: [
          0.2532518352946491,
          0.2595893567514896,
          0.28347898174404695,
          0.3259085386557743,
          0.3891443960499711,
          null,
          null,
        ],
        2: [
          0.267516133673234,
          0.2675401649393674,
          0.28352017226504744,
          0.3259768834722847,
          0.38924634523298074,
          null,
          null,
        ],
        3: [
          0.2987631239274922,
          0.2988006476362737,
          0.2988624550963691,
          0.3260946289851414,
          0.3894399049339657,
          null,
          null,
        ],
        4: [
          0.3500076480125456,
          0.350069356882329,
          0.35017393429119625,
          0.35036273334260215,
          0.38979025967254477,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.2511790870223489,
          0.2589360989403467,
          0.28273298528263474,
          0.32499179712519743,
          0.388606276229236,
          null,
          null,
        ],
        1: [
          0.2526398056164798,
          0.25895223297045966,
          0.28275558592295164,
          0.3250339274395109,
          0.3886527657329212,
          null,
          null,
        ],
        2: [
          0.26685093407169125,
          0.26687514373413823,
          0.2827974643305576,
          0.32510293126095297,
          0.38876992868109483,
          null,
          null,
        ],
        3: [
          0.2979857119389811,
          0.29802342560402384,
          0.29808546839504235,
          0.3252214878260885,
          0.3889634468525367,
          null,
          null,
        ],
        4: [
          0.3495827742892682,
          0.3496445174290357,
          0.3497493482545257,
          0.3499381593055715,
          0.3893145668758359,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
    },
    5: {
      5: {
        0: [
          0.6928395569437407, 0.7074302134334182, 0.7519784685521369,
          0.8312279573922232, 0.9430915339344355, 1.1022267858614114,
          1.2772729542352508,
        ],
        1: [
          0.6950563955975728, 0.7074753704635299, 0.7518225410855592,
          0.8311706289534693, 0.94310279850331, 1.102279748145619,
          1.2772459687305202,
        ],
        2: [
          0.7219657891922239, 0.7217490334704628, 0.7519951264153923,
          0.8311553649580685, 0.9431026892044315, 1.1023547657038704,
          1.2775297367234442,
        ],
        3: [
          0.7821474518962492, 0.7821105439746626, 0.782247182321931,
          0.8313993755267917, 0.943348702493717, 1.1026193974069578,
          1.2778697029516892,
        ],
        4: [
          0.8695537429018375, 0.8698288028831318, 0.8699420633963562,
          0.8698951309222995, 0.9435442216881171, 1.103003024832693,
          1.2784431769938247,
        ],
        5: [
          0.9992621072155914, 0.9992327789614404, 0.9995999713263076,
          0.9997563580362446, 1.0000014084776059, 1.103654605217847,
          1.2795717047045452,
        ],
        6: [
          1.1720994131956355, 1.172170565617765, 1.172461197930065,
          1.1727658184113705, 1.173339274033129, 1.174410507477951,
          1.281366647013742,
        ],
      },
      6: {
        0: [
          0.42256765299396915, 0.43151454507551157, 0.45882784467770976,
          0.5071485032918268, 0.574257347862037, 0.671330158666051,
          0.778064503267907,
        ],
        1: [
          0.4240604295311151, 0.43151014854575437, 0.4588359723480715,
          0.5071256315652842, 0.5742674114711788, 0.671330158666051,
          0.778064503267907,
        ],
        2: [
          0.4403663036265225, 0.4403878586056828, 0.45884522367700703,
          0.5071831030495495, 0.5742882633603079, 0.6713650096297905,
          0.778088084787942,
        ],
        3: [
          0.47612066393128005, 0.4761233808792918, 0.47616476432424854,
          0.5072407873407235, 0.5744097804259778, 0.6713650096297905,
          0.778088084787942,
        ],
        4: [
          0.5308645031247907, 0.5308905479671872, 0.530936963021282,
          0.53102474277839, 0.574574608940779, 0.67142714471798,
          0.7782343954886795,
        ],
        5: [
          0.6098392222618978, 0.6098990023587596, 0.6099683886584986,
          0.6101162470731827, 0.6103907837166687, 0.67142714471798,
          0.7782343954886795,
        ],
        6: [
          0.7139192350344963, 0.7139786822151563, 0.7141082971024921,
          0.7143334853236836, 0.7147719813733242, 0.6715862115555293,
          0.7784709552123511,
        ],
      },
      7: {
        0: [
          0.3519761594013713, 0.3594454905703869, 0.3821427022129922,
          0.42230393739807703, 0.47805740611355974, 0.5587272318662776,
          0.6474193123287784,
        ],
        1: [
          0.3532048419458328, 0.35945491844690575, 0.3821567176365194,
          0.4223175583476867, 0.47809304304406874, 0.5587272318662776,
          0.6474193123287784,
        ],
        2: [
          0.36681683531639603, 0.36684301485094084, 0.3821752738363116,
          0.4223618900023295, 0.4781410641434517, 0.5587689144069947,
          0.6474761803398636,
        ],
        3: [
          0.3965079019773199, 0.3965417463018718, 0.39657137588896985,
          0.4223952218270421, 0.47823286750931804, 0.5587689144069947,
          0.6474761803398636,
        ],
        4: [
          0.4420167031420571, 0.4420461920021398, 0.4420867342714559,
          0.442159226042053, 0.47835800967360564, 0.5588379694121032,
          0.6476003145483933,
        ],
        5: [
          0.5076582307333692, 0.5077143598896795, 0.5077703696206919,
          0.5078930573224635, 0.508115899152169, 0.5588379694121032,
          0.6476003145483933,
        ],
        6: [
          0.5941164305823459, 0.5942054293988803, 0.5943159029909337,
          0.5945017363510562, 0.5948631801397375, 0.558974397371288,
          0.647788158135308,
        ],
      },
      8: {
        0: [
          0.3109870678502657, 0.31749176014008185, 0.33744446766030783,
          0.3727492377738466, 0.42178595825526244, 0.49266632400566346,
          0.5706265109920907,
        ],
        1: [
          0.31205881813055936, 0.3175013650561331, 0.3374495112222814,
          0.37277829143141294, 0.42179907010471457, 0.49266632400566346,
          0.5706265109920907,
        ],
        2: [
          0.3239867051395495, 0.3239860141713723, 0.3374720287797498,
          0.37280774437420383, 0.4218569904485123, 0.49269607793750514,
          0.5706944190461276,
        ],
        3: [
          0.35008271898508986, 0.3501084159545348, 0.35011751683158243,
          0.37283321347852477, 0.4219161042303823, 0.49269607793750514,
          0.5706944190461276,
        ],
        4: [
          0.3900720770753663, 0.3900955540359302, 0.3901300716428363,
          0.39020452160692903, 0.42204575107843567, 0.4927672000931179,
          0.5707971956027792,
        ],
        5: [
          0.447794193429521, 0.44781586219238373, 0.4478733111262764,
          0.44799465712922937, 0.44821754349832055, 0.4927672000931179,
          0.5707971956027792,
        ],
        6: [
          0.5237911098115541, 0.5238593672358435, 0.5239342298471327,
          0.5241174606154958, 0.524452877791354, 0.4928845716623046,
          0.570935295819925,
        ],
      },
      9: {
        0: [
          0.27921317413067803, 0.2850332670097274, 0.30281337542749553,
          0.3343151724829634, 0.37801089291837986, 0.4411894728941072,
          0.5107025757905226,
        ],
        1: [
          0.28019565611008934, 0.28503744654957686, 0.30282594485279823,
          0.33431326830338826, 0.37804091262261696, 0.4411894728941072,
          0.5107025757905226,
        ],
        2: [
          0.29081069006056043, 0.2908141136109329, 0.30283603361263606,
          0.33433314242191753, 0.3780612327074959, 0.44122603285321693,
          0.5107357140258804,
        ],
        3: [
          0.31408114298218387, 0.3140951769696584, 0.3141121887321773,
          0.33439365220359835, 0.37813816839001013, 0.44122603285321693,
          0.5107357140258804,
        ],
        4: [
          0.34973108360735095, 0.34975162590266506, 0.34978640614175327,
          0.3498565482734473, 0.3782742866652573, 0.4412777672145559,
          0.5108199473790903,
        ],
        5: [
          0.4011758298307363, 0.4017628637669851, 0.4012652258762107,
          0.40193251079520115, 0.4015844858644061, 0.4412777672145559,
          0.5108199473790903,
        ],
        6: [
          0.46892313825735643, 0.4689748946659372, 0.46961550475432695,
          0.4692321041820141, 0.47009755623803057, 0.4413948135367357,
          0.5110108999399172,
        ],
      },
      10: {
        0: [
          0.26428489566994917, 0.26975673736272454, 0.2865004391955913,
          0.3161694711457391, 0.3573168843115905, 0.41678240795769816,
          0.4822351368253561,
        ],
        1: [
          0.2652120498889249, 0.26976139790084885, 0.28651078310491085,
          0.3161734384115693, 0.3573409372460348, 0.41678240795769816,
          0.4822351368253561,
        ],
        2: [
          0.27520308796844095, 0.27521096807750733, 0.28652289048199786,
          0.31619524511996444, 0.3573683852438848, 0.4168159595423614,
          0.48227286345631415,
        ],
        3: [
          0.29711785167220084, 0.2971309513006927, 0.29715198837623497,
          0.31624306695671034, 0.3574404388443315, 0.4168159595423614,
          0.48227286345631415,
        ],
        4: [
          0.3306780142260159, 0.33069856801774866, 0.3307334665236995,
          0.3308028756665919, 0.3575617648605802, 0.4168702397958254,
          0.4823577486535927,
        ],
        5: [
          0.3796281265613426, 0.37966141240423434, 0.37971784081194426,
          0.3798290821424196, 0.3800319107247926, 0.4168702397958254,
          0.4823577486535927,
        ],
        6: [
          0.4434113264721954, 0.4434610535249814, 0.4435446814385381,
          0.4437117693878541, 0.4440166862265666, 0.416984142566886,
          0.4825311404003324,
        ],
      },
      11: {
        0: [
          0.25442916206488536,
          0.25963404701071313,
          0.27567451378941193,
          0.3040902262240355,
          0.3435198124181722,
          0.40934259367487086,
          null,
        ],
        1: [
          0.2553149591440523,
          0.25963658962183844,
          0.27567902238036124,
          0.3040963640679509,
          0.34352756929725947,
          0.40934259367487086,
          null,
        ],
        2: [
          0.2648532245950519,
          0.2648678518520804,
          0.2756923829595147,
          0.3041193413421301,
          0.3435590095125738,
          0.40936777966838833,
          null,
        ],
        3: [
          0.28585050677106355,
          0.2858565945119002,
          0.2858851679170954,
          0.3041612000097852,
          0.343628825886676,
          0.40936777966838833,
          null,
        ],
        4: [
          0.3179842952639267,
          0.3180041498511904,
          0.318039807761929,
          0.31810677335205567,
          0.34375328486736434,
          0.40942373501603624,
          null,
        ],
        5: [
          0.3728730198326853,
          0.3729049025683574,
          0.37296267903185987,
          0.37307270013262195,
          0.3732745222907866,
          0.40942373501603624,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.2459256735230325,
          0.2509370009702066,
          0.26637170589056264,
          0.2937202778164381,
          0.33166680874090093,
          0.40295433671516767,
          null,
        ],
        1: [
          0.24677802787558278,
          0.25093879804600805,
          0.26637661458043194,
          0.2937235288261293,
          0.3316753956680837,
          0.40295433671516767,
          null,
        ],
        2: [
          0.2559555557297859,
          0.2559722698561972,
          0.26638919315199394,
          0.29375161532544547,
          0.3317060424065569,
          0.4029805400105074,
          null,
        ],
        3: [
          0.2761633620342743,
          0.2761667881580508,
          0.2761993591302176,
          0.2937927714851488,
          0.33178018198032877,
          0.4029805400105074,
          null,
        ],
        4: [
          0.30708494992878105,
          0.3071043241315221,
          0.3071410503887142,
          0.30720879669887574,
          0.33190449345544826,
          0.4030350673342564,
          null,
        ],
        5: [
          0.3670742038619901,
          0.36710550603782166,
          0.36716341261098856,
          0.36727409848677506,
          0.3674755990137879,
          0.4030350673342564,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.24127831817318918,
          0.24617404579128957,
          0.26125736827961243,
          0.28798901190425374,
          0.3250774632927871,
          0.39939169048191137,
          null,
        ],
        1: [
          0.2421127332159466,
          0.24617740008901623,
          0.26126297149920236,
          0.2879962848699938,
          0.3250889980469013,
          0.39939169048191137,
          null,
        ],
        2: [
          0.25108361856425215,
          0.25109275623182115,
          0.2612766777312443,
          0.2880225980322119,
          0.3251225460370796,
          0.3994184127686605,
          null,
        ],
        3: [
          0.27082858507784424,
          0.27083469376204117,
          0.27086014175053325,
          0.2880662429346314,
          0.32519556161955,
          0.3994184127686605,
          null,
        ],
        4: [
          0.3010455485866631,
          0.30106450386599515,
          0.30110044397283625,
          0.30116763645812394,
          0.3253164669491516,
          0.3994746768309517,
          null,
        ],
        5: [
          0.3638515908617562,
          0.3638834735285663,
          0.3639403883954553,
          0.3640517931683007,
          0.3642510526689312,
          0.3994746768309517,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.23794498321929536,
          0.24275489113070875,
          0.25757919074098984,
          0.2838571484946628,
          0.32031237605356516,
          0.39681059284505554,
          null,
        ],
        1: [
          0.2387663878177168,
          0.24275895061606995,
          0.2575851535153981,
          0.2838662366248538,
          0.32032546895301695,
          0.39681059284505554,
          null,
        ],
        2: [
          0.24758300862618915,
          0.247591027282999,
          0.25759938350493744,
          0.2838925094719754,
          0.3203605630941831,
          0.396837704495803,
          null,
        ],
        3: [
          0.26698770433220054,
          0.26699564801633807,
          0.26701995290632313,
          0.28393513247114166,
          0.32043254474202065,
          0.396837704495803,
          null,
        ],
        4: [
          0.29668574435850925,
          0.2967048233932904,
          0.2967406413877298,
          0.29680756822821613,
          0.32055384431009726,
          0.39689476437200377,
          null,
        ],
        5: [
          0.3615223125298911,
          0.3615544736687273,
          0.36161073066419114,
          0.3617227338184753,
          0.3619211541478179,
          0.39689476437200377,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.23509603199863266,
          0.23983352255975465,
          0.25443811712369013,
          0.28033185743269406,
          0.31625071886182093,
          0.39461155777198675,
          null,
        ],
        1: [
          0.2359066467192745,
          0.23984029963717968,
          0.25444493739768953,
          0.2803484287506277,
          0.3162678187611264,
          0.39461155777198675,
          null,
        ],
        2: [
          0.24459211493317634,
          0.24459929898556682,
          0.2544612426190053,
          0.2803697283566774,
          0.3163077780567797,
          0.394638982667996,
          null,
        ],
        3: [
          0.2637085711955037,
          0.26371758628786934,
          0.26373895422055593,
          0.28040858505598815,
          0.31637249481749785,
          0.394638982667996,
          null,
        ],
        4: [
          0.29296758089188074,
          0.29298668485651547,
          0.29302097920212167,
          0.2930868265892741,
          0.3164880491501838,
          0.3946992452774656,
          null,
        ],
        5: [
          0.35953724865817654,
          0.3595695539685716,
          0.3596254756120749,
          0.3597363185106413,
          0.3599353922643379,
          0.3946992452774656,
          null,
        ],
        6: [null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.23346729349208206,
          0.2381585300327075,
          0.2526262974201544,
          0.2782813896352556,
          0.31516360481759104,
          null,
          null,
        ],
        1: [
          0.234272563987155,
          0.2381644871273041,
          0.252633022506909,
          0.2782954696370652,
          0.3151810322337605,
          null,
          null,
        ],
        2: [
          0.242880795857856,
          0.24288247163614146,
          0.2526487638212561,
          0.27832054844852955,
          0.31521847612848397,
          null,
          null,
        ],
        3: [
          0.26181267666726415,
          0.2618275684067337,
          0.26184165637892864,
          0.2783625846967751,
          0.3152871779288534,
          null,
          null,
        ],
        4: [
          0.2919604403466956,
          0.2919810388389409,
          0.29201382905154794,
          0.29207975162934513,
          0.3154055989809614,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.23230511495808565,
          0.23696140773379887,
          0.25134589204022745,
          0.2768531304903219,
          0.31440926352725307,
          null,
          null,
        ],
        1: [
          0.23310467935053816,
          0.2369669211701238,
          0.251352525500359,
          0.2768657715791738,
          0.31442666284061943,
          null,
          null,
        ],
        2: [
          0.24164969375375733,
          0.24165245213949846,
          0.2513679320238032,
          0.2768933679584593,
          0.31446270536027376,
          null,
          null,
        ],
        3: [
          0.26047375899588965,
          0.2604872451574233,
          0.26050269337841103,
          0.2769269939736802,
          0.31453407861269755,
          null,
          null,
        ],
        4: [
          0.29125958552296477,
          0.2912798747126689,
          0.29131277568232994,
          0.29137860214054523,
          0.31464394890049285,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.23135636688968048,
          0.2359953289105005,
          0.2503010177671908,
          0.2756719894305297,
          0.3137841421570956,
          null,
          null,
        ],
        1: [
          0.23214846624641594,
          0.23600047178253375,
          0.2503075292011626,
          0.2756838227209433,
          0.31380168718652035,
          null,
          null,
        ],
        2: [
          0.2406576447179801,
          0.2406605171704721,
          0.25032277928013463,
          0.27571345807991077,
          0.31383688772770746,
          null,
          null,
        ],
        3: [
          0.2593791909408985,
          0.25939186230792877,
          0.259407836111899,
          0.27574544476275503,
          0.3139103637612401,
          null,
          null,
        ],
        4: [
          0.29067813209321147,
          0.290698181434338,
          0.29073131695771864,
          0.290797312225507,
          0.3140184405593897,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.23082446728084471,
          0.23544591671256115,
          0.24969911916593546,
          0.27497925676169654,
          0.31341468060921884,
          null,
          null,
        ],
        1: [
          0.23161417091043265,
          0.23545101701461496,
          0.24970565315895615,
          0.274990817264672,
          0.3134324279484557,
          null,
          null,
        ],
        2: [
          0.2400910488077757,
          0.24009452251631186,
          0.24972089060292418,
          0.2750212360035082,
          0.3134673406011661,
          null,
          null,
        ],
        3: [
          0.25874454723521445,
          0.2587568538487854,
          0.25877363171192125,
          0.2750527794647102,
          0.31354161271824177,
          null,
          null,
        ],
        4: [
          0.29033815388652373,
          0.290358111618805,
          0.2903914090598714,
          0.2904574561245692,
          0.31364915158164197,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null],
      },
    },
    6: {
      5: {
        0: [
          0.7055937673674533, 0.7216798710600911, 0.7683590434024232,
          0.8487776243991164, 0.9713284501491939, 1.1580275835923346,
          1.401730671990149, 1.7121580604003306, 2.219932554152186,
          2.8779526370623314,
        ],
        1: [
          0.7081591815077902, 0.7217729906413963, 0.7660291139999819,
          0.8516252210148809, 0.971383411861257, 1.1581595533760205,
          1.401890199027262, 1.7127203502401311, 2.2204568639876037,
          2.8786056144892003,
        ],
        2: [
          0.736718514931059, 0.7367619004327015, 0.7659704420473928,
          0.8492309225510544, 0.9717174754570042, 1.1584279494566379,
          1.4022628523908927, 1.7130933083364757, 2.221439672068665,
          2.880020186485175,
        ],
        3: [
          0.7978785256427362, 0.7979809141930196, 0.7980417682807015,
          0.8491633286526292, 0.971765901298091, 1.1586949382625917,
          1.4027579784583954, 1.7139938270016009, 2.2227352914847107,
          2.8821236425750834,
        ],
        4: [
          0.8937971454950906, 0.8938726708892004, 0.8939780881750168,
          0.894169324955798, 0.9721676320945905, 1.1593398268135915,
          1.4037992054287738, 1.7155039029616619, 2.2253859202375734,
          2.8863343645181443,
        ],
        5: [
          1.0376008026148253, 1.0377140235204507, 1.0379101429373505,
          1.0382196396025913, 1.0388059680742427, 1.1604764665917329,
          1.4056502649272251, 1.7187616172382765, 2.2301947416795196,
          2.8938671147463335,
        ],
        6: [
          1.2472164780112516, 1.2474753135017536, 1.2477822226668225,
          1.2483221414075492, 1.2493455840475176, 1.251231123106257,
          1.4085581455021299, 1.7234981659388113, 2.2380816304758078,
          2.905817886275784,
        ],
        7: [
          1.5089501905135436, 1.5093061989338037, 1.509784594011205,
          1.5106605895657508, 1.5123536485037046, 1.5153525278809252,
          1.5200623174986148, 1.7311032269345363, 2.250238831258401,
          2.924516544665778,
        ],
        8: [
          1.8880031083990092, 1.8884849787094633, 1.8892427686115938,
          1.8906248200692304, 1.8932661312865544, 1.8980833307802156,
          1.9056207253318633, 1.9174375175774159, 2.269489953394865,
          2.95431341619494,
        ],
        9: [
          2.5215241822742493, 2.5222452182459074, 2.5234264890350233,
          2.51652802396912, 2.520946606374472, 2.5289934083801624,
          2.541547375382719, 2.5611294271654916, 2.592031518816735,
          2.9922147590947974,
        ],
      },
      6: {
        0: [
          0.43037085284148485, 0.43928625002585897, 0.4677179483862172,
          0.5183326151407556, 0.5914852008834794, 0.7053743125679672,
          0.8540135256620268, 1.045628060793512, 1.3552037552014224,
          1.7543383938157011,
        ],
        1: [
          0.4321643602858396, 0.4393054191816502, 0.46774183688718807,
          0.5184115886037961, 0.5915178404855901, 0.7054325649988245,
          0.8541070758741705, 1.045786551011159, 1.3555325033097307,
          1.7547600792026132,
        ],
        2: [
          0.4484491788419418, 0.44847451532887966, 0.4677870403502262,
          0.5184117399370073, 0.5916233062975421, 0.7055622772976886,
          0.8543139489620972, 1.0461085823456184, 1.3560046439379332,
          1.7555979211217938,
        ],
        3: [
          0.48573546668825307, 0.48580674912759886, 0.48583336141529443,
          0.5185381944166955, 0.5917296229075912, 0.7057766012893413,
          0.8546644709650486, 1.0444526164458199, 1.3570024145731923,
          1.7570637432717868,
        ],
        4: [
          0.5442224636425574, 0.544272323600232, 0.5443329083437909,
          0.5444520271396105, 0.5920203253497629, 0.7062114771776136,
          0.8553599862983075, 1.0455712675379476, 1.3565655218851327,
          1.7599312884892813,
        ],
        5: [
          0.6332949383056232, 0.6333721301452446, 0.6334840638015042,
          0.633691840846318, 0.6341023906063386, 0.7069537645633606,
          0.8565645365599863, 1.047607832136065, 1.3597859710022178,
          1.764913289515003,
        ],
        6: [
          0.7611888253344024, 0.7612997518260605, 0.7614535246884,
          0.7618077507012508, 0.7625392808937445, 0.7637151522551151,
          0.8584766495777866, 1.050691381126355, 1.364916343804873,
          1.7727906207826019,
        ],
        7: [
          0.9193951433430455, 0.9196342979448656, 0.9199213649092857,
          0.9204582240529162, 0.9215829024683968, 0.9235718307487784,
          0.9266213061942521, 1.05564929380727, 1.3727672495204677,
          1.7851864451453139,
        ],
        8: [
          1.1506299130459028, 1.150948964233875, 1.1514185309159246,
          1.1523313494023402, 1.1541006080627287, 1.1572304561396543,
          1.1621379233376288, 1.16992806620666, 1.3854067295326637,
          1.804717693538637,
        ],
        9: [
          1.537076043435881, 1.5375538372900635, 1.5383100847516662,
          1.5397361396040146, 1.5425186938501907, 1.5474183180802838,
          1.5551422279819116, 1.5673720497335584, 1.5835980927875708,
          1.8348458906266738,
        ],
      },
      7: {
        0: [
          0.35851258946594233, 0.36592883864734693, 0.38956291191092807,
          0.43165562718530937, 0.49243612655967084, 0.5870457691870229,
          0.7105507762954854, 0.8697708123957798, 1.1270450626139104,
          1.4587001475871775,
        ],
        1: [
          0.3599887105966075, 0.365947031976023, 0.38957834737098435,
          0.4316997256333847, 0.4924814949563652, 0.5871108305252961,
          0.7106477580136512, 0.8699218713748136, 1.1273147765718663,
          1.4590994027445054,
        ],
        2: [
          0.3735173748048357, 0.3735191714989742, 0.3896107682875147,
          0.4317314238889322, 0.492563563509544, 0.5872240460014739,
          0.7108260719713502, 0.8702021687578857, 1.127759381873334,
          1.459830268950753,
        ],
        3: [
          0.40452103613946705, 0.4045557391673513, 0.4045755403803408,
          0.4317879518989358, 0.49266411012989975, 0.587408400157315,
          0.7111362443904761, 0.8707083544180843, 1.1285936027485106,
          1.46114252362599,
        ],
        4: [
          0.4531162495187028, 0.4531519774768684, 0.453209514506005,
          0.4533198959995828, 0.4928728625995536, 0.587771423947511,
          0.7117313514313524, 0.8716699789913562, 1.1301794936405567,
          1.4636141002959846,
        ],
        5: [
          0.527133272184336, 0.527195095169535, 0.5272938486441386,
          0.5274828263538465, 0.5278427191265447, 0.5884150321370858,
          0.712780872475306, 0.8733584883348062, 1.1329359017276899,
          1.467955916442436,
        ],
        6: [
          0.6333979981159297, 0.6334773820784123, 0.6336544516663276,
          0.6339518851447521, 0.634577961390381, 0.6356037538831034,
          0.7144273521100257, 0.8760164268651762, 1.1372815381564123,
          1.4747863041194351,
        ],
        7: [
          0.7648849694184694, 0.765057711129041, 0.7653134067433363,
          0.7658224120032551, 0.766786026259679, 0.768504033734945,
          0.7711491396059962, 0.8802235664643454, 1.1441738323552961,
          1.4855763639474047,
        ],
        8: [
          0.9570302447708441, 0.9572915377724884, 0.9577193661552038,
          0.958526598155432, 0.960068676084942, 0.9627877000763537,
          0.9670608834195288, 0.9738316956363791, 1.1550160769263296,
          1.5026322745524352,
        ],
        9: [
          1.2781571784880454, 1.27856229666444, 1.2792434123763885,
          1.2805108351761225, 1.2829371499714919, 1.2872094833110126,
          1.2939364568388254, 1.3045960912288557, 1.321470168837127,
          1.5288533301888045,
        ],
      },
      8: {
        0: [
          0.3166711600510567, 0.32319251026650675, 0.3439595123414703,
          0.381571974289819, 0.43501321259338466, 0.5175577724873415,
          0.6261108181971813, 0.766052950339168, 0.9922188847372506,
          1.283735340911051,
        ],
        1: [
          0.3179591438088258, 0.32319907265415904, 0.3439775831135441,
          0.3815914767960927, 0.43503596672179656, 0.517615205830106,
          0.6261979357411849, 0.7661930887970496, 0.9924268448709596,
          1.2841017618701551,
        ],
        2: [
          0.3298438505686439, 0.3298768377407255, 0.3439930477162949,
          0.3816241911423187, 0.4350918438947865, 0.5177024168045488,
          0.6263513569949, 0.7664449868359979, 0.9928431795415477,
          1.284739801494725,
        ],
        3: [
          0.3571061065175462, 0.3571321121926951, 0.3571808310868476,
          0.3816880243994175, 0.4352034206720909, 0.5178826439491637,
          0.6266444205709957, 0.7669153724783805, 0.9936244602031621,
          1.2859540019086744,
        ],
        4: [
          0.3998211964024955, 0.3998578905200856, 0.3999140866424057,
          0.40001268398145845, 0.43539422142828654, 0.5182198456363447,
          0.6271937382419416, 0.7678023713668333, 0.9950650401022972,
          1.2882400941168943,
        ],
        5: [
          0.4648820948888017, 0.4649370022867178, 0.4650350226221728,
          0.4652055655653643, 0.4655372638667428, 0.5187908018434058,
          0.6281451850239715, 0.7693417106325583, 0.9976029879801787,
          1.2922109431844226,
        ],
        6: [
          0.5582840011596535, 0.5583694726262259, 0.5585315648823569,
          0.5587914986855553, 0.5593714469431335, 0.5603358740085311,
          0.6296458087318915, 0.7717718161090511, 1.001550719117777,
          1.2984702115806042,
        ],
        7: [
          0.6738712872381053, 0.6740190215051516, 0.674267746227708,
          0.674736446674608, 0.6756031310730024, 0.6771880593861195,
          0.6796435866423831, 0.7756203681529046, 1.007855810476532,
          1.308312619105234,
        ],
        8: [
          0.8427517971942211, 0.8429869762213618, 0.8433871017053469,
          0.8441341381532116, 0.8455509934078822, 0.8480338514494111,
          0.8519530792348304, 0.8581523634822297, 1.0177729627703629,
          1.323900899936881,
        ],
        9: [
          1.12501261326218, 1.1253829968780655, 1.1260148235147307,
          1.1271934715470906, 1.1294225729589256, 1.1333276549388365,
          1.1394859249572593, 1.1492432097643464, 1.164658899462163,
          1.347907626659905,
        ],
      },
      9: {
        0: [
          0.28429547129648663, 0.29011203960915094, 0.30862803017672635,
          0.3421539364528571, 0.3897888840574184, 0.4633752440777847,
          0.5601393999237079, 0.6848846647862907, 0.8877956030324148,
          1.147630532142468,
        ],
        1: [
          0.28544507640528083, 0.2901143847856815, 0.3086350238998472,
          0.3421698665948044, 0.3898123560654686, 0.4634164779988445,
          0.5602141159885519, 0.6850094239814708, 0.8879971773373043,
          1.147948679773589,
        ],
        2: [
          0.29603491203554877, 0.2960577282988728, 0.30865385782536386,
          0.34220160227160634, 0.38987308630900663, 0.46350457343628726,
          0.5603597511880629, 0.6852438086399151, 0.88837317099502,
          1.1485700038770745,
        ],
        3: [
          0.32034566498953587, 0.32035386539342675, 0.3203987879439266,
          0.34226130805987126, 0.38996560369405164, 0.46367469018124874,
          0.5606314438238338, 0.685679908423579, 0.8890672620604203,
          1.1496782371819472,
        ],
        4: [
          0.3584236765013227, 0.358453555464178, 0.3585070533334651,
          0.35860135078086763, 0.3901497936529589, 0.4639779324948142,
          0.5611345989636889, 0.6864937781018348, 0.8903664587163134,
          1.1517505803065315,
        ],
        5: [
          0.4164293865424804, 0.41647860498167927, 0.4165676254131695,
          0.4167276712349999, 0.4170331397082788, 0.46451900391732975,
          0.5620106903175657, 0.6879065898318415, 0.8913384422173881,
          1.1553609353962975,
        ],
        6: [
          0.49967507502993835, 0.4997769164919659, 0.49991435099508835,
          0.500182951910414, 0.5006879217801314, 0.5015664401966637,
          0.5633956264169442, 0.6901346149951406, 0.8949881720799451,
          1.1597669846001373,
        ],
        7: [
          0.6027119275943558, 0.602839543058247, 0.6030880008466595,
          0.6035133716119292, 0.6043335408736278, 0.6057546801389022,
          0.6080027189888393, 0.693660131115975, 0.9007697751027262,
          1.168827375575176,
        ],
        8: [
          0.753241268673092, 0.7534551144234052, 0.7538325475062451,
          0.7545183722421065, 0.7558242348290011, 0.7580940349276234,
          0.7616792236761197, 0.76736116240069, 0.9098311771552996,
          1.18312226452396,
        ],
        9: [
          1.0048429200846107, 1.0051846661759427, 1.0057725168202565,
          1.0068566166272868, 1.0089133184238248, 1.0124914016221074,
          1.018138569114286, 1.027083476037847, 1.041215356526049,
          1.2051435653169373,
        ],
      },
      10: {
        0: [
          0.2690630955473352, 0.2745402648977209, 0.2919756216609471,
          0.3235413092819338, 0.36839218794055445, 0.43767030599748313,
          0.5287700320415974, 0.6462148021514136, 0.8372402633619873,
          1.0818812656518426,
        ],
        1: [
          0.27015000440228165, 0.2745472301221391, 0.2919850742215414,
          0.32355773295070966, 0.3684202073144013, 0.4377153925975391,
          0.5288459011644134, 0.6463378842593328, 0.8374373894613529,
          1.0821988879535798,
        ],
        2: [
          0.2801401507604893, 0.2801461102893491, 0.2920057967338038,
          0.3235889924730676, 0.3684742901664573, 0.4378037774991409,
          0.5289891050423818, 0.6465676445274579, 0.8378036468246104,
          1.0827871309568455,
        ],
        3: [
          0.3030219986139078, 0.30304016181877436, 0.3030669154530783,
          0.32364686019524447, 0.3685717840470189, 0.4379679319122172,
          0.5292542855694986, 0.6469926417798786, 0.8384789977957345,
          1.0838667009351988,
        ],
        4: [
          0.3388649711417977, 0.33889339113276234, 0.33894431620870297,
          0.33903850092384047, 0.3687551675767773, 0.43827111277679753,
          0.5297461770596635, 0.6477838028386734, 0.839741075983508,
          1.0858916973827006,
        ],
        5: [
          0.3934697248633452, 0.3935186671887875, 0.39360299246413516,
          0.3937618296445897, 0.3940570921442219, 0.4387844701167554,
          0.5305888251555184, 0.6491473231628334, 0.8407689461895416,
          1.0893745986736314,
        ],
        6: [
          0.4718785146844188, 0.47195262254893, 0.47210616953176265,
          0.4723563397171643, 0.4728607928890614, 0.473692319486094,
          0.5319176954911099, 0.6512963740822681, 0.8443148329135985,
          1.0937220394757896,
        ],
        7: [
          0.5688854656548707, 0.5690167034709592, 0.5692417784980703,
          0.5696720443389462, 0.5704613241166057, 0.5718391505885339,
          0.5739901908261598, 0.6547054953590408, 0.8498589148292948,
          1.1025011669749563,
        ],
        8: [
          0.7105834036744078, 0.7107927567478581, 0.711153475379692,
          0.7118282227907575, 0.7130918376236244, 0.7152860508300827,
          0.7187467340858484, 0.724230294908266, 0.8586282082351033,
          1.1162682113734128,
        ],
        9: [
          0.9474487130102622, 0.9477791732167529, 0.948349377783922,
          0.949414281787834, 0.9514042844157248, 0.9548605018810727,
          0.9603236857514137, 0.9689708543408133, 0.9826217786275021,
          1.1375803674353968,
        ],
      },
      11: {
        0: [
          0.2589643334283379,
          0.2642109331392614,
          0.28091343389790635,
          0.31114466153285647,
          0.35410251499451906,
          0.4299413322530709,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2600090534576578,
          0.2642243031385341,
          0.2809203624804111,
          0.3111608970604608,
          0.3541421760578256,
          0.4299802517343179,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2695808253266243,
          0.2695816376100704,
          0.28095043475371795,
          0.3111940758640008,
          0.354198499224891,
          0.4300808320856037,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.29149836787570316,
          0.29151542086824567,
          0.2915361027313987,
          0.3112514206782019,
          0.35429177177718696,
          0.43024634730815825,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.3258262934180024,
          0.32585344020077034,
          0.3259022881534991,
          0.32599612768921227,
          0.3544590753236194,
          0.4305454057364612,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.38650935188194024,
          0.38655778860011036,
          0.3866407964520065,
          0.38679884545575743,
          0.3870949445334632,
          0.4310432889519476,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      12: {
        0: [
          0.25029617125938824,
          0.25534728017870584,
          0.27141575209860735,
          0.30050443535084903,
          0.3418586485653585,
          0.4233169337616264,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.25129949280928915,
          0.25535797334345045,
          0.2714257001416054,
          0.30052087906188407,
          0.34189129555226105,
          0.42336166915338863,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.26051340068966533,
          0.26052319852179706,
          0.27144899855697713,
          0.3005519405111153,
          0.34193942299704483,
          0.42345480901397203,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.28160328000598545,
          0.28162266649320217,
          0.28165097835420183,
          0.3006073384332322,
          0.3420300705163277,
          0.42361287384651836,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.31463374589002396,
          0.3146622452724584,
          0.31471161785871704,
          0.31480195821535695,
          0.34220386229376276,
          0.4239100969143832,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.3805362799605724,
          0.38058439404027566,
          0.38066862292800385,
          0.3808268233173292,
          0.3811191415686176,
          0.42441504345678593,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      13: {
        0: [
          0.2455525619555935,
          0.250492810879495,
          0.26618994883121044,
          0.29461491578640786,
          0.33504633318821875,
          0.41961701406392704,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2465287275561832,
          0.25050457966004147,
          0.2662062267370018,
          0.29463262145488717,
          0.33507519957017995,
          0.41967131101603794,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.25553878356566584,
          0.25555012414553246,
          0.26622656774691533,
          0.2946631453874781,
          0.33511699004319984,
          0.4197599049350911,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.2761387334189944,
          0.276171821021841,
          0.27619784710203493,
          0.29471817639561715,
          0.3352082567216849,
          0.4199119892358426,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.3084229062986158,
          0.3084539188578985,
          0.308503372416869,
          0.30859286761087296,
          0.3353805463807304,
          0.4202096076752928,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.37721166376365745,
          0.37726201011134786,
          0.3773456044284911,
          0.37750451500036764,
          0.3777949915524714,
          0.42071377191024373,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      14: {
        0: [
          0.24214042614583203,
          0.2469935700709393,
          0.2624215439355121,
          0.2903628428407763,
          0.3301047048608912,
          0.41692866716290833,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.24310201158085362,
          0.24700347907965903,
          0.262439552793061,
          0.29038079683055956,
          0.3301295453155037,
          0.41698599996546515,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.25195482284634607,
          0.2519729542202008,
          0.26245675031484544,
          0.290410759512274,
          0.3301806479780296,
          0.4170703022450294,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.27221019732320423,
          0.272233892939998,
          0.27226763699031054,
          0.2904671128536268,
          0.330274018454828,
          0.4172319995131595,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.30393749833767253,
          0.3039678539667343,
          0.304017345472691,
          0.3041079003592716,
          0.33044460069384085,
          0.4175315310451899,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.37480921434458486,
          0.37485740780105736,
          0.3749428244446048,
          0.3750993814527931,
          0.3753939736675236,
          0.4180329611654713,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      15: {
        0: [
          0.23922790176325753,
          0.24401000740039186,
          0.25921130406123605,
          0.28673802613982313,
          0.32589643992772055,
          0.41464747274764047,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2401763617411684,
          0.24401922380555502,
          0.25922605407504706,
          0.2867553715985061,
          0.3259230625331747,
          0.4147000657726416,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.24890021318691807,
          0.24890991493385267,
          0.25924551973376236,
          0.2867860732241553,
          0.32597790569053897,
          0.4147865214559761,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.2688573938565483,
          0.2688770488867849,
          0.26890479366726955,
          0.28684261234289715,
          0.3260675504127931,
          0.4149517584022582,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.3001137191015739,
          0.3001423740759177,
          0.3001915342208195,
          0.30028380111076014,
          0.3262399055318215,
          0.4152472080553087,
          null,
          null,
          null,
          null,
        ],
        5: [
          0.3727617654192392,
          0.37280942318368093,
          0.37289365042832345,
          0.37305138677037303,
          0.3733461384303143,
          0.41575090208509713,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      16: {
        0: [
          0.2375586554036822,
          0.24229691456949778,
          0.25735631939759274,
          0.28463622407008116,
          0.3247827267422494,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.2384985481335318,
          0.2423056747152072,
          0.2573700077390124,
          0.28465331131134075,
          0.3248092343446799,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.2471426918929121,
          0.24714394042708093,
          0.25739053994996103,
          0.2846844212538615,
          0.324864058908205,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.26691400592654235,
          0.26693094212229174,
          0.26695232791458456,
          0.2847412773370202,
          0.3249540077277845,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.2990800273083663,
          0.2991103609496829,
          0.29915600699791844,
          0.2992499719109861,
          0.32512589157619054,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      17: {
        0: [
          0.2363685062826395,
          0.2410758071689011,
          0.25604790416473133,
          0.2831675169021749,
          0.3240025542370828,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.23729925794517043,
          0.24108259469557675,
          0.2560641845574636,
          0.28318520246965206,
          0.324029429084558,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.24588417932091466,
          0.24589677688624456,
          0.25607918570465,
          0.28321477744954304,
          0.3240839293099882,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.2655441632058393,
          0.2655628133094294,
          0.26559332986302847,
          0.2832710905210993,
          0.32417341023933005,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.29836252694514576,
          0.2983914529802324,
          0.2984407344257905,
          0.29853223936402906,
          0.3243460364921925,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      18: {
        0: [
          0.23540295586864796,
          0.2400846726433975,
          0.25497697411053166,
          0.2819451049805758,
          0.3233508715648995,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.23633139493495714,
          0.24009245937810603,
          0.2549899675850337,
          0.2819621670528786,
          0.32337735005801455,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.24487029465580074,
          0.24488358304591695,
          0.2550087895065727,
          0.2819928877115774,
          0.32343229306486093,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.26442269479713765,
          0.26444088017887973,
          0.2644724696195411,
          0.28204953090243895,
          0.323521951220479,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.2977660330185231,
          0.29779394139371457,
          0.29784439478406766,
          0.29793602167712396,
          0.323694709700104,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      19: {
        0: [
          0.2348559817953,
          0.23952175824798982,
          0.2543587381101818,
          0.28122777678928784,
          0.32296618936909216,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          0.23578122885935715,
          0.2395293342637908,
          0.254371633029952,
          0.2812449047569663,
          0.32299269531438174,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          0.24429025613036592,
          0.24430371245615817,
          0.25439043868476074,
          0.28127578164050104,
          0.32304770669517396,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          0.26377093102471394,
          0.26378900562485197,
          0.26382099639697987,
          0.2813332948944262,
          0.3231375053538693,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          0.2974161231765164,
          0.2974434086410858,
          0.2974945952140098,
          0.29758637336915905,
          0.3233110220791344,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [null, null, null, null, null, null, null, null, null, null],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
    },
    7: {
      5: {
        0: [
          28.36513228509552,
          28.365245578503274,
          28.365464424772128,
          28.36585159023722,
          28.366438212751646,
          28.367121754775567,
          28.367042178346146,
          null,
          null,
          null,
        ],
        1: [
          28.365184835768336,
          28.36529705624486,
          28.365513884099038,
          28.365897828701932,
          28.366479824223433,
          28.36715830402344,
          28.3670782831747,
          null,
          null,
          null,
        ],
        2: [
          28.365410706435767,
          28.36552061321199,
          28.365734106921728,
          28.366110675959753,
          28.36668202734424,
          28.36734569032173,
          28.367246301025546,
          null,
          null,
          null,
        ],
        3: [
          28.365804232083143,
          28.36591036036687,
          28.366116561850344,
          28.36648697731899,
          28.367040228699118,
          28.367679102355005,
          28.367546805307864,
          null,
          null,
          null,
        ],
        4: [
          28.36639653715777,
          28.366496941709833,
          28.366692708199608,
          28.367045115340733,
          28.36760688037639,
          28.368207952684905,
          28.368025712309812,
          null,
          null,
          null,
        ],
        5: [
          28.367086498261067,
          28.367179210567592,
          28.36736049692896,
          28.367688350514165,
          28.36821241928459,
          28.368976507174764,
          28.3687242717153,
          null,
          null,
          null,
        ],
        6: [
          28.367018239470184,
          28.367100982019302,
          28.36726339636149,
          28.367558740910113,
          28.368033171501196,
          28.368727441794114,
          28.369692497608685,
          null,
          null,
          null,
        ],
        7: [
          0.6704652782086995, 0.6704763674940815, 0.6704975974654427,
          0.6705269960953091, 0.6705233310803631, 0.6705886523494493,
          0.670663157611912, 0.6801200124587692, 0.7097793203909676,
          0.7510015817423898,
        ],
        8: [
          0.6881140089462898, 0.6881429692971229, 0.6882265257275936,
          0.6883059177966788, 0.6880948674445014, 0.6883880383947669,
          0.6882739784747838, 0.6886079852751407, 0.7098344287903249,
          0.75130333563562,
        ],
        9: [
          0.7262940604000614, 0.7263335604110828, 0.7263949200925033,
          0.7265148317641327, 0.7265470236773738, 0.7264998667290062,
          0.7268769733133701, 0.7268612516165636, 0.7274932736217913,
          0.752071011377385,
        ],
      },
      6: {
        0: [
          26.57907311473,
          26.55563731979685,
          26.562351971744718,
          26.56199457082814,
          26.58186534395401,
          26.57581939134885,
          27.483853491279124,
          null,
          null,
          null,
        ],
        1: [
          26.5558498522015,
          26.560334024671754,
          26.538940586464978,
          26.545429579569703,
          26.544537164195233,
          26.543123170547204,
          27.454453297578425,
          null,
          null,
          null,
        ],
        2: [
          26.562342238199832,
          26.539143681360148,
          26.543498624217996,
          26.54513396947416,
          26.544251682964145,
          26.543172045346836,
          27.45454983506452,
          null,
          null,
          null,
        ],
        3: [
          26.545558007701775,
          26.545411975285305,
          26.545125693986073,
          26.544613694164845,
          26.54373200055099,
          26.543231787081474,
          27.454874673618164,
          null,
          null,
          null,
        ],
        4: [
          26.544653044537053,
          26.54451263825804,
          26.544236056154638,
          26.54372485319243,
          26.54342838949733,
          26.543277742315986,
          27.45539480008905,
          null,
          null,
          null,
        ],
        5: [
          26.54314366385058,
          26.543119102673174,
          26.543168326359357,
          26.54322994932729,
          26.54327645910385,
          26.54382173685577,
          27.456155957337593,
          null,
          null,
          null,
        ],
        6: [
          27.467874928137462,
          27.46782999076882,
          27.467855277415104,
          27.468001614472605,
          27.468252993323368,
          27.468634561747262,
          27.457212598407256,
          null,
          null,
          null,
        ],
        7: [
          0.4080471617990002, 0.4080535084750216, 0.4080581908326999,
          0.4080582119791709, 0.40810435246156485, 0.40814210913448223,
          0.40820879732120846, 0.4140793750893689, 0.43207027284385513,
          0.45732979018809783,
        ],
        8: [
          0.41999375616835555, 0.4200024634528598, 0.4200121746421631,
          0.42002144172273126, 0.4200554093237411, 0.4201467549347395,
          0.42023310967949495, 0.4203141311006561, 0.4322803195191488,
          0.45757940200046776,
        ],
        9: [
          0.4433015350316346, 0.4433158064821495, 0.44331982274523224,
          0.44336278821893305, 0.44343984220018534, 0.4435268870250094,
          0.4436825732245774, 0.4438160766367271, 0.4440785208072312,
          0.4580525584097441,
        ],
      },
      7: {
        0: [
          26.463155817553353,
          26.450647074589426,
          26.426290961519975,
          26.382349907857314,
          26.311527902951532,
          26.206383655800636,
          27.273178729329118,
          null,
          null,
          null,
        ],
        1: [
          26.42961979119729,
          26.417041105265103,
          26.392534280559676,
          26.3482098741943,
          26.276539939767943,
          26.169805873813853,
          27.240303616989433,
          null,
          null,
          null,
        ],
        2: [
          26.40416207239622,
          26.39176917597551,
          26.367581289194167,
          26.323791532997312,
          26.252740464203757,
          26.147038968658308,
          27.23280512401037,
          null,
          null,
          null,
        ],
        3: [
          26.358872211098827,
          26.346766827780055,
          26.32310490891648,
          26.279907795936523,
          26.210179905693565,
          26.106194852931488,
          27.21827084030441,
          null,
          null,
          null,
        ],
        4: [
          26.28630222243291,
          26.274528421787586,
          26.251474964536143,
          26.209592333714475,
          26.1416082848055,
          26.040260829720587,
          27.19322561539148,
          null,
          null,
          null,
        ],
        5: [
          26.17849296561714,
          26.167272617562276,
          26.145234387178654,
          26.105055666964358,
          26.039696463936682,
          25.941861839166403,
          27.15431700318695,
          null,
          null,
          null,
        ],
        6: [
          27.267484467927545,
          27.263336074730198,
          27.255268002549826,
          27.23961084568371,
          27.212760021029233,
          27.17120566456773,
          27.09745174534465,
          null,
          null,
          null,
        ],
        7: [
          0.3399508905397157, 0.3399590043085783, 0.339966804433477,
          0.3399804195481875, 0.34000297140342806, 0.34003997161478283,
          0.34010028997484687, 0.34498813348251967, 0.3599853734771443,
          0.380961029455118,
        ],
        8: [
          0.34987552900032903, 0.3498860043726764, 0.3498982728187706,
          0.34991634399910115, 0.349951609796475, 0.3500084555167854,
          0.3500967878765986, 0.3501809087943982, 0.360152377064484,
          0.38122112556709914,
        ],
        9: [
          0.36924112952757115, 0.3692592335510958, 0.3692937218198566,
          0.36931338128464586, 0.36934134564251375, 0.36948311485803076,
          0.36960309980603795, 0.3697058255780165, 0.37000430361363135,
          0.3823090703828289,
        ],
      },
      8: {
        0: [
          26.462526143692095,
          26.449987454754485,
          26.425572873250196,
          26.3815091511183,
          26.310462106243364,
          26.204941830838784,
          27.271109286664007,
          null,
          null,
          null,
        ],
        1: [
          26.429605326524133,
          26.417026741673507,
          26.39252033531295,
          26.34819641030593,
          26.276524970060642,
          26.169789023563073,
          27.240295087916692,
          null,
          null,
          null,
        ],
        2: [
          26.40414804477095,
          26.391755234731093,
          26.367567519503957,
          26.323776558719125,
          26.252725402151242,
          26.147022035624232,
          27.232796570138184,
          null,
          null,
          null,
        ],
        3: [
          26.358858742121086,
          26.34675336102303,
          26.32308993138827,
          26.279892782014198,
          26.21016317745205,
          26.1061778019361,
          27.21826224731919,
          null,
          null,
          null,
        ],
        4: [
          26.286287255330276,
          26.27451344028835,
          26.251459886545327,
          26.209575595358622,
          26.14159130949533,
          26.040492491952914,
          27.19321697937493,
          null,
          null,
          null,
        ],
        5: [
          26.17847612288128,
          26.16725573265169,
          26.145217425715135,
          26.105038595167077,
          26.039932390120075,
          25.94302237579139,
          27.154557183052944,
          null,
          null,
          null,
        ],
        6: [
          27.26748620556086,
          27.26333755079822,
          27.255268965303244,
          27.239610797637898,
          27.212758798622332,
          27.171787210642908,
          27.098620900064194,
          null,
          null,
          null,
        ],
        7: [
          0.30033925764111735, 0.3003521886737357, 0.300358121520053,
          0.30037481208950967, 0.30039876043062186, 0.30043547908535817,
          0.30048789667510023, 0.30481607511853775, 0.3179895809067597,
          0.3369882394483764,
        ],
        8: [
          0.3090698585462591, 0.3090775361834279, 0.3090991467657456,
          0.30910687747885496, 0.3091482275843823, 0.30920419836262136,
          0.3092844375482008, 0.309366504654202, 0.31816514266020657,
          0.3372422395069942,
        ],
        9: [
          0.3261020111924049, 0.32610396386859075, 0.3261500423506984,
          0.32617176196274533, 0.3262223761966815, 0.3263155071379721,
          0.32644089206478905, 0.32657426836091863, 0.32680575755134667,
          0.33769683390123195,
        ],
      },
      9: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          26.310459769689263,
          26.20493849100402,
          27.271109286664004,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          26.27652108727801,
          26.16978318062297,
          27.24029172824968,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          26.252721188741496,
          26.14701584041755,
          27.232793092649967,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279888952863963,
          26.210157981303162,
          26.106170959919233,
          27.218258537348014,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570385432706,
          26.141585031343645,
          26.040484691738843,
          27.193212858542694,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          26.039924575033755,
          25.94301333286587,
          27.15455252074961,
          null,
          null,
          null,
        ],
        6: [
          27.267488034542268,
          27.2633393507452,
          27.255270702619846,
          27.239612303811807,
          27.21275978561227,
          27.17178700715243,
          27.098615656968185,
          null,
          null,
          null,
        ],
        7: [
          0.26974449086069274, 0.26975386129238077, 0.2697648915216258,
          0.2697741596177491, 0.2697910527440762, 0.2698276111396555,
          0.2698749663943407, 0.2737388867871541, 0.28554654807185387,
          0.3024448304961673,
        ],
        8: [
          0.2775249111159655, 0.27753770817911266, 0.27754932070679705,
          0.277568310417623, 0.2775950067780538, 0.27764960134385863,
          0.2777234978067744, 0.2778002694477093, 0.2856549521273185,
          0.30267876193095655,
        ],
        9: [
          0.2927052217178296, 0.2927298630584603, 0.2927516722836326,
          0.29277323669049127, 0.29282333195046484, 0.29290964774270256,
          0.29302513031505334, 0.29314872978791817, 0.2933926566532282,
          0.30309854990137564,
        ],
      },
      10: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          26.310459769689263,
          26.20493849100402,
          27.271109286664004,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          26.27652108727801,
          26.16978318062297,
          27.24029172824968,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          26.252721188741496,
          26.14701584041755,
          27.232793092649967,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279888952863963,
          26.210157981303162,
          26.106170959919233,
          27.218258537348014,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570385432706,
          26.141585031343645,
          26.040484691738843,
          27.193212858542694,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          26.039924575033755,
          25.94301333286587,
          27.15455252074961,
          null,
          null,
          null,
        ],
        6: [
          27.267488034542268,
          27.2633393507452,
          27.255270702619846,
          27.239612303811807,
          27.21275978561227,
          27.17178700715243,
          27.098615656968185,
          null,
          null,
          null,
        ],
        7: [
          0.25537317124472403, 0.2553788843034521, 0.2553824841610728,
          0.25539282637209176, 0.2554119272355659, 0.25544672687423614,
          0.25549567292323405, 0.2591711213679735, 0.27024057298763404,
          0.2861747232747879,
        ],
        8: [
          0.26269904008469447, 0.26270654909296653, 0.2627156137599422,
          0.2627297999362406, 0.2627585175215937, 0.26281378697248503,
          0.26288682157667187, 0.2629681936538459, 0.27041267896780224,
          0.28642434567091707,
        ],
        9: [
          0.2770098182874988, 0.2770216584950576, 0.27703317151407336,
          0.27706113316248904, 0.2771088400659743, 0.27719110858675966,
          0.27731540578838865, 0.27743622011704844, 0.27768303798913374,
          0.2868456128806393,
        ],
      },
      11: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          26.310459769689263,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          26.27652108727801,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          26.252721188741496,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279888952863963,
          26.210157981303162,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570385432706,
          26.141585031343645,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          26.039924575033755,
          null,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      12: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          26.310459769689263,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          26.27652108727801,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          26.252721188741496,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279888952863963,
          26.210157981303162,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570385432706,
          26.141585031343645,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          26.039924575033755,
          null,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      13: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          26.310459769689263,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          26.27652108727801,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          26.252721188741496,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279888952863963,
          26.210157981303162,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570385432706,
          26.141585031343645,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          26.039924575033755,
          null,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      14: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          26.310459769689263,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          26.27652108727801,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          26.252721188741496,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279888952863963,
          26.210157981303162,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570385432706,
          26.141585031343645,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          26.039924575033755,
          null,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      15: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          26.310459769689263,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          26.27652108727801,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          26.252721188741496,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279888952863963,
          26.210157981303162,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570385432706,
          26.141585031343645,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          26.039924575033755,
          null,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      16: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279888952863963,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570385432706,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      17: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279888952863963,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570385432706,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      18: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279888952863963,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570385432706,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      19: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.279889077410626,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.20957038542916,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
        7: [null, null, null, null, null, null, null, null, null, null],
        8: [null, null, null, null, null, null, null, null, null, null],
        9: [null, null, null, null, null, null, null, null, null, null],
      },
      20: {
        0: [
          26.46252537268805,
          26.449986584193525,
          26.425571842751893,
          26.381507783136996,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        1: [
          26.429603656451434,
          26.417024922246014,
          26.392518266231136,
          26.34819385402635,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        2: [
          26.404146109359246,
          26.39175315500766,
          26.367565158837785,
          26.32377333924527,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        3: [
          26.35885630401927,
          26.346750783488794,
          26.323086699698433,
          26.291379319940475,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        4: [
          26.286283498166462,
          26.274509521155828,
          26.25145564851528,
          26.209570398803468,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        5: [
          26.17847039386063,
          26.167249831729194,
          26.145211185616397,
          26.105031722000028,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        6: [null, null, null, null, null, null, null, null, null, null],
      },
    },
  },
}
